/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AbortIn,
  ActivateMember200,
  ActivateMemberRequest,
  AddExcludedCompaniesRequest,
  AddExcludedPeopleRequest,
  AddFromSearchRequest,
  AddFromSearchResponse,
  AddSeat200,
  AddSeatRequest,
  AddonCancelRequest,
  AddonMutationResponse,
  AddonResponse,
  AddonSubscribeRequest,
  AdhocIn,
  AdhocOut,
  AdminIdentity,
  AdminTalentPoolCreateRequest,
  AdminTalentPoolGrantRequest,
  AdminTalentPoolGrantResponse,
  AdminTalentPoolListResponse,
  AdminTalentPoolResponse,
  AdminTalentPoolUpdateRequest,
  AppApiRoutesSettingsMFAVerifyRequest,
  AppSchemasAuthMFAVerifyRequest,
  ApplicationAnswersPatch,
  ApplicationAnswersResponse,
  ArbitratorBulkActionRequest,
  ArbitratorBulkActionResponse,
  AssignCustomPlan200,
  AssignIn,
  AssignRequest,
  AssistantChatRequest,
  AssistantMessageRequest,
  AtsConnectionListResponse,
  AtsConnectionResponse,
  AtsPushResult,
  AttachPaymentMethod200,
  AttachPaymentMethodBody,
  AttentionCountsOut,
  AttentionCountsParams,
  AuditActionListResponse,
  AuditActionSchemaListResponse,
  AuditConfigurationResponse,
  AuditEventListResponse,
  AuditExportRequest,
  AuditExportResponse,
  AuditFilterOptionsResponse,
  AuditRetentionResponse,
  AuditRetentionUpdateRequest,
  AuthResponse,
  AutoDraftRegenerateRequest,
  AutoEmailTaskCreate,
  AutocompleteParams,
  AutocompleteResponseSchema,
  AutomaticEmailStep,
  BatchAutocompleteRequestSchema,
  BatchAutocompleteResponseSchema,
  BillingChangePreviewRequest,
  BillingChangePreviewResponse,
  BillingDetailsResponse,
  BodyCreateImportsApiJobsJobIdImportsPost,
  BodyCreateProjectApiProjectsPost,
  BodySaveStep3ApiOnboardingStep3Post,
  BodySetProjectCoverApiProjectsProjectIdCoverPut,
  BodyUploadAvatarApiUploadsAvatarPost,
  BodyUploadDocumentApiUploadsDocumentPost,
  BodyUploadEmployerCoverApiUploadsEmployerCoverPost,
  BodyUploadImageApiUploadsImagePost,
  BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost,
  BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost,
  BodyUploadOrgLogoApiUploadsOrgLogoPost,
  BodyUploadSignatureAssetApiUploadsSignatureAssetPost,
  BotNamePatch,
  BulkActionRequest,
  BulkActionResponse,
  BulkCancelRequest,
  BulkEnrollmentActionRequest,
  BulkEnrollmentActionResponse,
  BulkMarkChatsRequest,
  BulkMarkThreadsRequest,
  BulkMatchRequest,
  BulkMatchResponse,
  BulkMoveJobResponse,
  BulkPauseRequest,
  BulkRejectRequest,
  BulkRejectResponse,
  CalendarConnectionOut,
  CalendarOauthCallbackParams,
  CancelAssistant200,
  CancelConfirmRequest,
  CancelConfirmResponse,
  CancelContactRequest,
  CancelContactResponse,
  CancelContextResponse,
  CancelDiscountResponse,
  CancelDowngrade200,
  CancelFeedbackRequest,
  CancelFeedbackResponse,
  CancelOutreachAssistant200,
  CancelPauseRequest,
  CancelPauseResponse,
  CancelScheduledInboxChatSend200,
  CancelScheduledInboxSend200,
  CancelUndoResponse,
  CaptureAvailabilityOut,
  CaptureCommandIn,
  CaptureCommandOut,
  ChangeCadence200,
  ChangeCadenceRequest,
  ChangePassword200,
  ChangePlan200,
  ChangePlanRequest,
  ChangePrimaryEmailRequest,
  ChatMessageRequest,
  ChatMessageSendResponse,
  ClassificationOverrideRequest,
  ClearAllExclusionsResponse,
  ClearConnectionsResponse,
  ClearScheduleOverrideParams,
  CollaboratorAdd,
  CollaboratorResponse,
  ColumnsOut,
  CompanyAnalyticsResponse,
  CompanySummaryResponse,
  CompanyWorkforceAnalyticsResponse,
  CompleteIn,
  CompleteOut,
  ConnectSessionRequest,
  ConnectSessionResponse,
  ConnectedAccountsSummary,
  ConnectionTalentPoolPatch,
  ConnectionsRequest,
  ConsentChoiceIn,
  ConsentChoiceOut,
  ConsentContextOut,
  ConsentOut,
  ContactFeedbackRequest,
  ContactRevealResponse,
  ConversationNoteCreate,
  ConversationNoteListOut,
  ConversationNoteOut,
  ConversationNoteReactionIn,
  ConversationNoteUpdate,
  ConversationOut,
  ConversationPatch,
  CoverageRequestSchema,
  CoverageResponseSchema,
  CreateArbitratorCriteriaPreset200,
  CreateBillingPortal200,
  CreateNetworkMemberRequest,
  CreateOrgRequest,
  CreatePresetRequest,
  CreateSessionRequest,
  CreateTaskParams,
  CreditAnalyticsResponse,
  CreditBalanceResponse,
  CreditHistoryResponse,
  CreditLedgerExportRequest,
  CreditLedgerExportResponse,
  CreditLedgerExportStatusResponse,
  CriteriaSummarySchema,
  CustomTaskCreate,
  CustomTaskStep,
  CutQueuedOut,
  DeactivateMember200,
  DeactivateMemberRequest,
  DeactivationPreview200,
  DeleteAllFailed200,
  DeleteCalendarConnectionParams,
  DeleteImport200,
  DeleteOrgRequest,
  DeletePaymentMethod200,
  DeletePreviewOut,
  DeleteReviewsRequest,
  DeleteStageParams,
  DocumentSourceIn,
  DryRunOut,
  DsarExportOut,
  EmailSignatureCreate,
  EmailSignatureListResponse,
  EmailSignaturePublish,
  EmailSignatureResponse,
  EmailSignatureUpdate,
  EmailVerificationRequiredResponse,
  EmployerCreate,
  EmployerEnrichRequest,
  EmployerEnrichResponse,
  EmployerEnrichmentResponse,
  EmployerListResponse,
  EmployerProfileCreate,
  EmployerProfileResponse,
  EmployerResponse,
  EmployerUpdate,
  EnrollmentCommitRequest,
  EnrollmentCommitResponse,
  EnrollmentListResponse,
  EnrollmentPreviewPatchRequest,
  EnrollmentPreviewRequest,
  EnrollmentPreviewResponse,
  EnrollmentResponse,
  EnrollmentRevealEstimateRequest,
  EnrollmentRevealEstimateResponse,
  EnsureCustomer200,
  ErasureIn,
  ErasureRequestListOut,
  ErasureRequestOut,
  EvaluationListResponse,
  EvaluationRowSchema,
  ExchangeImpersonationGrantParams,
  ExcludedCompanyListResponse,
  ExcludedProfileListResponse,
  ExecuteResult,
  ExecuteTaskRequest,
  ExportEstimateRequestSchema,
  ExportEstimateSchema,
  ExportHistoryListSchema,
  ExportJobStatusSchema,
  ExportProfilesResponseSchema,
  ExtendCustomPlan200,
  ExtendRequest,
  FilterOptionsResponseSchema,
  FinalizeConnectionRequest,
  ForgotPasswordRequest,
  GetAssistantStatus200,
  GetCandidateDetail200,
  GetCreditAnalyticsParams,
  GetCreditHistoryParams,
  GetInvoices200Item,
  GetJobSequenceAnalyticsParams,
  GetMediaUrlParams,
  GetNextUnreviewedCandidateParams,
  GetOpenInvoices200Item,
  GetOrgStatus200,
  GetOutreachAssistantMessages200Item,
  GetOutreachAssistantStatus200,
  GetPaymentMethod200,
  GetProfileJobsParams,
  GetProfileParams,
  GetScheduleParams,
  GetScoreBandCounts200,
  GetSearchResultsParams,
  GetSegmentsParams,
  GetStuckQueued200,
  GetStuckQueuedParams,
  GetTaskCountsParams,
  GoogleOAuthResponse,
  GrantCreate,
  GrantOut,
  HTTPValidationError,
  HandleReplyIn,
  HandleReplyOut,
  HealthHealthGet200,
  ImportIn,
  ImportJobRequest,
  InboxThreadListResponse,
  InboxThreadResponse,
  InsightsResponseSchema,
  IntegrationCatalogResponse,
  IntegrationRequestBody,
  IntegrationRequestResponse,
  IntroRequest,
  InvitationAcceptResponse,
  InvitationDetailResponse,
  InvitationResponse,
  InvitationSendRequest,
  InvitationTokenInfoResponse,
  JobAtsLinkResponse,
  JobCreate,
  JobLinkResponse,
  JobListResponse,
  JobProfileNoteListResponse,
  JobResponse,
  JobSequenceAnalyticsResponse,
  JobUpdate,
  KomboWebhook200,
  LanguageIn,
  LanguageOut,
  LaunchRequest,
  LeaveOrgPreflightResponse,
  LeaveOrgRequest,
  LeaveOrgResponse,
  LegalHoldIn,
  LegalHoldOut,
  LinkJobRequest,
  LinkStageMapPreviewResponse,
  LinkedInAccountResponse,
  LinkedInAccountUpdate,
  LinkedInChatListResponse,
  LinkedInChatResponse,
  LinkedInCheckpointRequest,
  LinkedInCheckpointResendRequest,
  LinkedInConnectRequest,
  LinkedInConnectResponse,
  LinkedInConnectionRequestStep,
  LinkedInConnectionRequestTaskCreate,
  LinkedInLimitsResponse,
  LinkedInMessageStep,
  LinkedInMessageTaskCreate,
  LinkedInProfileViewStep,
  LinkedInProfileViewTaskCreate,
  LinkedInRefreshResponse,
  LinkedInSignatureCreate,
  LinkedInSignatureResponse,
  LinkedInSignatureUpdate,
  ListArbitratorCriteriaPresets200,
  ListAtsSyncRunsParams,
  ListAuditEventsParams,
  ListEmailSignaturesParams,
  ListEmployersParams,
  ListEnrollmentsParams,
  ListExcludedCompaniesParams,
  ListExcludedPeopleParams,
  ListExportHistoryParams,
  ListImportsParams,
  ListInboxChatsParams,
  ListInboxThreadsParams,
  ListJobScorecardDefinitionsParams,
  ListJobsParams,
  ListMailboxesParams,
  ListMembersParams,
  ListNotificationsParams,
  ListOrgContextVersionsParams,
  ListOrgSessionsParams,
  ListPaymentMethods200Item,
  ListPipelineParams,
  ListPresetsParams,
  ListProfileReviewsParams,
  ListProjectMemberMailboxesParams,
  ListProjectSequenceFilterJobs200,
  ListProjectSequenceFilterJobsParams,
  ListProjectSequences200,
  ListProjectSequencesByJob200,
  ListProjectSequencesByJobParams,
  ListProjectSequencesParams,
  ListProjectsParams,
  ListRemoteAtsJobsParams,
  ListResultsParams,
  ListSavedSearchesParams,
  ListScorecardFillsParams,
  ListScorecardLibraryParams,
  ListSequences200,
  ListSequencesParams,
  ListSnippetsParams,
  ListStepSets200,
  ListTalentPoolProfilesParams,
  ListTasksParams,
  LoginRequest,
  LogoutRequest,
  MFAChallengeResponse,
  MFAEnrollResponse,
  MFAFactorsResponse,
  MailboxImapCreateRequest,
  MailboxList,
  MailboxOAuthStartRequest,
  MailboxOAuthStartResponse,
  MailboxOauthCallbackParams,
  MailboxResponse,
  MailboxUpdate,
  ManualContactCreate,
  ManualEmailStep,
  ManualEmailTaskCreate,
  MarkersOut,
  MeResponse,
  MediaUrlOut,
  MemberDetailResponse,
  MemberListResponse,
  MessageResponse,
  MfaDeleteFactor200,
  MfaVerify200,
  ModifyCriteriaRequest,
  ModifyCriteriaResponse,
  NeedsMergeListResponse,
  NetworkMemberListResponse,
  NetworkMemberResponse,
  NetworkPathsResponse,
  NextUnreviewedResponse,
  NoticeResendIn,
  NoticeResendOut,
  NotificationListResponse,
  NotificationPreferencesResponse,
  NotificationPreferencesUpdate,
  NylasWebhook200,
  NylasWebhookChallengeParams,
  OAuthCompleteIn,
  OAuthCompleteOut,
  OAuthStartIn,
  OAuthStartOut,
  OAuthStartRequest,
  OauthCallbackParams,
  OnBehalfIn,
  OnboardingCompleteResponse,
  OnboardingStatusResponse,
  OnboardingStepResponse,
  OrgBrandingOut,
  OrgComplianceSettingsRequest,
  OrgComplianceSettingsResponse,
  OrgContextOut,
  OrgContextPut,
  OrgContextRevert,
  OrgContextVersionOut,
  OrgEnrichmentResponse,
  OrgMembershipListResponse,
  OrgOutreachSettingsRequest,
  OrgOutreachSettingsResponse,
  OrgSessionsResponse,
  OrgSettingsOut,
  OrgSettingsPut,
  OrganizationResponse,
  OutreachAssistantMessageRequest,
  OverrideClearedOut,
  OverrideIn,
  OverrideOut,
  ParticipantPatch,
  PasswordChangeRequest,
  PatchAtsSyncSettings200,
  PatchParticipantParams,
  PauseCustomPlan200,
  PauseResumeRequest,
  PayInvoice200,
  PhoneCallStep,
  PhoneCallTaskCreate,
  PipelineFilterOptionsResponse,
  PipelineListResponse,
  PipelineQueryRequest,
  PlanResponse,
  PollNotificationsParams,
  PollSequenceEventsParams,
  PostHeal200,
  PostReset200,
  PostRetry200,
  PresetAppendItemsRequest,
  PresetAppendItemsResponse,
  PresetCreate,
  PresetListResponse,
  PresetResponse,
  PresetUpdate,
  PresignIn,
  PresignOut,
  PreviewAtsLinkStageMapParams,
  PreviewOrgBotTileParams,
  PreviewStepBody,
  ProfileContactResponse,
  ProfileDetailSchema,
  ProfileImportActionResponse,
  ProfileImportCreateResponse,
  ProfileImportListResponse,
  ProfileImportProgressResponse,
  ProfileJobsResponse,
  ProfileNoteCreate,
  ProfileNoteListResponse,
  ProfileNoteReactionRequest,
  ProfileNoteResponse,
  ProfileNoteUpdate,
  ProfileSummaryResponse,
  ProfileUpdateRequest,
  ProfileUpdateResponse,
  ProjectListResponse,
  ProjectResponse,
  ProjectUpdate,
  PromoteResultView,
  PromotionPrecheckResponse,
  PropertiesOut,
  PropertiesPut,
  PropertiesSchemaPut,
  PropertyOut,
  PublicShareResponseSchema,
  PushEvaluationResult,
  QueryIn,
  QueryOut,
  QueryPipelineParams,
  ReactivateRequest,
  RecallAccountWebhook200,
  RecallRealtimeWebhook200,
  RefreshRequest,
  RefreshResponse,
  RegisterRequest,
  RejectPreflightOut,
  RejectRequest,
  RelinkIn,
  RemoteJobListResponse,
  RemoveCustomPlan200,
  RemoveRequest,
  RemoveSeat200,
  RemoveSeatRequest,
  RenderedStepPreview,
  ReplyRequest,
  ReplySendResponse,
  RerunSessionParams,
  ResendInboundWebhook200,
  ResendInvitation200,
  ResendVerificationRequest,
  ResetOutreachAssistant200,
  ResetPasswordRequest,
  ResolveCandidatesRequest,
  ResolveCandidatesResponse,
  ResolveExcludedPeopleByLinkedinUrlsRequest,
  ResolveExcludedPeopleByLinkedinUrlsResponse,
  ResolveMergeRequest,
  ResolveMergeResponse,
  ResolvedScorecardSet,
  ResumeCustomPlan200,
  ResumeSubscription200,
  ResumeSyncStatusResponse,
  ResumeUrlResponse,
  RetentionPreviewIn,
  RetentionPreviewOut,
  RetryRequest,
  ReviewsResponse,
  RevokeAllOrgSessions200,
  RevokeIn,
  RevokeInvitation200,
  RevokeMemberSession200,
  RevokeSessionRequest,
  RunSearchRequestSchema,
  SampleAiForStep200,
  SavedSearchListResponseSchema,
  SavedSearchSchema,
  SavedSearchUpdateSchema,
  ScheduleOut,
  ScorecardDefinitionCreate,
  ScorecardDefinitionFromLibrary,
  ScorecardDefinitionOut,
  ScorecardDefinitionPatch,
  ScorecardFillCreate,
  ScorecardFillOut,
  ScorecardFillPatch,
  ScorecardFillsOut,
  ScorecardOrderUpdate,
  ScorecardTypePatch,
  ScorecardVersionOut,
  ScreeningAnswersEnforcementResetResponse,
  SearchChatRequest,
  SearchClassifyRequest,
  SearchClassifyResponse,
  SearchFeedbackCreateSchema,
  SearchFeedbackResponseSchema,
  SearchProfilesResponseSchema,
  SearchRequestSchema,
  SearchResultsPageSchema,
  SearchWithRunResponseSchema,
  SeatAssignmentResponse,
  SeatInfoResponse,
  SeedAssistantMessages200,
  SeedRequest,
  SegmentOut,
  SentResponse,
  SequenceCloneStepsRequest,
  SequenceCreate,
  SequenceEventsPollResponse,
  SequenceResponse,
  SequenceStepSetResponse,
  SequenceUpdate,
  SessionListResponse,
  SessionSchema,
  SessionTerminationResponse,
  SessionsResponse,
  SetLinkedinRequest,
  SetupPaymentMethod200,
  ShareCreateRequestSchema,
  ShareCreateResponseSchema,
  SignupAttributionRequest,
  SingleCandidateActionRequest,
  SingleCandidateActionResponse,
  SnippetCreate,
  SnippetListResponse,
  SnippetPreviewRequest,
  SnippetPreviewResponse,
  SnippetResponse,
  SnippetUpdate,
  SourceOut,
  SpeakersOut,
  SpotlightRequestSchema,
  SpotlightResponseSchema,
  StageCreate,
  StageMappingListResponse,
  StageReorderRequest,
  StageResponse,
  StageSyncRequest,
  StageSyncResponse,
  StageUpdate,
  StartExportRequestSchema,
  StateOut,
  Step1Data,
  Step2Data,
  Step4Data,
  StepReorderRequest,
  StepUpdate,
  StoredMessageResponse,
  StripeWebhook200,
  Subscribe200,
  SubscribeRequest,
  SubscribeResponse,
  SubscriptionResponse,
  SuggestCriteriaRequest,
  SuggestForSession200,
  SummarizeProfileEndpointParams,
  SummaryResponse,
  SuspendMember200,
  SwitchOrgRequest,
  SwitchOrgResponse,
  SyncJobResponse,
  SyncNowResponse,
  SyncPreflightRequest,
  SyncPreflightResponse,
  SyncRequest,
  SyncResponse,
  SyncRunListResponse,
  SyncSettingsPatch,
  TalentPoolImportRequest,
  TalentPoolImportResponse,
  TalentPoolListResponse,
  TalentPoolNameRequest,
  TalentPoolProfileListResponse,
  TalentPoolProfilesDeleteRequest,
  TalentPoolProfilesDeleteResponse,
  TalentPoolResponse,
  TalentPoolTransferRequest,
  TalentPoolTransferResponse,
  TalentPoolUpdateRequest,
  TalentPoolUploadDestinationRequest,
  TaskCounts,
  TaskDetail,
  TaskListPage,
  TaskUpdate,
  TaskVariablesResponse,
  TechnicalProfileResponse,
  TestSendStep202,
  TestSendStepBody,
  TextMessageStep,
  TextMessageTaskCreate,
  ThreadOut,
  ThreadVariablesResponse,
  ToolAnswerRequest,
  TransferOwnershipRequest,
  TransferProjectOwnership200,
  TriageAssignOneIn,
  TriageOut,
  TriagePerCandidateIn,
  UnipileWebhook200,
  UniversalSearchParams,
  UniversalSearchResponseSchema,
  UnreadCountResponse,
  UpdateBillingDetailsRequest,
  UpdateCriteriaRequest,
  UpdateMemberProfileRequest,
  UpdateMemberRoleRequest,
  UpdateNetworkMemberRequest,
  UpdateOrgRequest,
  UpdateStageMappingsRequest,
  UploadConnectionsRequest,
  UploadConnectionsResponse,
  UploadLinkConnectionsRequest,
  UploadLinkResponse,
  UploadResponse,
  UpsertReviewsRequest,
  UserResponse,
  UserSettingsOut,
  UserSettingsPut,
  ValidateCouponRequest,
  ValidateCouponResponse,
  VerifiedDomainIn,
  VerifiedDomainListOut,
  VerifiedDomainOut,
  VerifyEmailRequest,
  WebImportRequest,
  WebImportResponse,
  WithdrawIn,
  WorkflowAcknowledgement,
  WriteWithAIRequest,
  WriteWithAIResponse,
  _CancelRequest,
  _OutcomeRequest,
  _PauseRequest
} from './model';

import { customInstance } from './client';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getRegisterUrl = () => {




  return `/api/auth/register`
}

/**
 * @summary Register
 */
export const register = async (registerRequest: RegisterRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuthResponse | EmailVerificationRequiredResponse> => {

  return customInstance<AuthResponse | EmailVerificationRequiredResponse>(getRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registerRequest)
  }
);}





export const getRegisterMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext> => {

const mutationKey = ['register'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, {data: RegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  register(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = RegisterRequest
    export type RegisterMutationError = HTTPValidationError

    /**
 * @summary Register
 */
export const useRegister = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        {data: RegisterRequest},
        TContext
      > => {
      return useMutation(getRegisterMutationOptions(options), queryClient);
    }

export const getGetInvitationTokenInfoUrl = (invitationToken: string,) => {




  return `/api/auth/invitations/${invitationToken}`
}

/**
 * @summary Get Invitation Token Info
 */
export const getInvitationTokenInfo = async (invitationToken: string, options?: Parameters<typeof customInstance>[1]): Promise<InvitationTokenInfoResponse> => {

  return customInstance<InvitationTokenInfoResponse>(getGetInvitationTokenInfoUrl(invitationToken),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvitationTokenInfoQueryKey = (invitationToken: string,) => {
    return [
    `/api/auth/invitations/${invitationToken}`
    ] as const;
    }


export const getGetInvitationTokenInfoQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(invitationToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationTokenInfoQueryKey(invitationToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationTokenInfo>>> = ({ signal }) => getInvitationTokenInfo(invitationToken, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invitationToken !== null && invitationToken !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationTokenInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationTokenInfo>>>
export type GetInvitationTokenInfoQueryError = HTTPValidationError


export function useGetInvitationTokenInfo<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationTokenInfo>>,
          TError,
          Awaited<ReturnType<typeof getInvitationTokenInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTokenInfo<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationTokenInfo>>,
          TError,
          Awaited<ReturnType<typeof getInvitationTokenInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTokenInfo<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invitation Token Info
 */

export function useGetInvitationTokenInfo<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationTokenInfoQueryOptions(invitationToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInvitationTokenInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(invitationToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationTokenInfoQueryKey(invitationToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationTokenInfo>>> = ({ signal }) => getInvitationTokenInfo(invitationToken, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationTokenInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationTokenInfo>>>
export type GetInvitationTokenInfoSuspenseQueryError = HTTPValidationError


export function useGetInvitationTokenInfoSuspense<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTokenInfoSuspense<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTokenInfoSuspense<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invitation Token Info
 */

export function useGetInvitationTokenInfoSuspense<TData = Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError = HTTPValidationError>(
 invitationToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationTokenInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationTokenInfoSuspenseQueryOptions(invitationToken,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResendVerificationUrl = () => {




  return `/api/auth/resend-verification`
}

/**
 * @summary Resend Verification
 */
export const resendVerification = async (resendVerificationRequest: ResendVerificationRequest, options?: Parameters<typeof customInstance>[1]): Promise<MessageResponse> => {

  return customInstance<MessageResponse>(getResendVerificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resendVerificationRequest)
  }
);}





export const getResendVerificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,{data: ResendVerificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,{data: ResendVerificationRequest}, TContext> => {

const mutationKey = ['resendVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendVerification>>, {data: ResendVerificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  resendVerification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendVerification>>>
    export type ResendVerificationMutationBody = ResendVerificationRequest
    export type ResendVerificationMutationError = HTTPValidationError

    /**
 * @summary Resend Verification
 */
export const useResendVerification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,{data: ResendVerificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendVerification>>,
        TError,
        {data: ResendVerificationRequest},
        TContext
      > => {
      return useMutation(getResendVerificationMutationOptions(options), queryClient);
    }

export const getForgotPasswordUrl = () => {




  return `/api/auth/forgot-password`
}

/**
 * @summary Forgot Password
 */
export const forgotPassword = async (forgotPasswordRequest: ForgotPasswordRequest, options?: Parameters<typeof customInstance>[1]): Promise<MessageResponse> => {

  return customInstance<MessageResponse>(getForgotPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forgotPasswordRequest)
  }
);}





export const getForgotPasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext> => {

const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequest
    export type ForgotPasswordMutationError = HTTPValidationError

    /**
 * @summary Forgot Password
 */
export const useForgotPassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordRequest},
        TContext
      > => {
      return useMutation(getForgotPasswordMutationOptions(options), queryClient);
    }

export const getResetPasswordUrl = () => {




  return `/api/auth/reset-password`
}

/**
 * @summary Reset Password
 */
export const resetPassword = async (resetPasswordRequest: ResetPasswordRequest, options?: Parameters<typeof customInstance>[1]): Promise<MessageResponse> => {

  return customInstance<MessageResponse>(getResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordRequest)
  }
);}





export const getResetPasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = HTTPValidationError

    /**
 * @summary Reset Password
 */
export const useResetPassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequest},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Login
 */
export const login = async (loginRequest: LoginRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuthResponse | MFAChallengeResponse | EmailVerificationRequiredResponse> => {

  return customInstance<AuthResponse | MFAChallengeResponse | EmailVerificationRequiredResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginRequest)
  }
);}





export const getLoginMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = HTTPValidationError

    /**
 * @summary Login
 */
export const useLogin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

export const getLoginMfaVerifyUrl = () => {




  return `/api/auth/mfa-verify`
}

/**
 * @summary Login Mfa Verify
 */
export const loginMfaVerify = async (appSchemasAuthMFAVerifyRequest: AppSchemasAuthMFAVerifyRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuthResponse> => {

  return customInstance<AuthResponse>(getLoginMfaVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(appSchemasAuthMFAVerifyRequest)
  }
);}





export const getLoginMfaVerifyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginMfaVerify>>, TError,{data: AppSchemasAuthMFAVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof loginMfaVerify>>, TError,{data: AppSchemasAuthMFAVerifyRequest}, TContext> => {

const mutationKey = ['loginMfaVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginMfaVerify>>, {data: AppSchemasAuthMFAVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginMfaVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMfaVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof loginMfaVerify>>>
    export type LoginMfaVerifyMutationBody = AppSchemasAuthMFAVerifyRequest
    export type LoginMfaVerifyMutationError = HTTPValidationError

    /**
 * @summary Login Mfa Verify
 */
export const useLoginMfaVerify = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginMfaVerify>>, TError,{data: AppSchemasAuthMFAVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginMfaVerify>>,
        TError,
        {data: AppSchemasAuthMFAVerifyRequest},
        TContext
      > => {
      return useMutation(getLoginMfaVerifyMutationOptions(options), queryClient);
    }

export const getVerifyEmailUrl = () => {




  return `/api/auth/verify-email`
}

/**
 * @summary Verify Email
 */
export const verifyEmail = async (verifyEmailRequest: VerifyEmailRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuthResponse> => {

  return customInstance<AuthResponse>(getVerifyEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailRequest)
  }
);}





export const getVerifyEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailRequest}, TContext> => {

const mutationKey = ['verifyEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmail>>, {data: VerifyEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>
    export type VerifyEmailMutationBody = VerifyEmailRequest
    export type VerifyEmailMutationError = HTTPValidationError

    /**
 * @summary Verify Email
 */
export const useVerifyEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmail>>,
        TError,
        {data: VerifyEmailRequest},
        TContext
      > => {
      return useMutation(getVerifyEmailMutationOptions(options), queryClient);
    }

export const getRefreshUrl = () => {




  return `/api/auth/refresh`
}

/**
 * @summary Refresh
 */
export const refresh = async (refreshRequest: RefreshRequest, options?: Parameters<typeof customInstance>[1]): Promise<RefreshResponse> => {

  return customInstance<RefreshResponse>(getRefreshUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refreshRequest)
  }
);}





export const getRefreshMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshRequest}, TContext> => {

const mutationKey = ['refresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refresh>>, {data: RefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  refresh(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>
    export type RefreshMutationBody = RefreshRequest
    export type RefreshMutationError = HTTPValidationError

    /**
 * @summary Refresh
 */
export const useRefresh = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refresh>>,
        TError,
        {data: RefreshRequest},
        TContext
      > => {
      return useMutation(getRefreshMutationOptions(options), queryClient);
    }

export const getGoogleOauthUrl = () => {




  return `/api/auth/google`
}

/**
 * @summary Google Oauth
 */
export const googleOauth = async (oAuthStartRequestNull?: OAuthStartRequest | null, options?: Parameters<typeof customInstance>[1]): Promise<GoogleOAuthResponse> => {

  return customInstance<GoogleOAuthResponse>(getGoogleOauthUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthStartRequestNull)
  }
);}





export const getGoogleOauthMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleOauth>>, TError,{data?: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof googleOauth>>, TError,{data?: OAuthStartRequest | null}, TContext> => {

const mutationKey = ['googleOauth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof googleOauth>>, {data?: OAuthStartRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  googleOauth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GoogleOauthMutationResult = NonNullable<Awaited<ReturnType<typeof googleOauth>>>
    export type GoogleOauthMutationBody = OAuthStartRequest | null | undefined
    export type GoogleOauthMutationError = HTTPValidationError

    /**
 * @summary Google Oauth
 */
export const useGoogleOauth = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleOauth>>, TError,{data?: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof googleOauth>>,
        TError,
        {data?: OAuthStartRequest | null},
        TContext
      > => {
      return useMutation(getGoogleOauthMutationOptions(options), queryClient);
    }

export const getMicrosoftOauthUrl = () => {




  return `/api/auth/microsoft`
}

/**
 * @summary Microsoft Oauth
 */
export const microsoftOauth = async (oAuthStartRequestNull?: OAuthStartRequest | null, options?: Parameters<typeof customInstance>[1]): Promise<GoogleOAuthResponse> => {

  return customInstance<GoogleOAuthResponse>(getMicrosoftOauthUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthStartRequestNull)
  }
);}





export const getMicrosoftOauthMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftOauth>>, TError,{data?: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof microsoftOauth>>, TError,{data?: OAuthStartRequest | null}, TContext> => {

const mutationKey = ['microsoftOauth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof microsoftOauth>>, {data?: OAuthStartRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  microsoftOauth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MicrosoftOauthMutationResult = NonNullable<Awaited<ReturnType<typeof microsoftOauth>>>
    export type MicrosoftOauthMutationBody = OAuthStartRequest | null | undefined
    export type MicrosoftOauthMutationError = HTTPValidationError

    /**
 * @summary Microsoft Oauth
 */
export const useMicrosoftOauth = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftOauth>>, TError,{data?: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof microsoftOauth>>,
        TError,
        {data?: OAuthStartRequest | null},
        TContext
      > => {
      return useMutation(getMicrosoftOauthMutationOptions(options), queryClient);
    }

export const getOauthCallbackUrl = (params: OauthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auth/callback?${stringifiedParams}` : `/api/auth/callback`
}

/**
 * @summary Oauth Callback
 */
export const oauthCallback = async (params: OauthCallbackParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getOauthCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOauthCallbackQueryKey = (params?: OauthCallbackParams,) => {
    return [
    `/api/auth/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(params: OauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthCallback>>> = ({ signal }) => oauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof oauthCallback>>>
export type OauthCallbackQueryError = HTTPValidationError


export function useOauthCallback<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauthCallback>>,
          TError,
          Awaited<ReturnType<typeof oauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOauthCallback<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauthCallback>>,
          TError,
          Awaited<ReturnType<typeof oauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOauthCallback<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Oauth Callback
 */

export function useOauthCallback<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOauthCallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(params: OauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthCallback>>> = ({ signal }) => oauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OauthCallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof oauthCallback>>>
export type OauthCallbackSuspenseQueryError = HTTPValidationError


export function useOauthCallbackSuspense<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOauthCallbackSuspense<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOauthCallbackSuspense<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Oauth Callback
 */

export function useOauthCallbackSuspense<TData = Awaited<ReturnType<typeof oauthCallback>>, TError = HTTPValidationError>(
 params: OauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof oauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOauthCallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Logout
 */
export const logout = async (logoutRequestNull?: LogoutRequest | null, options?: Parameters<typeof customInstance>[1]): Promise<SessionTerminationResponse> => {

  return customInstance<SessionTerminationResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(logoutRequestNull)
  }
);}





export const getLogoutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data?: LogoutRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data?: LogoutRequest | null}, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, {data?: LogoutRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  logout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>
    export type LogoutMutationBody = LogoutRequest | null | undefined
    export type LogoutMutationError = HTTPValidationError

    /**
 * @summary Logout
 */
export const useLogout = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data?: LogoutRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        {data?: LogoutRequest | null},
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }

export const getMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Me
 */
export const me = async ( options?: Parameters<typeof customInstance>[1]): Promise<MeResponse> => {

  return customInstance<MeResponse>(getMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getMeQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeQueryError = unknown


export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Me
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeSuspenseQueryError = unknown


export function useMeSuspense<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeSuspense<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeSuspense<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Me
 */

export function useMeSuspense<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetSignupAttributionUrl = () => {




  return `/api/auth/attribution`
}

/**
 * Write-once first-touch acquisition attribution for the current user.
 *
 * The frontend captures utm_* params / referrer at first landing, stores
 * them through the signup flow (email+password, OAuth, and invite paths
 * all converge here after auth), and posts them once a session exists.
 * Idempotent: repeat calls, empty payloads, and stale-account calls are
 * silent no-ops so the frontend can fire-and-forget.
 * @summary Set Signup Attribution
 */
export const setSignupAttribution = async (signupAttributionRequest: SignupAttributionRequest, options?: Parameters<typeof customInstance>[1]): Promise<MessageResponse> => {

  return customInstance<MessageResponse>(getSetSignupAttributionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupAttributionRequest)
  }
);}





export const getSetSignupAttributionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSignupAttribution>>, TError,{data: SignupAttributionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSignupAttribution>>, TError,{data: SignupAttributionRequest}, TContext> => {

const mutationKey = ['setSignupAttribution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSignupAttribution>>, {data: SignupAttributionRequest}> = (props) => {
          const {data} = props ?? {};

          return  setSignupAttribution(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSignupAttributionMutationResult = NonNullable<Awaited<ReturnType<typeof setSignupAttribution>>>
    export type SetSignupAttributionMutationBody = SignupAttributionRequest
    export type SetSignupAttributionMutationError = HTTPValidationError

    /**
 * @summary Set Signup Attribution
 */
export const useSetSignupAttribution = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSignupAttribution>>, TError,{data: SignupAttributionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSignupAttribution>>,
        TError,
        {data: SignupAttributionRequest},
        TContext
      > => {
      return useMutation(getSetSignupAttributionMutationOptions(options), queryClient);
    }

export const getExchangeImpersonationGrantUrl = (params: ExchangeImpersonationGrantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auth/impersonate?${stringifiedParams}` : `/api/auth/impersonate`
}

/**
 * @summary Exchange Impersonation Grant
 */
export const exchangeImpersonationGrant = async (params: ExchangeImpersonationGrantParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getExchangeImpersonationGrantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExchangeImpersonationGrantQueryKey = (params?: ExchangeImpersonationGrantParams,) => {
    return [
    `/api/auth/impersonate`, ...(params ? [params] : [])
    ] as const;
    }


export const getExchangeImpersonationGrantQueryOptions = <TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExchangeImpersonationGrantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exchangeImpersonationGrant>>> = ({ signal }) => exchangeImpersonationGrant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExchangeImpersonationGrantQueryResult = NonNullable<Awaited<ReturnType<typeof exchangeImpersonationGrant>>>
export type ExchangeImpersonationGrantQueryError = HTTPValidationError


export function useExchangeImpersonationGrant<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exchangeImpersonationGrant>>,
          TError,
          Awaited<ReturnType<typeof exchangeImpersonationGrant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExchangeImpersonationGrant<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exchangeImpersonationGrant>>,
          TError,
          Awaited<ReturnType<typeof exchangeImpersonationGrant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExchangeImpersonationGrant<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exchange Impersonation Grant
 */

export function useExchangeImpersonationGrant<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExchangeImpersonationGrantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExchangeImpersonationGrantSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExchangeImpersonationGrantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exchangeImpersonationGrant>>> = ({ signal }) => exchangeImpersonationGrant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExchangeImpersonationGrantSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof exchangeImpersonationGrant>>>
export type ExchangeImpersonationGrantSuspenseQueryError = HTTPValidationError


export function useExchangeImpersonationGrantSuspense<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExchangeImpersonationGrantSuspense<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExchangeImpersonationGrantSuspense<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exchange Impersonation Grant
 */

export function useExchangeImpersonationGrantSuspense<TData = Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError = HTTPValidationError>(
 params: ExchangeImpersonationGrantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exchangeImpersonationGrant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExchangeImpersonationGrantSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPlansUrl = () => {




  return `/api/billing/plans`
}

/**
 * @summary List Plans
 */
export const listPlans = async ( options?: Parameters<typeof customInstance>[1]): Promise<PlanResponse[]> => {

  return customInstance<PlanResponse[]>(getListPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlansQueryKey = () => {
    return [
    `/api/billing/plans`
    ] as const;
    }


export const getListPlansQueryOptions = <TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({ signal }) => listPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listPlans>>>
export type ListPlansQueryError = unknown


export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Plans
 */

export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPlansSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({ signal }) => listPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlansSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPlans>>>
export type ListPlansSuspenseQueryError = unknown


export function useListPlansSuspense<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlansSuspense<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlansSuspense<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Plans
 */

export function useListPlansSuspense<TData = Awaited<ReturnType<typeof listPlans>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlansSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSubscriptionUrl = () => {




  return `/api/billing/subscription`
}

/**
 * @summary Get Subscription
 */
export const getSubscription = async ( options?: Parameters<typeof customInstance>[1]): Promise<SubscriptionResponse | null> => {

  return customInstance<SubscriptionResponse | null>(getGetSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    `/api/billing/subscription`
    ] as const;
    }


export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = unknown


export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscription>>,
          TError,
          Awaited<ReturnType<typeof getSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscription>>,
          TError,
          Awaited<ReturnType<typeof getSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Subscription
 */

export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSubscriptionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionSuspenseQueryError = unknown


export function useGetSubscriptionSuspense<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSuspense<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSuspense<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Subscription
 */

export function useGetSubscriptionSuspense<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCreditsUrl = () => {




  return `/api/billing/credits`
}

/**
 * @summary Get Credits
 */
export const getCredits = async ( options?: Parameters<typeof customInstance>[1]): Promise<CreditBalanceResponse> => {

  return customInstance<CreditBalanceResponse>(getGetCreditsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreditsQueryKey = () => {
    return [
    `/api/billing/credits`
    ] as const;
    }


export const getGetCreditsQueryOptions = <TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCredits>>> = ({ signal }) => getCredits({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof getCredits>>>
export type GetCreditsQueryError = unknown


export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredits>>,
          TError,
          Awaited<ReturnType<typeof getCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredits>>,
          TError,
          Awaited<ReturnType<typeof getCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credits
 */

export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCreditsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCredits>>> = ({ signal }) => getCredits({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCredits>>>
export type GetCreditsSuspenseQueryError = unknown


export function useGetCreditsSuspense<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditsSuspense<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditsSuspense<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credits
 */

export function useGetCreditsSuspense<TData = Awaited<ReturnType<typeof getCredits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCreditHistoryUrl = (params?: GetCreditHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories","entry_types","actor_user_ids","exclude_categories","exclude_entry_types","exclude_actor_user_ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/billing/credits/history?${stringifiedParams}` : `/api/billing/credits/history`
}

/**
 * @summary Get Credit History
 */
export const getCreditHistory = async (params?: GetCreditHistoryParams, options?: Parameters<typeof customInstance>[1]): Promise<CreditHistoryResponse> => {

  return customInstance<CreditHistoryResponse>(getGetCreditHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreditHistoryQueryKey = (params?: GetCreditHistoryParams,) => {
    return [
    `/api/billing/credits/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCreditHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(params?: GetCreditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditHistory>>> = ({ signal }) => getCreditHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditHistory>>>
export type GetCreditHistoryQueryError = HTTPValidationError


export function useGetCreditHistory<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params: undefined |  GetCreditHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditHistory<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditHistory<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit History
 */

export function useGetCreditHistory<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCreditHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(params?: GetCreditHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditHistory>>> = ({ signal }) => getCreditHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditHistory>>>
export type GetCreditHistorySuspenseQueryError = HTTPValidationError


export function useGetCreditHistorySuspense<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params: undefined |  GetCreditHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditHistorySuspense<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditHistorySuspense<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit History
 */

export function useGetCreditHistorySuspense<TData = Awaited<ReturnType<typeof getCreditHistory>>, TError = HTTPValidationError>(
 params?: GetCreditHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditHistorySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCreditAnalyticsUrl = (params?: GetCreditAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories","entry_types","actor_user_ids","exclude_categories","exclude_entry_types","exclude_actor_user_ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/billing/credits/analytics?${stringifiedParams}` : `/api/billing/credits/analytics`
}

/**
 * Credit usage analytics in the caller's IANA timezone.
 *
 * The window is derived from the filters: explicit date bounds win,
 * else the trailing ``days`` shorthand, else the span of the data in
 * scope. Powers the credits breakdown page: the used-by-day chart, the
 * KPI tiles, and the by-category / by-member breakdowns.
 * @summary Get Credit Analytics
 */
export const getCreditAnalytics = async (params?: GetCreditAnalyticsParams, options?: Parameters<typeof customInstance>[1]): Promise<CreditAnalyticsResponse> => {

  return customInstance<CreditAnalyticsResponse>(getGetCreditAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreditAnalyticsQueryKey = (params?: GetCreditAnalyticsParams,) => {
    return [
    `/api/billing/credits/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCreditAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditAnalytics>>> = ({ signal }) => getCreditAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditAnalytics>>>
export type GetCreditAnalyticsQueryError = HTTPValidationError


export function useGetCreditAnalytics<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params: undefined |  GetCreditAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCreditAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAnalytics<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCreditAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAnalytics<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit Analytics
 */

export function useGetCreditAnalytics<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCreditAnalyticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditAnalytics>>> = ({ signal }) => getCreditAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditAnalyticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditAnalytics>>>
export type GetCreditAnalyticsSuspenseQueryError = HTTPValidationError


export function useGetCreditAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params: undefined |  GetCreditAnalyticsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit Analytics
 */

export function useGetCreditAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCreditAnalytics>>, TError = HTTPValidationError>(
 params?: GetCreditAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditAnalyticsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartCreditLedgerExportUrl = () => {




  return `/api/billing/credits/export`
}

/**
 * Kick off a Temporal workflow that renders the filtered ledger to
 * CSV and uploads it to private storage. Returns immediately; the FE
 * polls ``GET /credits/export/{job_id}``.
 * @summary Start Credit Ledger Export
 */
export const startCreditLedgerExport = async (creditLedgerExportRequest: CreditLedgerExportRequest, options?: Parameters<typeof customInstance>[1]): Promise<CreditLedgerExportResponse> => {

  return customInstance<CreditLedgerExportResponse>(getStartCreditLedgerExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(creditLedgerExportRequest)
  }
);}





export const getStartCreditLedgerExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCreditLedgerExport>>, TError,{data: CreditLedgerExportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startCreditLedgerExport>>, TError,{data: CreditLedgerExportRequest}, TContext> => {

const mutationKey = ['startCreditLedgerExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startCreditLedgerExport>>, {data: CreditLedgerExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  startCreditLedgerExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartCreditLedgerExportMutationResult = NonNullable<Awaited<ReturnType<typeof startCreditLedgerExport>>>
    export type StartCreditLedgerExportMutationBody = CreditLedgerExportRequest
    export type StartCreditLedgerExportMutationError = HTTPValidationError

    /**
 * @summary Start Credit Ledger Export
 */
export const useStartCreditLedgerExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCreditLedgerExport>>, TError,{data: CreditLedgerExportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startCreditLedgerExport>>,
        TError,
        {data: CreditLedgerExportRequest},
        TContext
      > => {
      return useMutation(getStartCreditLedgerExportMutationOptions(options), queryClient);
    }

export const getGetCreditLedgerExportUrl = (jobId: string,) => {




  return `/api/billing/credits/export/${jobId}`
}

/**
 * Poll a ledger export.
 *
 * There is no database row backing this — state comes straight from
 * Temporal. Once the workflow ages out of retention the handle is gone
 * and this 404s, which the FE surfaces as "regenerate the export".
 * @summary Get Credit Ledger Export
 */
export const getCreditLedgerExport = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<CreditLedgerExportStatusResponse> => {

  return customInstance<CreditLedgerExportStatusResponse>(getGetCreditLedgerExportUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreditLedgerExportQueryKey = (jobId: string,) => {
    return [
    `/api/billing/credits/export/${jobId}`
    ] as const;
    }


export const getGetCreditLedgerExportQueryOptions = <TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditLedgerExportQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditLedgerExport>>> = ({ signal }) => getCreditLedgerExport(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditLedgerExportQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditLedgerExport>>>
export type GetCreditLedgerExportQueryError = HTTPValidationError


export function useGetCreditLedgerExport<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerExport>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerExport<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerExport>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerExport<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit Ledger Export
 */

export function useGetCreditLedgerExport<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditLedgerExportQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCreditLedgerExportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditLedgerExportQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditLedgerExport>>> = ({ signal }) => getCreditLedgerExport(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditLedgerExportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditLedgerExport>>>
export type GetCreditLedgerExportSuspenseQueryError = HTTPValidationError


export function useGetCreditLedgerExportSuspense<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerExportSuspense<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerExportSuspense<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credit Ledger Export
 */

export function useGetCreditLedgerExportSuspense<TData = Awaited<ReturnType<typeof getCreditLedgerExport>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditLedgerExportSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnsureCustomerUrl = () => {




  return `/api/billing/ensure-customer`
}

/**
 * @summary Ensure Customer
 */
export const ensureCustomer = async ( options?: Parameters<typeof customInstance>[1]): Promise<EnsureCustomer200> => {

  return customInstance<EnsureCustomer200>(getEnsureCustomerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnsureCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ensureCustomer>>, TError,void, TContext> => {

const mutationKey = ['ensureCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ensureCustomer>>, void> = () => {


          return  ensureCustomer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnsureCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof ensureCustomer>>>

    export type EnsureCustomerMutationError = unknown

    /**
 * @summary Ensure Customer
 */
export const useEnsureCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ensureCustomer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEnsureCustomerMutationOptions(options), queryClient);
    }

export const getListPaymentMethodsUrl = () => {




  return `/api/billing/payment-methods`
}

/**
 * @summary List Payment Methods
 */
export const listPaymentMethods = async ( options?: Parameters<typeof customInstance>[1]): Promise<ListPaymentMethods200Item[]> => {

  return customInstance<ListPaymentMethods200Item[]>(getListPaymentMethodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentMethodsQueryKey = () => {
    return [
    `/api/billing/payment-methods`
    ] as const;
    }


export const getListPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethods>>> = ({ signal }) => listPaymentMethods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethods>>>
export type ListPaymentMethodsQueryError = unknown


export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Payment Methods
 */

export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPaymentMethodsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethods>>> = ({ signal }) => listPaymentMethods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentMethodsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethods>>>
export type ListPaymentMethodsSuspenseQueryError = unknown


export function useListPaymentMethodsSuspense<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethodsSuspense<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPaymentMethodsSuspense<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Payment Methods
 */

export function useListPaymentMethodsSuspense<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentMethodsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAttachPaymentMethodUrl = () => {




  return `/api/billing/payment-methods/attach`
}

/**
 * @summary Attach Payment Method
 */
export const attachPaymentMethod = async (attachPaymentMethodBody: AttachPaymentMethodBody, options?: Parameters<typeof customInstance>[1]): Promise<AttachPaymentMethod200> => {

  return customInstance<AttachPaymentMethod200>(getAttachPaymentMethodUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attachPaymentMethodBody)
  }
);}





export const getAttachPaymentMethodMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachPaymentMethod>>, TError,{data: AttachPaymentMethodBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof attachPaymentMethod>>, TError,{data: AttachPaymentMethodBody}, TContext> => {

const mutationKey = ['attachPaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachPaymentMethod>>, {data: AttachPaymentMethodBody}> = (props) => {
          const {data} = props ?? {};

          return  attachPaymentMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof attachPaymentMethod>>>
    export type AttachPaymentMethodMutationBody = AttachPaymentMethodBody
    export type AttachPaymentMethodMutationError = HTTPValidationError

    /**
 * @summary Attach Payment Method
 */
export const useAttachPaymentMethod = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachPaymentMethod>>, TError,{data: AttachPaymentMethodBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachPaymentMethod>>,
        TError,
        {data: AttachPaymentMethodBody},
        TContext
      > => {
      return useMutation(getAttachPaymentMethodMutationOptions(options), queryClient);
    }

export const getDeletePaymentMethodUrl = (pmId: string,) => {




  return `/api/billing/payment-methods/${pmId}`
}

/**
 * @summary Delete Payment Method
 */
export const deletePaymentMethod = async (pmId: string, options?: Parameters<typeof customInstance>[1]): Promise<DeletePaymentMethod200> => {

  return customInstance<DeletePaymentMethod200>(getDeletePaymentMethodUrl(pmId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePaymentMethodMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{pmId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{pmId: string}, TContext> => {

const mutationKey = ['deletePaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentMethod>>, {pmId: string}> = (props) => {
          const {pmId} = props ?? {};

          return  deletePaymentMethod(pmId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentMethod>>>

    export type DeletePaymentMethodMutationError = HTTPValidationError

    /**
 * @summary Delete Payment Method
 */
export const useDeletePaymentMethod = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{pmId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        {pmId: string},
        TContext
      > => {
      return useMutation(getDeletePaymentMethodMutationOptions(options), queryClient);
    }

export const getValidateCouponUrl = () => {




  return `/api/billing/validate-coupon`
}

/**
 * @summary Validate Coupon
 */
export const validateCoupon = async (validateCouponRequest: ValidateCouponRequest, options?: Parameters<typeof customInstance>[1]): Promise<ValidateCouponResponse> => {

  return customInstance<ValidateCouponResponse>(getValidateCouponUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(validateCouponRequest)
  }
);}





export const getValidateCouponMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCoupon>>, TError,{data: ValidateCouponRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateCoupon>>, TError,{data: ValidateCouponRequest}, TContext> => {

const mutationKey = ['validateCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateCoupon>>, {data: ValidateCouponRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateCoupon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof validateCoupon>>>
    export type ValidateCouponMutationBody = ValidateCouponRequest
    export type ValidateCouponMutationError = HTTPValidationError

    /**
 * @summary Validate Coupon
 */
export const useValidateCoupon = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCoupon>>, TError,{data: ValidateCouponRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateCoupon>>,
        TError,
        {data: ValidateCouponRequest},
        TContext
      > => {
      return useMutation(getValidateCouponMutationOptions(options), queryClient);
    }

export const getSubscribeUrl = () => {




  return `/api/billing/subscribe`
}

/**
 * @summary Subscribe
 */
export const subscribe = async (subscribeRequest: SubscribeRequest, options?: Parameters<typeof customInstance>[1]): Promise<Subscribe200> => {

  return customInstance<Subscribe200>(getSubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscribeRequest)
  }
);}





export const getSubscribeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: SubscribeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: SubscribeRequest}, TContext> => {

const mutationKey = ['subscribe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribe>>, {data: SubscribeRequest}> = (props) => {
          const {data} = props ?? {};

          return  subscribe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof subscribe>>>
    export type SubscribeMutationBody = SubscribeRequest
    export type SubscribeMutationError = HTTPValidationError

    /**
 * @summary Subscribe
 */
export const useSubscribe = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: SubscribeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof subscribe>>,
        TError,
        {data: SubscribeRequest},
        TContext
      > => {
      return useMutation(getSubscribeMutationOptions(options), queryClient);
    }

export const getAddSeatUrl = () => {




  return `/api/billing/add-seat`
}

/**
 * @summary Add Seat
 */
export const addSeat = async (addSeatRequest: AddSeatRequest, options?: Parameters<typeof customInstance>[1]): Promise<AddSeat200> => {

  return customInstance<AddSeat200>(getAddSeatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addSeatRequest)
  }
);}





export const getAddSeatMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSeat>>, TError,{data: AddSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addSeat>>, TError,{data: AddSeatRequest}, TContext> => {

const mutationKey = ['addSeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSeat>>, {data: AddSeatRequest}> = (props) => {
          const {data} = props ?? {};

          return  addSeat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSeatMutationResult = NonNullable<Awaited<ReturnType<typeof addSeat>>>
    export type AddSeatMutationBody = AddSeatRequest
    export type AddSeatMutationError = HTTPValidationError

    /**
 * @summary Add Seat
 */
export const useAddSeat = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSeat>>, TError,{data: AddSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSeat>>,
        TError,
        {data: AddSeatRequest},
        TContext
      > => {
      return useMutation(getAddSeatMutationOptions(options), queryClient);
    }

export const getRemoveSeatUrl = () => {




  return `/api/billing/remove-seat`
}

/**
 * @summary Remove Seat
 */
export const removeSeat = async (removeSeatRequest: RemoveSeatRequest, options?: Parameters<typeof customInstance>[1]): Promise<RemoveSeat200> => {

  return customInstance<RemoveSeat200>(getRemoveSeatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removeSeatRequest)
  }
);}





export const getRemoveSeatMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSeat>>, TError,{data: RemoveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeSeat>>, TError,{data: RemoveSeatRequest}, TContext> => {

const mutationKey = ['removeSeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSeat>>, {data: RemoveSeatRequest}> = (props) => {
          const {data} = props ?? {};

          return  removeSeat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveSeatMutationResult = NonNullable<Awaited<ReturnType<typeof removeSeat>>>
    export type RemoveSeatMutationBody = RemoveSeatRequest
    export type RemoveSeatMutationError = HTTPValidationError

    /**
 * @summary Remove Seat
 */
export const useRemoveSeat = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSeat>>, TError,{data: RemoveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeSeat>>,
        TError,
        {data: RemoveSeatRequest},
        TContext
      > => {
      return useMutation(getRemoveSeatMutationOptions(options), queryClient);
    }

export const getGetCancelContextUrl = () => {




  return `/api/billing/cancel/context`
}

/**
 * @summary Get Cancel Context
 */
export const getCancelContext = async ( options?: Parameters<typeof customInstance>[1]): Promise<CancelContextResponse> => {

  return customInstance<CancelContextResponse>(getGetCancelContextUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCancelContextQueryKey = () => {
    return [
    `/api/billing/cancel/context`
    ] as const;
    }


export const getGetCancelContextQueryOptions = <TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancelContextQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancelContext>>> = ({ signal }) => getCancelContext({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCancelContextQueryResult = NonNullable<Awaited<ReturnType<typeof getCancelContext>>>
export type GetCancelContextQueryError = unknown


export function useGetCancelContext<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancelContext>>,
          TError,
          Awaited<ReturnType<typeof getCancelContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancelContext<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancelContext>>,
          TError,
          Awaited<ReturnType<typeof getCancelContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancelContext<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cancel Context
 */

export function useGetCancelContext<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancelContextQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCancelContextSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancelContextQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancelContext>>> = ({ signal }) => getCancelContext({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCancelContextSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCancelContext>>>
export type GetCancelContextSuspenseQueryError = unknown


export function useGetCancelContextSuspense<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancelContextSuspense<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCancelContextSuspense<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cancel Context
 */

export function useGetCancelContextSuspense<TData = Awaited<ReturnType<typeof getCancelContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCancelContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCancelContextSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelPauseUrl = () => {




  return `/api/billing/cancel/pause`
}

/**
 * @summary Cancel Pause
 */
export const cancelPause = async (cancelPauseRequest: CancelPauseRequest, options?: Parameters<typeof customInstance>[1]): Promise<CancelPauseResponse> => {

  return customInstance<CancelPauseResponse>(getCancelPauseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelPauseRequest)
  }
);}





export const getCancelPauseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPause>>, TError,{data: CancelPauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPause>>, TError,{data: CancelPauseRequest}, TContext> => {

const mutationKey = ['cancelPause'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPause>>, {data: CancelPauseRequest}> = (props) => {
          const {data} = props ?? {};

          return  cancelPause(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPauseMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPause>>>
    export type CancelPauseMutationBody = CancelPauseRequest
    export type CancelPauseMutationError = HTTPValidationError

    /**
 * @summary Cancel Pause
 */
export const useCancelPause = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPause>>, TError,{data: CancelPauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelPause>>,
        TError,
        {data: CancelPauseRequest},
        TContext
      > => {
      return useMutation(getCancelPauseMutationOptions(options), queryClient);
    }

export const getCancelFeedbackUrl = () => {




  return `/api/billing/cancel/feedback`
}

/**
 * @summary Cancel Feedback
 */
export const cancelFeedback = async (cancelFeedbackRequest: CancelFeedbackRequest, options?: Parameters<typeof customInstance>[1]): Promise<CancelFeedbackResponse> => {

  return customInstance<CancelFeedbackResponse>(getCancelFeedbackUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelFeedbackRequest)
  }
);}





export const getCancelFeedbackMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFeedback>>, TError,{data: CancelFeedbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelFeedback>>, TError,{data: CancelFeedbackRequest}, TContext> => {

const mutationKey = ['cancelFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFeedback>>, {data: CancelFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  cancelFeedback(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFeedback>>>
    export type CancelFeedbackMutationBody = CancelFeedbackRequest
    export type CancelFeedbackMutationError = HTTPValidationError

    /**
 * @summary Cancel Feedback
 */
export const useCancelFeedback = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFeedback>>, TError,{data: CancelFeedbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelFeedback>>,
        TError,
        {data: CancelFeedbackRequest},
        TContext
      > => {
      return useMutation(getCancelFeedbackMutationOptions(options), queryClient);
    }

export const getCancelDiscountUrl = () => {




  return `/api/billing/cancel/discount`
}

/**
 * @summary Cancel Discount
 */
export const cancelDiscount = async ( options?: Parameters<typeof customInstance>[1]): Promise<CancelDiscountResponse> => {

  return customInstance<CancelDiscountResponse>(getCancelDiscountUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelDiscountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDiscount>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelDiscount>>, TError,void, TContext> => {

const mutationKey = ['cancelDiscount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDiscount>>, void> = () => {


          return  cancelDiscount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelDiscountMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDiscount>>>

    export type CancelDiscountMutationError = unknown

    /**
 * @summary Cancel Discount
 */
export const useCancelDiscount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDiscount>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelDiscount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCancelDiscountMutationOptions(options), queryClient);
    }

export const getCancelContactUrl = () => {




  return `/api/billing/cancel/contact`
}

/**
 * @summary Cancel Contact
 */
export const cancelContact = async (cancelContactRequest: CancelContactRequest, options?: Parameters<typeof customInstance>[1]): Promise<CancelContactResponse> => {

  return customInstance<CancelContactResponse>(getCancelContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelContactRequest)
  }
);}





export const getCancelContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelContact>>, TError,{data: CancelContactRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelContact>>, TError,{data: CancelContactRequest}, TContext> => {

const mutationKey = ['cancelContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelContact>>, {data: CancelContactRequest}> = (props) => {
          const {data} = props ?? {};

          return  cancelContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelContactMutationResult = NonNullable<Awaited<ReturnType<typeof cancelContact>>>
    export type CancelContactMutationBody = CancelContactRequest
    export type CancelContactMutationError = HTTPValidationError

    /**
 * @summary Cancel Contact
 */
export const useCancelContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelContact>>, TError,{data: CancelContactRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelContact>>,
        TError,
        {data: CancelContactRequest},
        TContext
      > => {
      return useMutation(getCancelContactMutationOptions(options), queryClient);
    }

export const getConfirmCancelUrl = () => {




  return `/api/billing/cancel/confirm`
}

/**
 * @summary Confirm Cancel
 */
export const confirmCancel = async (cancelConfirmRequestNull?: CancelConfirmRequest | null, options?: Parameters<typeof customInstance>[1]): Promise<CancelConfirmResponse> => {

  return customInstance<CancelConfirmResponse>(getConfirmCancelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelConfirmRequestNull)
  }
);}





export const getConfirmCancelMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCancel>>, TError,{data?: CancelConfirmRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmCancel>>, TError,{data?: CancelConfirmRequest | null}, TContext> => {

const mutationKey = ['confirmCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCancel>>, {data?: CancelConfirmRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  confirmCancel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCancelMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCancel>>>
    export type ConfirmCancelMutationBody = CancelConfirmRequest | null | undefined
    export type ConfirmCancelMutationError = HTTPValidationError

    /**
 * @summary Confirm Cancel
 */
export const useConfirmCancel = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCancel>>, TError,{data?: CancelConfirmRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCancel>>,
        TError,
        {data?: CancelConfirmRequest | null},
        TContext
      > => {
      return useMutation(getConfirmCancelMutationOptions(options), queryClient);
    }

export const getUndoCancellationUrl = () => {




  return `/api/billing/cancel/undo`
}

/**
 * @summary Undo Cancellation
 */
export const undoCancellation = async ( options?: Parameters<typeof customInstance>[1]): Promise<CancelUndoResponse> => {

  return customInstance<CancelUndoResponse>(getUndoCancellationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUndoCancellationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellation>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof undoCancellation>>, TError,void, TContext> => {

const mutationKey = ['undoCancellation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoCancellation>>, void> = () => {


          return  undoCancellation(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndoCancellationMutationResult = NonNullable<Awaited<ReturnType<typeof undoCancellation>>>

    export type UndoCancellationMutationError = unknown

    /**
 * @summary Undo Cancellation
 */
export const useUndoCancellation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellation>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof undoCancellation>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUndoCancellationMutationOptions(options), queryClient);
    }

export const getGetSeatInfoUrl = () => {




  return `/api/billing/seats`
}

/**
 * @summary Get Seat Info
 */
export const getSeatInfo = async ( options?: Parameters<typeof customInstance>[1]): Promise<SeatInfoResponse> => {

  return customInstance<SeatInfoResponse>(getGetSeatInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeatInfoQueryKey = () => {
    return [
    `/api/billing/seats`
    ] as const;
    }


export const getGetSeatInfoQueryOptions = <TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeatInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeatInfo>>> = ({ signal }) => getSeatInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeatInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getSeatInfo>>>
export type GetSeatInfoQueryError = unknown


export function useGetSeatInfo<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeatInfo>>,
          TError,
          Awaited<ReturnType<typeof getSeatInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeatInfo<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeatInfo>>,
          TError,
          Awaited<ReturnType<typeof getSeatInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeatInfo<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Seat Info
 */

export function useGetSeatInfo<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeatInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSeatInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeatInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeatInfo>>> = ({ signal }) => getSeatInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeatInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSeatInfo>>>
export type GetSeatInfoSuspenseQueryError = unknown


export function useGetSeatInfoSuspense<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeatInfoSuspense<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeatInfoSuspense<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Seat Info
 */

export function useGetSeatInfoSuspense<TData = Awaited<ReturnType<typeof getSeatInfo>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeatInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeatInfoSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSeatAssignmentsUrl = () => {




  return `/api/billing/seats/assignments`
}

/**
 * @summary List Seat Assignments
 */
export const listSeatAssignments = async ( options?: Parameters<typeof customInstance>[1]): Promise<SeatAssignmentResponse[]> => {

  return customInstance<SeatAssignmentResponse[]>(getListSeatAssignmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSeatAssignmentsQueryKey = () => {
    return [
    `/api/billing/seats/assignments`
    ] as const;
    }


export const getListSeatAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSeatAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSeatAssignments>>> = ({ signal }) => listSeatAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSeatAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSeatAssignments>>>
export type ListSeatAssignmentsQueryError = unknown


export function useListSeatAssignments<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSeatAssignments>>,
          TError,
          Awaited<ReturnType<typeof listSeatAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSeatAssignments<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSeatAssignments>>,
          TError,
          Awaited<ReturnType<typeof listSeatAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSeatAssignments<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Seat Assignments
 */

export function useListSeatAssignments<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSeatAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSeatAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSeatAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSeatAssignments>>> = ({ signal }) => listSeatAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSeatAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSeatAssignments>>>
export type ListSeatAssignmentsSuspenseQueryError = unknown


export function useListSeatAssignmentsSuspense<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSeatAssignmentsSuspense<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSeatAssignmentsSuspense<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Seat Assignments
 */

export function useListSeatAssignmentsSuspense<TData = Awaited<ReturnType<typeof listSeatAssignments>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSeatAssignments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSeatAssignmentsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getActivateMemberUrl = () => {




  return `/api/billing/seats/activate`
}

/**
 * @summary Activate Member
 */
export const activateMember = async (activateMemberRequest: ActivateMemberRequest, options?: Parameters<typeof customInstance>[1]): Promise<ActivateMember200> => {

  return customInstance<ActivateMember200>(getActivateMemberUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateMemberRequest)
  }
);}





export const getActivateMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateMember>>, TError,{data: ActivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activateMember>>, TError,{data: ActivateMemberRequest}, TContext> => {

const mutationKey = ['activateMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateMember>>, {data: ActivateMemberRequest}> = (props) => {
          const {data} = props ?? {};

          return  activateMember(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof activateMember>>>
    export type ActivateMemberMutationBody = ActivateMemberRequest
    export type ActivateMemberMutationError = HTTPValidationError

    /**
 * @summary Activate Member
 */
export const useActivateMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateMember>>, TError,{data: ActivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateMember>>,
        TError,
        {data: ActivateMemberRequest},
        TContext
      > => {
      return useMutation(getActivateMemberMutationOptions(options), queryClient);
    }

export const getDeactivateMemberUrl = () => {




  return `/api/billing/seats/deactivate`
}

/**
 * @summary Deactivate Member
 */
export const deactivateMember = async (deactivateMemberRequest: DeactivateMemberRequest, options?: Parameters<typeof customInstance>[1]): Promise<DeactivateMember200> => {

  return customInstance<DeactivateMember200>(getDeactivateMemberUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deactivateMemberRequest)
  }
);}





export const getDeactivateMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateMember>>, TError,{data: DeactivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateMember>>, TError,{data: DeactivateMemberRequest}, TContext> => {

const mutationKey = ['deactivateMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateMember>>, {data: DeactivateMemberRequest}> = (props) => {
          const {data} = props ?? {};

          return  deactivateMember(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateMember>>>
    export type DeactivateMemberMutationBody = DeactivateMemberRequest
    export type DeactivateMemberMutationError = HTTPValidationError

    /**
 * @summary Deactivate Member
 */
export const useDeactivateMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateMember>>, TError,{data: DeactivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateMember>>,
        TError,
        {data: DeactivateMemberRequest},
        TContext
      > => {
      return useMutation(getDeactivateMemberMutationOptions(options), queryClient);
    }

export const getDeactivationPreviewUrl = () => {




  return `/api/billing/seats/deactivation-preview`
}

/**
 * Dry-run: returns what would happen if a member were deactivated.
 * @summary Deactivation Preview
 */
export const deactivationPreview = async (deactivateMemberRequest: DeactivateMemberRequest, options?: Parameters<typeof customInstance>[1]): Promise<DeactivationPreview200> => {

  return customInstance<DeactivationPreview200>(getDeactivationPreviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deactivateMemberRequest)
  }
);}





export const getDeactivationPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivationPreview>>, TError,{data: DeactivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivationPreview>>, TError,{data: DeactivateMemberRequest}, TContext> => {

const mutationKey = ['deactivationPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivationPreview>>, {data: DeactivateMemberRequest}> = (props) => {
          const {data} = props ?? {};

          return  deactivationPreview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivationPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof deactivationPreview>>>
    export type DeactivationPreviewMutationBody = DeactivateMemberRequest
    export type DeactivationPreviewMutationError = HTTPValidationError

    /**
 * @summary Deactivation Preview
 */
export const useDeactivationPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivationPreview>>, TError,{data: DeactivateMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivationPreview>>,
        TError,
        {data: DeactivateMemberRequest},
        TContext
      > => {
      return useMutation(getDeactivationPreviewMutationOptions(options), queryClient);
    }

export const getGetOrgStatusUrl = () => {




  return `/api/billing/org-status`
}

/**
 * @summary Get Org Status
 */
export const getOrgStatus = async ( options?: Parameters<typeof customInstance>[1]): Promise<GetOrgStatus200> => {

  return customInstance<GetOrgStatus200>(getGetOrgStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgStatusQueryKey = () => {
    return [
    `/api/billing/org-status`
    ] as const;
    }


export const getGetOrgStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgStatus>>> = ({ signal }) => getOrgStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgStatus>>>
export type GetOrgStatusQueryError = unknown


export function useGetOrgStatus<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrgStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgStatus<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrgStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgStatus<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Status
 */

export function useGetOrgStatus<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgStatus>>> = ({ signal }) => getOrgStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgStatus>>>
export type GetOrgStatusSuspenseQueryError = unknown


export function useGetOrgStatusSuspense<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgStatusSuspense<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgStatusSuspense<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Status
 */

export function useGetOrgStatusSuspense<TData = Awaited<ReturnType<typeof getOrgStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOpenInvoicesUrl = () => {




  return `/api/billing/open-invoices`
}

/**
 * Return any open (unpaid) invoices for the org's Stripe customer.
 * @summary Get Open Invoices
 */
export const getOpenInvoices = async ( options?: Parameters<typeof customInstance>[1]): Promise<GetOpenInvoices200Item[]> => {

  return customInstance<GetOpenInvoices200Item[]>(getGetOpenInvoicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpenInvoicesQueryKey = () => {
    return [
    `/api/billing/open-invoices`
    ] as const;
    }


export const getGetOpenInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenInvoices>>> = ({ signal }) => getOpenInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpenInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenInvoices>>>
export type GetOpenInvoicesQueryError = unknown


export function useGetOpenInvoices<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenInvoices>>,
          TError,
          Awaited<ReturnType<typeof getOpenInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenInvoices<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenInvoices>>,
          TError,
          Awaited<ReturnType<typeof getOpenInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenInvoices<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Open Invoices
 */

export function useGetOpenInvoices<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpenInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOpenInvoicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenInvoices>>> = ({ signal }) => getOpenInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpenInvoicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenInvoices>>>
export type GetOpenInvoicesSuspenseQueryError = unknown


export function useGetOpenInvoicesSuspense<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenInvoicesSuspense<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenInvoicesSuspense<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Open Invoices
 */

export function useGetOpenInvoicesSuspense<TData = Awaited<ReturnType<typeof getOpenInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpenInvoicesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPayInvoiceUrl = (invoiceId: string,) => {




  return `/api/billing/pay-invoice/${invoiceId}`
}

/**
 * Retry payment on an open invoice to resolve past-due status.
 * @summary Pay Invoice
 */
export const payInvoice = async (invoiceId: string, options?: Parameters<typeof customInstance>[1]): Promise<PayInvoice200> => {

  return customInstance<PayInvoice200>(getPayInvoiceUrl(invoiceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPayInvoiceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payInvoice>>, TError,{invoiceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payInvoice>>, TError,{invoiceId: string}, TContext> => {

const mutationKey = ['payInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payInvoice>>, {invoiceId: string}> = (props) => {
          const {invoiceId} = props ?? {};

          return  payInvoice(invoiceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PayInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof payInvoice>>>

    export type PayInvoiceMutationError = HTTPValidationError

    /**
 * @summary Pay Invoice
 */
export const usePayInvoice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payInvoice>>, TError,{invoiceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payInvoice>>,
        TError,
        {invoiceId: string},
        TContext
      > => {
      return useMutation(getPayInvoiceMutationOptions(options), queryClient);
    }

export const getReactivateUrl = () => {




  return `/api/billing/reactivate`
}

/**
 * @summary Reactivate
 */
export const reactivate = async (reactivateRequest: ReactivateRequest, options?: Parameters<typeof customInstance>[1]): Promise<SubscribeResponse> => {

  return customInstance<SubscribeResponse>(getReactivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reactivateRequest)
  }
);}





export const getReactivateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{data: ReactivateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{data: ReactivateRequest}, TContext> => {

const mutationKey = ['reactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivate>>, {data: ReactivateRequest}> = (props) => {
          const {data} = props ?? {};

          return  reactivate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof reactivate>>>
    export type ReactivateMutationBody = ReactivateRequest
    export type ReactivateMutationError = HTTPValidationError

    /**
 * @summary Reactivate
 */
export const useReactivate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{data: ReactivateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivate>>,
        TError,
        {data: ReactivateRequest},
        TContext
      > => {
      return useMutation(getReactivateMutationOptions(options), queryClient);
    }

export const getResumeSubscriptionUrl = () => {




  return `/api/billing/resume`
}

/**
 * @summary Resume Subscription
 */
export const resumeSubscription = async ( options?: Parameters<typeof customInstance>[1]): Promise<ResumeSubscription200> => {

  return customInstance<ResumeSubscription200>(getResumeSubscriptionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResumeSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeSubscription>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeSubscription>>, TError,void, TContext> => {

const mutationKey = ['resumeSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeSubscription>>, void> = () => {


          return  resumeSubscription(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof resumeSubscription>>>

    export type ResumeSubscriptionMutationError = unknown

    /**
 * @summary Resume Subscription
 */
export const useResumeSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeSubscription>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeSubscription>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResumeSubscriptionMutationOptions(options), queryClient);
    }

export const getCancelDowngradeUrl = () => {




  return `/api/billing/cancel-downgrade`
}

/**
 * @summary Cancel Downgrade
 */
export const cancelDowngrade = async ( options?: Parameters<typeof customInstance>[1]): Promise<CancelDowngrade200> => {

  return customInstance<CancelDowngrade200>(getCancelDowngradeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelDowngradeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDowngrade>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelDowngrade>>, TError,void, TContext> => {

const mutationKey = ['cancelDowngrade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDowngrade>>, void> = () => {


          return  cancelDowngrade(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelDowngradeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDowngrade>>>

    export type CancelDowngradeMutationError = unknown

    /**
 * @summary Cancel Downgrade
 */
export const useCancelDowngrade = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDowngrade>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelDowngrade>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCancelDowngradeMutationOptions(options), queryClient);
    }

export const getChangePlanUrl = () => {




  return `/api/billing/change-plan`
}

/**
 * @summary Change Plan
 */
export const changePlan = async (changePlanRequest: ChangePlanRequest, options?: Parameters<typeof customInstance>[1]): Promise<ChangePlan200> => {

  return customInstance<ChangePlan200>(getChangePlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePlanRequest)
  }
);}





export const getChangePlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{data: ChangePlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{data: ChangePlanRequest}, TContext> => {

const mutationKey = ['changePlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePlan>>, {data: ChangePlanRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePlanMutationResult = NonNullable<Awaited<ReturnType<typeof changePlan>>>
    export type ChangePlanMutationBody = ChangePlanRequest
    export type ChangePlanMutationError = HTTPValidationError

    /**
 * @summary Change Plan
 */
export const useChangePlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{data: ChangePlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePlan>>,
        TError,
        {data: ChangePlanRequest},
        TContext
      > => {
      return useMutation(getChangePlanMutationOptions(options), queryClient);
    }

export const getPreviewBillingChangeUrl = () => {




  return `/api/billing/preview-change`
}

/**
 * @summary Preview Billing Change
 */
export const previewBillingChange = async (billingChangePreviewRequest: BillingChangePreviewRequest, options?: Parameters<typeof customInstance>[1]): Promise<BillingChangePreviewResponse> => {

  return customInstance<BillingChangePreviewResponse>(getPreviewBillingChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(billingChangePreviewRequest)
  }
);}





export const getPreviewBillingChangeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBillingChange>>, TError,{data: BillingChangePreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewBillingChange>>, TError,{data: BillingChangePreviewRequest}, TContext> => {

const mutationKey = ['previewBillingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewBillingChange>>, {data: BillingChangePreviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  previewBillingChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewBillingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof previewBillingChange>>>
    export type PreviewBillingChangeMutationBody = BillingChangePreviewRequest
    export type PreviewBillingChangeMutationError = HTTPValidationError

    /**
 * @summary Preview Billing Change
 */
export const usePreviewBillingChange = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBillingChange>>, TError,{data: BillingChangePreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewBillingChange>>,
        TError,
        {data: BillingChangePreviewRequest},
        TContext
      > => {
      return useMutation(getPreviewBillingChangeMutationOptions(options), queryClient);
    }

export const getChangeCadenceUrl = () => {




  return `/api/billing/change-cadence`
}

/**
 * @summary Change Cadence
 */
export const changeCadence = async (changeCadenceRequest: ChangeCadenceRequest, options?: Parameters<typeof customInstance>[1]): Promise<ChangeCadence200> => {

  return customInstance<ChangeCadence200>(getChangeCadenceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeCadenceRequest)
  }
);}





export const getChangeCadenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCadence>>, TError,{data: ChangeCadenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeCadence>>, TError,{data: ChangeCadenceRequest}, TContext> => {

const mutationKey = ['changeCadence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeCadence>>, {data: ChangeCadenceRequest}> = (props) => {
          const {data} = props ?? {};

          return  changeCadence(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeCadenceMutationResult = NonNullable<Awaited<ReturnType<typeof changeCadence>>>
    export type ChangeCadenceMutationBody = ChangeCadenceRequest
    export type ChangeCadenceMutationError = HTTPValidationError

    /**
 * @summary Change Cadence
 */
export const useChangeCadence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCadence>>, TError,{data: ChangeCadenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeCadence>>,
        TError,
        {data: ChangeCadenceRequest},
        TContext
      > => {
      return useMutation(getChangeCadenceMutationOptions(options), queryClient);
    }

export const getGetPaymentMethodUrl = () => {




  return `/api/billing/payment-method`
}

/**
 * @summary Get Payment Method
 */
export const getPaymentMethod = async ( options?: Parameters<typeof customInstance>[1]): Promise<GetPaymentMethod200> => {

  return customInstance<GetPaymentMethod200>(getGetPaymentMethodUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentMethodQueryKey = () => {
    return [
    `/api/billing/payment-method`
    ] as const;
    }


export const getGetPaymentMethodQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentMethodQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethod>>> = ({ signal }) => getPaymentMethod({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentMethod>>>
export type GetPaymentMethodQueryError = unknown


export function useGetPaymentMethod<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethod<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethod<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Payment Method
 */

export function useGetPaymentMethod<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentMethodQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaymentMethodSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentMethodQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethod>>> = ({ signal }) => getPaymentMethod({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentMethodSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentMethod>>>
export type GetPaymentMethodSuspenseQueryError = unknown


export function useGetPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Payment Method
 */

export function useGetPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getPaymentMethod>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentMethodSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetupPaymentMethodUrl = () => {




  return `/api/billing/payment-method/setup`
}

/**
 * @summary Setup Payment Method
 */
export const setupPaymentMethod = async ( options?: Parameters<typeof customInstance>[1]): Promise<SetupPaymentMethod200> => {

  return customInstance<SetupPaymentMethod200>(getSetupPaymentMethodUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetupPaymentMethodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupPaymentMethod>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setupPaymentMethod>>, TError,void, TContext> => {

const mutationKey = ['setupPaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupPaymentMethod>>, void> = () => {


          return  setupPaymentMethod(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetupPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof setupPaymentMethod>>>

    export type SetupPaymentMethodMutationError = unknown

    /**
 * @summary Setup Payment Method
 */
export const useSetupPaymentMethod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupPaymentMethod>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setupPaymentMethod>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSetupPaymentMethodMutationOptions(options), queryClient);
    }

export const getCreateBillingPortalUrl = () => {




  return `/api/billing/portal`
}

/**
 * @summary Create Billing Portal
 */
export const createBillingPortal = async ( options?: Parameters<typeof customInstance>[1]): Promise<CreateBillingPortal200> => {

  return customInstance<CreateBillingPortal200>(getCreateBillingPortalUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateBillingPortalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,void, TContext> => {

const mutationKey = ['createBillingPortal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingPortal>>, void> = () => {


          return  createBillingPortal(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingPortalMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingPortal>>>

    export type CreateBillingPortalMutationError = unknown

    /**
 * @summary Create Billing Portal
 */
export const useCreateBillingPortal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBillingPortal>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateBillingPortalMutationOptions(options), queryClient);
    }

export const getGetInvoicesUrl = () => {




  return `/api/billing/invoices`
}

/**
 * @summary Get Invoices
 */
export const getInvoices = async ( options?: Parameters<typeof customInstance>[1]): Promise<GetInvoices200Item[]> => {

  return customInstance<GetInvoices200Item[]>(getGetInvoicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoicesQueryKey = () => {
    return [
    `/api/billing/invoices`
    ] as const;
    }


export const getGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = unknown


export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoices
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInvoicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesSuspenseQueryError = unknown


export function useGetInvoicesSuspense<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesSuspense<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesSuspense<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoices
 */

export function useGetInvoicesSuspense<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDownloadInvoicePdfUrl = (invoiceId: string,) => {




  return `/api/billing/invoices/${invoiceId}/pdf`
}

/**
 * @summary Download Invoice Pdf
 */
export const downloadInvoicePdf = async (invoiceId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getDownloadInvoicePdfUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadInvoicePdfQueryKey = (invoiceId: string,) => {
    return [
    `/api/billing/invoices/${invoiceId}/pdf`
    ] as const;
    }


export const getDownloadInvoicePdfQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadInvoicePdfQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoicePdf>>> = ({ signal }) => downloadInvoicePdf(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadInvoicePdfQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoicePdf>>>
export type DownloadInvoicePdfQueryError = HTTPValidationError


export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoicePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoicePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Invoice Pdf
 */

export function useDownloadInvoicePdf<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoicePdfQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDownloadInvoicePdfSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadInvoicePdfQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoicePdf>>> = ({ signal }) => downloadInvoicePdf(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadInvoicePdfSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoicePdf>>>
export type DownloadInvoicePdfSuspenseQueryError = HTTPValidationError


export function useDownloadInvoicePdfSuspense<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdfSuspense<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoicePdfSuspense<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Invoice Pdf
 */

export function useDownloadInvoicePdfSuspense<TData = Awaited<ReturnType<typeof downloadInvoicePdf>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoicePdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoicePdfSuspenseQueryOptions(invoiceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDownloadInvoiceReceiptUrl = (invoiceId: string,) => {




  return `/api/billing/invoices/${invoiceId}/receipt`
}

/**
 * @summary Download Invoice Receipt
 */
export const downloadInvoiceReceipt = async (invoiceId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getDownloadInvoiceReceiptUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadInvoiceReceiptQueryKey = (invoiceId: string,) => {
    return [
    `/api/billing/invoices/${invoiceId}/receipt`
    ] as const;
    }


export const getDownloadInvoiceReceiptQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadInvoiceReceiptQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoiceReceipt>>> = ({ signal }) => downloadInvoiceReceipt(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadInvoiceReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoiceReceipt>>>
export type DownloadInvoiceReceiptQueryError = HTTPValidationError


export function useDownloadInvoiceReceipt<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoiceReceipt>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoiceReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoiceReceipt<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadInvoiceReceipt>>,
          TError,
          Awaited<ReturnType<typeof downloadInvoiceReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoiceReceipt<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Invoice Receipt
 */

export function useDownloadInvoiceReceipt<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoiceReceiptQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDownloadInvoiceReceiptSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadInvoiceReceiptQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoiceReceipt>>> = ({ signal }) => downloadInvoiceReceipt(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadInvoiceReceiptSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoiceReceipt>>>
export type DownloadInvoiceReceiptSuspenseQueryError = HTTPValidationError


export function useDownloadInvoiceReceiptSuspense<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoiceReceiptSuspense<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadInvoiceReceiptSuspense<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Invoice Receipt
 */

export function useDownloadInvoiceReceiptSuspense<TData = Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceReceipt>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoiceReceiptSuspenseQueryOptions(invoiceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAddonsUrl = () => {




  return `/api/billing/addons`
}

/**
 * @summary List Addons
 */
export const listAddons = async ( options?: Parameters<typeof customInstance>[1]): Promise<AddonResponse[]> => {

  return customInstance<AddonResponse[]>(getListAddonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAddonsQueryKey = () => {
    return [
    `/api/billing/addons`
    ] as const;
    }


export const getListAddonsQueryOptions = <TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddons>>> = ({ signal }) => listAddons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAddonsQueryResult = NonNullable<Awaited<ReturnType<typeof listAddons>>>
export type ListAddonsQueryError = unknown


export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAddons>>,
          TError,
          Awaited<ReturnType<typeof listAddons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAddons>>,
          TError,
          Awaited<ReturnType<typeof listAddons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Addons
 */

export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAddonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAddonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddons>>> = ({ signal }) => listAddons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAddonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAddons>>>
export type ListAddonsSuspenseQueryError = unknown


export function useListAddonsSuspense<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAddonsSuspense<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAddonsSuspense<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Addons
 */

export function useListAddonsSuspense<TData = Awaited<ReturnType<typeof listAddons>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAddonsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubscribeAddonUrl = () => {




  return `/api/billing/addons/subscribe`
}

/**
 * @summary Subscribe Addon
 */
export const subscribeAddon = async (addonSubscribeRequest: AddonSubscribeRequest, options?: Parameters<typeof customInstance>[1]): Promise<AddonMutationResponse> => {

  return customInstance<AddonMutationResponse>(getSubscribeAddonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addonSubscribeRequest)
  }
);}





export const getSubscribeAddonMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeAddon>>, TError,{data: AddonSubscribeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeAddon>>, TError,{data: AddonSubscribeRequest}, TContext> => {

const mutationKey = ['subscribeAddon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeAddon>>, {data: AddonSubscribeRequest}> = (props) => {
          const {data} = props ?? {};

          return  subscribeAddon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeAddonMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeAddon>>>
    export type SubscribeAddonMutationBody = AddonSubscribeRequest
    export type SubscribeAddonMutationError = HTTPValidationError

    /**
 * @summary Subscribe Addon
 */
export const useSubscribeAddon = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeAddon>>, TError,{data: AddonSubscribeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof subscribeAddon>>,
        TError,
        {data: AddonSubscribeRequest},
        TContext
      > => {
      return useMutation(getSubscribeAddonMutationOptions(options), queryClient);
    }

export const getCancelAddonUrl = () => {




  return `/api/billing/addons/cancel`
}

/**
 * @summary Cancel Addon
 */
export const cancelAddon = async (addonCancelRequest: AddonCancelRequest, options?: Parameters<typeof customInstance>[1]): Promise<AddonMutationResponse> => {

  return customInstance<AddonMutationResponse>(getCancelAddonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addonCancelRequest)
  }
);}





export const getCancelAddonMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAddon>>, TError,{data: AddonCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAddon>>, TError,{data: AddonCancelRequest}, TContext> => {

const mutationKey = ['cancelAddon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAddon>>, {data: AddonCancelRequest}> = (props) => {
          const {data} = props ?? {};

          return  cancelAddon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAddonMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAddon>>>
    export type CancelAddonMutationBody = AddonCancelRequest
    export type CancelAddonMutationError = HTTPValidationError

    /**
 * @summary Cancel Addon
 */
export const useCancelAddon = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAddon>>, TError,{data: AddonCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAddon>>,
        TError,
        {data: AddonCancelRequest},
        TContext
      > => {
      return useMutation(getCancelAddonMutationOptions(options), queryClient);
    }

export const getGetBillingDetailsUrl = () => {




  return `/api/billing/details`
}

/**
 * @summary Get Billing Details
 */
export const getBillingDetails = async ( options?: Parameters<typeof customInstance>[1]): Promise<BillingDetailsResponse> => {

  return customInstance<BillingDetailsResponse>(getGetBillingDetailsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingDetailsQueryKey = () => {
    return [
    `/api/billing/details`
    ] as const;
    }


export const getGetBillingDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingDetails>>> = ({ signal }) => getBillingDetails({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingDetails>>>
export type GetBillingDetailsQueryError = unknown


export function useGetBillingDetails<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingDetails>>,
          TError,
          Awaited<ReturnType<typeof getBillingDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingDetails<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingDetails>>,
          TError,
          Awaited<ReturnType<typeof getBillingDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingDetails<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Billing Details
 */

export function useGetBillingDetails<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingDetailsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBillingDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingDetails>>> = ({ signal }) => getBillingDetails({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingDetails>>>
export type GetBillingDetailsSuspenseQueryError = unknown


export function useGetBillingDetailsSuspense<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingDetailsSuspense<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingDetailsSuspense<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Billing Details
 */

export function useGetBillingDetailsSuspense<TData = Awaited<ReturnType<typeof getBillingDetails>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBillingDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingDetailsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBillingDetailsUrl = () => {




  return `/api/billing/details`
}

/**
 * @summary Update Billing Details
 */
export const updateBillingDetails = async (updateBillingDetailsRequest: UpdateBillingDetailsRequest, options?: Parameters<typeof customInstance>[1]): Promise<BillingDetailsResponse> => {

  return customInstance<BillingDetailsResponse>(getUpdateBillingDetailsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateBillingDetailsRequest)
  }
);}





export const getUpdateBillingDetailsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingDetails>>, TError,{data: UpdateBillingDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBillingDetails>>, TError,{data: UpdateBillingDetailsRequest}, TContext> => {

const mutationKey = ['updateBillingDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBillingDetails>>, {data: UpdateBillingDetailsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateBillingDetails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBillingDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateBillingDetails>>>
    export type UpdateBillingDetailsMutationBody = UpdateBillingDetailsRequest
    export type UpdateBillingDetailsMutationError = HTTPValidationError

    /**
 * @summary Update Billing Details
 */
export const useUpdateBillingDetails = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingDetails>>, TError,{data: UpdateBillingDetailsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBillingDetails>>,
        TError,
        {data: UpdateBillingDetailsRequest},
        TContext
      > => {
      return useMutation(getUpdateBillingDetailsMutationOptions(options), queryClient);
    }

export const getStripeWebhookUrl = () => {




  return `/api/billing/stripe-webhooks`
}

/**
 * @summary Stripe Webhook
 */
export const stripeWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<StripeWebhook200> => {

  return customInstance<StripeWebhook200>(getStripeWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStripeWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof stripeWebhook>>, TError,void, TContext> => {

const mutationKey = ['stripeWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stripeWebhook>>, void> = () => {


          return  stripeWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof stripeWebhook>>>

    export type StripeWebhookMutationError = unknown

    /**
 * @summary Stripe Webhook
 */
export const useStripeWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stripeWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStripeWebhookMutationOptions(options), queryClient);
    }

export const getAssignCustomPlanUrl = () => {




  return `/api/admin/custom-plans/assign`
}

/**
 * Assign a custom plan to an organization via Temporal workflow.
 * @summary Assign Custom Plan
 */
export const assignCustomPlan = async (assignRequest: AssignRequest, options?: Parameters<typeof customInstance>[1]): Promise<AssignCustomPlan200> => {

  return customInstance<AssignCustomPlan200>(getAssignCustomPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignRequest)
  }
);}





export const getAssignCustomPlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCustomPlan>>, TError,{data: AssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignCustomPlan>>, TError,{data: AssignRequest}, TContext> => {

const mutationKey = ['assignCustomPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignCustomPlan>>, {data: AssignRequest}> = (props) => {
          const {data} = props ?? {};

          return  assignCustomPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignCustomPlanMutationResult = NonNullable<Awaited<ReturnType<typeof assignCustomPlan>>>
    export type AssignCustomPlanMutationBody = AssignRequest
    export type AssignCustomPlanMutationError = HTTPValidationError

    /**
 * @summary Assign Custom Plan
 */
export const useAssignCustomPlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCustomPlan>>, TError,{data: AssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignCustomPlan>>,
        TError,
        {data: AssignRequest},
        TContext
      > => {
      return useMutation(getAssignCustomPlanMutationOptions(options), queryClient);
    }

export const getRemoveCustomPlanUrl = () => {




  return `/api/admin/custom-plans/remove`
}

/**
 * Remove a custom plan and revert org to free tier.
 * @summary Remove Custom Plan
 */
export const removeCustomPlan = async (removeRequest: RemoveRequest, options?: Parameters<typeof customInstance>[1]): Promise<RemoveCustomPlan200> => {

  return customInstance<RemoveCustomPlan200>(getRemoveCustomPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removeRequest)
  }
);}





export const getRemoveCustomPlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCustomPlan>>, TError,{data: RemoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCustomPlan>>, TError,{data: RemoveRequest}, TContext> => {

const mutationKey = ['removeCustomPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCustomPlan>>, {data: RemoveRequest}> = (props) => {
          const {data} = props ?? {};

          return  removeCustomPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCustomPlanMutationResult = NonNullable<Awaited<ReturnType<typeof removeCustomPlan>>>
    export type RemoveCustomPlanMutationBody = RemoveRequest
    export type RemoveCustomPlanMutationError = HTTPValidationError

    /**
 * @summary Remove Custom Plan
 */
export const useRemoveCustomPlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCustomPlan>>, TError,{data: RemoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCustomPlan>>,
        TError,
        {data: RemoveRequest},
        TContext
      > => {
      return useMutation(getRemoveCustomPlanMutationOptions(options), queryClient);
    }

export const getExtendCustomPlanUrl = () => {




  return `/api/admin/custom-plans/extend`
}

/**
 * Extend the expiry date of an active custom plan.
 * @summary Extend Custom Plan
 */
export const extendCustomPlan = async (extendRequest: ExtendRequest, options?: Parameters<typeof customInstance>[1]): Promise<ExtendCustomPlan200> => {

  return customInstance<ExtendCustomPlan200>(getExtendCustomPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(extendRequest)
  }
);}





export const getExtendCustomPlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendCustomPlan>>, TError,{data: ExtendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof extendCustomPlan>>, TError,{data: ExtendRequest}, TContext> => {

const mutationKey = ['extendCustomPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extendCustomPlan>>, {data: ExtendRequest}> = (props) => {
          const {data} = props ?? {};

          return  extendCustomPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendCustomPlanMutationResult = NonNullable<Awaited<ReturnType<typeof extendCustomPlan>>>
    export type ExtendCustomPlanMutationBody = ExtendRequest
    export type ExtendCustomPlanMutationError = HTTPValidationError

    /**
 * @summary Extend Custom Plan
 */
export const useExtendCustomPlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendCustomPlan>>, TError,{data: ExtendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extendCustomPlan>>,
        TError,
        {data: ExtendRequest},
        TContext
      > => {
      return useMutation(getExtendCustomPlanMutationOptions(options), queryClient);
    }

export const getPauseCustomPlanUrl = () => {




  return `/api/admin/custom-plans/pause`
}

/**
 * Pause a custom plan — soft-locks the org.
 * @summary Pause Custom Plan
 */
export const pauseCustomPlan = async (pauseResumeRequest: PauseResumeRequest, options?: Parameters<typeof customInstance>[1]): Promise<PauseCustomPlan200> => {

  return customInstance<PauseCustomPlan200>(getPauseCustomPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pauseResumeRequest)
  }
);}





export const getPauseCustomPlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseCustomPlan>>, TError,{data: PauseResumeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseCustomPlan>>, TError,{data: PauseResumeRequest}, TContext> => {

const mutationKey = ['pauseCustomPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseCustomPlan>>, {data: PauseResumeRequest}> = (props) => {
          const {data} = props ?? {};

          return  pauseCustomPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseCustomPlanMutationResult = NonNullable<Awaited<ReturnType<typeof pauseCustomPlan>>>
    export type PauseCustomPlanMutationBody = PauseResumeRequest
    export type PauseCustomPlanMutationError = HTTPValidationError

    /**
 * @summary Pause Custom Plan
 */
export const usePauseCustomPlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseCustomPlan>>, TError,{data: PauseResumeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pauseCustomPlan>>,
        TError,
        {data: PauseResumeRequest},
        TContext
      > => {
      return useMutation(getPauseCustomPlanMutationOptions(options), queryClient);
    }

export const getResumeCustomPlanUrl = () => {




  return `/api/admin/custom-plans/resume`
}

/**
 * Resume a paused custom plan — clears the soft lock.
 * @summary Resume Custom Plan
 */
export const resumeCustomPlan = async (pauseResumeRequest: PauseResumeRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResumeCustomPlan200> => {

  return customInstance<ResumeCustomPlan200>(getResumeCustomPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pauseResumeRequest)
  }
);}





export const getResumeCustomPlanMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomPlan>>, TError,{data: PauseResumeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeCustomPlan>>, TError,{data: PauseResumeRequest}, TContext> => {

const mutationKey = ['resumeCustomPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeCustomPlan>>, {data: PauseResumeRequest}> = (props) => {
          const {data} = props ?? {};

          return  resumeCustomPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeCustomPlanMutationResult = NonNullable<Awaited<ReturnType<typeof resumeCustomPlan>>>
    export type ResumeCustomPlanMutationBody = PauseResumeRequest
    export type ResumeCustomPlanMutationError = HTTPValidationError

    /**
 * @summary Resume Custom Plan
 */
export const useResumeCustomPlan = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomPlan>>, TError,{data: PauseResumeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeCustomPlan>>,
        TError,
        {data: PauseResumeRequest},
        TContext
      > => {
      return useMutation(getResumeCustomPlanMutationOptions(options), queryClient);
    }

export const getAdminListTalentPoolsUrl = () => {




  return `/api/admin/talent-pools`
}

/**
 * Global pools with the orgs granted access.
 * @summary Admin List Talent Pools
 */
export const adminListTalentPools = async ( options?: Parameters<typeof customInstance>[1]): Promise<AdminTalentPoolListResponse> => {

  return customInstance<AdminTalentPoolListResponse>(getAdminListTalentPoolsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListTalentPoolsQueryKey = () => {
    return [
    `/api/admin/talent-pools`
    ] as const;
    }


export const getAdminListTalentPoolsQueryOptions = <TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListTalentPoolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTalentPools>>> = ({ signal }) => adminListTalentPools({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListTalentPoolsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTalentPools>>>
export type AdminListTalentPoolsQueryError = unknown


export function useAdminListTalentPools<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTalentPools>>,
          TError,
          Awaited<ReturnType<typeof adminListTalentPools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTalentPools<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTalentPools>>,
          TError,
          Awaited<ReturnType<typeof adminListTalentPools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTalentPools<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Admin List Talent Pools
 */

export function useAdminListTalentPools<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListTalentPoolsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminListTalentPoolsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListTalentPoolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTalentPools>>> = ({ signal }) => adminListTalentPools({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListTalentPoolsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTalentPools>>>
export type AdminListTalentPoolsSuspenseQueryError = unknown


export function useAdminListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Admin List Talent Pools
 */

export function useAdminListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof adminListTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminListTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListTalentPoolsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminCreateTalentPoolUrl = () => {




  return `/api/admin/talent-pools`
}

/**
 * Create an empty global pool; ingest fills the index behind ``index_alias``.
 * @summary Admin Create Talent Pool
 */
export const adminCreateTalentPool = async (adminTalentPoolCreateRequest: AdminTalentPoolCreateRequest, options?: Parameters<typeof customInstance>[1]): Promise<AdminTalentPoolResponse> => {

  return customInstance<AdminTalentPoolResponse>(getAdminCreateTalentPoolUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminTalentPoolCreateRequest)
  }
);}





export const getAdminCreateTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateTalentPool>>, TError,{data: AdminTalentPoolCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateTalentPool>>, TError,{data: AdminTalentPoolCreateRequest}, TContext> => {

const mutationKey = ['adminCreateTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateTalentPool>>, {data: AdminTalentPoolCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateTalentPool(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateTalentPool>>>
    export type AdminCreateTalentPoolMutationBody = AdminTalentPoolCreateRequest
    export type AdminCreateTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Admin Create Talent Pool
 */
export const useAdminCreateTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateTalentPool>>, TError,{data: AdminTalentPoolCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCreateTalentPool>>,
        TError,
        {data: AdminTalentPoolCreateRequest},
        TContext
      > => {
      return useMutation(getAdminCreateTalentPoolMutationOptions(options), queryClient);
    }

export const getAdminUpdateTalentPoolUrl = (poolId: string,) => {




  return `/api/admin/talent-pools/${poolId}`
}

/**
 * Rename, archive/reactivate, or set the filter categories a global pool can't serve.
 * @summary Admin Update Talent Pool
 */
export const adminUpdateTalentPool = async (poolId: string,
    adminTalentPoolUpdateRequest: AdminTalentPoolUpdateRequest, options?: Parameters<typeof customInstance>[1]): Promise<AdminTalentPoolResponse> => {

  return customInstance<AdminTalentPoolResponse>(getAdminUpdateTalentPoolUrl(poolId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminTalentPoolUpdateRequest)
  }
);}





export const getAdminUpdateTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateTalentPool>>, TError,{poolId: string;data: AdminTalentPoolUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateTalentPool>>, TError,{poolId: string;data: AdminTalentPoolUpdateRequest}, TContext> => {

const mutationKey = ['adminUpdateTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateTalentPool>>, {poolId: string;data: AdminTalentPoolUpdateRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  adminUpdateTalentPool(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateTalentPool>>>
    export type AdminUpdateTalentPoolMutationBody = AdminTalentPoolUpdateRequest
    export type AdminUpdateTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Admin Update Talent Pool
 */
export const useAdminUpdateTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateTalentPool>>, TError,{poolId: string;data: AdminTalentPoolUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateTalentPool>>,
        TError,
        {poolId: string;data: AdminTalentPoolUpdateRequest},
        TContext
      > => {
      return useMutation(getAdminUpdateTalentPoolMutationOptions(options), queryClient);
    }

export const getAdminGrantTalentPoolUrl = (poolId: string,) => {




  return `/api/admin/talent-pools/${poolId}/grants`
}

/**
 * Give an org access to a non-standard global pool (idempotent).
 * @summary Admin Grant Talent Pool
 */
export const adminGrantTalentPool = async (poolId: string,
    adminTalentPoolGrantRequest: AdminTalentPoolGrantRequest, options?: Parameters<typeof customInstance>[1]): Promise<AdminTalentPoolGrantResponse> => {

  return customInstance<AdminTalentPoolGrantResponse>(getAdminGrantTalentPoolUrl(poolId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminTalentPoolGrantRequest)
  }
);}





export const getAdminGrantTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGrantTalentPool>>, TError,{poolId: string;data: AdminTalentPoolGrantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGrantTalentPool>>, TError,{poolId: string;data: AdminTalentPoolGrantRequest}, TContext> => {

const mutationKey = ['adminGrantTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGrantTalentPool>>, {poolId: string;data: AdminTalentPoolGrantRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  adminGrantTalentPool(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGrantTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof adminGrantTalentPool>>>
    export type AdminGrantTalentPoolMutationBody = AdminTalentPoolGrantRequest
    export type AdminGrantTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Admin Grant Talent Pool
 */
export const useAdminGrantTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGrantTalentPool>>, TError,{poolId: string;data: AdminTalentPoolGrantRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGrantTalentPool>>,
        TError,
        {poolId: string;data: AdminTalentPoolGrantRequest},
        TContext
      > => {
      return useMutation(getAdminGrantTalentPoolMutationOptions(options), queryClient);
    }

export const getAdminRevokeTalentPoolGrantUrl = (poolId: string,
    orgId: string,) => {




  return `/api/admin/talent-pools/${poolId}/grants/${orgId}`
}

/**
 * @summary Admin Revoke Talent Pool Grant
 */
export const adminRevokeTalentPoolGrant = async (poolId: string,
    orgId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getAdminRevokeTalentPoolGrantUrl(poolId,orgId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminRevokeTalentPoolGrantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>, TError,{poolId: string;orgId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>, TError,{poolId: string;orgId: string}, TContext> => {

const mutationKey = ['adminRevokeTalentPoolGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>, {poolId: string;orgId: string}> = (props) => {
          const {poolId,orgId} = props ?? {};

          return  adminRevokeTalentPoolGrant(poolId,orgId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRevokeTalentPoolGrantMutationResult = NonNullable<Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>>

    export type AdminRevokeTalentPoolGrantMutationError = HTTPValidationError

    /**
 * @summary Admin Revoke Talent Pool Grant
 */
export const useAdminRevokeTalentPoolGrant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>, TError,{poolId: string;orgId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRevokeTalentPoolGrant>>,
        TError,
        {poolId: string;orgId: string},
        TContext
      > => {
      return useMutation(getAdminRevokeTalentPoolGrantMutationOptions(options), queryClient);
    }

export const getGetStuckQueuedUrl = (params?: GetStuckQueuedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/ats-sync/stuck-queued?${stringifiedParams}` : `/api/admin/ats-sync/stuck-queued`
}

/**
 * @summary Get Stuck Queued
 */
export const getStuckQueued = async (params?: GetStuckQueuedParams, options?: Parameters<typeof customInstance>[1]): Promise<GetStuckQueued200> => {

  return customInstance<GetStuckQueued200>(getGetStuckQueuedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStuckQueuedQueryKey = (params?: GetStuckQueuedParams,) => {
    return [
    `/api/admin/ats-sync/stuck-queued`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStuckQueuedQueryOptions = <TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(params?: GetStuckQueuedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStuckQueuedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStuckQueued>>> = ({ signal }) => getStuckQueued(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStuckQueuedQueryResult = NonNullable<Awaited<ReturnType<typeof getStuckQueued>>>
export type GetStuckQueuedQueryError = HTTPValidationError


export function useGetStuckQueued<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params: undefined |  GetStuckQueuedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStuckQueued>>,
          TError,
          Awaited<ReturnType<typeof getStuckQueued>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStuckQueued<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStuckQueued>>,
          TError,
          Awaited<ReturnType<typeof getStuckQueued>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStuckQueued<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Stuck Queued
 */

export function useGetStuckQueued<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStuckQueuedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetStuckQueuedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(params?: GetStuckQueuedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStuckQueuedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStuckQueued>>> = ({ signal }) => getStuckQueued(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStuckQueuedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStuckQueued>>>
export type GetStuckQueuedSuspenseQueryError = HTTPValidationError


export function useGetStuckQueuedSuspense<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params: undefined |  GetStuckQueuedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStuckQueuedSuspense<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStuckQueuedSuspense<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Stuck Queued
 */

export function useGetStuckQueuedSuspense<TData = Awaited<ReturnType<typeof getStuckQueued>>, TError = HTTPValidationError>(
 params?: GetStuckQueuedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStuckQueued>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStuckQueuedSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostResetUrl = (jobCandidateId: string,) => {




  return `/api/admin/ats-sync/stuck-queued/${jobCandidateId}/reset`
}

/**
 * @summary Post Reset
 */
export const postReset = async (jobCandidateId: string,
    adminIdentity: AdminIdentity, options?: Parameters<typeof customInstance>[1]): Promise<PostReset200> => {

  return customInstance<PostReset200>(getPostResetUrl(jobCandidateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminIdentity)
  }
);}





export const getPostResetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReset>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postReset>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext> => {

const mutationKey = ['postReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postReset>>, {jobCandidateId: string;data: AdminIdentity}> = (props) => {
          const {jobCandidateId,data} = props ?? {};

          return  postReset(jobCandidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostResetMutationResult = NonNullable<Awaited<ReturnType<typeof postReset>>>
    export type PostResetMutationBody = AdminIdentity
    export type PostResetMutationError = HTTPValidationError

    /**
 * @summary Post Reset
 */
export const usePostReset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReset>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postReset>>,
        TError,
        {jobCandidateId: string;data: AdminIdentity},
        TContext
      > => {
      return useMutation(getPostResetMutationOptions(options), queryClient);
    }

export const getPostRetryUrl = (jobCandidateId: string,) => {




  return `/api/admin/ats-sync/stuck-queued/${jobCandidateId}/retry`
}

/**
 * @summary Post Retry
 */
export const postRetry = async (jobCandidateId: string,
    retryRequest: RetryRequest, options?: Parameters<typeof customInstance>[1]): Promise<PostRetry200> => {

  return customInstance<PostRetry200>(getPostRetryUrl(jobCandidateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retryRequest)
  }
);}





export const getPostRetryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRetry>>, TError,{jobCandidateId: string;data: RetryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postRetry>>, TError,{jobCandidateId: string;data: RetryRequest}, TContext> => {

const mutationKey = ['postRetry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRetry>>, {jobCandidateId: string;data: RetryRequest}> = (props) => {
          const {jobCandidateId,data} = props ?? {};

          return  postRetry(jobCandidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostRetryMutationResult = NonNullable<Awaited<ReturnType<typeof postRetry>>>
    export type PostRetryMutationBody = RetryRequest
    export type PostRetryMutationError = HTTPValidationError

    /**
 * @summary Post Retry
 */
export const usePostRetry = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRetry>>, TError,{jobCandidateId: string;data: RetryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postRetry>>,
        TError,
        {jobCandidateId: string;data: RetryRequest},
        TContext
      > => {
      return useMutation(getPostRetryMutationOptions(options), queryClient);
    }

export const getPostHealUrl = (jobCandidateId: string,) => {




  return `/api/admin/ats-sync/stuck-queued/${jobCandidateId}/heal`
}

/**
 * @summary Post Heal
 */
export const postHeal = async (jobCandidateId: string,
    adminIdentity: AdminIdentity, options?: Parameters<typeof customInstance>[1]): Promise<PostHeal200> => {

  return customInstance<PostHeal200>(getPostHealUrl(jobCandidateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminIdentity)
  }
);}





export const getPostHealMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHeal>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postHeal>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext> => {

const mutationKey = ['postHeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHeal>>, {jobCandidateId: string;data: AdminIdentity}> = (props) => {
          const {jobCandidateId,data} = props ?? {};

          return  postHeal(jobCandidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostHealMutationResult = NonNullable<Awaited<ReturnType<typeof postHeal>>>
    export type PostHealMutationBody = AdminIdentity
    export type PostHealMutationError = HTTPValidationError

    /**
 * @summary Post Heal
 */
export const usePostHeal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHeal>>, TError,{jobCandidateId: string;data: AdminIdentity}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postHeal>>,
        TError,
        {jobCandidateId: string;data: AdminIdentity},
        TContext
      > => {
      return useMutation(getPostHealMutationOptions(options), queryClient);
    }

export const getGetOnboardingStatusUrl = () => {




  return `/api/onboarding/status`
}

/**
 * @summary Get Onboarding Status
 */
export const getOnboardingStatus = async ( options?: Parameters<typeof customInstance>[1]): Promise<OnboardingStatusResponse> => {

  return customInstance<OnboardingStatusResponse>(getGetOnboardingStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOnboardingStatusQueryKey = () => {
    return [
    `/api/onboarding/status`
    ] as const;
    }


export const getGetOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingStatus>>> = ({ signal }) => getOnboardingStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingStatus>>>
export type GetOnboardingStatusQueryError = unknown


export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Onboarding Status
 */

export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOnboardingStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingStatus>>> = ({ signal }) => getOnboardingStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingStatus>>>
export type GetOnboardingStatusSuspenseQueryError = unknown


export function useGetOnboardingStatusSuspense<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatusSuspense<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatusSuspense<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Onboarding Status
 */

export function useGetOnboardingStatusSuspense<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnrichOrgUrl = () => {




  return `/api/onboarding/enrich-org`
}

/**
 * @summary Enrich Org
 */
export const enrichOrg = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgEnrichmentResponse> => {

  return customInstance<OrgEnrichmentResponse>(getEnrichOrgUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEnrichOrgQueryKey = () => {
    return [
    `/api/onboarding/enrich-org`
    ] as const;
    }


export const getEnrichOrgQueryOptions = <TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEnrichOrgQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof enrichOrg>>> = ({ signal }) => enrichOrg({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EnrichOrgQueryResult = NonNullable<Awaited<ReturnType<typeof enrichOrg>>>
export type EnrichOrgQueryError = unknown


export function useEnrichOrg<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof enrichOrg>>,
          TError,
          Awaited<ReturnType<typeof enrichOrg>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEnrichOrg<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof enrichOrg>>,
          TError,
          Awaited<ReturnType<typeof enrichOrg>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEnrichOrg<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrich Org
 */

export function useEnrichOrg<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEnrichOrgQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEnrichOrgSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEnrichOrgQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof enrichOrg>>> = ({ signal }) => enrichOrg({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EnrichOrgSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof enrichOrg>>>
export type EnrichOrgSuspenseQueryError = unknown


export function useEnrichOrgSuspense<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEnrichOrgSuspense<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEnrichOrgSuspense<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrich Org
 */

export function useEnrichOrgSuspense<TData = Awaited<ReturnType<typeof enrichOrg>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof enrichOrg>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEnrichOrgSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveStep1Url = () => {




  return `/api/onboarding/step/1`
}

/**
 * @summary Save Step 1
 */
export const saveStep1 = async (step1Data: Step1Data, options?: Parameters<typeof customInstance>[1]): Promise<OnboardingStepResponse> => {

  return customInstance<OnboardingStepResponse>(getSaveStep1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(step1Data)
  }
);}





export const getSaveStep1MutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep1>>, TError,{data: Step1Data}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveStep1>>, TError,{data: Step1Data}, TContext> => {

const mutationKey = ['saveStep1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStep1>>, {data: Step1Data}> = (props) => {
          const {data} = props ?? {};

          return  saveStep1(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveStep1MutationResult = NonNullable<Awaited<ReturnType<typeof saveStep1>>>
    export type SaveStep1MutationBody = Step1Data
    export type SaveStep1MutationError = HTTPValidationError

    /**
 * @summary Save Step 1
 */
export const useSaveStep1 = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep1>>, TError,{data: Step1Data}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveStep1>>,
        TError,
        {data: Step1Data},
        TContext
      > => {
      return useMutation(getSaveStep1MutationOptions(options), queryClient);
    }

export const getSaveStep2Url = () => {




  return `/api/onboarding/step/2`
}

/**
 * @summary Save Step 2
 */
export const saveStep2 = async (step2Data: Step2Data, options?: Parameters<typeof customInstance>[1]): Promise<OnboardingStepResponse> => {

  return customInstance<OnboardingStepResponse>(getSaveStep2Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(step2Data)
  }
);}





export const getSaveStep2MutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep2>>, TError,{data: Step2Data}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveStep2>>, TError,{data: Step2Data}, TContext> => {

const mutationKey = ['saveStep2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStep2>>, {data: Step2Data}> = (props) => {
          const {data} = props ?? {};

          return  saveStep2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveStep2MutationResult = NonNullable<Awaited<ReturnType<typeof saveStep2>>>
    export type SaveStep2MutationBody = Step2Data
    export type SaveStep2MutationError = HTTPValidationError

    /**
 * @summary Save Step 2
 */
export const useSaveStep2 = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep2>>, TError,{data: Step2Data}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveStep2>>,
        TError,
        {data: Step2Data},
        TContext
      > => {
      return useMutation(getSaveStep2MutationOptions(options), queryClient);
    }

export const getSaveStep3Url = () => {




  return `/api/onboarding/step/3`
}

/**
 * @summary Save Step 3
 */
export const saveStep3 = async (bodySaveStep3ApiOnboardingStep3Post: BodySaveStep3ApiOnboardingStep3Post, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {
    const formData = new FormData();
formData.append(`title`, bodySaveStep3ApiOnboardingStep3Post.title);
if(bodySaveStep3ApiOnboardingStep3Post.description !== undefined && bodySaveStep3ApiOnboardingStep3Post.description !== null) {
 formData.append(`description`, bodySaveStep3ApiOnboardingStep3Post.description);
 }
if(bodySaveStep3ApiOnboardingStep3Post.access_level !== undefined) {
 formData.append(`access_level`, bodySaveStep3ApiOnboardingStep3Post.access_level);
 }
if(bodySaveStep3ApiOnboardingStep3Post.collaborator_ids !== undefined) {
 bodySaveStep3ApiOnboardingStep3Post.collaborator_ids.forEach(value => formData.append(`collaborator_ids`, value));
 }
if(bodySaveStep3ApiOnboardingStep3Post.job_title !== undefined && bodySaveStep3ApiOnboardingStep3Post.job_title !== null) {
 formData.append(`job_title`, bodySaveStep3ApiOnboardingStep3Post.job_title);
 }
if(bodySaveStep3ApiOnboardingStep3Post.cover !== undefined && bodySaveStep3ApiOnboardingStep3Post.cover !== null) {
 formData.append(`cover`, bodySaveStep3ApiOnboardingStep3Post.cover);
 }

  return customInstance<ProjectResponse>(getSaveStep3Url(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getSaveStep3MutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep3>>, TError,{data: BodySaveStep3ApiOnboardingStep3Post}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveStep3>>, TError,{data: BodySaveStep3ApiOnboardingStep3Post}, TContext> => {

const mutationKey = ['saveStep3'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStep3>>, {data: BodySaveStep3ApiOnboardingStep3Post}> = (props) => {
          const {data} = props ?? {};

          return  saveStep3(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveStep3MutationResult = NonNullable<Awaited<ReturnType<typeof saveStep3>>>
    export type SaveStep3MutationBody = BodySaveStep3ApiOnboardingStep3Post
    export type SaveStep3MutationError = HTTPValidationError

    /**
 * @summary Save Step 3
 */
export const useSaveStep3 = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep3>>, TError,{data: BodySaveStep3ApiOnboardingStep3Post}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveStep3>>,
        TError,
        {data: BodySaveStep3ApiOnboardingStep3Post},
        TContext
      > => {
      return useMutation(getSaveStep3MutationOptions(options), queryClient);
    }

export const getSaveStep4Url = () => {




  return `/api/onboarding/step/4`
}

/**
 * @summary Save Step 4
 */
export const saveStep4 = async (step4Data: Step4Data, options?: Parameters<typeof customInstance>[1]): Promise<OnboardingStepResponse> => {

  return customInstance<OnboardingStepResponse>(getSaveStep4Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(step4Data)
  }
);}





export const getSaveStep4MutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep4>>, TError,{data: Step4Data}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveStep4>>, TError,{data: Step4Data}, TContext> => {

const mutationKey = ['saveStep4'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStep4>>, {data: Step4Data}> = (props) => {
          const {data} = props ?? {};

          return  saveStep4(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveStep4MutationResult = NonNullable<Awaited<ReturnType<typeof saveStep4>>>
    export type SaveStep4MutationBody = Step4Data
    export type SaveStep4MutationError = HTTPValidationError

    /**
 * @summary Save Step 4
 */
export const useSaveStep4 = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep4>>, TError,{data: Step4Data}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveStep4>>,
        TError,
        {data: Step4Data},
        TContext
      > => {
      return useMutation(getSaveStep4MutationOptions(options), queryClient);
    }

export const getSaveStep5Url = () => {




  return `/api/onboarding/step/5`
}

/**
 * @summary Save Step 5
 */
export const saveStep5 = async ( options?: Parameters<typeof customInstance>[1]): Promise<OnboardingStepResponse> => {

  return customInstance<OnboardingStepResponse>(getSaveStep5Url(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSaveStep5MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep5>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveStep5>>, TError,void, TContext> => {

const mutationKey = ['saveStep5'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStep5>>, void> = () => {


          return  saveStep5(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveStep5MutationResult = NonNullable<Awaited<ReturnType<typeof saveStep5>>>

    export type SaveStep5MutationError = unknown

    /**
 * @summary Save Step 5
 */
export const useSaveStep5 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStep5>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveStep5>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSaveStep5MutationOptions(options), queryClient);
    }

export const getGetOnboardingEmployerEnrichmentUrl = () => {




  return `/api/onboarding/employer/enrich`
}

/**
 * @summary Enrich Employer Profile
 */
export const getOnboardingEmployerEnrichment = async ( options?: Parameters<typeof customInstance>[1]): Promise<EmployerEnrichmentResponse> => {

  return customInstance<EmployerEnrichmentResponse>(getGetOnboardingEmployerEnrichmentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOnboardingEmployerEnrichmentQueryKey = () => {
    return [
    `/api/onboarding/employer/enrich`
    ] as const;
    }


export const getGetOnboardingEmployerEnrichmentQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployerEnrichmentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>> = ({ signal }) => getOnboardingEmployerEnrichment({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployerEnrichmentQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>>
export type GetOnboardingEmployerEnrichmentQueryError = unknown


export function useGetOnboardingEmployerEnrichment<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployerEnrichment<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployerEnrichment<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrich Employer Profile
 */

export function useGetOnboardingEmployerEnrichment<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployerEnrichmentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOnboardingEmployerEnrichmentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployerEnrichmentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>> = ({ signal }) => getOnboardingEmployerEnrichment({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployerEnrichmentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>>
export type GetOnboardingEmployerEnrichmentSuspenseQueryError = unknown


export function useGetOnboardingEmployerEnrichmentSuspense<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployerEnrichmentSuspense<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployerEnrichmentSuspense<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrich Employer Profile
 */

export function useGetOnboardingEmployerEnrichmentSuspense<TData = Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployerEnrichment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployerEnrichmentSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDefaultEmployerUrl = () => {




  return `/api/onboarding/employer`
}

/**
 * @summary Create Default Employer
 */
export const createDefaultEmployer = async (employerProfileCreate: EmployerProfileCreate, options?: Parameters<typeof customInstance>[1]): Promise<EmployerProfileResponse> => {

  return customInstance<EmployerProfileResponse>(getCreateDefaultEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(employerProfileCreate)
  }
);}





export const getCreateDefaultEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDefaultEmployer>>, TError,{data: EmployerProfileCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDefaultEmployer>>, TError,{data: EmployerProfileCreate}, TContext> => {

const mutationKey = ['createDefaultEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDefaultEmployer>>, {data: EmployerProfileCreate}> = (props) => {
          const {data} = props ?? {};

          return  createDefaultEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDefaultEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createDefaultEmployer>>>
    export type CreateDefaultEmployerMutationBody = EmployerProfileCreate
    export type CreateDefaultEmployerMutationError = HTTPValidationError

    /**
 * @summary Create Default Employer
 */
export const useCreateDefaultEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDefaultEmployer>>, TError,{data: EmployerProfileCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDefaultEmployer>>,
        TError,
        {data: EmployerProfileCreate},
        TContext
      > => {
      return useMutation(getCreateDefaultEmployerMutationOptions(options), queryClient);
    }

export const getCompleteOnboardingUrl = () => {




  return `/api/onboarding/complete`
}

/**
 * @summary Complete Onboarding
 */
export const completeOnboarding = async ( options?: Parameters<typeof customInstance>[1]): Promise<OnboardingCompleteResponse> => {

  return customInstance<OnboardingCompleteResponse>(getCompleteOnboardingUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,void, TContext> => {

const mutationKey = ['completeOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOnboarding>>, void> = () => {


          return  completeOnboarding(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof completeOnboarding>>>

    export type CompleteOnboardingMutationError = unknown

    /**
 * @summary Complete Onboarding
 */
export const useCompleteOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompleteOnboardingMutationOptions(options), queryClient);
    }

export const getUpdateProfileUrl = () => {




  return `/api/settings/profile`
}

/**
 * @summary Update Profile
 */
export const updateProfile = async (profileUpdateRequest: ProfileUpdateRequest, options?: Parameters<typeof customInstance>[1]): Promise<ProfileUpdateResponse> => {

  return customInstance<ProfileUpdateResponse>(getUpdateProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileUpdateRequest)
  }
);}





export const getUpdateProfileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: ProfileUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: ProfileUpdateRequest}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: ProfileUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = ProfileUpdateRequest
    export type UpdateProfileMutationError = HTTPValidationError

    /**
 * @summary Update Profile
 */
export const useUpdateProfile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: ProfileUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: ProfileUpdateRequest},
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }

export const getChangePasswordUrl = () => {




  return `/api/settings/password`
}

/**
 * @summary Change Password
 */
export const changePassword = async (passwordChangeRequest: PasswordChangeRequest, options?: Parameters<typeof customInstance>[1]): Promise<ChangePassword200> => {

  return customInstance<ChangePassword200>(getChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(passwordChangeRequest)
  }
);}





export const getChangePasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: PasswordChangeRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = PasswordChangeRequest
    export type ChangePasswordMutationError = HTTPValidationError

    /**
 * @summary Change Password
 */
export const useChangePassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: PasswordChangeRequest},
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }

export const getMfaEnrollUrl = () => {




  return `/api/settings/mfa/enroll`
}

/**
 * @summary Mfa Enroll
 */
export const mfaEnroll = async ( options?: Parameters<typeof customInstance>[1]): Promise<MFAEnrollResponse> => {

  return customInstance<MFAEnrollResponse>(getMfaEnrollUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMfaEnrollMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaEnroll>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mfaEnroll>>, TError,void, TContext> => {

const mutationKey = ['mfaEnroll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mfaEnroll>>, void> = () => {


          return  mfaEnroll(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MfaEnrollMutationResult = NonNullable<Awaited<ReturnType<typeof mfaEnroll>>>

    export type MfaEnrollMutationError = unknown

    /**
 * @summary Mfa Enroll
 */
export const useMfaEnroll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaEnroll>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mfaEnroll>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMfaEnrollMutationOptions(options), queryClient);
    }

export const getMfaVerifyUrl = () => {




  return `/api/settings/mfa/verify`
}

/**
 * @summary Mfa Verify
 */
export const mfaVerify = async (appApiRoutesSettingsMFAVerifyRequest: AppApiRoutesSettingsMFAVerifyRequest, options?: Parameters<typeof customInstance>[1]): Promise<MfaVerify200> => {

  return customInstance<MfaVerify200>(getMfaVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(appApiRoutesSettingsMFAVerifyRequest)
  }
);}





export const getMfaVerifyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaVerify>>, TError,{data: AppApiRoutesSettingsMFAVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mfaVerify>>, TError,{data: AppApiRoutesSettingsMFAVerifyRequest}, TContext> => {

const mutationKey = ['mfaVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mfaVerify>>, {data: AppApiRoutesSettingsMFAVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  mfaVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MfaVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof mfaVerify>>>
    export type MfaVerifyMutationBody = AppApiRoutesSettingsMFAVerifyRequest
    export type MfaVerifyMutationError = HTTPValidationError

    /**
 * @summary Mfa Verify
 */
export const useMfaVerify = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaVerify>>, TError,{data: AppApiRoutesSettingsMFAVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mfaVerify>>,
        TError,
        {data: AppApiRoutesSettingsMFAVerifyRequest},
        TContext
      > => {
      return useMutation(getMfaVerifyMutationOptions(options), queryClient);
    }

export const getMfaListFactorsUrl = () => {




  return `/api/settings/mfa/factors`
}

/**
 * @summary Mfa List Factors
 */
export const mfaListFactors = async ( options?: Parameters<typeof customInstance>[1]): Promise<MFAFactorsResponse> => {

  return customInstance<MFAFactorsResponse>(getMfaListFactorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMfaListFactorsQueryKey = () => {
    return [
    `/api/settings/mfa/factors`
    ] as const;
    }


export const getMfaListFactorsQueryOptions = <TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMfaListFactorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mfaListFactors>>> = ({ signal }) => mfaListFactors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MfaListFactorsQueryResult = NonNullable<Awaited<ReturnType<typeof mfaListFactors>>>
export type MfaListFactorsQueryError = unknown


export function useMfaListFactors<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mfaListFactors>>,
          TError,
          Awaited<ReturnType<typeof mfaListFactors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMfaListFactors<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mfaListFactors>>,
          TError,
          Awaited<ReturnType<typeof mfaListFactors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMfaListFactors<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mfa List Factors
 */

export function useMfaListFactors<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMfaListFactorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMfaListFactorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMfaListFactorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mfaListFactors>>> = ({ signal }) => mfaListFactors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MfaListFactorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof mfaListFactors>>>
export type MfaListFactorsSuspenseQueryError = unknown


export function useMfaListFactorsSuspense<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMfaListFactorsSuspense<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMfaListFactorsSuspense<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mfa List Factors
 */

export function useMfaListFactorsSuspense<TData = Awaited<ReturnType<typeof mfaListFactors>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mfaListFactors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMfaListFactorsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMfaDeleteFactorUrl = (factorId: string,) => {




  return `/api/settings/mfa/factors/${factorId}`
}

/**
 * @summary Mfa Delete Factor
 */
export const mfaDeleteFactor = async (factorId: string, options?: Parameters<typeof customInstance>[1]): Promise<MfaDeleteFactor200> => {

  return customInstance<MfaDeleteFactor200>(getMfaDeleteFactorUrl(factorId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMfaDeleteFactorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaDeleteFactor>>, TError,{factorId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mfaDeleteFactor>>, TError,{factorId: string}, TContext> => {

const mutationKey = ['mfaDeleteFactor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mfaDeleteFactor>>, {factorId: string}> = (props) => {
          const {factorId} = props ?? {};

          return  mfaDeleteFactor(factorId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MfaDeleteFactorMutationResult = NonNullable<Awaited<ReturnType<typeof mfaDeleteFactor>>>

    export type MfaDeleteFactorMutationError = HTTPValidationError

    /**
 * @summary Mfa Delete Factor
 */
export const useMfaDeleteFactor = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mfaDeleteFactor>>, TError,{factorId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mfaDeleteFactor>>,
        TError,
        {factorId: string},
        TContext
      > => {
      return useMutation(getMfaDeleteFactorMutationOptions(options), queryClient);
    }

export const getListSessionsUrl = () => {




  return `/api/settings/sessions`
}

/**
 * @summary List Sessions
 */
export const listSessions = async ( options?: Parameters<typeof customInstance>[1]): Promise<SessionsResponse> => {

  return customInstance<SessionsResponse>(getListSessionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSessionsQueryKey = () => {
    return [
    `/api/settings/sessions`
    ] as const;
    }


export const getListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) => listSessions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>
export type ListSessionsQueryError = unknown


export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sessions
 */

export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSessionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSessionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) => listSessions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSessionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>
export type ListSessionsSuspenseQueryError = unknown


export function useListSessionsSuspense<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessionsSuspense<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessionsSuspense<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sessions
 */

export function useListSessionsSuspense<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSessionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeSessionUrl = () => {




  return `/api/settings/sessions/revoke`
}

/**
 * @summary Revoke Session
 */
export const revokeSession = async (revokeSessionRequest: RevokeSessionRequest, options?: Parameters<typeof customInstance>[1]): Promise<SessionTerminationResponse> => {

  return customInstance<SessionTerminationResponse>(getRevokeSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revokeSessionRequest)
  }
);}





export const getRevokeSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{data: RevokeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{data: RevokeSessionRequest}, TContext> => {

const mutationKey = ['revokeSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeSession>>, {data: RevokeSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  revokeSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeSession>>>
    export type RevokeSessionMutationBody = RevokeSessionRequest
    export type RevokeSessionMutationError = HTTPValidationError

    /**
 * @summary Revoke Session
 */
export const useRevokeSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{data: RevokeSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeSession>>,
        TError,
        {data: RevokeSessionRequest},
        TContext
      > => {
      return useMutation(getRevokeSessionMutationOptions(options), queryClient);
    }

export const getRevokeOtherSessionsUrl = () => {




  return `/api/settings/sessions/revoke-others`
}

/**
 * @summary Revoke Other Sessions
 */
export const revokeOtherSessions = async ( options?: Parameters<typeof customInstance>[1]): Promise<MessageResponse> => {

  return customInstance<MessageResponse>(getRevokeOtherSessionsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeOtherSessionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOtherSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOtherSessions>>, TError,void, TContext> => {

const mutationKey = ['revokeOtherSessions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOtherSessions>>, void> = () => {


          return  revokeOtherSessions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOtherSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOtherSessions>>>

    export type RevokeOtherSessionsMutationError = unknown

    /**
 * @summary Revoke Other Sessions
 */
export const useRevokeOtherSessions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOtherSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeOtherSessions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeOtherSessionsMutationOptions(options), queryClient);
    }

export const getListScorecardLibraryUrl = (params?: ListScorecardLibraryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/settings/scorecard-library?${stringifiedParams}` : `/api/settings/scorecard-library`
}

/**
 * @summary List Scorecard Library
 */
export const listScorecardLibrary = async (params?: ListScorecardLibraryParams, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut[]> => {

  return customInstance<ScorecardDefinitionOut[]>(getListScorecardLibraryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScorecardLibraryQueryKey = (params?: ListScorecardLibraryParams,) => {
    return [
    `/api/settings/scorecard-library`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScorecardLibraryQueryOptions = <TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(params?: ListScorecardLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScorecardLibraryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScorecardLibrary>>> = ({ signal }) => listScorecardLibrary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScorecardLibraryQueryResult = NonNullable<Awaited<ReturnType<typeof listScorecardLibrary>>>
export type ListScorecardLibraryQueryError = HTTPValidationError


export function useListScorecardLibrary<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params: undefined |  ListScorecardLibraryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScorecardLibrary>>,
          TError,
          Awaited<ReturnType<typeof listScorecardLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardLibrary<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScorecardLibrary>>,
          TError,
          Awaited<ReturnType<typeof listScorecardLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardLibrary<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Scorecard Library
 */

export function useListScorecardLibrary<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScorecardLibraryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListScorecardLibrarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(params?: ListScorecardLibraryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScorecardLibraryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScorecardLibrary>>> = ({ signal }) => listScorecardLibrary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScorecardLibrarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listScorecardLibrary>>>
export type ListScorecardLibrarySuspenseQueryError = HTTPValidationError


export function useListScorecardLibrarySuspense<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params: undefined |  ListScorecardLibraryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardLibrarySuspense<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardLibrarySuspense<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Scorecard Library
 */

export function useListScorecardLibrarySuspense<TData = Awaited<ReturnType<typeof listScorecardLibrary>>, TError = HTTPValidationError>(
 params?: ListScorecardLibraryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScorecardLibrarySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScorecardLibraryDefinitionUrl = () => {




  return `/api/settings/scorecard-library`
}

/**
 * @summary Create Scorecard Library Definition
 */
export const createScorecardLibraryDefinition = async (scorecardDefinitionCreate: ScorecardDefinitionCreate, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut> => {

  return customInstance<ScorecardDefinitionOut>(getCreateScorecardLibraryDefinitionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardDefinitionCreate)
  }
);}





export const getCreateScorecardLibraryDefinitionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScorecardLibraryDefinition>>, TError,{data: ScorecardDefinitionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createScorecardLibraryDefinition>>, TError,{data: ScorecardDefinitionCreate}, TContext> => {

const mutationKey = ['createScorecardLibraryDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScorecardLibraryDefinition>>, {data: ScorecardDefinitionCreate}> = (props) => {
          const {data} = props ?? {};

          return  createScorecardLibraryDefinition(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScorecardLibraryDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof createScorecardLibraryDefinition>>>
    export type CreateScorecardLibraryDefinitionMutationBody = ScorecardDefinitionCreate
    export type CreateScorecardLibraryDefinitionMutationError = HTTPValidationError

    /**
 * @summary Create Scorecard Library Definition
 */
export const useCreateScorecardLibraryDefinition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScorecardLibraryDefinition>>, TError,{data: ScorecardDefinitionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScorecardLibraryDefinition>>,
        TError,
        {data: ScorecardDefinitionCreate},
        TContext
      > => {
      return useMutation(getCreateScorecardLibraryDefinitionMutationOptions(options), queryClient);
    }

export const getUpdateScorecardLibraryDefinitionUrl = (definitionId: string,) => {




  return `/api/settings/scorecard-library/${definitionId}`
}

/**
 * @summary Update Scorecard Library Definition
 */
export const updateScorecardLibraryDefinition = async (definitionId: string,
    scorecardDefinitionPatch: ScorecardDefinitionPatch, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut> => {

  return customInstance<ScorecardDefinitionOut>(getUpdateScorecardLibraryDefinitionUrl(definitionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardDefinitionPatch)
  }
);}





export const getUpdateScorecardLibraryDefinitionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>, TError,{definitionId: string;data: ScorecardDefinitionPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>, TError,{definitionId: string;data: ScorecardDefinitionPatch}, TContext> => {

const mutationKey = ['updateScorecardLibraryDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>, {definitionId: string;data: ScorecardDefinitionPatch}> = (props) => {
          const {definitionId,data} = props ?? {};

          return  updateScorecardLibraryDefinition(definitionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScorecardLibraryDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>>
    export type UpdateScorecardLibraryDefinitionMutationBody = ScorecardDefinitionPatch
    export type UpdateScorecardLibraryDefinitionMutationError = HTTPValidationError

    /**
 * @summary Update Scorecard Library Definition
 */
export const useUpdateScorecardLibraryDefinition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>, TError,{definitionId: string;data: ScorecardDefinitionPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScorecardLibraryDefinition>>,
        TError,
        {definitionId: string;data: ScorecardDefinitionPatch},
        TContext
      > => {
      return useMutation(getUpdateScorecardLibraryDefinitionMutationOptions(options), queryClient);
    }

export const getReorderScorecardLibraryUrl = () => {




  return `/api/settings/scorecard-library/order`
}

/**
 * @summary Reorder Scorecard Library
 */
export const reorderScorecardLibrary = async (scorecardOrderUpdate: ScorecardOrderUpdate, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut[]> => {

  return customInstance<ScorecardDefinitionOut[]>(getReorderScorecardLibraryUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardOrderUpdate)
  }
);}





export const getReorderScorecardLibraryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderScorecardLibrary>>, TError,{data: ScorecardOrderUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderScorecardLibrary>>, TError,{data: ScorecardOrderUpdate}, TContext> => {

const mutationKey = ['reorderScorecardLibrary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderScorecardLibrary>>, {data: ScorecardOrderUpdate}> = (props) => {
          const {data} = props ?? {};

          return  reorderScorecardLibrary(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderScorecardLibraryMutationResult = NonNullable<Awaited<ReturnType<typeof reorderScorecardLibrary>>>
    export type ReorderScorecardLibraryMutationBody = ScorecardOrderUpdate
    export type ReorderScorecardLibraryMutationError = HTTPValidationError

    /**
 * @summary Reorder Scorecard Library
 */
export const useReorderScorecardLibrary = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderScorecardLibrary>>, TError,{data: ScorecardOrderUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderScorecardLibrary>>,
        TError,
        {data: ScorecardOrderUpdate},
        TContext
      > => {
      return useMutation(getReorderScorecardLibraryMutationOptions(options), queryClient);
    }

export const getListMyMembershipsUrl = () => {




  return `/api/org/memberships`
}

/**
 * @summary List My Memberships
 */
export const listMyMemberships = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgMembershipListResponse> => {

  return customInstance<OrgMembershipListResponse>(getListMyMembershipsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyMembershipsQueryKey = () => {
    return [
    `/api/org/memberships`
    ] as const;
    }


export const getListMyMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyMembershipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyMemberships>>> = ({ signal }) => listMyMemberships({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyMemberships>>>
export type ListMyMembershipsQueryError = unknown


export function useListMyMemberships<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyMemberships>>,
          TError,
          Awaited<ReturnType<typeof listMyMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyMemberships<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyMemberships>>,
          TError,
          Awaited<ReturnType<typeof listMyMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyMemberships<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List My Memberships
 */

export function useListMyMemberships<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyMembershipsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMyMembershipsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyMembershipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyMemberships>>> = ({ signal }) => listMyMemberships({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyMembershipsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMyMemberships>>>
export type ListMyMembershipsSuspenseQueryError = unknown


export function useListMyMembershipsSuspense<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyMembershipsSuspense<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyMembershipsSuspense<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List My Memberships
 */

export function useListMyMembershipsSuspense<TData = Awaited<ReturnType<typeof listMyMemberships>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMyMemberships>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyMembershipsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSwitchOrgContextUrl = () => {




  return `/api/org/switch`
}

/**
 * @summary Switch Org Context
 */
export const switchOrgContext = async (switchOrgRequest: SwitchOrgRequest, options?: Parameters<typeof customInstance>[1]): Promise<SwitchOrgResponse> => {

  return customInstance<SwitchOrgResponse>(getSwitchOrgContextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(switchOrgRequest)
  }
);}





export const getSwitchOrgContextMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchOrgContext>>, TError,{data: SwitchOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof switchOrgContext>>, TError,{data: SwitchOrgRequest}, TContext> => {

const mutationKey = ['switchOrgContext'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchOrgContext>>, {data: SwitchOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  switchOrgContext(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchOrgContextMutationResult = NonNullable<Awaited<ReturnType<typeof switchOrgContext>>>
    export type SwitchOrgContextMutationBody = SwitchOrgRequest
    export type SwitchOrgContextMutationError = HTTPValidationError

    /**
 * @summary Switch Org Context
 */
export const useSwitchOrgContext = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchOrgContext>>, TError,{data: SwitchOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchOrgContext>>,
        TError,
        {data: SwitchOrgRequest},
        TContext
      > => {
      return useMutation(getSwitchOrgContextMutationOptions(options), queryClient);
    }

export const getCreateOrganizationUrl = () => {




  return `/api/org/create`
}

/**
 * @summary Create Organization
 */
export const createOrganization = async (createOrgRequest: CreateOrgRequest, options?: Parameters<typeof customInstance>[1]): Promise<SwitchOrgResponse> => {

  return customInstance<SwitchOrgResponse>(getCreateOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrgRequest)
  }
);}





export const getCreateOrganizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrgRequest}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {data: CreateOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = CreateOrgRequest
    export type CreateOrganizationMutationError = HTTPValidationError

    /**
 * @summary Create Organization
 */
export const useCreateOrganization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {data: CreateOrgRequest},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
    }

export const getLeaveOrgPreflightUrl = () => {




  return `/api/org/leave/preflight`
}

/**
 * @summary Leave Org Preflight
 */
export const leaveOrgPreflight = async ( options?: Parameters<typeof customInstance>[1]): Promise<LeaveOrgPreflightResponse> => {

  return customInstance<LeaveOrgPreflightResponse>(getLeaveOrgPreflightUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLeaveOrgPreflightQueryKey = () => {
    return [
    `/api/org/leave/preflight`
    ] as const;
    }


export const getLeaveOrgPreflightQueryOptions = <TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLeaveOrgPreflightQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof leaveOrgPreflight>>> = ({ signal }) => leaveOrgPreflight({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LeaveOrgPreflightQueryResult = NonNullable<Awaited<ReturnType<typeof leaveOrgPreflight>>>
export type LeaveOrgPreflightQueryError = unknown


export function useLeaveOrgPreflight<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveOrgPreflight>>,
          TError,
          Awaited<ReturnType<typeof leaveOrgPreflight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaveOrgPreflight<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveOrgPreflight>>,
          TError,
          Awaited<ReturnType<typeof leaveOrgPreflight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaveOrgPreflight<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Leave Org Preflight
 */

export function useLeaveOrgPreflight<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLeaveOrgPreflightQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLeaveOrgPreflightSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLeaveOrgPreflightQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof leaveOrgPreflight>>> = ({ signal }) => leaveOrgPreflight({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LeaveOrgPreflightSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof leaveOrgPreflight>>>
export type LeaveOrgPreflightSuspenseQueryError = unknown


export function useLeaveOrgPreflightSuspense<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaveOrgPreflightSuspense<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaveOrgPreflightSuspense<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Leave Org Preflight
 */

export function useLeaveOrgPreflightSuspense<TData = Awaited<ReturnType<typeof leaveOrgPreflight>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof leaveOrgPreflight>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLeaveOrgPreflightSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLeaveOrganizationUrl = () => {




  return `/api/org/leave`
}

/**
 * @summary Leave Organization
 */
export const leaveOrganization = async (leaveOrgRequest: LeaveOrgRequest, options?: Parameters<typeof customInstance>[1]): Promise<LeaveOrgResponse> => {

  return customInstance<LeaveOrgResponse>(getLeaveOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(leaveOrgRequest)
  }
);}





export const getLeaveOrganizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveOrganization>>, TError,{data: LeaveOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveOrganization>>, TError,{data: LeaveOrgRequest}, TContext> => {

const mutationKey = ['leaveOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveOrganization>>, {data: LeaveOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  leaveOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof leaveOrganization>>>
    export type LeaveOrganizationMutationBody = LeaveOrgRequest
    export type LeaveOrganizationMutationError = HTTPValidationError

    /**
 * @summary Leave Organization
 */
export const useLeaveOrganization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveOrganization>>, TError,{data: LeaveOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leaveOrganization>>,
        TError,
        {data: LeaveOrgRequest},
        TContext
      > => {
      return useMutation(getLeaveOrganizationMutationOptions(options), queryClient);
    }

export const getListMembersUrl = (params?: ListMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/org/members?${stringifiedParams}` : `/api/org/members`
}

/**
 * @summary List Members
 */
export const listMembers = async (params?: ListMembersParams, options?: Parameters<typeof customInstance>[1]): Promise<MemberListResponse> => {

  return customInstance<MemberListResponse>(getListMembersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMembersQueryKey = (params?: ListMembersParams,) => {
    return [
    `/api/org/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(params?: ListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = HTTPValidationError


export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params: undefined |  ListMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Members
 */

export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMembersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMembersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(params?: ListMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMembersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersSuspenseQueryError = HTTPValidationError


export function useListMembersSuspense<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params: undefined |  ListMembersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembersSuspense<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembersSuspense<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Members
 */

export function useListMembersSuspense<TData = Awaited<ReturnType<typeof listMembers>>, TError = HTTPValidationError>(
 params?: ListMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMembersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMemberUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}`
}

/**
 * @summary Get Member
 */
export const getMember = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<MemberDetailResponse> => {

  return customInstance<MemberDetailResponse>(getGetMemberUrl(memberId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMemberQueryKey = (memberId: string,) => {
    return [
    `/api/org/members/${memberId}`
    ] as const;
    }


export const getGetMemberQueryOptions = <TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberQueryKey(memberId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMember>>> = ({ signal }) => getMember(memberId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: memberId !== null && memberId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberQueryResult = NonNullable<Awaited<ReturnType<typeof getMember>>>
export type GetMemberQueryError = HTTPValidationError


export function useGetMember<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMember>>,
          TError,
          Awaited<ReturnType<typeof getMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMember<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMember>>,
          TError,
          Awaited<ReturnType<typeof getMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMember<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Member
 */

export function useGetMember<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberQueryOptions(memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMemberSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberQueryKey(memberId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMember>>> = ({ signal }) => getMember(memberId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMember>>>
export type GetMemberSuspenseQueryError = HTTPValidationError


export function useGetMemberSuspense<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberSuspense<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberSuspense<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Member
 */

export function useGetMemberSuspense<TData = Awaited<ReturnType<typeof getMember>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberSuspenseQueryOptions(memberId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMemberRoleUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}/role`
}

/**
 * @summary Update Member Role
 */
export const updateMemberRole = async (memberId: string,
    updateMemberRoleRequest: UpdateMemberRoleRequest, options?: Parameters<typeof customInstance>[1]): Promise<UserResponse> => {

  return customInstance<UserResponse>(getUpdateMemberRoleUrl(memberId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMemberRoleRequest)
  }
);}





export const getUpdateMemberRoleMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{memberId: string;data: UpdateMemberRoleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{memberId: string;data: UpdateMemberRoleRequest}, TContext> => {

const mutationKey = ['updateMemberRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberRole>>, {memberId: string;data: UpdateMemberRoleRequest}> = (props) => {
          const {memberId,data} = props ?? {};

          return  updateMemberRole(memberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberRole>>>
    export type UpdateMemberRoleMutationBody = UpdateMemberRoleRequest
    export type UpdateMemberRoleMutationError = HTTPValidationError

    /**
 * @summary Update Member Role
 */
export const useUpdateMemberRole = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{memberId: string;data: UpdateMemberRoleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberRole>>,
        TError,
        {memberId: string;data: UpdateMemberRoleRequest},
        TContext
      > => {
      return useMutation(getUpdateMemberRoleMutationOptions(options), queryClient);
    }

export const getSuspendMemberUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}/suspend`
}

/**
 * @summary Suspend Member
 */
export const suspendMember = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<SuspendMember200> => {

  return customInstance<SuspendMember200>(getSuspendMemberUrl(memberId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSuspendMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspendMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suspendMember>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['suspendMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suspendMember>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  suspendMember(memberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuspendMemberMutationResult = NonNullable<Awaited<ReturnType<typeof suspendMember>>>

    export type SuspendMemberMutationError = HTTPValidationError

    /**
 * @summary Suspend Member
 */
export const useSuspendMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspendMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suspendMember>>,
        TError,
        {memberId: string},
        TContext
      > => {
      return useMutation(getSuspendMemberMutationOptions(options), queryClient);
    }

export const getReactivateMemberUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}/reactivate`
}

/**
 * @summary Reactivate Member
 */
export const reactivateMember = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<UserResponse> => {

  return customInstance<UserResponse>(getReactivateMemberUrl(memberId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReactivateMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateMember>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['reactivateMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateMember>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  reactivateMember(memberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateMember>>>

    export type ReactivateMemberMutationError = HTTPValidationError

    /**
 * @summary Reactivate Member
 */
export const useReactivateMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateMember>>,
        TError,
        {memberId: string},
        TContext
      > => {
      return useMutation(getReactivateMemberMutationOptions(options), queryClient);
    }

export const getUpdateMemberProfileUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}/profile`
}

/**
 * @summary Update Member Profile
 */
export const updateMemberProfile = async (memberId: string,
    updateMemberProfileRequest: UpdateMemberProfileRequest, options?: Parameters<typeof customInstance>[1]): Promise<UserResponse> => {

  return customInstance<UserResponse>(getUpdateMemberProfileUrl(memberId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMemberProfileRequest)
  }
);}





export const getUpdateMemberProfileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberProfile>>, TError,{memberId: string;data: UpdateMemberProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberProfile>>, TError,{memberId: string;data: UpdateMemberProfileRequest}, TContext> => {

const mutationKey = ['updateMemberProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberProfile>>, {memberId: string;data: UpdateMemberProfileRequest}> = (props) => {
          const {memberId,data} = props ?? {};

          return  updateMemberProfile(memberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberProfile>>>
    export type UpdateMemberProfileMutationBody = UpdateMemberProfileRequest
    export type UpdateMemberProfileMutationError = HTTPValidationError

    /**
 * @summary Update Member Profile
 */
export const useUpdateMemberProfile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberProfile>>, TError,{memberId: string;data: UpdateMemberProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberProfile>>,
        TError,
        {memberId: string;data: UpdateMemberProfileRequest},
        TContext
      > => {
      return useMutation(getUpdateMemberProfileMutationOptions(options), queryClient);
    }

export const getListOrgSessionsUrl = (params?: ListOrgSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/org/sessions?${stringifiedParams}` : `/api/org/sessions`
}

/**
 * List all active sessions across the organization, grouped by user.
 * @summary List Org Sessions
 */
export const listOrgSessions = async (params?: ListOrgSessionsParams, options?: Parameters<typeof customInstance>[1]): Promise<OrgSessionsResponse> => {

  return customInstance<OrgSessionsResponse>(getListOrgSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrgSessionsQueryKey = (params?: ListOrgSessionsParams,) => {
    return [
    `/api/org/sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(params?: ListOrgSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgSessions>>> = ({ signal }) => listOrgSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgSessions>>>
export type ListOrgSessionsQueryError = HTTPValidationError


export function useListOrgSessions<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params: undefined |  ListOrgSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgSessions>>,
          TError,
          Awaited<ReturnType<typeof listOrgSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgSessions<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgSessions>>,
          TError,
          Awaited<ReturnType<typeof listOrgSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgSessions<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Sessions
 */

export function useListOrgSessions<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOrgSessionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(params?: ListOrgSessionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgSessions>>> = ({ signal }) => listOrgSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgSessionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgSessions>>>
export type ListOrgSessionsSuspenseQueryError = HTTPValidationError


export function useListOrgSessionsSuspense<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params: undefined |  ListOrgSessionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgSessionsSuspense<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgSessionsSuspense<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Sessions
 */

export function useListOrgSessionsSuspense<TData = Awaited<ReturnType<typeof listOrgSessions>>, TError = HTTPValidationError>(
 params?: ListOrgSessionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgSessionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeAllOrgSessionsUrl = () => {




  return `/api/org/sessions/revoke-all`
}

/**
 * Revoke all sessions for every member in the organization.
 * @summary Revoke All Org Sessions
 */
export const revokeAllOrgSessions = async ( options?: Parameters<typeof customInstance>[1]): Promise<RevokeAllOrgSessions200> => {

  return customInstance<RevokeAllOrgSessions200>(getRevokeAllOrgSessionsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeAllOrgSessionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllOrgSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeAllOrgSessions>>, TError,void, TContext> => {

const mutationKey = ['revokeAllOrgSessions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAllOrgSessions>>, void> = () => {


          return  revokeAllOrgSessions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAllOrgSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAllOrgSessions>>>

    export type RevokeAllOrgSessionsMutationError = unknown

    /**
 * @summary Revoke All Org Sessions
 */
export const useRevokeAllOrgSessions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllOrgSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeAllOrgSessions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeAllOrgSessionsMutationOptions(options), queryClient);
    }

export const getListMemberSessionsUrl = (memberId: string,) => {




  return `/api/org/members/${memberId}/sessions`
}

/**
 * @summary List Member Sessions
 */
export const listMemberSessions = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<SessionListResponse> => {

  return customInstance<SessionListResponse>(getListMemberSessionsUrl(memberId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMemberSessionsQueryKey = (memberId: string,) => {
    return [
    `/api/org/members/${memberId}/sessions`
    ] as const;
    }


export const getListMemberSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMemberSessionsQueryKey(memberId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberSessions>>> = ({ signal }) => listMemberSessions(memberId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: memberId !== null && memberId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMemberSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listMemberSessions>>>
export type ListMemberSessionsQueryError = HTTPValidationError


export function useListMemberSessions<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberSessions>>,
          TError,
          Awaited<ReturnType<typeof listMemberSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberSessions<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberSessions>>,
          TError,
          Awaited<ReturnType<typeof listMemberSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberSessions<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Member Sessions
 */

export function useListMemberSessions<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMemberSessionsQueryOptions(memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMemberSessionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMemberSessionsQueryKey(memberId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberSessions>>> = ({ signal }) => listMemberSessions(memberId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMemberSessionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMemberSessions>>>
export type ListMemberSessionsSuspenseQueryError = HTTPValidationError


export function useListMemberSessionsSuspense<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberSessionsSuspense<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberSessionsSuspense<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Member Sessions
 */

export function useListMemberSessionsSuspense<TData = Awaited<ReturnType<typeof listMemberSessions>>, TError = HTTPValidationError>(
 memberId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMemberSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMemberSessionsSuspenseQueryOptions(memberId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeMemberSessionUrl = (memberId: string,
    sessionId: string,) => {




  return `/api/org/members/${memberId}/sessions/${sessionId}/revoke`
}

/**
 * @summary Revoke Member Session
 */
export const revokeMemberSession = async (memberId: string,
    sessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<RevokeMemberSession200> => {

  return customInstance<RevokeMemberSession200>(getRevokeMemberSessionUrl(memberId,sessionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeMemberSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMemberSession>>, TError,{memberId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeMemberSession>>, TError,{memberId: string;sessionId: string}, TContext> => {

const mutationKey = ['revokeMemberSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeMemberSession>>, {memberId: string;sessionId: string}> = (props) => {
          const {memberId,sessionId} = props ?? {};

          return  revokeMemberSession(memberId,sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeMemberSessionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeMemberSession>>>

    export type RevokeMemberSessionMutationError = HTTPValidationError

    /**
 * @summary Revoke Member Session
 */
export const useRevokeMemberSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMemberSession>>, TError,{memberId: string;sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeMemberSession>>,
        TError,
        {memberId: string;sessionId: string},
        TContext
      > => {
      return useMutation(getRevokeMemberSessionMutationOptions(options), queryClient);
    }

export const getGetOrgSettingsUrl = () => {




  return `/api/org/settings`
}

/**
 * @summary Get Org Settings
 */
export const getOrgSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrganizationResponse> => {

  return customInstance<OrganizationResponse>(getGetOrgSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgSettingsQueryKey = () => {
    return [
    `/api/org/settings`
    ] as const;
    }


export const getGetOrgSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSettings>>> = ({ signal }) => getOrgSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSettings>>>
export type GetOrgSettingsQueryError = unknown


export function useGetOrgSettings<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSettings<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSettings<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Settings
 */

export function useGetOrgSettings<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSettings>>> = ({ signal }) => getOrgSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSettings>>>
export type GetOrgSettingsSuspenseQueryError = unknown


export function useGetOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Settings
 */

export function useGetOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrgSettingsUrl = () => {




  return `/api/org/settings`
}

/**
 * @summary Update Org Settings
 */
export const updateOrgSettings = async (updateOrgRequest: UpdateOrgRequest, options?: Parameters<typeof customInstance>[1]): Promise<OrganizationResponse> => {

  return customInstance<OrganizationResponse>(getUpdateOrgSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrgRequest)
  }
);}





export const getUpdateOrgSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgSettings>>, TError,{data: UpdateOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgSettings>>, TError,{data: UpdateOrgRequest}, TContext> => {

const mutationKey = ['updateOrgSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgSettings>>, {data: UpdateOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateOrgSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgSettings>>>
    export type UpdateOrgSettingsMutationBody = UpdateOrgRequest
    export type UpdateOrgSettingsMutationError = HTTPValidationError

    /**
 * @summary Update Org Settings
 */
export const useUpdateOrgSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgSettings>>, TError,{data: UpdateOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgSettings>>,
        TError,
        {data: UpdateOrgRequest},
        TContext
      > => {
      return useMutation(getUpdateOrgSettingsMutationOptions(options), queryClient);
    }

export const getDeleteOrganizationUrl = () => {




  return `/api/org/delete`
}

/**
 * @summary Delete Organization
 */
export const deleteOrganization = async (deleteOrgRequest: DeleteOrgRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteOrgRequest)
  }
);}





export const getDeleteOrganizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{data: DeleteOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{data: DeleteOrgRequest}, TContext> => {

const mutationKey = ['deleteOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganization>>, {data: DeleteOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  deleteOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganization>>>
    export type DeleteOrganizationMutationBody = DeleteOrgRequest
    export type DeleteOrganizationMutationError = HTTPValidationError

    /**
 * @summary Delete Organization
 */
export const useDeleteOrganization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{data: DeleteOrgRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganization>>,
        TError,
        {data: DeleteOrgRequest},
        TContext
      > => {
      return useMutation(getDeleteOrganizationMutationOptions(options), queryClient);
    }

export const getGetOrgComplianceSettingsUrl = () => {




  return `/api/org/compliance-settings`
}

/**
 * @summary Get Org Compliance Settings
 */
export const getOrgComplianceSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgComplianceSettingsResponse> => {

  return customInstance<OrgComplianceSettingsResponse>(getGetOrgComplianceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgComplianceSettingsQueryKey = () => {
    return [
    `/api/org/compliance-settings`
    ] as const;
    }


export const getGetOrgComplianceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgComplianceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgComplianceSettings>>> = ({ signal }) => getOrgComplianceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgComplianceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgComplianceSettings>>>
export type GetOrgComplianceSettingsQueryError = unknown


export function useGetOrgComplianceSettings<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgComplianceSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgComplianceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgComplianceSettings<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgComplianceSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgComplianceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgComplianceSettings<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Compliance Settings
 */

export function useGetOrgComplianceSettings<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgComplianceSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgComplianceSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgComplianceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgComplianceSettings>>> = ({ signal }) => getOrgComplianceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgComplianceSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgComplianceSettings>>>
export type GetOrgComplianceSettingsSuspenseQueryError = unknown


export function useGetOrgComplianceSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgComplianceSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgComplianceSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Compliance Settings
 */

export function useGetOrgComplianceSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgComplianceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgComplianceSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrgComplianceSettingsUrl = () => {




  return `/api/org/compliance-settings`
}

/**
 * @summary Update Org Compliance Settings
 */
export const updateOrgComplianceSettings = async (orgComplianceSettingsRequest: OrgComplianceSettingsRequest, options?: Parameters<typeof customInstance>[1]): Promise<OrgComplianceSettingsResponse> => {

  return customInstance<OrgComplianceSettingsResponse>(getUpdateOrgComplianceSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orgComplianceSettingsRequest)
  }
);}





export const getUpdateOrgComplianceSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgComplianceSettings>>, TError,{data: OrgComplianceSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgComplianceSettings>>, TError,{data: OrgComplianceSettingsRequest}, TContext> => {

const mutationKey = ['updateOrgComplianceSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgComplianceSettings>>, {data: OrgComplianceSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateOrgComplianceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgComplianceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgComplianceSettings>>>
    export type UpdateOrgComplianceSettingsMutationBody = OrgComplianceSettingsRequest
    export type UpdateOrgComplianceSettingsMutationError = HTTPValidationError

    /**
 * @summary Update Org Compliance Settings
 */
export const useUpdateOrgComplianceSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgComplianceSettings>>, TError,{data: OrgComplianceSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgComplianceSettings>>,
        TError,
        {data: OrgComplianceSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateOrgComplianceSettingsMutationOptions(options), queryClient);
    }

export const getListMailboxesUrl = (params?: ListMailboxesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/connected-accounts/mailboxes?${stringifiedParams}` : `/api/connected-accounts/mailboxes`
}

/**
 * @summary List Mailboxes
 */
export const listMailboxes = async (params?: ListMailboxesParams, options?: Parameters<typeof customInstance>[1]): Promise<MailboxList> => {

  return customInstance<MailboxList>(getListMailboxesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMailboxesQueryKey = (params?: ListMailboxesParams,) => {
    return [
    `/api/connected-accounts/mailboxes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMailboxesQueryOptions = <TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(params?: ListMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailboxesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailboxes>>> = ({ signal }) => listMailboxes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailboxesQueryResult = NonNullable<Awaited<ReturnType<typeof listMailboxes>>>
export type ListMailboxesQueryError = HTTPValidationError


export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params: undefined |  ListMailboxesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Mailboxes
 */

export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailboxesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMailboxesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(params?: ListMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailboxesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailboxes>>> = ({ signal }) => listMailboxes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailboxesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMailboxes>>>
export type ListMailboxesSuspenseQueryError = HTTPValidationError


export function useListMailboxesSuspense<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params: undefined |  ListMailboxesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxesSuspense<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxesSuspense<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Mailboxes
 */

export function useListMailboxesSuspense<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = HTTPValidationError>(
 params?: ListMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailboxesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMailboxOauthStartUrl = () => {




  return `/api/connected-accounts/mailboxes/oauth-start`
}

/**
 * @summary Mailbox Oauth Start
 */
export const mailboxOauthStart = async (mailboxOAuthStartRequest: MailboxOAuthStartRequest, options?: Parameters<typeof customInstance>[1]): Promise<MailboxOAuthStartResponse> => {

  return customInstance<MailboxOAuthStartResponse>(getMailboxOauthStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailboxOAuthStartRequest)
  }
);}





export const getMailboxOauthStartMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailboxOauthStart>>, TError,{data: MailboxOAuthStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mailboxOauthStart>>, TError,{data: MailboxOAuthStartRequest}, TContext> => {

const mutationKey = ['mailboxOauthStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mailboxOauthStart>>, {data: MailboxOAuthStartRequest}> = (props) => {
          const {data} = props ?? {};

          return  mailboxOauthStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MailboxOauthStartMutationResult = NonNullable<Awaited<ReturnType<typeof mailboxOauthStart>>>
    export type MailboxOauthStartMutationBody = MailboxOAuthStartRequest
    export type MailboxOauthStartMutationError = HTTPValidationError

    /**
 * @summary Mailbox Oauth Start
 */
export const useMailboxOauthStart = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailboxOauthStart>>, TError,{data: MailboxOAuthStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mailboxOauthStart>>,
        TError,
        {data: MailboxOAuthStartRequest},
        TContext
      > => {
      return useMutation(getMailboxOauthStartMutationOptions(options), queryClient);
    }

export const getCreateImapMailboxUrl = () => {




  return `/api/connected-accounts/mailboxes/imap`
}

/**
 * @summary Create Imap Mailbox
 */
export const createImapMailbox = async (mailboxImapCreateRequest: MailboxImapCreateRequest, options?: Parameters<typeof customInstance>[1]): Promise<MailboxResponse> => {

  return customInstance<MailboxResponse>(getCreateImapMailboxUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailboxImapCreateRequest)
  }
);}





export const getCreateImapMailboxMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImapMailbox>>, TError,{data: MailboxImapCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createImapMailbox>>, TError,{data: MailboxImapCreateRequest}, TContext> => {

const mutationKey = ['createImapMailbox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImapMailbox>>, {data: MailboxImapCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createImapMailbox(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImapMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof createImapMailbox>>>
    export type CreateImapMailboxMutationBody = MailboxImapCreateRequest
    export type CreateImapMailboxMutationError = HTTPValidationError

    /**
 * @summary Create Imap Mailbox
 */
export const useCreateImapMailbox = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImapMailbox>>, TError,{data: MailboxImapCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImapMailbox>>,
        TError,
        {data: MailboxImapCreateRequest},
        TContext
      > => {
      return useMutation(getCreateImapMailboxMutationOptions(options), queryClient);
    }

export const getUpdateMailboxUrl = (mailboxId: string,) => {




  return `/api/connected-accounts/mailboxes/${mailboxId}`
}

/**
 * @summary Update Mailbox
 */
export const updateMailbox = async (mailboxId: string,
    mailboxUpdate: MailboxUpdate, options?: Parameters<typeof customInstance>[1]): Promise<MailboxResponse> => {

  return customInstance<MailboxResponse>(getUpdateMailboxUrl(mailboxId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mailboxUpdate)
  }
);}





export const getUpdateMailboxMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,{mailboxId: string;data: MailboxUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,{mailboxId: string;data: MailboxUpdate}, TContext> => {

const mutationKey = ['updateMailbox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMailbox>>, {mailboxId: string;data: MailboxUpdate}> = (props) => {
          const {mailboxId,data} = props ?? {};

          return  updateMailbox(mailboxId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof updateMailbox>>>
    export type UpdateMailboxMutationBody = MailboxUpdate
    export type UpdateMailboxMutationError = HTTPValidationError

    /**
 * @summary Update Mailbox
 */
export const useUpdateMailbox = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,{mailboxId: string;data: MailboxUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMailbox>>,
        TError,
        {mailboxId: string;data: MailboxUpdate},
        TContext
      > => {
      return useMutation(getUpdateMailboxMutationOptions(options), queryClient);
    }

export const getSetPrimaryMailboxUrl = (mailboxId: string,) => {




  return `/api/connected-accounts/mailboxes/${mailboxId}/set-primary`
}

/**
 * @summary Set Primary Mailbox
 */
export const setPrimaryMailbox = async (mailboxId: string, options?: Parameters<typeof customInstance>[1]): Promise<MailboxResponse> => {

  return customInstance<MailboxResponse>(getSetPrimaryMailboxUrl(mailboxId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetPrimaryMailboxMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPrimaryMailbox>>, TError,{mailboxId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setPrimaryMailbox>>, TError,{mailboxId: string}, TContext> => {

const mutationKey = ['setPrimaryMailbox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPrimaryMailbox>>, {mailboxId: string}> = (props) => {
          const {mailboxId} = props ?? {};

          return  setPrimaryMailbox(mailboxId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPrimaryMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof setPrimaryMailbox>>>

    export type SetPrimaryMailboxMutationError = HTTPValidationError

    /**
 * @summary Set Primary Mailbox
 */
export const useSetPrimaryMailbox = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPrimaryMailbox>>, TError,{mailboxId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPrimaryMailbox>>,
        TError,
        {mailboxId: string},
        TContext
      > => {
      return useMutation(getSetPrimaryMailboxMutationOptions(options), queryClient);
    }

export const getDisconnectMailboxUrl = (mailboxId: string,) => {




  return `/api/connected-accounts/mailboxes/${mailboxId}/disconnect`
}

/**
 * @summary Disconnect Mailbox
 */
export const disconnectMailbox = async (mailboxId: string, options?: Parameters<typeof customInstance>[1]): Promise<MailboxResponse> => {

  return customInstance<MailboxResponse>(getDisconnectMailboxUrl(mailboxId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectMailboxMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMailbox>>, TError,{mailboxId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectMailbox>>, TError,{mailboxId: string}, TContext> => {

const mutationKey = ['disconnectMailbox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectMailbox>>, {mailboxId: string}> = (props) => {
          const {mailboxId} = props ?? {};

          return  disconnectMailbox(mailboxId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectMailbox>>>

    export type DisconnectMailboxMutationError = HTTPValidationError

    /**
 * @summary Disconnect Mailbox
 */
export const useDisconnectMailbox = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMailbox>>, TError,{mailboxId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectMailbox>>,
        TError,
        {mailboxId: string},
        TContext
      > => {
      return useMutation(getDisconnectMailboxMutationOptions(options), queryClient);
    }

export const getGetLinkedinAccountUrl = () => {




  return `/api/connected-accounts/linkedin`
}

/**
 * @summary Get Linkedin Account
 */
export const getLinkedinAccount = async ( options?: Parameters<typeof customInstance>[1]): Promise<LinkedInAccountResponse> => {

  return customInstance<LinkedInAccountResponse>(getGetLinkedinAccountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLinkedinAccountQueryKey = () => {
    return [
    `/api/connected-accounts/linkedin`
    ] as const;
    }


export const getGetLinkedinAccountQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedinAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedinAccount>>> = ({ signal }) => getLinkedinAccount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLinkedinAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedinAccount>>>
export type GetLinkedinAccountQueryError = unknown


export function useGetLinkedinAccount<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedinAccount>>,
          TError,
          Awaited<ReturnType<typeof getLinkedinAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinAccount<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedinAccount>>,
          TError,
          Awaited<ReturnType<typeof getLinkedinAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinAccount<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Linkedin Account
 */

export function useGetLinkedinAccount<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLinkedinAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLinkedinAccountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedinAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedinAccount>>> = ({ signal }) => getLinkedinAccount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLinkedinAccountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedinAccount>>>
export type GetLinkedinAccountSuspenseQueryError = unknown


export function useGetLinkedinAccountSuspense<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinAccountSuspense<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinAccountSuspense<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Linkedin Account
 */

export function useGetLinkedinAccountSuspense<TData = Awaited<ReturnType<typeof getLinkedinAccount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLinkedinAccountSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLinkedinLimitsUrl = () => {




  return `/api/connected-accounts/linkedin/limits`
}

/**
 * Tier-aware LinkedIn safe-usage education for the caller's account.
 *
 * Returns the connected account's ``account_type`` plus the per-action
 * recommended limits + notes for that tier. 404 ``LINKEDIN_NOT_CONNECTED``
 * when the caller has no connected LinkedIn account.
 * @summary Get Linkedin Limits
 */
export const getLinkedinLimits = async ( options?: Parameters<typeof customInstance>[1]): Promise<LinkedInLimitsResponse> => {

  return customInstance<LinkedInLimitsResponse>(getGetLinkedinLimitsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLinkedinLimitsQueryKey = () => {
    return [
    `/api/connected-accounts/linkedin/limits`
    ] as const;
    }


export const getGetLinkedinLimitsQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedinLimitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedinLimits>>> = ({ signal }) => getLinkedinLimits({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLinkedinLimitsQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedinLimits>>>
export type GetLinkedinLimitsQueryError = unknown


export function useGetLinkedinLimits<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedinLimits>>,
          TError,
          Awaited<ReturnType<typeof getLinkedinLimits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinLimits<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedinLimits>>,
          TError,
          Awaited<ReturnType<typeof getLinkedinLimits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinLimits<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Linkedin Limits
 */

export function useGetLinkedinLimits<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLinkedinLimitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLinkedinLimitsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedinLimitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedinLimits>>> = ({ signal }) => getLinkedinLimits({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLinkedinLimitsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedinLimits>>>
export type GetLinkedinLimitsSuspenseQueryError = unknown


export function useGetLinkedinLimitsSuspense<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinLimitsSuspense<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLinkedinLimitsSuspense<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Linkedin Limits
 */

export function useGetLinkedinLimitsSuspense<TData = Awaited<ReturnType<typeof getLinkedinLimits>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLinkedinLimits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLinkedinLimitsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkedinConnectUrl = () => {




  return `/api/connected-accounts/linkedin/connect`
}

/**
 * @summary Linkedin Connect
 */
export const linkedinConnect = async (linkedInConnectRequest: LinkedInConnectRequest, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInConnectResponse> => {

  return customInstance<LinkedInConnectResponse>(getLinkedinConnectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInConnectRequest)
  }
);}





export const getLinkedinConnectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinConnect>>, TError,{data: LinkedInConnectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkedinConnect>>, TError,{data: LinkedInConnectRequest}, TContext> => {

const mutationKey = ['linkedinConnect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkedinConnect>>, {data: LinkedInConnectRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkedinConnect(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkedinConnectMutationResult = NonNullable<Awaited<ReturnType<typeof linkedinConnect>>>
    export type LinkedinConnectMutationBody = LinkedInConnectRequest
    export type LinkedinConnectMutationError = HTTPValidationError

    /**
 * @summary Linkedin Connect
 */
export const useLinkedinConnect = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinConnect>>, TError,{data: LinkedInConnectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkedinConnect>>,
        TError,
        {data: LinkedInConnectRequest},
        TContext
      > => {
      return useMutation(getLinkedinConnectMutationOptions(options), queryClient);
    }

export const getLinkedinResendCheckpointUrl = () => {




  return `/api/connected-accounts/linkedin/checkpoint/resend`
}

/**
 * Re-send the pending checkpoint notification (re-trigger the LinkedIn
 * in-app push / re-send a code) via ``POST /api/v1/accounts/checkpoint/resend``.
 * @summary Linkedin Resend Checkpoint
 */
export const linkedinResendCheckpoint = async (linkedInCheckpointResendRequest: LinkedInCheckpointResendRequest, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInConnectResponse> => {

  return customInstance<LinkedInConnectResponse>(getLinkedinResendCheckpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInCheckpointResendRequest)
  }
);}





export const getLinkedinResendCheckpointMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinResendCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkedinResendCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext> => {

const mutationKey = ['linkedinResendCheckpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkedinResendCheckpoint>>, {data: LinkedInCheckpointResendRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkedinResendCheckpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkedinResendCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof linkedinResendCheckpoint>>>
    export type LinkedinResendCheckpointMutationBody = LinkedInCheckpointResendRequest
    export type LinkedinResendCheckpointMutationError = HTTPValidationError

    /**
 * @summary Linkedin Resend Checkpoint
 */
export const useLinkedinResendCheckpoint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinResendCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkedinResendCheckpoint>>,
        TError,
        {data: LinkedInCheckpointResendRequest},
        TContext
      > => {
      return useMutation(getLinkedinResendCheckpointMutationOptions(options), queryClient);
    }

export const getLinkedinSwitchCheckpointUrl = () => {




  return `/api/connected-accounts/linkedin/checkpoint/switch`
}

/**
 * "Try another way" — switch an in-app-validation push to a code-based
 * checkpoint (2FA / OTP) via Solve with ``TRY_ANOTHER_WAY``.
 * @summary Linkedin Switch Checkpoint
 */
export const linkedinSwitchCheckpoint = async (linkedInCheckpointResendRequest: LinkedInCheckpointResendRequest, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInConnectResponse> => {

  return customInstance<LinkedInConnectResponse>(getLinkedinSwitchCheckpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInCheckpointResendRequest)
  }
);}





export const getLinkedinSwitchCheckpointMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext> => {

const mutationKey = ['linkedinSwitchCheckpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>, {data: LinkedInCheckpointResendRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkedinSwitchCheckpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkedinSwitchCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>>
    export type LinkedinSwitchCheckpointMutationBody = LinkedInCheckpointResendRequest
    export type LinkedinSwitchCheckpointMutationError = HTTPValidationError

    /**
 * @summary Linkedin Switch Checkpoint
 */
export const useLinkedinSwitchCheckpoint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkedinSwitchCheckpoint>>,
        TError,
        {data: LinkedInCheckpointResendRequest},
        TContext
      > => {
      return useMutation(getLinkedinSwitchCheckpointMutationOptions(options), queryClient);
    }

export const getLinkedinCancelCheckpointUrl = () => {




  return `/api/connected-accounts/linkedin/checkpoint/cancel`
}

/**
 * Cancel an in-progress connect (the user closed the modal mid-checkpoint).
 * Deletes the abandoned ``connecting`` row so it never lingers as a stuck
 * 'verifying' account. Idempotent.
 * @summary Linkedin Cancel Checkpoint
 */
export const linkedinCancelCheckpoint = async (linkedInCheckpointResendRequest: LinkedInCheckpointResendRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getLinkedinCancelCheckpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInCheckpointResendRequest)
  }
);}





export const getLinkedinCancelCheckpointMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinCancelCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkedinCancelCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext> => {

const mutationKey = ['linkedinCancelCheckpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkedinCancelCheckpoint>>, {data: LinkedInCheckpointResendRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkedinCancelCheckpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkedinCancelCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof linkedinCancelCheckpoint>>>
    export type LinkedinCancelCheckpointMutationBody = LinkedInCheckpointResendRequest
    export type LinkedinCancelCheckpointMutationError = HTTPValidationError

    /**
 * @summary Linkedin Cancel Checkpoint
 */
export const useLinkedinCancelCheckpoint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinCancelCheckpoint>>, TError,{data: LinkedInCheckpointResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkedinCancelCheckpoint>>,
        TError,
        {data: LinkedInCheckpointResendRequest},
        TContext
      > => {
      return useMutation(getLinkedinCancelCheckpointMutationOptions(options), queryClient);
    }

export const getUpdateLinkedinAccountUrl = (linkedinAccountId: string,) => {




  return `/api/connected-accounts/linkedin/${linkedinAccountId}`
}

/**
 * @summary Update Linkedin Account
 */
export const updateLinkedinAccount = async (linkedinAccountId: string,
    linkedInAccountUpdate: LinkedInAccountUpdate, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInAccountResponse> => {

  return customInstance<LinkedInAccountResponse>(getUpdateLinkedinAccountUrl(linkedinAccountId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInAccountUpdate)
  }
);}





export const getUpdateLinkedinAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinAccount>>, TError,{linkedinAccountId: string;data: LinkedInAccountUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinAccount>>, TError,{linkedinAccountId: string;data: LinkedInAccountUpdate}, TContext> => {

const mutationKey = ['updateLinkedinAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLinkedinAccount>>, {linkedinAccountId: string;data: LinkedInAccountUpdate}> = (props) => {
          const {linkedinAccountId,data} = props ?? {};

          return  updateLinkedinAccount(linkedinAccountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLinkedinAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateLinkedinAccount>>>
    export type UpdateLinkedinAccountMutationBody = LinkedInAccountUpdate
    export type UpdateLinkedinAccountMutationError = HTTPValidationError

    /**
 * @summary Update Linkedin Account
 */
export const useUpdateLinkedinAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinAccount>>, TError,{linkedinAccountId: string;data: LinkedInAccountUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLinkedinAccount>>,
        TError,
        {linkedinAccountId: string;data: LinkedInAccountUpdate},
        TContext
      > => {
      return useMutation(getUpdateLinkedinAccountMutationOptions(options), queryClient);
    }

export const getRefreshLinkedinAccountUrl = (linkedinAccountId: string,) => {




  return `/api/connected-accounts/linkedin/${linkedinAccountId}/refresh`
}

/**
 * @summary Refresh Linkedin Account
 */
export const refreshLinkedinAccount = async (linkedinAccountId: string, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInRefreshResponse> => {

  return customInstance<LinkedInRefreshResponse>(getRefreshLinkedinAccountUrl(linkedinAccountId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshLinkedinAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext> => {

const mutationKey = ['refreshLinkedinAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshLinkedinAccount>>, {linkedinAccountId: string}> = (props) => {
          const {linkedinAccountId} = props ?? {};

          return  refreshLinkedinAccount(linkedinAccountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshLinkedinAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshLinkedinAccount>>>

    export type RefreshLinkedinAccountMutationError = HTTPValidationError

    /**
 * @summary Refresh Linkedin Account
 */
export const useRefreshLinkedinAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshLinkedinAccount>>,
        TError,
        {linkedinAccountId: string},
        TContext
      > => {
      return useMutation(getRefreshLinkedinAccountMutationOptions(options), queryClient);
    }

export const getDisconnectLinkedinAccountUrl = (linkedinAccountId: string,) => {




  return `/api/connected-accounts/linkedin/${linkedinAccountId}/disconnect`
}

/**
 * @summary Disconnect Linkedin Account
 */
export const disconnectLinkedinAccount = async (linkedinAccountId: string, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInAccountResponse> => {

  return customInstance<LinkedInAccountResponse>(getDisconnectLinkedinAccountUrl(linkedinAccountId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectLinkedinAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext> => {

const mutationKey = ['disconnectLinkedinAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectLinkedinAccount>>, {linkedinAccountId: string}> = (props) => {
          const {linkedinAccountId} = props ?? {};

          return  disconnectLinkedinAccount(linkedinAccountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectLinkedinAccountMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectLinkedinAccount>>>

    export type DisconnectLinkedinAccountMutationError = HTTPValidationError

    /**
 * @summary Disconnect Linkedin Account
 */
export const useDisconnectLinkedinAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectLinkedinAccount>>, TError,{linkedinAccountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectLinkedinAccount>>,
        TError,
        {linkedinAccountId: string},
        TContext
      > => {
      return useMutation(getDisconnectLinkedinAccountMutationOptions(options), queryClient);
    }

export const getListEmailSignaturesUrl = (params?: ListEmailSignaturesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/connected-accounts/signatures/email?${stringifiedParams}` : `/api/connected-accounts/signatures/email`
}

/**
 * @summary List Email Signatures
 */
export const listEmailSignatures = async (params?: ListEmailSignaturesParams, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureListResponse> => {

  return customInstance<EmailSignatureListResponse>(getListEmailSignaturesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailSignaturesQueryKey = (params?: ListEmailSignaturesParams,) => {
    return [
    `/api/connected-accounts/signatures/email`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmailSignaturesQueryOptions = <TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(params?: ListEmailSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailSignaturesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailSignatures>>> = ({ signal }) => listEmailSignatures(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmailSignaturesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailSignatures>>>
export type ListEmailSignaturesQueryError = HTTPValidationError


export function useListEmailSignatures<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params: undefined |  ListEmailSignaturesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailSignatures>>,
          TError,
          Awaited<ReturnType<typeof listEmailSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailSignatures<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailSignatures>>,
          TError,
          Awaited<ReturnType<typeof listEmailSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailSignatures<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Email Signatures
 */

export function useListEmailSignatures<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmailSignaturesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEmailSignaturesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(params?: ListEmailSignaturesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailSignaturesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailSignatures>>> = ({ signal }) => listEmailSignatures(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmailSignaturesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailSignatures>>>
export type ListEmailSignaturesSuspenseQueryError = HTTPValidationError


export function useListEmailSignaturesSuspense<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params: undefined |  ListEmailSignaturesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailSignaturesSuspense<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailSignaturesSuspense<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Email Signatures
 */

export function useListEmailSignaturesSuspense<TData = Awaited<ReturnType<typeof listEmailSignatures>>, TError = HTTPValidationError>(
 params?: ListEmailSignaturesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmailSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmailSignaturesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateEmailSignatureUrl = () => {




  return `/api/connected-accounts/signatures/email`
}

/**
 * Create a new signature row in draft status.
 *
 * The row is born with ``saved_at = NULL`` — the user has to call
 * ``POST .../publish`` to mint a usable canonical version. Initial
 * ``name`` / ``body_html`` are optional so the FE can open the editor
 * with an empty row and PATCH as the user types.
 * @summary Create Email Signature
 */
export const createEmailSignature = async (emailSignatureCreate: EmailSignatureCreate, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getCreateEmailSignatureUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailSignatureCreate)
  }
);}





export const getCreateEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailSignature>>, TError,{data: EmailSignatureCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailSignature>>, TError,{data: EmailSignatureCreate}, TContext> => {

const mutationKey = ['createEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailSignature>>, {data: EmailSignatureCreate}> = (props) => {
          const {data} = props ?? {};

          return  createEmailSignature(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailSignature>>>
    export type CreateEmailSignatureMutationBody = EmailSignatureCreate
    export type CreateEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Create Email Signature
 */
export const useCreateEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailSignature>>, TError,{data: EmailSignatureCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailSignature>>,
        TError,
        {data: EmailSignatureCreate},
        TContext
      > => {
      return useMutation(getCreateEmailSignatureMutationOptions(options), queryClient);
    }

export const getGetEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}`
}

/**
 * Fetch a single signature by id. Used by the editor modal so it
 * can open without paginating the full list first.
 * @summary Get Email Signature
 */
export const getEmailSignature = async (signatureId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getGetEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmailSignatureQueryKey = (signatureId: string,) => {
    return [
    `/api/connected-accounts/signatures/email/${signatureId}`
    ] as const;
    }


export const getGetEmailSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(signatureId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailSignatureQueryKey(signatureId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailSignature>>> = ({ signal }) => getEmailSignature(signatureId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: signatureId !== null && signatureId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailSignature>>>
export type GetEmailSignatureQueryError = HTTPValidationError


export function useGetEmailSignature<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailSignature>>,
          TError,
          Awaited<ReturnType<typeof getEmailSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailSignature<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailSignature>>,
          TError,
          Awaited<ReturnType<typeof getEmailSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailSignature<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Email Signature
 */

export function useGetEmailSignature<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailSignatureQueryOptions(signatureId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEmailSignatureSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(signatureId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailSignatureQueryKey(signatureId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailSignature>>> = ({ signal }) => getEmailSignature(signatureId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailSignatureSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailSignature>>>
export type GetEmailSignatureSuspenseQueryError = HTTPValidationError


export function useGetEmailSignatureSuspense<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailSignatureSuspense<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailSignatureSuspense<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Email Signature
 */

export function useGetEmailSignatureSuspense<TData = Awaited<ReturnType<typeof getEmailSignature>>, TError = HTTPValidationError>(
 signatureId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmailSignature>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailSignatureSuspenseQueryOptions(signatureId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}`
}

/**
 * PATCH writes always go to ``draft_*`` — the canonical fields used
 * by real email sends only change on ``POST .../publish``. Empty /
 * whitespace-only values are allowed so the FE can debounce-PATCH on
 * every keystroke; the publish call is what gates on non-empty.
 * @summary Update Email Signature
 */
export const updateEmailSignature = async (signatureId: string,
    emailSignatureUpdate: EmailSignatureUpdate, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getUpdateEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailSignatureUpdate)
  }
);}





export const getUpdateEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailSignature>>, TError,{signatureId: string;data: EmailSignatureUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailSignature>>, TError,{signatureId: string;data: EmailSignatureUpdate}, TContext> => {

const mutationKey = ['updateEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailSignature>>, {signatureId: string;data: EmailSignatureUpdate}> = (props) => {
          const {signatureId,data} = props ?? {};

          return  updateEmailSignature(signatureId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailSignature>>>
    export type UpdateEmailSignatureMutationBody = EmailSignatureUpdate
    export type UpdateEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Update Email Signature
 */
export const useUpdateEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailSignature>>, TError,{signatureId: string;data: EmailSignatureUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailSignature>>,
        TError,
        {signatureId: string;data: EmailSignatureUpdate},
        TContext
      > => {
      return useMutation(getUpdateEmailSignatureMutationOptions(options), queryClient);
    }

export const getDeleteEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}`
}

/**
 * Delete the row. Works for both saved and never-saved signatures —
 * the 409 ``SIGNATURE_IN_USE`` guard still applies for any row a mailbox
 * references as its default.
 * @summary Delete Email Signature
 */
export const deleteEmailSignature = async (signatureId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailSignature>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['deleteEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailSignature>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  deleteEmailSignature(signatureId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailSignature>>>

    export type DeleteEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Delete Email Signature
 */
export const useDeleteEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailSignature>>,
        TError,
        {signatureId: string},
        TContext
      > => {
      return useMutation(getDeleteEmailSignatureMutationOptions(options), queryClient);
    }

export const getPublishEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}/publish`
}

/**
 * Promote ``draft_*`` → canonical and mint ``saved_at`` (if first
 * time). ``revision`` is the optimistic-concurrency token returned by
 * the most recent ``GET`` / ``PATCH``.
 * @summary Publish Email Signature
 */
export const publishEmailSignature = async (signatureId: string,
    emailSignaturePublish: EmailSignaturePublish, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getPublishEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailSignaturePublish)
  }
);}





export const getPublishEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishEmailSignature>>, TError,{signatureId: string;data: EmailSignaturePublish}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof publishEmailSignature>>, TError,{signatureId: string;data: EmailSignaturePublish}, TContext> => {

const mutationKey = ['publishEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishEmailSignature>>, {signatureId: string;data: EmailSignaturePublish}> = (props) => {
          const {signatureId,data} = props ?? {};

          return  publishEmailSignature(signatureId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof publishEmailSignature>>>
    export type PublishEmailSignatureMutationBody = EmailSignaturePublish
    export type PublishEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Publish Email Signature
 */
export const usePublishEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishEmailSignature>>, TError,{signatureId: string;data: EmailSignaturePublish}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishEmailSignature>>,
        TError,
        {signatureId: string;data: EmailSignaturePublish},
        TContext
      > => {
      return useMutation(getPublishEmailSignatureMutationOptions(options), queryClient);
    }

export const getResetEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}/reset`
}

/**
 * Clear ``draft_*`` back to mirror ``saved_*``. Only meaningful for
 * rows that have been published before — never-saved rows have nothing
 * to revert to (the FE should use ``DELETE`` instead).
 * @summary Reset Email Signature
 */
export const resetEmailSignature = async (signatureId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getResetEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetEmailSignature>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['resetEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetEmailSignature>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  resetEmailSignature(signatureId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof resetEmailSignature>>>

    export type ResetEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Reset Email Signature
 */
export const useResetEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetEmailSignature>>,
        TError,
        {signatureId: string},
        TContext
      > => {
      return useMutation(getResetEmailSignatureMutationOptions(options), queryClient);
    }

export const getDuplicateEmailSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/email/${signatureId}/duplicate`
}

/**
 * Deep-copy a published signature into a new published ``(copy)`` row.
 * @summary Duplicate Email Signature
 */
export const duplicateEmailSignature = async (signatureId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmailSignatureResponse> => {

  return customInstance<EmailSignatureResponse>(getDuplicateEmailSignatureUrl(signatureId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDuplicateEmailSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateEmailSignature>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['duplicateEmailSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateEmailSignature>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  duplicateEmailSignature(signatureId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateEmailSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateEmailSignature>>>

    export type DuplicateEmailSignatureMutationError = HTTPValidationError

    /**
 * @summary Duplicate Email Signature
 */
export const useDuplicateEmailSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmailSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateEmailSignature>>,
        TError,
        {signatureId: string},
        TContext
      > => {
      return useMutation(getDuplicateEmailSignatureMutationOptions(options), queryClient);
    }

export const getListLinkedinSignaturesUrl = () => {




  return `/api/connected-accounts/signatures/linkedin`
}

/**
 * @summary List Linkedin Signatures
 */
export const listLinkedinSignatures = async ( options?: Parameters<typeof customInstance>[1]): Promise<LinkedInSignatureResponse[]> => {

  return customInstance<LinkedInSignatureResponse[]>(getListLinkedinSignaturesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLinkedinSignaturesQueryKey = () => {
    return [
    `/api/connected-accounts/signatures/linkedin`
    ] as const;
    }


export const getListLinkedinSignaturesQueryOptions = <TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLinkedinSignaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkedinSignatures>>> = ({ signal }) => listLinkedinSignatures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLinkedinSignaturesQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkedinSignatures>>>
export type ListLinkedinSignaturesQueryError = unknown


export function useListLinkedinSignatures<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkedinSignatures>>,
          TError,
          Awaited<ReturnType<typeof listLinkedinSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkedinSignatures<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkedinSignatures>>,
          TError,
          Awaited<ReturnType<typeof listLinkedinSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkedinSignatures<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Linkedin Signatures
 */

export function useListLinkedinSignatures<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkedinSignaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListLinkedinSignaturesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLinkedinSignaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkedinSignatures>>> = ({ signal }) => listLinkedinSignatures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLinkedinSignaturesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkedinSignatures>>>
export type ListLinkedinSignaturesSuspenseQueryError = unknown


export function useListLinkedinSignaturesSuspense<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkedinSignaturesSuspense<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkedinSignaturesSuspense<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Linkedin Signatures
 */

export function useListLinkedinSignaturesSuspense<TData = Awaited<ReturnType<typeof listLinkedinSignatures>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listLinkedinSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkedinSignaturesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLinkedinSignatureUrl = () => {




  return `/api/connected-accounts/signatures/linkedin`
}

/**
 * @summary Create Linkedin Signature
 */
export const createLinkedinSignature = async (linkedInSignatureCreate: LinkedInSignatureCreate, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInSignatureResponse> => {

  return customInstance<LinkedInSignatureResponse>(getCreateLinkedinSignatureUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInSignatureCreate)
  }
);}





export const getCreateLinkedinSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkedinSignature>>, TError,{data: LinkedInSignatureCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLinkedinSignature>>, TError,{data: LinkedInSignatureCreate}, TContext> => {

const mutationKey = ['createLinkedinSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkedinSignature>>, {data: LinkedInSignatureCreate}> = (props) => {
          const {data} = props ?? {};

          return  createLinkedinSignature(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkedinSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkedinSignature>>>
    export type CreateLinkedinSignatureMutationBody = LinkedInSignatureCreate
    export type CreateLinkedinSignatureMutationError = HTTPValidationError

    /**
 * @summary Create Linkedin Signature
 */
export const useCreateLinkedinSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkedinSignature>>, TError,{data: LinkedInSignatureCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLinkedinSignature>>,
        TError,
        {data: LinkedInSignatureCreate},
        TContext
      > => {
      return useMutation(getCreateLinkedinSignatureMutationOptions(options), queryClient);
    }

export const getUpdateLinkedinSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/linkedin/${signatureId}`
}

/**
 * @summary Update Linkedin Signature
 */
export const updateLinkedinSignature = async (signatureId: string,
    linkedInSignatureUpdate: LinkedInSignatureUpdate, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInSignatureResponse> => {

  return customInstance<LinkedInSignatureResponse>(getUpdateLinkedinSignatureUrl(signatureId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInSignatureUpdate)
  }
);}





export const getUpdateLinkedinSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinSignature>>, TError,{signatureId: string;data: LinkedInSignatureUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinSignature>>, TError,{signatureId: string;data: LinkedInSignatureUpdate}, TContext> => {

const mutationKey = ['updateLinkedinSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLinkedinSignature>>, {signatureId: string;data: LinkedInSignatureUpdate}> = (props) => {
          const {signatureId,data} = props ?? {};

          return  updateLinkedinSignature(signatureId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLinkedinSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof updateLinkedinSignature>>>
    export type UpdateLinkedinSignatureMutationBody = LinkedInSignatureUpdate
    export type UpdateLinkedinSignatureMutationError = HTTPValidationError

    /**
 * @summary Update Linkedin Signature
 */
export const useUpdateLinkedinSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkedinSignature>>, TError,{signatureId: string;data: LinkedInSignatureUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLinkedinSignature>>,
        TError,
        {signatureId: string;data: LinkedInSignatureUpdate},
        TContext
      > => {
      return useMutation(getUpdateLinkedinSignatureMutationOptions(options), queryClient);
    }

export const getDeleteLinkedinSignatureUrl = (signatureId: string,) => {




  return `/api/connected-accounts/signatures/linkedin/${signatureId}`
}

/**
 * @summary Delete Linkedin Signature
 */
export const deleteLinkedinSignature = async (signatureId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteLinkedinSignatureUrl(signatureId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLinkedinSignatureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinkedinSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLinkedinSignature>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['deleteLinkedinSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLinkedinSignature>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  deleteLinkedinSignature(signatureId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLinkedinSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLinkedinSignature>>>

    export type DeleteLinkedinSignatureMutationError = HTTPValidationError

    /**
 * @summary Delete Linkedin Signature
 */
export const useDeleteLinkedinSignature = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinkedinSignature>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLinkedinSignature>>,
        TError,
        {signatureId: string},
        TContext
      > => {
      return useMutation(getDeleteLinkedinSignatureMutationOptions(options), queryClient);
    }

export const getGetSummaryUrl = () => {




  return `/api/connected-accounts/summary`
}

/**
 * @summary Get Summary
 */
export const getSummary = async ( options?: Parameters<typeof customInstance>[1]): Promise<ConnectedAccountsSummary> => {

  return customInstance<ConnectedAccountsSummary>(getGetSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSummaryQueryKey = () => {
    return [
    `/api/connected-accounts/summary`
    ] as const;
    }


export const getGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({ signal }) => getSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSummary>>>
export type GetSummaryQueryError = unknown


export function useGetSummary<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSummary<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSummary<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Summary
 */

export function useGetSummary<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({ signal }) => getSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSummary>>>
export type GetSummarySuspenseQueryError = unknown


export function useGetSummarySuspense<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSummarySuspense<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSummarySuspense<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Summary
 */

export function useGetSummarySuspense<TData = Awaited<ReturnType<typeof getSummary>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSummarySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkedinSolveCheckpointUrl = () => {




  return `/api/connected-accounts/linkedin/checkpoint`
}

/**
 * Solve a checkpoint. ``code`` may be a real code, ``""`` (long-poll wait
 * for an IN_APP_VALIDATION push approval), or ``"TRY_ANOTHER_WAY"``. Returns
 * a unified ``connected`` / ``checkpoint_required`` result so the UI can
 * drive chained checkpoints without erroring.
 * @summary Linkedin Solve Checkpoint
 */
export const linkedinSolveCheckpoint = async (linkedInCheckpointRequest: LinkedInCheckpointRequest, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInConnectResponse> => {

  return customInstance<LinkedInConnectResponse>(getLinkedinSolveCheckpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkedInCheckpointRequest)
  }
);}





export const getLinkedinSolveCheckpointMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinSolveCheckpoint>>, TError,{data: LinkedInCheckpointRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkedinSolveCheckpoint>>, TError,{data: LinkedInCheckpointRequest}, TContext> => {

const mutationKey = ['linkedinSolveCheckpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkedinSolveCheckpoint>>, {data: LinkedInCheckpointRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkedinSolveCheckpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkedinSolveCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof linkedinSolveCheckpoint>>>
    export type LinkedinSolveCheckpointMutationBody = LinkedInCheckpointRequest
    export type LinkedinSolveCheckpointMutationError = HTTPValidationError

    /**
 * @summary Linkedin Solve Checkpoint
 */
export const useLinkedinSolveCheckpoint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkedinSolveCheckpoint>>, TError,{data: LinkedInCheckpointRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkedinSolveCheckpoint>>,
        TError,
        {data: LinkedInCheckpointRequest},
        TContext
      > => {
      return useMutation(getLinkedinSolveCheckpointMutationOptions(options), queryClient);
    }

export const getMailboxOauthCallbackUrl = (params: MailboxOauthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/connected-accounts/mailboxes/oauth-callback?${stringifiedParams}` : `/api/connected-accounts/mailboxes/oauth-callback`
}

/**
 * @summary Mailbox Oauth Callback
 */
export const mailboxOauthCallback = async (params: MailboxOauthCallbackParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getMailboxOauthCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMailboxOauthCallbackQueryKey = (params?: MailboxOauthCallbackParams,) => {
    return [
    `/api/connected-accounts/mailboxes/oauth-callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getMailboxOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(params: MailboxOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMailboxOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mailboxOauthCallback>>> = ({ signal }) => mailboxOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MailboxOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof mailboxOauthCallback>>>
export type MailboxOauthCallbackQueryError = HTTPValidationError


export function useMailboxOauthCallback<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mailboxOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof mailboxOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMailboxOauthCallback<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mailboxOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof mailboxOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMailboxOauthCallback<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mailbox Oauth Callback
 */

export function useMailboxOauthCallback<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMailboxOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMailboxOauthCallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(params: MailboxOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMailboxOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mailboxOauthCallback>>> = ({ signal }) => mailboxOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MailboxOauthCallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof mailboxOauthCallback>>>
export type MailboxOauthCallbackSuspenseQueryError = HTTPValidationError


export function useMailboxOauthCallbackSuspense<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMailboxOauthCallbackSuspense<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMailboxOauthCallbackSuspense<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mailbox Oauth Callback
 */

export function useMailboxOauthCallbackSuspense<TData = Awaited<ReturnType<typeof mailboxOauthCallback>>, TError = HTTPValidationError>(
 params: MailboxOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mailboxOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMailboxOauthCallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProjectMemberMailboxesUrl = (projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/members/${memberUserId}/mailboxes?${stringifiedParams}` : `/api/projects/${projectId}/members/${memberUserId}/mailboxes`
}

/**
 * List ``member_user_id``'s mailboxes, scoped to ``project_id``.
 *
 * This is the ONLY way the wizard learns another teammate's mailboxes, so it
 * is gated tightly (fail-closed) and never trusts the client:
 *
 * 1. The project must exist in the caller's org (else 404 — no cross-org leak).
 * 2. The caller must have access to the project (``project:view``).
 * 3. The *target* member must themselves have access to the project (same
 *    collaborator rule the sender dropdown uses), so you cannot enumerate an
 *    arbitrary org user's mailboxes through a project you can merely see.
 *
 * Returns only the target's connected mailboxes (org-scoped). The response
 * shape is identical to ``GET /connected-accounts/mailboxes`` so the frontend
 * reuses the same model.
 * @summary List Project Member Mailboxes
 */
export const listProjectMemberMailboxes = async (projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: Parameters<typeof customInstance>[1]): Promise<MailboxList> => {

  return customInstance<MailboxList>(getListProjectMemberMailboxesUrl(projectId,memberUserId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectMemberMailboxesQueryKey = (projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams,) => {
    return [
    `/api/projects/${projectId}/members/${memberUserId}/mailboxes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectMemberMailboxesQueryOptions = <TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectMemberMailboxesQueryKey(projectId,memberUserId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMemberMailboxes>>> = ({ signal }) => listProjectMemberMailboxes(projectId,memberUserId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && memberUserId !== null && memberUserId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectMemberMailboxesQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMemberMailboxes>>>
export type ListProjectMemberMailboxesQueryError = HTTPValidationError


export function useListProjectMemberMailboxes<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params: undefined |  ListProjectMemberMailboxesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMemberMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listProjectMemberMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMemberMailboxes<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMemberMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listProjectMemberMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMemberMailboxes<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Member Mailboxes
 */

export function useListProjectMemberMailboxes<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMemberMailboxesQueryOptions(projectId,memberUserId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectMemberMailboxesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectMemberMailboxesQueryKey(projectId,memberUserId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMemberMailboxes>>> = ({ signal }) => listProjectMemberMailboxes(projectId,memberUserId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectMemberMailboxesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMemberMailboxes>>>
export type ListProjectMemberMailboxesSuspenseQueryError = HTTPValidationError


export function useListProjectMemberMailboxesSuspense<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params: undefined |  ListProjectMemberMailboxesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMemberMailboxesSuspense<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMemberMailboxesSuspense<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Member Mailboxes
 */

export function useListProjectMemberMailboxesSuspense<TData = Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError = HTTPValidationError>(
 projectId: string,
    memberUserId: string,
    params?: ListProjectMemberMailboxesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMemberMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMemberMailboxesSuspenseQueryOptions(projectId,memberUserId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCalendarOauthStartUrl = () => {




  return `/api/connected-accounts/calendars/oauth-start`
}

/**
 * @summary Calendar Oauth Start
 */
export const calendarOauthStart = async (oAuthStartIn: OAuthStartIn, options?: Parameters<typeof customInstance>[1]): Promise<OAuthStartOut> => {

  return customInstance<OAuthStartOut>(getCalendarOauthStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthStartIn)
  }
);}





export const getCalendarOauthStartMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarOauthStart>>, TError,{data: OAuthStartIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calendarOauthStart>>, TError,{data: OAuthStartIn}, TContext> => {

const mutationKey = ['calendarOauthStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calendarOauthStart>>, {data: OAuthStartIn}> = (props) => {
          const {data} = props ?? {};

          return  calendarOauthStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalendarOauthStartMutationResult = NonNullable<Awaited<ReturnType<typeof calendarOauthStart>>>
    export type CalendarOauthStartMutationBody = OAuthStartIn
    export type CalendarOauthStartMutationError = HTTPValidationError

    /**
 * @summary Calendar Oauth Start
 */
export const useCalendarOauthStart = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarOauthStart>>, TError,{data: OAuthStartIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calendarOauthStart>>,
        TError,
        {data: OAuthStartIn},
        TContext
      > => {
      return useMutation(getCalendarOauthStartMutationOptions(options), queryClient);
    }

export const getListCalendarConnectionsUrl = () => {




  return `/api/connected-accounts/calendars`
}

/**
 * Bare list (D8; like GET …/settings/org/properties): member → own rows; admin → org-wide incl. `disconnected`.
 * @summary List Calendar Connections
 */
export const listCalendarConnections = async ( options?: Parameters<typeof customInstance>[1]): Promise<CalendarConnectionOut[]> => {

  return customInstance<CalendarConnectionOut[]>(getListCalendarConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarConnectionsQueryKey = () => {
    return [
    `/api/connected-accounts/calendars`
    ] as const;
    }


export const getListCalendarConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarConnections>>> = ({ signal }) => listCalendarConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCalendarConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarConnections>>>
export type ListCalendarConnectionsQueryError = unknown


export function useListCalendarConnections<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarConnections>>,
          TError,
          Awaited<ReturnType<typeof listCalendarConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarConnections<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarConnections>>,
          TError,
          Awaited<ReturnType<typeof listCalendarConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarConnections<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Calendar Connections
 */

export function useListCalendarConnections<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCalendarConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListCalendarConnectionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarConnections>>> = ({ signal }) => listCalendarConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCalendarConnectionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarConnections>>>
export type ListCalendarConnectionsSuspenseQueryError = unknown


export function useListCalendarConnectionsSuspense<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarConnectionsSuspense<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarConnectionsSuspense<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Calendar Connections
 */

export function useListCalendarConnectionsSuspense<TData = Awaited<ReturnType<typeof listCalendarConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendarConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCalendarConnectionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReconnectCalendarConnectionUrl = (connectionId: string,) => {




  return `/api/connected-accounts/calendars/${connectionId}/reconnect`
}

/**
 * @summary Reconnect Calendar Connection
 */
export const reconnectCalendarConnection = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<OAuthStartOut> => {

  return customInstance<OAuthStartOut>(getReconnectCalendarConnectionUrl(connectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReconnectCalendarConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconnectCalendarConnection>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reconnectCalendarConnection>>, TError,{connectionId: string}, TContext> => {

const mutationKey = ['reconnectCalendarConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconnectCalendarConnection>>, {connectionId: string}> = (props) => {
          const {connectionId} = props ?? {};

          return  reconnectCalendarConnection(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconnectCalendarConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof reconnectCalendarConnection>>>

    export type ReconnectCalendarConnectionMutationError = HTTPValidationError

    /**
 * @summary Reconnect Calendar Connection
 */
export const useReconnectCalendarConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconnectCalendarConnection>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconnectCalendarConnection>>,
        TError,
        {connectionId: string},
        TContext
      > => {
      return useMutation(getReconnectCalendarConnectionMutationOptions(options), queryClient);
    }

export const getDeleteCalendarConnectionUrl = (connectionId: string,
    params?: DeleteCalendarConnectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/connected-accounts/calendars/${connectionId}?${stringifiedParams}` : `/api/connected-accounts/calendars/${connectionId}`
}

/**
 * `?preview=1` lists the `scheduled` conversations that would cancel; the real delete returns the ones it did cancel
 * (same shape, 200) so the client has one type for both — no bare 204 through the app envelope.
 * @summary Delete Calendar Connection
 */
export const deleteCalendarConnection = async (connectionId: string,
    params?: DeleteCalendarConnectionParams, options?: Parameters<typeof customInstance>[1]): Promise<DeletePreviewOut> => {

  return customInstance<DeletePreviewOut>(getDeleteCalendarConnectionUrl(connectionId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCalendarConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarConnection>>, TError,{connectionId: string;params?: DeleteCalendarConnectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarConnection>>, TError,{connectionId: string;params?: DeleteCalendarConnectionParams}, TContext> => {

const mutationKey = ['deleteCalendarConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCalendarConnection>>, {connectionId: string;params?: DeleteCalendarConnectionParams}> = (props) => {
          const {connectionId,params} = props ?? {};

          return  deleteCalendarConnection(connectionId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCalendarConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCalendarConnection>>>

    export type DeleteCalendarConnectionMutationError = HTTPValidationError

    /**
 * @summary Delete Calendar Connection
 */
export const useDeleteCalendarConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarConnection>>, TError,{connectionId: string;params?: DeleteCalendarConnectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCalendarConnection>>,
        TError,
        {connectionId: string;params?: DeleteCalendarConnectionParams},
        TContext
      > => {
      return useMutation(getDeleteCalendarConnectionMutationOptions(options), queryClient);
    }

export const getCalendarOauthCompleteUrl = () => {




  return `/api/connected-accounts/calendars/oauth-complete`
}

/**
 * @summary Calendar Oauth Complete
 */
export const calendarOauthComplete = async (oAuthCompleteIn: OAuthCompleteIn, options?: Parameters<typeof customInstance>[1]): Promise<OAuthCompleteOut> => {

  return customInstance<OAuthCompleteOut>(getCalendarOauthCompleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthCompleteIn)
  }
);}





export const getCalendarOauthCompleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarOauthComplete>>, TError,{data: OAuthCompleteIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calendarOauthComplete>>, TError,{data: OAuthCompleteIn}, TContext> => {

const mutationKey = ['calendarOauthComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calendarOauthComplete>>, {data: OAuthCompleteIn}> = (props) => {
          const {data} = props ?? {};

          return  calendarOauthComplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalendarOauthCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof calendarOauthComplete>>>
    export type CalendarOauthCompleteMutationBody = OAuthCompleteIn
    export type CalendarOauthCompleteMutationError = HTTPValidationError

    /**
 * @summary Calendar Oauth Complete
 */
export const useCalendarOauthComplete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarOauthComplete>>, TError,{data: OAuthCompleteIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calendarOauthComplete>>,
        TError,
        {data: OAuthCompleteIn},
        TContext
      > => {
      return useMutation(getCalendarOauthCompleteMutationOptions(options), queryClient);
    }

export const getCalendarOauthCallbackUrl = (params?: CalendarOauthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/connected-accounts/calendars/oauth-callback?${stringifiedParams}` : `/api/connected-accounts/calendars/oauth-callback`
}

/**
 * @summary Calendar Oauth Callback
 */
export const calendarOauthCallback = async (params?: CalendarOauthCallbackParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getCalendarOauthCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCalendarOauthCallbackQueryKey = (params?: CalendarOauthCallbackParams,) => {
    return [
    `/api/connected-accounts/calendars/oauth-callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getCalendarOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarOauthCallback>>> = ({ signal }) => calendarOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof calendarOauthCallback>>>
export type CalendarOauthCallbackQueryError = HTTPValidationError


export function useCalendarOauthCallback<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params: undefined |  CalendarOauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof calendarOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarOauthCallback<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof calendarOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarOauthCallback<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Calendar Oauth Callback
 */

export function useCalendarOauthCallback<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCalendarOauthCallbackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarOauthCallback>>> = ({ signal }) => calendarOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarOauthCallbackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof calendarOauthCallback>>>
export type CalendarOauthCallbackSuspenseQueryError = HTTPValidationError


export function useCalendarOauthCallbackSuspense<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params: undefined |  CalendarOauthCallbackParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarOauthCallbackSuspense<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarOauthCallbackSuspense<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Calendar Oauth Callback
 */

export function useCalendarOauthCallbackSuspense<TData = Awaited<ReturnType<typeof calendarOauthCallback>>, TError = HTTPValidationError>(
 params?: CalendarOauthCallbackParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarOauthCallbackSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendInvitationUrl = () => {




  return `/api/invitations/send`
}

/**
 * @summary Send Invitation
 */
export const sendInvitation = async (invitationSendRequest: InvitationSendRequest, options?: Parameters<typeof customInstance>[1]): Promise<InvitationResponse> => {

  return customInstance<InvitationResponse>(getSendInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invitationSendRequest)
  }
);}





export const getSendInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: InvitationSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: InvitationSendRequest}, TContext> => {

const mutationKey = ['sendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInvitation>>, {data: InvitationSendRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof sendInvitation>>>
    export type SendInvitationMutationBody = InvitationSendRequest
    export type SendInvitationMutationError = HTTPValidationError

    /**
 * @summary Send Invitation
 */
export const useSendInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvitation>>, TError,{data: InvitationSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInvitation>>,
        TError,
        {data: InvitationSendRequest},
        TContext
      > => {
      return useMutation(getSendInvitationMutationOptions(options), queryClient);
    }

export const getListPendingInvitationsUrl = () => {




  return `/api/invitations/pending`
}

/**
 * @summary List Pending Invitations
 */
export const listPendingInvitations = async ( options?: Parameters<typeof customInstance>[1]): Promise<InvitationResponse[]> => {

  return customInstance<InvitationResponse[]>(getListPendingInvitationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingInvitationsQueryKey = () => {
    return [
    `/api/invitations/pending`
    ] as const;
    }


export const getListPendingInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingInvitationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingInvitations>>> = ({ signal }) => listPendingInvitations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingInvitations>>>
export type ListPendingInvitationsQueryError = unknown


export function useListPendingInvitations<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof listPendingInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingInvitations<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof listPendingInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingInvitations<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Pending Invitations
 */

export function useListPendingInvitations<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingInvitationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPendingInvitationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingInvitationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingInvitations>>> = ({ signal }) => listPendingInvitations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingInvitationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingInvitations>>>
export type ListPendingInvitationsSuspenseQueryError = unknown


export function useListPendingInvitationsSuspense<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingInvitationsSuspense<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingInvitationsSuspense<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Pending Invitations
 */

export function useListPendingInvitationsSuspense<TData = Awaited<ReturnType<typeof listPendingInvitations>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingInvitationsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeInvitationUrl = (invitationId: string,) => {




  return `/api/invitations/${invitationId}`
}

/**
 * @summary Revoke Invitation
 */
export const revokeInvitation = async (invitationId: string, options?: Parameters<typeof customInstance>[1]): Promise<RevokeInvitation200> => {

  return customInstance<RevokeInvitation200>(getRevokeInvitationUrl(invitationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{invitationId: string}, TContext> => {

const mutationKey = ['revokeInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeInvitation>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  revokeInvitation(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeInvitation>>>

    export type RevokeInvitationMutationError = HTTPValidationError

    /**
 * @summary Revoke Invitation
 */
export const useRevokeInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeInvitation>>,
        TError,
        {invitationId: string},
        TContext
      > => {
      return useMutation(getRevokeInvitationMutationOptions(options), queryClient);
    }

export const getResendInvitationUrl = (invitationId: string,) => {




  return `/api/invitations/${invitationId}/resend`
}

/**
 * @summary Resend Invitation
 */
export const resendInvitation = async (invitationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ResendInvitation200> => {

  return customInstance<ResendInvitation200>(getResendInvitationUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationId: string}, TContext> => {

const mutationKey = ['resendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvitation>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  resendInvitation(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvitation>>>

    export type ResendInvitationMutationError = HTTPValidationError

    /**
 * @summary Resend Invitation
 */
export const useResendInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvitation>>,
        TError,
        {invitationId: string},
        TContext
      > => {
      return useMutation(getResendInvitationMutationOptions(options), queryClient);
    }

export const getAcceptInvitationUrl = (token: string,) => {




  return `/api/invitations/${token}/accept`
}

/**
 * @summary Accept Invitation
 */
export const acceptInvitation = async (token: string, options?: Parameters<typeof customInstance>[1]): Promise<InvitationAcceptResponse> => {

  return customInstance<InvitationAcceptResponse>(getAcceptInvitationUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext> => {

const mutationKey = ['acceptInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitation>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  acceptInvitation(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitation>>>

    export type AcceptInvitationMutationError = HTTPValidationError

    /**
 * @summary Accept Invitation
 */
export const useAcceptInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitation>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getAcceptInvitationMutationOptions(options), queryClient);
    }

export const getGetInvitationDetailUrl = (token: string,) => {




  return `/api/invitations/${token}`
}

/**
 * @summary Get Invitation Detail
 */
export const getInvitationDetail = async (token: string, options?: Parameters<typeof customInstance>[1]): Promise<InvitationDetailResponse> => {

  return customInstance<InvitationDetailResponse>(getGetInvitationDetailUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvitationDetailQueryKey = (token: string,) => {
    return [
    `/api/invitations/${token}`
    ] as const;
    }


export const getGetInvitationDetailQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationDetailQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationDetail>>> = ({ signal }) => getInvitationDetail(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationDetail>>>
export type GetInvitationDetailQueryError = HTTPValidationError


export function useGetInvitationDetail<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationDetail>>,
          TError,
          Awaited<ReturnType<typeof getInvitationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationDetail<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationDetail>>,
          TError,
          Awaited<ReturnType<typeof getInvitationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationDetail<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invitation Detail
 */

export function useGetInvitationDetail<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationDetailQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInvitationDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationDetailQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationDetail>>> = ({ signal }) => getInvitationDetail(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationDetail>>>
export type GetInvitationDetailSuspenseQueryError = HTTPValidationError


export function useGetInvitationDetailSuspense<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationDetailSuspense<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationDetailSuspense<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invitation Detail
 */

export function useGetInvitationDetailSuspense<TData = Awaited<ReturnType<typeof getInvitationDetail>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationDetailSuspenseQueryOptions(token,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListIntegrationsPublicUrl = () => {




  return `/api/public/integrations/catalog`
}

/**
 * @summary List Integrations Public
 */
export const listIntegrationsPublic = async ( options?: Parameters<typeof customInstance>[1]): Promise<IntegrationCatalogResponse> => {

  return customInstance<IntegrationCatalogResponse>(getListIntegrationsPublicUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntegrationsPublicQueryKey = () => {
    return [
    `/api/public/integrations/catalog`
    ] as const;
    }


export const getListIntegrationsPublicQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsPublicQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrationsPublic>>> = ({ signal }) => listIntegrationsPublic({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIntegrationsPublicQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrationsPublic>>>
export type ListIntegrationsPublicQueryError = unknown


export function useListIntegrationsPublic<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrationsPublic>>,
          TError,
          Awaited<ReturnType<typeof listIntegrationsPublic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsPublic<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrationsPublic>>,
          TError,
          Awaited<ReturnType<typeof listIntegrationsPublic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsPublic<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Integrations Public
 */

export function useListIntegrationsPublic<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListIntegrationsPublicSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsPublicQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrationsPublic>>> = ({ signal }) => listIntegrationsPublic({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIntegrationsPublicSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrationsPublic>>>
export type ListIntegrationsPublicSuspenseQueryError = unknown


export function useListIntegrationsPublicSuspense<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsPublicSuspense<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsPublicSuspense<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Integrations Public
 */

export function useListIntegrationsPublicSuspense<TData = Awaited<ReturnType<typeof listIntegrationsPublic>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsPublic>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsPublicSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitIntegrationRequestUrl = () => {




  return `/api/settings/integrations/requests`
}

/**
 * @summary Submit Integration Request
 */
export const submitIntegrationRequest = async (integrationRequestBody: IntegrationRequestBody, options?: Parameters<typeof customInstance>[1]): Promise<IntegrationRequestResponse> => {

  return customInstance<IntegrationRequestResponse>(getSubmitIntegrationRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(integrationRequestBody)
  }
);}





export const getSubmitIntegrationRequestMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitIntegrationRequest>>, TError,{data: IntegrationRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitIntegrationRequest>>, TError,{data: IntegrationRequestBody}, TContext> => {

const mutationKey = ['submitIntegrationRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitIntegrationRequest>>, {data: IntegrationRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  submitIntegrationRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitIntegrationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitIntegrationRequest>>>
    export type SubmitIntegrationRequestMutationBody = IntegrationRequestBody
    export type SubmitIntegrationRequestMutationError = HTTPValidationError

    /**
 * @summary Submit Integration Request
 */
export const useSubmitIntegrationRequest = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitIntegrationRequest>>, TError,{data: IntegrationRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitIntegrationRequest>>,
        TError,
        {data: IntegrationRequestBody},
        TContext
      > => {
      return useMutation(getSubmitIntegrationRequestMutationOptions(options), queryClient);
    }

export const getListIntegrationsAuthenticatedUrl = () => {




  return `/api/settings/integrations/catalog`
}

/**
 * @summary List Integrations Authenticated
 */
export const listIntegrationsAuthenticated = async ( options?: Parameters<typeof customInstance>[1]): Promise<IntegrationCatalogResponse> => {

  return customInstance<IntegrationCatalogResponse>(getListIntegrationsAuthenticatedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntegrationsAuthenticatedQueryKey = () => {
    return [
    `/api/settings/integrations/catalog`
    ] as const;
    }


export const getListIntegrationsAuthenticatedQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsAuthenticatedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>> = ({ signal }) => listIntegrationsAuthenticated({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIntegrationsAuthenticatedQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>>
export type ListIntegrationsAuthenticatedQueryError = unknown


export function useListIntegrationsAuthenticated<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrationsAuthenticated>>,
          TError,
          Awaited<ReturnType<typeof listIntegrationsAuthenticated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsAuthenticated<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrationsAuthenticated>>,
          TError,
          Awaited<ReturnType<typeof listIntegrationsAuthenticated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsAuthenticated<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Integrations Authenticated
 */

export function useListIntegrationsAuthenticated<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsAuthenticatedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListIntegrationsAuthenticatedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsAuthenticatedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>> = ({ signal }) => listIntegrationsAuthenticated({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIntegrationsAuthenticatedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>>
export type ListIntegrationsAuthenticatedSuspenseQueryError = unknown


export function useListIntegrationsAuthenticatedSuspense<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsAuthenticatedSuspense<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIntegrationsAuthenticatedSuspense<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Integrations Authenticated
 */

export function useListIntegrationsAuthenticatedSuspense<TData = Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listIntegrationsAuthenticated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsAuthenticatedSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAtsConnectSessionUrl = () => {




  return `/api/settings/ats/connections/connect-session`
}

/**
 * @summary Create Connect Session
 */
export const createAtsConnectSession = async (connectSessionRequest: ConnectSessionRequest, options?: Parameters<typeof customInstance>[1]): Promise<ConnectSessionResponse> => {

  return customInstance<ConnectSessionResponse>(getCreateAtsConnectSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(connectSessionRequest)
  }
);}





export const getCreateAtsConnectSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAtsConnectSession>>, TError,{data: ConnectSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAtsConnectSession>>, TError,{data: ConnectSessionRequest}, TContext> => {

const mutationKey = ['createAtsConnectSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAtsConnectSession>>, {data: ConnectSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAtsConnectSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAtsConnectSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createAtsConnectSession>>>
    export type CreateAtsConnectSessionMutationBody = ConnectSessionRequest
    export type CreateAtsConnectSessionMutationError = HTTPValidationError

    /**
 * @summary Create Connect Session
 */
export const useCreateAtsConnectSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAtsConnectSession>>, TError,{data: ConnectSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAtsConnectSession>>,
        TError,
        {data: ConnectSessionRequest},
        TContext
      > => {
      return useMutation(getCreateAtsConnectSessionMutationOptions(options), queryClient);
    }

export const getFinalizeAtsConnectionUrl = () => {




  return `/api/settings/ats/connections/finalize`
}

/**
 * Finalize a connection from the Connect SDK activation token. Exchanges the
 * token for the integration server-side (verifying it belongs to this org) and
 * upserts the AtsConnection — the primary, immediate finalization path so the
 * UI doesn't depend on webhook timing.
 * @summary Finalize Connection
 */
export const finalizeAtsConnection = async (finalizeConnectionRequest: FinalizeConnectionRequest, options?: Parameters<typeof customInstance>[1]): Promise<AtsConnectionResponse> => {

  return customInstance<AtsConnectionResponse>(getFinalizeAtsConnectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(finalizeConnectionRequest)
  }
);}





export const getFinalizeAtsConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeAtsConnection>>, TError,{data: FinalizeConnectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof finalizeAtsConnection>>, TError,{data: FinalizeConnectionRequest}, TContext> => {

const mutationKey = ['finalizeAtsConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizeAtsConnection>>, {data: FinalizeConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  finalizeAtsConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizeAtsConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof finalizeAtsConnection>>>
    export type FinalizeAtsConnectionMutationBody = FinalizeConnectionRequest
    export type FinalizeAtsConnectionMutationError = HTTPValidationError

    /**
 * @summary Finalize Connection
 */
export const useFinalizeAtsConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeAtsConnection>>, TError,{data: FinalizeConnectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finalizeAtsConnection>>,
        TError,
        {data: FinalizeConnectionRequest},
        TContext
      > => {
      return useMutation(getFinalizeAtsConnectionMutationOptions(options), queryClient);
    }

export const getListAtsConnectionsUrl = () => {




  return `/api/settings/ats/connections`
}

/**
 * @summary List Connections
 */
export const listAtsConnections = async ( options?: Parameters<typeof customInstance>[1]): Promise<AtsConnectionListResponse> => {

  return customInstance<AtsConnectionListResponse>(getListAtsConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsConnectionsQueryKey = () => {
    return [
    `/api/settings/ats/connections`
    ] as const;
    }


export const getListAtsConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsConnections>>> = ({ signal }) => listAtsConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsConnections>>>
export type ListAtsConnectionsQueryError = unknown


export function useListAtsConnections<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsConnections>>,
          TError,
          Awaited<ReturnType<typeof listAtsConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsConnections<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsConnections>>,
          TError,
          Awaited<ReturnType<typeof listAtsConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsConnections<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Connections
 */

export function useListAtsConnections<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAtsConnectionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsConnections>>> = ({ signal }) => listAtsConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsConnectionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsConnections>>>
export type ListAtsConnectionsSuspenseQueryError = unknown


export function useListAtsConnectionsSuspense<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsConnectionsSuspense<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsConnectionsSuspense<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Connections
 */

export function useListAtsConnectionsSuspense<TData = Awaited<ReturnType<typeof listAtsConnections>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsConnectionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAtsConnectionUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}`
}

/**
 * @summary Get Connection
 */
export const getAtsConnection = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<AtsConnectionResponse> => {

  return customInstance<AtsConnectionResponse>(getGetAtsConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAtsConnectionQueryKey = (connectionId: string,) => {
    return [
    `/api/settings/ats/connections/${connectionId}`
    ] as const;
    }


export const getGetAtsConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsConnection>>> = ({ signal }) => getAtsConnection(connectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsConnection>>>
export type GetAtsConnectionQueryError = HTTPValidationError


export function useGetAtsConnection<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsConnection>>,
          TError,
          Awaited<ReturnType<typeof getAtsConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsConnection<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsConnection>>,
          TError,
          Awaited<ReturnType<typeof getAtsConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsConnection<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Connection
 */

export function useGetAtsConnection<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAtsConnectionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsConnection>>> = ({ signal }) => getAtsConnection(connectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsConnectionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsConnection>>>
export type GetAtsConnectionSuspenseQueryError = HTTPValidationError


export function useGetAtsConnectionSuspense<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsConnectionSuspense<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsConnectionSuspense<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Connection
 */

export function useGetAtsConnectionSuspense<TData = Awaited<ReturnType<typeof getAtsConnection>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsConnection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsConnectionSuspenseQueryOptions(connectionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDisconnectAtsConnectionUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}`
}

/**
 * @summary Delete Connection
 */
export const disconnectAtsConnection = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDisconnectAtsConnectionUrl(connectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectAtsConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAtsConnection>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectAtsConnection>>, TError,{connectionId: string}, TContext> => {

const mutationKey = ['disconnectAtsConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectAtsConnection>>, {connectionId: string}> = (props) => {
          const {connectionId} = props ?? {};

          return  disconnectAtsConnection(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectAtsConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectAtsConnection>>>

    export type DisconnectAtsConnectionMutationError = HTTPValidationError

    /**
 * @summary Delete Connection
 */
export const useDisconnectAtsConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAtsConnection>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectAtsConnection>>,
        TError,
        {connectionId: string},
        TContext
      > => {
      return useMutation(getDisconnectAtsConnectionMutationOptions(options), queryClient);
    }

export const getPatchAtsConnectionTalentPoolUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/talent-pool`
}

/**
 * Choose the tenant pool this connection's future candidates land in.
 * Already-synced profiles stay in their pool.
 * @summary Patch Connection Talent Pool
 */
export const patchAtsConnectionTalentPool = async (connectionId: string,
    connectionTalentPoolPatch: ConnectionTalentPoolPatch, options?: Parameters<typeof customInstance>[1]): Promise<AtsConnectionResponse> => {

  return customInstance<AtsConnectionResponse>(getPatchAtsConnectionTalentPoolUrl(connectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(connectionTalentPoolPatch)
  }
);}





export const getPatchAtsConnectionTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>, TError,{connectionId: string;data: ConnectionTalentPoolPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>, TError,{connectionId: string;data: ConnectionTalentPoolPatch}, TContext> => {

const mutationKey = ['patchAtsConnectionTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>, {connectionId: string;data: ConnectionTalentPoolPatch}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  patchAtsConnectionTalentPool(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAtsConnectionTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>>
    export type PatchAtsConnectionTalentPoolMutationBody = ConnectionTalentPoolPatch
    export type PatchAtsConnectionTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Patch Connection Talent Pool
 */
export const usePatchAtsConnectionTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>, TError,{connectionId: string;data: ConnectionTalentPoolPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAtsConnectionTalentPool>>,
        TError,
        {connectionId: string;data: ConnectionTalentPoolPatch},
        TContext
      > => {
      return useMutation(getPatchAtsConnectionTalentPoolMutationOptions(options), queryClient);
    }

export const getCreateAtsReconnectSessionUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/reconnect-session`
}

/**
 * @summary Reconnect Session
 */
export const createAtsReconnectSession = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConnectSessionResponse> => {

  return customInstance<ConnectSessionResponse>(getCreateAtsReconnectSessionUrl(connectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateAtsReconnectSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAtsReconnectSession>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAtsReconnectSession>>, TError,{connectionId: string}, TContext> => {

const mutationKey = ['createAtsReconnectSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAtsReconnectSession>>, {connectionId: string}> = (props) => {
          const {connectionId} = props ?? {};

          return  createAtsReconnectSession(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAtsReconnectSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createAtsReconnectSession>>>

    export type CreateAtsReconnectSessionMutationError = HTTPValidationError

    /**
 * @summary Reconnect Session
 */
export const useCreateAtsReconnectSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAtsReconnectSession>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAtsReconnectSession>>,
        TError,
        {connectionId: string},
        TContext
      > => {
      return useMutation(getCreateAtsReconnectSessionMutationOptions(options), queryClient);
    }

export const getPatchAtsSyncSettingsUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/sync-settings`
}

/**
 * Partially update a connection's sync settings.
 *
 * Mirrors the sibling connection routes' access checks: active-org required,
 * ``ats_integrations`` feature-gated, org-scoped fetch (cross-org / missing →
 * 404, never 403). Only the provided keys are merged over the resolved
 * defaults; unknown keys are rejected (422) by ``SyncSettingsPatch``.
 * @summary Patch Sync Settings
 */
export const patchAtsSyncSettings = async (connectionId: string,
    syncSettingsPatch: SyncSettingsPatch, options?: Parameters<typeof customInstance>[1]): Promise<PatchAtsSyncSettings200> => {

  return customInstance<PatchAtsSyncSettings200>(getPatchAtsSyncSettingsUrl(connectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncSettingsPatch)
  }
);}





export const getPatchAtsSyncSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsSyncSettings>>, TError,{connectionId: string;data: SyncSettingsPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAtsSyncSettings>>, TError,{connectionId: string;data: SyncSettingsPatch}, TContext> => {

const mutationKey = ['patchAtsSyncSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAtsSyncSettings>>, {connectionId: string;data: SyncSettingsPatch}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  patchAtsSyncSettings(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAtsSyncSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchAtsSyncSettings>>>
    export type PatchAtsSyncSettingsMutationBody = SyncSettingsPatch
    export type PatchAtsSyncSettingsMutationError = HTTPValidationError

    /**
 * @summary Patch Sync Settings
 */
export const usePatchAtsSyncSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsSyncSettings>>, TError,{connectionId: string;data: SyncSettingsPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAtsSyncSettings>>,
        TError,
        {connectionId: string;data: SyncSettingsPatch},
        TContext
      > => {
      return useMutation(getPatchAtsSyncSettingsMutationOptions(options), queryClient);
    }

export const getListAtsRejectionReasonsUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/rejection-reasons`
}

/**
 * Return rejection-reason preflight for a connection.
 *
 * Calls the ATS provider to list available reasons and asserts the connection
 * allows rejecting.  Cross-org / missing connection → 404 (never 403).
 * @summary List Ats Rejection Reasons
 */
export const listAtsRejectionReasons = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<RejectPreflightOut> => {

  return customInstance<RejectPreflightOut>(getListAtsRejectionReasonsUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsRejectionReasonsQueryKey = (connectionId: string,) => {
    return [
    `/api/settings/ats/connections/${connectionId}/rejection-reasons`
    ] as const;
    }


export const getListAtsRejectionReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsRejectionReasonsQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsRejectionReasons>>> = ({ signal }) => listAtsRejectionReasons(connectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsRejectionReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsRejectionReasons>>>
export type ListAtsRejectionReasonsQueryError = HTTPValidationError


export function useListAtsRejectionReasons<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsRejectionReasons>>,
          TError,
          Awaited<ReturnType<typeof listAtsRejectionReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsRejectionReasons<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsRejectionReasons>>,
          TError,
          Awaited<ReturnType<typeof listAtsRejectionReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsRejectionReasons<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Ats Rejection Reasons
 */

export function useListAtsRejectionReasons<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsRejectionReasonsQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAtsRejectionReasonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsRejectionReasonsQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsRejectionReasons>>> = ({ signal }) => listAtsRejectionReasons(connectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsRejectionReasonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsRejectionReasons>>>
export type ListAtsRejectionReasonsSuspenseQueryError = HTTPValidationError


export function useListAtsRejectionReasonsSuspense<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsRejectionReasonsSuspense<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsRejectionReasonsSuspense<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Ats Rejection Reasons
 */

export function useListAtsRejectionReasonsSuspense<TData = Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError = HTTPValidationError>(
 connectionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsRejectionReasonsSuspenseQueryOptions(connectionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRejectAtsApplicationUrl = (connectionId: string,
    jobCandidateId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/candidates/${jobCandidateId}/reject`
}

/**
 * Reject a candidate application via the ATS.
 *
 * Runs a preflight check before enqueuing the reject write-back workflow.
 * Returns 409 when the ATS blocks rejection or no reason was provided.
 * @summary Reject Ats Application
 */
export const rejectAtsApplication = async (connectionId: string,
    jobCandidateId: string,
    rejectRequest: RejectRequest, options?: Parameters<typeof customInstance>[1]): Promise<AtsPushResult> => {

  return customInstance<AtsPushResult>(getRejectAtsApplicationUrl(connectionId,jobCandidateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejectRequest)
  }
);}





export const getRejectAtsApplicationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplication>>, TError,{connectionId: string;jobCandidateId: string;data: RejectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplication>>, TError,{connectionId: string;jobCandidateId: string;data: RejectRequest}, TContext> => {

const mutationKey = ['rejectAtsApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAtsApplication>>, {connectionId: string;jobCandidateId: string;data: RejectRequest}> = (props) => {
          const {connectionId,jobCandidateId,data} = props ?? {};

          return  rejectAtsApplication(connectionId,jobCandidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAtsApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAtsApplication>>>
    export type RejectAtsApplicationMutationBody = RejectRequest
    export type RejectAtsApplicationMutationError = HTTPValidationError

    /**
 * @summary Reject Ats Application
 */
export const useRejectAtsApplication = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplication>>, TError,{connectionId: string;jobCandidateId: string;data: RejectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAtsApplication>>,
        TError,
        {connectionId: string;jobCandidateId: string;data: RejectRequest},
        TContext
      > => {
      return useMutation(getRejectAtsApplicationMutationOptions(options), queryClient);
    }

export const getRejectAtsApplicationsBulkUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/candidates/reject-bulk`
}

/**
 * Bulk reject candidates for ONE job through an ATS connection (spec B3).
 *
 * Narrowed to a single ``body.job_id``: edit access + an active job↔connection
 * link are enforced up front. The selection (explicit ids XOR a compact
 * pipeline ``bulk`` descriptor) is split into application-linked candidates
 * (reject-enqueued in the ATS) and unpushed candidates (archived locally →
 * ``ARCHIVED_LOCAL``). The ATS reason/blocked gates apply only when at least
 * one candidate is application-linked; a purely local selection skips them.
 * Per-candidate failures are reported, not fatal (partial success).
 * @summary Reject Ats Applications Bulk
 */
export const rejectAtsApplicationsBulk = async (connectionId: string,
    bulkRejectRequest: BulkRejectRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkRejectResponse> => {

  return customInstance<BulkRejectResponse>(getRejectAtsApplicationsBulkUrl(connectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkRejectRequest)
  }
);}





export const getRejectAtsApplicationsBulkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>, TError,{connectionId: string;data: BulkRejectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>, TError,{connectionId: string;data: BulkRejectRequest}, TContext> => {

const mutationKey = ['rejectAtsApplicationsBulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>, {connectionId: string;data: BulkRejectRequest}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  rejectAtsApplicationsBulk(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAtsApplicationsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>>
    export type RejectAtsApplicationsBulkMutationBody = BulkRejectRequest
    export type RejectAtsApplicationsBulkMutationError = HTTPValidationError

    /**
 * @summary Reject Ats Applications Bulk
 */
export const useRejectAtsApplicationsBulk = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>, TError,{connectionId: string;data: BulkRejectRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAtsApplicationsBulk>>,
        TError,
        {connectionId: string;data: BulkRejectRequest},
        TContext
      > => {
      return useMutation(getRejectAtsApplicationsBulkMutationOptions(options), queryClient);
    }

export const getAtsSyncNowUrl = (connectionId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/sync-now`
}

/**
 * Trigger an immediate full sync for an ATS connection.
 *
 * Uses the singleton-workflow pattern from sync_trigger (FAIL + requeue
 * signal) so concurrent manual triggers never start a second run.
 * @summary Ats Sync Now
 */
export const atsSyncNow = async (connectionId: string, options?: Parameters<typeof customInstance>[1]): Promise<SyncNowResponse> => {

  return customInstance<SyncNowResponse>(getAtsSyncNowUrl(connectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAtsSyncNowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof atsSyncNow>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof atsSyncNow>>, TError,{connectionId: string}, TContext> => {

const mutationKey = ['atsSyncNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof atsSyncNow>>, {connectionId: string}> = (props) => {
          const {connectionId} = props ?? {};

          return  atsSyncNow(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AtsSyncNowMutationResult = NonNullable<Awaited<ReturnType<typeof atsSyncNow>>>

    export type AtsSyncNowMutationError = HTTPValidationError

    /**
 * @summary Ats Sync Now
 */
export const useAtsSyncNow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof atsSyncNow>>, TError,{connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof atsSyncNow>>,
        TError,
        {connectionId: string},
        TContext
      > => {
      return useMutation(getAtsSyncNowMutationOptions(options), queryClient);
    }

export const getRetryAtsPushUrl = (connectionId: string,
    jobCandidateId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/candidates/${jobCandidateId}/retry-push`
}

/**
 * Re-enqueue an AtsPushWorkflow for an errored entity link.
 *
 * Finds the most recent ``error`` state AtsEntityLink (entity_type=
 * 'application') for this candidate+connection and starts a fresh
 * create_application push.  404 if no errored link exists or the candidate
 * is gone; 403 when the caller lacks EDIT on the candidate's project.
 * @summary Retry Ats Push
 */
export const retryAtsPush = async (connectionId: string,
    jobCandidateId: string, options?: Parameters<typeof customInstance>[1]): Promise<AtsPushResult> => {

  return customInstance<AtsPushResult>(getRetryAtsPushUrl(connectionId,jobCandidateId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryAtsPushMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAtsPush>>, TError,{connectionId: string;jobCandidateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryAtsPush>>, TError,{connectionId: string;jobCandidateId: string}, TContext> => {

const mutationKey = ['retryAtsPush'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAtsPush>>, {connectionId: string;jobCandidateId: string}> = (props) => {
          const {connectionId,jobCandidateId} = props ?? {};

          return  retryAtsPush(connectionId,jobCandidateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAtsPushMutationResult = NonNullable<Awaited<ReturnType<typeof retryAtsPush>>>

    export type RetryAtsPushMutationError = HTTPValidationError

    /**
 * @summary Retry Ats Push
 */
export const useRetryAtsPush = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAtsPush>>, TError,{connectionId: string;jobCandidateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryAtsPush>>,
        TError,
        {connectionId: string;jobCandidateId: string},
        TContext
      > => {
      return useMutation(getRetryAtsPushMutationOptions(options), queryClient);
    }

export const getPushAtsEvaluationUrl = (connectionId: string,
    evaluationId: string,) => {




  return `/api/settings/ats/connections/${connectionId}/evaluations/${evaluationId}/push`
}

/**
 * Push an Arbitrator evaluation to the ATS as a scorecard.
 *
 * Resolves the fidelity rung from capabilities_snapshot and returns it
 * before dispatch so the UI can display "will push as PDF+note" etc.
 * Cross-org / missing connection → 404. Unpushable evaluation → 422.
 * Concurrent duplicate workflow → 409.
 * @summary Push Ats Evaluation
 */
export const pushAtsEvaluation = async (connectionId: string,
    evaluationId: string, options?: Parameters<typeof customInstance>[1]): Promise<PushEvaluationResult> => {

  return customInstance<PushEvaluationResult>(getPushAtsEvaluationUrl(connectionId,evaluationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPushAtsEvaluationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushAtsEvaluation>>, TError,{connectionId: string;evaluationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pushAtsEvaluation>>, TError,{connectionId: string;evaluationId: string}, TContext> => {

const mutationKey = ['pushAtsEvaluation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushAtsEvaluation>>, {connectionId: string;evaluationId: string}> = (props) => {
          const {connectionId,evaluationId} = props ?? {};

          return  pushAtsEvaluation(connectionId,evaluationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushAtsEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof pushAtsEvaluation>>>

    export type PushAtsEvaluationMutationError = HTTPValidationError

    /**
 * @summary Push Ats Evaluation
 */
export const usePushAtsEvaluation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushAtsEvaluation>>, TError,{connectionId: string;evaluationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pushAtsEvaluation>>,
        TError,
        {connectionId: string;evaluationId: string},
        TContext
      > => {
      return useMutation(getPushAtsEvaluationMutationOptions(options), queryClient);
    }

export const getListRemoteAtsJobsUrl = (connectionId: string,
    params?: ListRemoteAtsJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/settings/ats/connections/${connectionId}/remote-jobs?${stringifiedParams}` : `/api/settings/ats/connections/${connectionId}/remote-jobs`
}

/**
 * @summary List Remote Jobs
 */
export const listRemoteAtsJobs = async (connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: Parameters<typeof customInstance>[1]): Promise<RemoteJobListResponse> => {

  return customInstance<RemoteJobListResponse>(getListRemoteAtsJobsUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemoteAtsJobsQueryKey = (connectionId: string,
    params?: ListRemoteAtsJobsParams,) => {
    return [
    `/api/settings/ats/connections/${connectionId}/remote-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRemoteAtsJobsQueryOptions = <TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemoteAtsJobsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemoteAtsJobs>>> = ({ signal }) => listRemoteAtsJobs(connectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRemoteAtsJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listRemoteAtsJobs>>>
export type ListRemoteAtsJobsQueryError = HTTPValidationError


export function useListRemoteAtsJobs<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params: undefined |  ListRemoteAtsJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRemoteAtsJobs>>,
          TError,
          Awaited<ReturnType<typeof listRemoteAtsJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRemoteAtsJobs<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRemoteAtsJobs>>,
          TError,
          Awaited<ReturnType<typeof listRemoteAtsJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRemoteAtsJobs<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Jobs
 */

export function useListRemoteAtsJobs<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRemoteAtsJobsQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListRemoteAtsJobsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemoteAtsJobsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemoteAtsJobs>>> = ({ signal }) => listRemoteAtsJobs(connectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRemoteAtsJobsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listRemoteAtsJobs>>>
export type ListRemoteAtsJobsSuspenseQueryError = HTTPValidationError


export function useListRemoteAtsJobsSuspense<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params: undefined |  ListRemoteAtsJobsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRemoteAtsJobsSuspense<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRemoteAtsJobsSuspense<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Jobs
 */

export function useListRemoteAtsJobsSuspense<TData = Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListRemoteAtsJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRemoteAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRemoteAtsJobsSuspenseQueryOptions(connectionId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkAtsJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/link`
}

/**
 * @summary Link Job
 */
export const linkAtsJob = async (jobId: string,
    linkJobRequest: LinkJobRequest, options?: Parameters<typeof customInstance>[1]): Promise<JobLinkResponse> => {

  return customInstance<JobLinkResponse>(getLinkAtsJobUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkJobRequest)
  }
);}





export const getLinkAtsJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAtsJob>>, TError,{jobId: string;data: LinkJobRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkAtsJob>>, TError,{jobId: string;data: LinkJobRequest}, TContext> => {

const mutationKey = ['linkAtsJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkAtsJob>>, {jobId: string;data: LinkJobRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  linkAtsJob(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof linkAtsJob>>>
    export type LinkAtsJobMutationBody = LinkJobRequest
    export type LinkAtsJobMutationError = HTTPValidationError

    /**
 * @summary Link Job
 */
export const useLinkAtsJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAtsJob>>, TError,{jobId: string;data: LinkJobRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkAtsJob>>,
        TError,
        {jobId: string;data: LinkJobRequest},
        TContext
      > => {
      return useMutation(getLinkAtsJobMutationOptions(options), queryClient);
    }

export const getGetJobAtsLinkUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/link`
}

/**
 * @summary Get Job Ats Link
 */
export const getJobAtsLink = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobAtsLinkResponse> => {

  return customInstance<JobAtsLinkResponse>(getGetJobAtsLinkUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobAtsLinkQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/ats/link`
    ] as const;
    }


export const getGetJobAtsLinkQueryOptions = <TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAtsLinkQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobAtsLink>>> = ({ signal }) => getJobAtsLink(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobAtsLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getJobAtsLink>>>
export type GetJobAtsLinkQueryError = HTTPValidationError


export function useGetJobAtsLink<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobAtsLink>>,
          TError,
          Awaited<ReturnType<typeof getJobAtsLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobAtsLink<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobAtsLink>>,
          TError,
          Awaited<ReturnType<typeof getJobAtsLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobAtsLink<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Ats Link
 */

export function useGetJobAtsLink<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobAtsLinkQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobAtsLinkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAtsLinkQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobAtsLink>>> = ({ signal }) => getJobAtsLink(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobAtsLinkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getJobAtsLink>>>
export type GetJobAtsLinkSuspenseQueryError = HTTPValidationError


export function useGetJobAtsLinkSuspense<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobAtsLinkSuspense<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobAtsLinkSuspense<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Ats Link
 */

export function useGetJobAtsLinkSuspense<TData = Awaited<ReturnType<typeof getJobAtsLink>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobAtsLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobAtsLinkSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUnlinkAtsJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/link`
}

/**
 * @summary Unlink Job
 */
export const unlinkAtsJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getUnlinkAtsJobUrl(jobId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkAtsJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAtsJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkAtsJob>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['unlinkAtsJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkAtsJob>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  unlinkAtsJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkAtsJob>>>

    export type UnlinkAtsJobMutationError = HTTPValidationError

    /**
 * @summary Unlink Job
 */
export const useUnlinkAtsJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAtsJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkAtsJob>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getUnlinkAtsJobMutationOptions(options), queryClient);
    }

export const getPreviewAtsLinkStageMapUrl = (jobId: string,
    params: PreviewAtsLinkStageMapParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/ats/link/stage-map-preview?${stringifiedParams}` : `/api/jobs/${jobId}/ats/link/stage-map-preview`
}

/**
 * @summary Preview Link Stage Map
 */
export const previewAtsLinkStageMap = async (jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: Parameters<typeof customInstance>[1]): Promise<LinkStageMapPreviewResponse> => {

  return customInstance<LinkStageMapPreviewResponse>(getPreviewAtsLinkStageMapUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewAtsLinkStageMapQueryKey = (jobId: string,
    params?: PreviewAtsLinkStageMapParams,) => {
    return [
    `/api/jobs/${jobId}/ats/link/stage-map-preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewAtsLinkStageMapQueryOptions = <TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewAtsLinkStageMapQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewAtsLinkStageMap>>> = ({ signal }) => previewAtsLinkStageMap(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewAtsLinkStageMapQueryResult = NonNullable<Awaited<ReturnType<typeof previewAtsLinkStageMap>>>
export type PreviewAtsLinkStageMapQueryError = HTTPValidationError


export function usePreviewAtsLinkStageMap<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewAtsLinkStageMap>>,
          TError,
          Awaited<ReturnType<typeof previewAtsLinkStageMap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewAtsLinkStageMap<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewAtsLinkStageMap>>,
          TError,
          Awaited<ReturnType<typeof previewAtsLinkStageMap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewAtsLinkStageMap<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Link Stage Map
 */

export function usePreviewAtsLinkStageMap<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewAtsLinkStageMapQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPreviewAtsLinkStageMapSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewAtsLinkStageMapQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewAtsLinkStageMap>>> = ({ signal }) => previewAtsLinkStageMap(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewAtsLinkStageMapSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof previewAtsLinkStageMap>>>
export type PreviewAtsLinkStageMapSuspenseQueryError = HTTPValidationError


export function usePreviewAtsLinkStageMapSuspense<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewAtsLinkStageMapSuspense<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewAtsLinkStageMapSuspense<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Link Stage Map
 */

export function usePreviewAtsLinkStageMapSuspense<TData = Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError = HTTPValidationError>(
 jobId: string,
    params: PreviewAtsLinkStageMapParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewAtsLinkStageMap>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewAtsLinkStageMapSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportAtsJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/import`
}

/**
 * @summary Import Job
 */
export const importAtsJob = async (jobId: string,
    importJobRequest: ImportJobRequest, options?: Parameters<typeof customInstance>[1]): Promise<JobLinkResponse> => {

  return customInstance<JobLinkResponse>(getImportAtsJobUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importJobRequest)
  }
);}





export const getImportAtsJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,{jobId: string;data: ImportJobRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,{jobId: string;data: ImportJobRequest}, TContext> => {

const mutationKey = ['importAtsJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importAtsJob>>, {jobId: string;data: ImportJobRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  importAtsJob(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof importAtsJob>>>
    export type ImportAtsJobMutationBody = ImportJobRequest
    export type ImportAtsJobMutationError = HTTPValidationError

    /**
 * @summary Import Job
 */
export const useImportAtsJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,{jobId: string;data: ImportJobRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importAtsJob>>,
        TError,
        {jobId: string;data: ImportJobRequest},
        TContext
      > => {
      return useMutation(getImportAtsJobMutationOptions(options), queryClient);
    }

export const getGetAtsStageMappingsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/stage-mappings`
}

/**
 * @summary Get Stage Mappings
 */
export const getAtsStageMappings = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<StageMappingListResponse> => {

  return customInstance<StageMappingListResponse>(getGetAtsStageMappingsUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAtsStageMappingsQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/ats/stage-mappings`
    ] as const;
    }


export const getGetAtsStageMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsStageMappingsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsStageMappings>>> = ({ signal }) => getAtsStageMappings(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsStageMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsStageMappings>>>
export type GetAtsStageMappingsQueryError = HTTPValidationError


export function useGetAtsStageMappings<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsStageMappings>>,
          TError,
          Awaited<ReturnType<typeof getAtsStageMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsStageMappings<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsStageMappings>>,
          TError,
          Awaited<ReturnType<typeof getAtsStageMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsStageMappings<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Stage Mappings
 */

export function useGetAtsStageMappings<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsStageMappingsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAtsStageMappingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsStageMappingsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsStageMappings>>> = ({ signal }) => getAtsStageMappings(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsStageMappingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsStageMappings>>>
export type GetAtsStageMappingsSuspenseQueryError = HTTPValidationError


export function useGetAtsStageMappingsSuspense<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsStageMappingsSuspense<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsStageMappingsSuspense<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Stage Mappings
 */

export function useGetAtsStageMappingsSuspense<TData = Awaited<ReturnType<typeof getAtsStageMappings>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsStageMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsStageMappingsSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAtsStageMappingsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/stage-mappings`
}

/**
 * @summary Update Stage Mappings
 */
export const updateAtsStageMappings = async (jobId: string,
    updateStageMappingsRequest: UpdateStageMappingsRequest, options?: Parameters<typeof customInstance>[1]): Promise<StageMappingListResponse> => {

  return customInstance<StageMappingListResponse>(getUpdateAtsStageMappingsUrl(jobId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateStageMappingsRequest)
  }
);}





export const getUpdateAtsStageMappingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAtsStageMappings>>, TError,{jobId: string;data: UpdateStageMappingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAtsStageMappings>>, TError,{jobId: string;data: UpdateStageMappingsRequest}, TContext> => {

const mutationKey = ['updateAtsStageMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAtsStageMappings>>, {jobId: string;data: UpdateStageMappingsRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  updateAtsStageMappings(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAtsStageMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAtsStageMappings>>>
    export type UpdateAtsStageMappingsMutationBody = UpdateStageMappingsRequest
    export type UpdateAtsStageMappingsMutationError = HTTPValidationError

    /**
 * @summary Update Stage Mappings
 */
export const useUpdateAtsStageMappings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAtsStageMappings>>, TError,{jobId: string;data: UpdateStageMappingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAtsStageMappings>>,
        TError,
        {jobId: string;data: UpdateStageMappingsRequest},
        TContext
      > => {
      return useMutation(getUpdateAtsStageMappingsMutationOptions(options), queryClient);
    }

export const getGetAtsAttachmentStatusUrl = (jobId: string,
    jobCandidateId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jobCandidateId}/ats/attachment-status`
}

/**
 * @summary Ats Attachment Status
 */
export const getAtsAttachmentStatus = async (jobId: string,
    jobCandidateId: string, options?: Parameters<typeof customInstance>[1]): Promise<ResumeSyncStatusResponse> => {

  return customInstance<ResumeSyncStatusResponse>(getGetAtsAttachmentStatusUrl(jobId,jobCandidateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAtsAttachmentStatusQueryKey = (jobId: string,
    jobCandidateId: string,) => {
    return [
    `/api/jobs/${jobId}/candidates/${jobCandidateId}/ats/attachment-status`
    ] as const;
    }


export const getGetAtsAttachmentStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsAttachmentStatusQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsAttachmentStatus>>> = ({ signal }) => getAtsAttachmentStatus(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && jobCandidateId !== null && jobCandidateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsAttachmentStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsAttachmentStatus>>>
export type GetAtsAttachmentStatusQueryError = HTTPValidationError


export function useGetAtsAttachmentStatus<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsAttachmentStatus>>,
          TError,
          Awaited<ReturnType<typeof getAtsAttachmentStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsAttachmentStatus<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsAttachmentStatus>>,
          TError,
          Awaited<ReturnType<typeof getAtsAttachmentStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsAttachmentStatus<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ats Attachment Status
 */

export function useGetAtsAttachmentStatus<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsAttachmentStatusQueryOptions(jobId,jobCandidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAtsAttachmentStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsAttachmentStatusQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsAttachmentStatus>>> = ({ signal }) => getAtsAttachmentStatus(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsAttachmentStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsAttachmentStatus>>>
export type GetAtsAttachmentStatusSuspenseQueryError = HTTPValidationError


export function useGetAtsAttachmentStatusSuspense<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsAttachmentStatusSuspense<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsAttachmentStatusSuspense<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ats Attachment Status
 */

export function useGetAtsAttachmentStatusSuspense<TData = Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsAttachmentStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsAttachmentStatusSuspenseQueryOptions(jobId,jobCandidateId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAtsPromotionPrecheckUrl = (jobId: string,
    jobCandidateId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jobCandidateId}/ats/promotion-precheck`
}

/**
 * @summary Ats Promotion Precheck
 */
export const getAtsPromotionPrecheck = async (jobId: string,
    jobCandidateId: string, options?: Parameters<typeof customInstance>[1]): Promise<PromotionPrecheckResponse> => {

  return customInstance<PromotionPrecheckResponse>(getGetAtsPromotionPrecheckUrl(jobId,jobCandidateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAtsPromotionPrecheckQueryKey = (jobId: string,
    jobCandidateId: string,) => {
    return [
    `/api/jobs/${jobId}/candidates/${jobCandidateId}/ats/promotion-precheck`
    ] as const;
    }


export const getGetAtsPromotionPrecheckQueryOptions = <TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsPromotionPrecheckQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>> = ({ signal }) => getAtsPromotionPrecheck(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && jobCandidateId !== null && jobCandidateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsPromotionPrecheckQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>>
export type GetAtsPromotionPrecheckQueryError = HTTPValidationError


export function useGetAtsPromotionPrecheck<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsPromotionPrecheck>>,
          TError,
          Awaited<ReturnType<typeof getAtsPromotionPrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsPromotionPrecheck<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsPromotionPrecheck>>,
          TError,
          Awaited<ReturnType<typeof getAtsPromotionPrecheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsPromotionPrecheck<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ats Promotion Precheck
 */

export function useGetAtsPromotionPrecheck<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsPromotionPrecheckQueryOptions(jobId,jobCandidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAtsPromotionPrecheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsPromotionPrecheckQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>> = ({ signal }) => getAtsPromotionPrecheck(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsPromotionPrecheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>>
export type GetAtsPromotionPrecheckSuspenseQueryError = HTTPValidationError


export function useGetAtsPromotionPrecheckSuspense<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsPromotionPrecheckSuspense<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsPromotionPrecheckSuspense<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ats Promotion Precheck
 */

export function useGetAtsPromotionPrecheckSuspense<TData = Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAtsPromotionPrecheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsPromotionPrecheckSuspenseQueryOptions(jobId,jobCandidateId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResetAtsScreeningAnswersEnforcementUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/screening-answers-enforcement/reset`
}

/**
 * Return an active Ashby link to fail-open screening-answer mode.
 * @summary Reset Screening Answers Enforcement
 */
export const resetAtsScreeningAnswersEnforcement = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<ScreeningAnswersEnforcementResetResponse> => {

  return customInstance<ScreeningAnswersEnforcementResetResponse>(getResetAtsScreeningAnswersEnforcementUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetAtsScreeningAnswersEnforcementMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['resetAtsScreeningAnswersEnforcement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  resetAtsScreeningAnswersEnforcement(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetAtsScreeningAnswersEnforcementMutationResult = NonNullable<Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>>

    export type ResetAtsScreeningAnswersEnforcementMutationError = HTTPValidationError

    /**
 * @summary Reset Screening Answers Enforcement
 */
export const useResetAtsScreeningAnswersEnforcement = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetAtsScreeningAnswersEnforcement>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getResetAtsScreeningAnswersEnforcementMutationOptions(options), queryClient);
    }

export const getPatchAtsApplicationAnswersUrl = (jobId: string,
    jobCandidateId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jobCandidateId}/ats/application-answers`
}

/**
 * Persist application-question answers for a job candidate (#20).
 *
 * Allowed/forbidden field ids come from the current Ashby screening defs
 * (partial scope). Optional ``apply_to_job_candidate_ids`` copies the same
 * field patch onto other candidates on this job.
 * @summary Patch Application Answers
 */
export const patchAtsApplicationAnswers = async (jobId: string,
    jobCandidateId: string,
    applicationAnswersPatch: ApplicationAnswersPatch, options?: Parameters<typeof customInstance>[1]): Promise<ApplicationAnswersResponse> => {

  return customInstance<ApplicationAnswersResponse>(getPatchAtsApplicationAnswersUrl(jobId,jobCandidateId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(applicationAnswersPatch)
  }
);}





export const getPatchAtsApplicationAnswersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsApplicationAnswers>>, TError,{jobId: string;jobCandidateId: string;data: ApplicationAnswersPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAtsApplicationAnswers>>, TError,{jobId: string;jobCandidateId: string;data: ApplicationAnswersPatch}, TContext> => {

const mutationKey = ['patchAtsApplicationAnswers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAtsApplicationAnswers>>, {jobId: string;jobCandidateId: string;data: ApplicationAnswersPatch}> = (props) => {
          const {jobId,jobCandidateId,data} = props ?? {};

          return  patchAtsApplicationAnswers(jobId,jobCandidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAtsApplicationAnswersMutationResult = NonNullable<Awaited<ReturnType<typeof patchAtsApplicationAnswers>>>
    export type PatchAtsApplicationAnswersMutationBody = ApplicationAnswersPatch
    export type PatchAtsApplicationAnswersMutationError = HTTPValidationError

    /**
 * @summary Patch Application Answers
 */
export const usePatchAtsApplicationAnswers = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAtsApplicationAnswers>>, TError,{jobId: string;jobCandidateId: string;data: ApplicationAnswersPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAtsApplicationAnswers>>,
        TError,
        {jobId: string;jobCandidateId: string;data: ApplicationAnswersPatch},
        TContext
      > => {
      return useMutation(getPatchAtsApplicationAnswersMutationOptions(options), queryClient);
    }

export const getListAtsSyncRunsUrl = (connectionId: string,
    params?: ListAtsSyncRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/settings/ats/connections/${connectionId}/sync-runs?${stringifiedParams}` : `/api/settings/ats/connections/${connectionId}/sync-runs`
}

/**
 * @summary List Sync Runs
 */
export const listAtsSyncRuns = async (connectionId: string,
    params?: ListAtsSyncRunsParams, options?: Parameters<typeof customInstance>[1]): Promise<SyncRunListResponse> => {

  return customInstance<SyncRunListResponse>(getListAtsSyncRunsUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsSyncRunsQueryKey = (connectionId: string,
    params?: ListAtsSyncRunsParams,) => {
    return [
    `/api/settings/ats/connections/${connectionId}/sync-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAtsSyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsSyncRunsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsSyncRuns>>> = ({ signal }) => listAtsSyncRuns(connectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsSyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsSyncRuns>>>
export type ListAtsSyncRunsQueryError = HTTPValidationError


export function useListAtsSyncRuns<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params: undefined |  ListAtsSyncRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsSyncRuns>>,
          TError,
          Awaited<ReturnType<typeof listAtsSyncRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsSyncRuns<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsSyncRuns>>,
          TError,
          Awaited<ReturnType<typeof listAtsSyncRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsSyncRuns<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sync Runs
 */

export function useListAtsSyncRuns<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsSyncRunsQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAtsSyncRunsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsSyncRunsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsSyncRuns>>> = ({ signal }) => listAtsSyncRuns(connectionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsSyncRunsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsSyncRuns>>>
export type ListAtsSyncRunsSuspenseQueryError = HTTPValidationError


export function useListAtsSyncRunsSuspense<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params: undefined |  ListAtsSyncRunsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsSyncRunsSuspense<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsSyncRunsSuspense<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sync Runs
 */

export function useListAtsSyncRunsSuspense<TData = Awaited<ReturnType<typeof listAtsSyncRuns>>, TError = HTTPValidationError>(
 connectionId: string,
    params?: ListAtsSyncRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsSyncRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsSyncRunsSuspenseQueryOptions(connectionId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAtsNeedsMergeUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/ats/needs-merge`
}

/**
 * @summary Get Needs Merge
 */
export const listAtsNeedsMerge = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<NeedsMergeListResponse> => {

  return customInstance<NeedsMergeListResponse>(getListAtsNeedsMergeUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsNeedsMergeQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/ats/needs-merge`
    ] as const;
    }


export const getListAtsNeedsMergeQueryOptions = <TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsNeedsMergeQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsNeedsMerge>>> = ({ signal }) => listAtsNeedsMerge(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsNeedsMergeQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsNeedsMerge>>>
export type ListAtsNeedsMergeQueryError = HTTPValidationError


export function useListAtsNeedsMerge<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsNeedsMerge>>,
          TError,
          Awaited<ReturnType<typeof listAtsNeedsMerge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsNeedsMerge<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAtsNeedsMerge>>,
          TError,
          Awaited<ReturnType<typeof listAtsNeedsMerge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsNeedsMerge<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Needs Merge
 */

export function useListAtsNeedsMerge<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsNeedsMergeQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAtsNeedsMergeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAtsNeedsMergeQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsNeedsMerge>>> = ({ signal }) => listAtsNeedsMerge(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAtsNeedsMergeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsNeedsMerge>>>
export type ListAtsNeedsMergeSuspenseQueryError = HTTPValidationError


export function useListAtsNeedsMergeSuspense<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsNeedsMergeSuspense<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAtsNeedsMergeSuspense<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Needs Merge
 */

export function useListAtsNeedsMergeSuspense<TData = Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAtsNeedsMerge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsNeedsMergeSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolveAtsNeedsMergeUrl = (jobId: string,
    linkId: string,) => {




  return `/api/jobs/${jobId}/ats/needs-merge/${linkId}/resolve`
}

/**
 * @summary Post Resolve Needs Merge
 */
export const resolveAtsNeedsMerge = async (jobId: string,
    linkId: string,
    resolveMergeRequest: ResolveMergeRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResolveMergeResponse> => {

  return customInstance<ResolveMergeResponse>(getResolveAtsNeedsMergeUrl(jobId,linkId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveMergeRequest)
  }
);}





export const getResolveAtsNeedsMergeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveAtsNeedsMerge>>, TError,{jobId: string;linkId: string;data: ResolveMergeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveAtsNeedsMerge>>, TError,{jobId: string;linkId: string;data: ResolveMergeRequest}, TContext> => {

const mutationKey = ['resolveAtsNeedsMerge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveAtsNeedsMerge>>, {jobId: string;linkId: string;data: ResolveMergeRequest}> = (props) => {
          const {jobId,linkId,data} = props ?? {};

          return  resolveAtsNeedsMerge(jobId,linkId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveAtsNeedsMergeMutationResult = NonNullable<Awaited<ReturnType<typeof resolveAtsNeedsMerge>>>
    export type ResolveAtsNeedsMergeMutationBody = ResolveMergeRequest
    export type ResolveAtsNeedsMergeMutationError = HTTPValidationError

    /**
 * @summary Post Resolve Needs Merge
 */
export const useResolveAtsNeedsMerge = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveAtsNeedsMerge>>, TError,{jobId: string;linkId: string;data: ResolveMergeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveAtsNeedsMerge>>,
        TError,
        {jobId: string;linkId: string;data: ResolveMergeRequest},
        TContext
      > => {
      return useMutation(getResolveAtsNeedsMergeMutationOptions(options), queryClient);
    }

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

/**
 * @summary List Notifications
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: Parameters<typeof customInstance>[1]): Promise<NotificationListResponse> => {

  return customInstance<NotificationListResponse>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = HTTPValidationError


export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params: undefined |  ListNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notifications
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNotificationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(params?: ListNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsSuspenseQueryError = HTTPValidationError


export function useListNotificationsSuspense<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params: undefined |  ListNotificationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationsSuspense<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationsSuspense<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notifications
 */

export function useListNotificationsSuspense<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUnreadCountUrl = () => {




  return `/api/notifications/unread-count`
}

/**
 * @summary Get Unread Count
 */
export const getUnreadCount = async ( options?: Parameters<typeof customInstance>[1]): Promise<UnreadCountResponse> => {

  return customInstance<UnreadCountResponse>(getGetUnreadCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnreadCountQueryKey = () => {
    return [
    `/api/notifications/unread-count`
    ] as const;
    }


export const getGetUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountQueryError = unknown


export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Unread Count
 */

export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUnreadCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountSuspenseQueryError = unknown


export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Unread Count
 */

export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadCountSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkReadUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/read`
}

/**
 * @summary Mark Read
 */
export const markRead = async (notificationId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkReadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['markRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  markRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof markRead>>>

    export type MarkReadMutationError = HTTPValidationError

    /**
 * @summary Mark Read
 */
export const useMarkRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getMarkReadMutationOptions(options), queryClient);
    }

export const getMarkUnreadUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/unread`
}

/**
 * @summary Mark Unread
 */
export const markUnread = async (notificationId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkUnreadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkUnreadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUnread>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markUnread>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['markUnread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markUnread>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  markUnread(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkUnreadMutationResult = NonNullable<Awaited<ReturnType<typeof markUnread>>>

    export type MarkUnreadMutationError = HTTPValidationError

    /**
 * @summary Mark Unread
 */
export const useMarkUnread = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUnread>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markUnread>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getMarkUnreadMutationOptions(options), queryClient);
    }

export const getMarkAllReadUrl = () => {




  return `/api/notifications/read-all`
}

/**
 * @summary Mark All Read
 */
export const markAllRead = async ( options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkAllReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkAllReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllRead>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllRead>>, TError,void, TContext> => {

const mutationKey = ['markAllRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllRead>>, void> = () => {


          return  markAllRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllRead>>>

    export type MarkAllReadMutationError = unknown

    /**
 * @summary Mark All Read
 */
export const useMarkAllRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllRead>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllReadMutationOptions(options), queryClient);
    }

export const getClearNotificationUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/clear`
}

/**
 * @summary Clear Notification
 */
export const clearNotification = async (notificationId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getClearNotificationUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getClearNotificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearNotification>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearNotification>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['clearNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearNotification>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  clearNotification(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof clearNotification>>>

    export type ClearNotificationMutationError = HTTPValidationError

    /**
 * @summary Clear Notification
 */
export const useClearNotification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearNotification>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearNotification>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getClearNotificationMutationOptions(options), queryClient);
    }

export const getClearAllNotificationsUrl = () => {




  return `/api/notifications/clear-all`
}

/**
 * @summary Clear All Notifications
 */
export const clearAllNotifications = async ( options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getClearAllNotificationsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getClearAllNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllNotifications>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearAllNotifications>>, TError,void, TContext> => {

const mutationKey = ['clearAllNotifications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearAllNotifications>>, void> = () => {


          return  clearAllNotifications(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearAllNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof clearAllNotifications>>>

    export type ClearAllNotificationsMutationError = unknown

    /**
 * @summary Clear All Notifications
 */
export const useClearAllNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllNotifications>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearAllNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearAllNotificationsMutationOptions(options), queryClient);
    }

export const getGetPreferencesUrl = () => {




  return `/api/notifications/preferences`
}

/**
 * @summary Get Preferences
 */
export const getPreferences = async ( options?: Parameters<typeof customInstance>[1]): Promise<NotificationPreferencesResponse> => {

  return customInstance<NotificationPreferencesResponse>(getGetPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreferencesQueryKey = () => {
    return [
    `/api/notifications/preferences`
    ] as const;
    }


export const getGetPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreferences>>> = ({ signal }) => getPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getPreferences>>>
export type GetPreferencesQueryError = unknown


export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreferences>>,
          TError,
          Awaited<ReturnType<typeof getPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreferences>>,
          TError,
          Awaited<ReturnType<typeof getPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preferences
 */

export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPreferencesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreferences>>> = ({ signal }) => getPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreferencesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPreferences>>>
export type GetPreferencesSuspenseQueryError = unknown


export function useGetPreferencesSuspense<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferencesSuspense<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferencesSuspense<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preferences
 */

export function useGetPreferencesSuspense<TData = Awaited<ReturnType<typeof getPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreferencesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePreferencesUrl = () => {




  return `/api/notifications/preferences`
}

/**
 * @summary Update Preferences
 */
export const updatePreferences = async (notificationPreferencesUpdate: NotificationPreferencesUpdate, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getUpdatePreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationPreferencesUpdate)
  }
);}





export const getUpdatePreferencesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreferences>>, TError,{data: NotificationPreferencesUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreferences>>, TError,{data: NotificationPreferencesUpdate}, TContext> => {

const mutationKey = ['updatePreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreferences>>, {data: NotificationPreferencesUpdate}> = (props) => {
          const {data} = props ?? {};

          return  updatePreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreferences>>>
    export type UpdatePreferencesMutationBody = NotificationPreferencesUpdate
    export type UpdatePreferencesMutationError = HTTPValidationError

    /**
 * @summary Update Preferences
 */
export const useUpdatePreferences = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreferences>>, TError,{data: NotificationPreferencesUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePreferences>>,
        TError,
        {data: NotificationPreferencesUpdate},
        TContext
      > => {
      return useMutation(getUpdatePreferencesMutationOptions(options), queryClient);
    }

export const getGetMyNetworkUrl = () => {




  return `/api/network/me`
}

/**
 * @summary Get My Network
 */
export const getMyNetwork = async ( options?: Parameters<typeof customInstance>[1]): Promise<NetworkMemberResponse> => {

  return customInstance<NetworkMemberResponse>(getGetMyNetworkUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyNetworkQueryKey = () => {
    return [
    `/api/network/me`
    ] as const;
    }


export const getGetMyNetworkQueryOptions = <TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyNetworkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyNetwork>>> = ({ signal }) => getMyNetwork({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyNetworkQueryResult = NonNullable<Awaited<ReturnType<typeof getMyNetwork>>>
export type GetMyNetworkQueryError = unknown


export function useGetMyNetwork<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNetwork>>,
          TError,
          Awaited<ReturnType<typeof getMyNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyNetwork<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNetwork>>,
          TError,
          Awaited<ReturnType<typeof getMyNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyNetwork<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Network
 */

export function useGetMyNetwork<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyNetworkQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyNetworkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyNetworkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyNetwork>>> = ({ signal }) => getMyNetwork({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyNetworkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyNetwork>>>
export type GetMyNetworkSuspenseQueryError = unknown


export function useGetMyNetworkSuspense<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyNetworkSuspense<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyNetworkSuspense<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Network
 */

export function useGetMyNetworkSuspense<TData = Awaited<ReturnType<typeof getMyNetwork>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyNetworkSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetMyLinkedinUrl = () => {




  return `/api/network/me/linkedin`
}

/**
 * Set (or with a null URL, forget) the caller's own LinkedIn profile, used to find overlaps.
 * @summary Set My Linkedin
 */
export const setMyLinkedin = async (setLinkedinRequest: SetLinkedinRequest, options?: Parameters<typeof customInstance>[1]): Promise<NetworkMemberResponse> => {

  return customInstance<NetworkMemberResponse>(getSetMyLinkedinUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setLinkedinRequest)
  }
);}





export const getSetMyLinkedinMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyLinkedin>>, TError,{data: SetLinkedinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setMyLinkedin>>, TError,{data: SetLinkedinRequest}, TContext> => {

const mutationKey = ['setMyLinkedin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMyLinkedin>>, {data: SetLinkedinRequest}> = (props) => {
          const {data} = props ?? {};

          return  setMyLinkedin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMyLinkedinMutationResult = NonNullable<Awaited<ReturnType<typeof setMyLinkedin>>>
    export type SetMyLinkedinMutationBody = SetLinkedinRequest
    export type SetMyLinkedinMutationError = HTTPValidationError

    /**
 * @summary Set My Linkedin
 */
export const useSetMyLinkedin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyLinkedin>>, TError,{data: SetLinkedinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMyLinkedin>>,
        TError,
        {data: SetLinkedinRequest},
        TContext
      > => {
      return useMutation(getSetMyLinkedinMutationOptions(options), queryClient);
    }

export const getUploadConnectionsUrl = () => {




  return `/api/network/connections`
}

/**
 * Store one chunk (at most 5,000 rows) of the caller's LinkedIn ``Connections.csv``.
 *
 * The browser parses the file and sends rows without emails (an ``email``
 * field is rejected). Send ``replace: true`` on the first chunk of an upload:
 * it drops the previous upload. A member holds at most 30,000 connections.
 * @summary Upload Connections
 */
export const uploadConnections = async (uploadConnectionsRequest: UploadConnectionsRequest, options?: Parameters<typeof customInstance>[1]): Promise<UploadConnectionsResponse> => {

  return customInstance<UploadConnectionsResponse>(getUploadConnectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadConnectionsRequest)
  }
);}





export const getUploadConnectionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConnections>>, TError,{data: UploadConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadConnections>>, TError,{data: UploadConnectionsRequest}, TContext> => {

const mutationKey = ['uploadConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadConnections>>, {data: UploadConnectionsRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadConnections(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadConnections>>>
    export type UploadConnectionsMutationBody = UploadConnectionsRequest
    export type UploadConnectionsMutationError = HTTPValidationError

    /**
 * @summary Upload Connections
 */
export const useUploadConnections = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConnections>>, TError,{data: UploadConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadConnections>>,
        TError,
        {data: UploadConnectionsRequest},
        TContext
      > => {
      return useMutation(getUploadConnectionsMutationOptions(options), queryClient);
    }

export const getClearConnectionsUrl = () => {




  return `/api/network/connections`
}

/**
 * @summary Clear Connections
 */
export const clearConnections = async ( options?: Parameters<typeof customInstance>[1]): Promise<ClearConnectionsResponse> => {

  return customInstance<ClearConnectionsResponse>(getClearConnectionsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearConnectionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConnections>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearConnections>>, TError,void, TContext> => {

const mutationKey = ['clearConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearConnections>>, void> = () => {


          return  clearConnections(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof clearConnections>>>

    export type ClearConnectionsMutationError = unknown

    /**
 * @summary Clear Connections
 */
export const useClearConnections = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConnections>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearConnections>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearConnectionsMutationOptions(options), queryClient);
    }

export const getListNetworkMembersUrl = () => {




  return `/api/network/members`
}

/**
 * Every active Arbi user of the org and every external member, with counts and status.
 * @summary List Network Members
 */
export const listNetworkMembers = async ( options?: Parameters<typeof customInstance>[1]): Promise<NetworkMemberListResponse> => {

  return customInstance<NetworkMemberListResponse>(getListNetworkMembersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNetworkMembersQueryKey = () => {
    return [
    `/api/network/members`
    ] as const;
    }


export const getListNetworkMembersQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkMembers>>> = ({ signal }) => listNetworkMembers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkMembers>>>
export type ListNetworkMembersQueryError = unknown


export function useListNetworkMembers<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkMembers>>,
          TError,
          Awaited<ReturnType<typeof listNetworkMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkMembers<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkMembers>>,
          TError,
          Awaited<ReturnType<typeof listNetworkMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkMembers<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Network Members
 */

export function useListNetworkMembers<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkMembersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNetworkMembersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkMembers>>> = ({ signal }) => listNetworkMembers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkMembersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkMembers>>>
export type ListNetworkMembersSuspenseQueryError = unknown


export function useListNetworkMembersSuspense<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkMembersSuspense<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkMembersSuspense<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Network Members
 */

export function useListNetworkMembersSuspense<TData = Awaited<ReturnType<typeof listNetworkMembers>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkMembersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateNetworkMemberUrl = () => {




  return `/api/network/members`
}

/**
 * Add an external member: someone on the team who isn't an Arbi user.
 *
 * 409 ``NETWORK_MEMBER_EXISTS`` when an external member already has this email
 * or LinkedIn profile, or the email belongs to an Arbi user in the org.
 * @summary Create Network Member
 */
export const createNetworkMember = async (createNetworkMemberRequest: CreateNetworkMemberRequest, options?: Parameters<typeof customInstance>[1]): Promise<NetworkMemberResponse> => {

  return customInstance<NetworkMemberResponse>(getCreateNetworkMemberUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createNetworkMemberRequest)
  }
);}





export const getCreateNetworkMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkMember>>, TError,{data: CreateNetworkMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createNetworkMember>>, TError,{data: CreateNetworkMemberRequest}, TContext> => {

const mutationKey = ['createNetworkMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNetworkMember>>, {data: CreateNetworkMemberRequest}> = (props) => {
          const {data} = props ?? {};

          return  createNetworkMember(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNetworkMemberMutationResult = NonNullable<Awaited<ReturnType<typeof createNetworkMember>>>
    export type CreateNetworkMemberMutationBody = CreateNetworkMemberRequest
    export type CreateNetworkMemberMutationError = HTTPValidationError

    /**
 * @summary Create Network Member
 */
export const useCreateNetworkMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkMember>>, TError,{data: CreateNetworkMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNetworkMember>>,
        TError,
        {data: CreateNetworkMemberRequest},
        TContext
      > => {
      return useMutation(getCreateNetworkMemberMutationOptions(options), queryClient);
    }

export const getUpdateNetworkMemberUrl = (memberId: string,) => {




  return `/api/network/members/${memberId}`
}

/**
 * Edit an external member; an explicit null clears ``email`` or ``linkedin_url``.
 * @summary Update Network Member
 */
export const updateNetworkMember = async (memberId: string,
    updateNetworkMemberRequest: UpdateNetworkMemberRequest, options?: Parameters<typeof customInstance>[1]): Promise<NetworkMemberResponse> => {

  return customInstance<NetworkMemberResponse>(getUpdateNetworkMemberUrl(memberId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNetworkMemberRequest)
  }
);}





export const getUpdateNetworkMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkMember>>, TError,{memberId: string;data: UpdateNetworkMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNetworkMember>>, TError,{memberId: string;data: UpdateNetworkMemberRequest}, TContext> => {

const mutationKey = ['updateNetworkMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNetworkMember>>, {memberId: string;data: UpdateNetworkMemberRequest}> = (props) => {
          const {memberId,data} = props ?? {};

          return  updateNetworkMember(memberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNetworkMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateNetworkMember>>>
    export type UpdateNetworkMemberMutationBody = UpdateNetworkMemberRequest
    export type UpdateNetworkMemberMutationError = HTTPValidationError

    /**
 * @summary Update Network Member
 */
export const useUpdateNetworkMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkMember>>, TError,{memberId: string;data: UpdateNetworkMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNetworkMember>>,
        TError,
        {memberId: string;data: UpdateNetworkMemberRequest},
        TContext
      > => {
      return useMutation(getUpdateNetworkMemberMutationOptions(options), queryClient);
    }

export const getDeleteNetworkMemberUrl = (memberId: string,) => {




  return `/api/network/members/${memberId}`
}

/**
 * Remove an external member with their connections and paths.
 * @summary Delete Network Member
 */
export const deleteNetworkMember = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteNetworkMemberUrl(memberId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNetworkMemberMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkMember>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['deleteNetworkMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNetworkMember>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  deleteNetworkMember(memberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNetworkMemberMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNetworkMember>>>

    export type DeleteNetworkMemberMutationError = HTTPValidationError

    /**
 * @summary Delete Network Member
 */
export const useDeleteNetworkMember = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkMember>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNetworkMember>>,
        TError,
        {memberId: string},
        TContext
      > => {
      return useMutation(getDeleteNetworkMemberMutationOptions(options), queryClient);
    }

export const getUploadMemberConnectionsUrl = (memberId: string,) => {




  return `/api/network/members/${memberId}/connections`
}

/**
 * Upload an external member's ``Connections.csv``, same rules as ``POST /network/connections``.
 * @summary Upload Member Connections
 */
export const uploadMemberConnections = async (memberId: string,
    uploadConnectionsRequest: UploadConnectionsRequest, options?: Parameters<typeof customInstance>[1]): Promise<UploadConnectionsResponse> => {

  return customInstance<UploadConnectionsResponse>(getUploadMemberConnectionsUrl(memberId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadConnectionsRequest)
  }
);}





export const getUploadMemberConnectionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMemberConnections>>, TError,{memberId: string;data: UploadConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadMemberConnections>>, TError,{memberId: string;data: UploadConnectionsRequest}, TContext> => {

const mutationKey = ['uploadMemberConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadMemberConnections>>, {memberId: string;data: UploadConnectionsRequest}> = (props) => {
          const {memberId,data} = props ?? {};

          return  uploadMemberConnections(memberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadMemberConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMemberConnections>>>
    export type UploadMemberConnectionsMutationBody = UploadConnectionsRequest
    export type UploadMemberConnectionsMutationError = HTTPValidationError

    /**
 * @summary Upload Member Connections
 */
export const useUploadMemberConnections = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMemberConnections>>, TError,{memberId: string;data: UploadConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadMemberConnections>>,
        TError,
        {memberId: string;data: UploadConnectionsRequest},
        TContext
      > => {
      return useMutation(getUploadMemberConnectionsMutationOptions(options), queryClient);
    }

export const getClearMemberConnectionsUrl = (memberId: string,) => {




  return `/api/network/members/${memberId}/connections`
}

/**
 * @summary Clear Member Connections
 */
export const clearMemberConnections = async (memberId: string, options?: Parameters<typeof customInstance>[1]): Promise<ClearConnectionsResponse> => {

  return customInstance<ClearConnectionsResponse>(getClearMemberConnectionsUrl(memberId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearMemberConnectionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMemberConnections>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearMemberConnections>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['clearMemberConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearMemberConnections>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  clearMemberConnections(memberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearMemberConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof clearMemberConnections>>>

    export type ClearMemberConnectionsMutationError = HTTPValidationError

    /**
 * @summary Clear Member Connections
 */
export const useClearMemberConnections = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMemberConnections>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearMemberConnections>>,
        TError,
        {memberId: string},
        TContext
      > => {
      return useMutation(getClearMemberConnectionsMutationOptions(options), queryClient);
    }

export const getGetProfilePathsUrl = (profileId: string,) => {




  return `/api/network/profiles/${profileId}/paths`
}

/**
 * Which active members are connected to or overlapped with a person, and why.
 * @summary Get Profile Paths
 */
export const getProfilePaths = async (profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<NetworkPathsResponse> => {

  return customInstance<NetworkPathsResponse>(getGetProfilePathsUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfilePathsQueryKey = (profileId: string,) => {
    return [
    `/api/network/profiles/${profileId}/paths`
    ] as const;
    }


export const getGetProfilePathsQueryOptions = <TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfilePathsQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfilePaths>>> = ({ signal }) => getProfilePaths(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfilePathsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfilePaths>>>
export type GetProfilePathsQueryError = HTTPValidationError


export function useGetProfilePaths<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfilePaths>>,
          TError,
          Awaited<ReturnType<typeof getProfilePaths>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePaths<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfilePaths>>,
          TError,
          Awaited<ReturnType<typeof getProfilePaths>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePaths<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Paths
 */

export function useGetProfilePaths<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfilePathsQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfilePathsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfilePathsQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfilePaths>>> = ({ signal }) => getProfilePaths(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfilePathsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfilePaths>>>
export type GetProfilePathsSuspenseQueryError = HTTPValidationError


export function useGetProfilePathsSuspense<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePathsSuspense<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePathsSuspense<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Paths
 */

export function useGetProfilePathsSuspense<TData = Awaited<ReturnType<typeof getProfilePaths>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfilePaths>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfilePathsSuspenseQueryOptions(profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestIntroUrl = () => {




  return `/api/network/intro-requests`
}

/**
 * Email members with a path to a person asking for an intro; replies go to the caller.
 *
 * 409 ``NO_NETWORK_PATH`` when an asked member has no path; 422
 * ``NETWORK_MEMBER_NO_EMAIL`` when an external member has no email.
 * @summary Request Intro
 */
export const requestIntro = async (introRequest: IntroRequest, options?: Parameters<typeof customInstance>[1]): Promise<SentResponse> => {

  return customInstance<SentResponse>(getRequestIntroUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(introRequest)
  }
);}





export const getRequestIntroMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestIntro>>, TError,{data: IntroRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestIntro>>, TError,{data: IntroRequest}, TContext> => {

const mutationKey = ['requestIntro'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestIntro>>, {data: IntroRequest}> = (props) => {
          const {data} = props ?? {};

          return  requestIntro(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestIntroMutationResult = NonNullable<Awaited<ReturnType<typeof requestIntro>>>
    export type RequestIntroMutationBody = IntroRequest
    export type RequestIntroMutationError = HTTPValidationError

    /**
 * @summary Request Intro
 */
export const useRequestIntro = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestIntro>>, TError,{data: IntroRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestIntro>>,
        TError,
        {data: IntroRequest},
        TContext
      > => {
      return useMutation(getRequestIntroMutationOptions(options), queryClient);
    }

export const getRequestConnectionsUrl = () => {




  return `/api/network/connection-requests`
}

/**
 * Ask teammates to upload their connections; the caller is never asked.
 *
 * ``user_ids`` (Arbi users) get an email pointing to the network page;
 * ``member_ids`` (external members) each get a private upload link valid for
 * 7 days, replacing their earlier unused links (made when the email is sent). Ids that aren't active users or
 * external members of the org are skipped. 422 ``NETWORK_MEMBER_NO_EMAIL``
 * when an asked external member has no email.
 * @summary Request Connections
 */
export const requestConnections = async (connectionsRequest: ConnectionsRequest, options?: Parameters<typeof customInstance>[1]): Promise<SentResponse> => {

  return customInstance<SentResponse>(getRequestConnectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(connectionsRequest)
  }
);}





export const getRequestConnectionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConnections>>, TError,{data: ConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestConnections>>, TError,{data: ConnectionsRequest}, TContext> => {

const mutationKey = ['requestConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestConnections>>, {data: ConnectionsRequest}> = (props) => {
          const {data} = props ?? {};

          return  requestConnections(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof requestConnections>>>
    export type RequestConnectionsMutationBody = ConnectionsRequest
    export type RequestConnectionsMutationError = HTTPValidationError

    /**
 * @summary Request Connections
 */
export const useRequestConnections = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConnections>>, TError,{data: ConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestConnections>>,
        TError,
        {data: ConnectionsRequest},
        TContext
      > => {
      return useMutation(getRequestConnectionsMutationOptions(options), queryClient);
    }

export const getGetUploadLinkUrl = (token: string,) => {




  return `/api/network/upload-links/${token}`
}

/**
 * Who asked whom to upload. 404 ``UPLOAD_LINK_NOT_FOUND``; 410 ``UPLOAD_LINK_EXPIRED`` / ``UPLOAD_LINK_USED``.
 * @summary Get Upload Link
 */
export const getUploadLink = async (token: string, options?: Parameters<typeof customInstance>[1]): Promise<UploadLinkResponse> => {

  return customInstance<UploadLinkResponse>(getGetUploadLinkUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUploadLinkQueryKey = (token: string,) => {
    return [
    `/api/network/upload-links/${token}`
    ] as const;
    }


export const getGetUploadLinkQueryOptions = <TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUploadLinkQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadLink>>> = ({ signal }) => getUploadLink(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUploadLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getUploadLink>>>
export type GetUploadLinkQueryError = HTTPValidationError


export function useGetUploadLink<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadLink>>,
          TError,
          Awaited<ReturnType<typeof getUploadLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadLink<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadLink>>,
          TError,
          Awaited<ReturnType<typeof getUploadLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadLink<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Upload Link
 */

export function useGetUploadLink<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUploadLinkQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUploadLinkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUploadLinkQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadLink>>> = ({ signal }) => getUploadLink(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUploadLinkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUploadLink>>>
export type GetUploadLinkSuspenseQueryError = HTTPValidationError


export function useGetUploadLinkSuspense<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadLinkSuspense<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadLinkSuspense<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Upload Link
 */

export function useGetUploadLinkSuspense<TData = Awaited<ReturnType<typeof getUploadLink>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUploadLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUploadLinkSuspenseQueryOptions(token,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadLinkConnectionsUrl = (token: string,) => {




  return `/api/network/upload-links/${token}/connections`
}

/**
 * Store one chunk of the member's ``Connections.csv``, same rules as ``POST /network/members/{id}/connections``.
 *
 * ``final: true`` on the last chunk consumes the link and starts the member's
 * network refresh. Same 404/410 as ``GET``.
 * @summary Upload Link Connections
 */
export const uploadLinkConnections = async (token: string,
    uploadLinkConnectionsRequest: UploadLinkConnectionsRequest, options?: Parameters<typeof customInstance>[1]): Promise<UploadConnectionsResponse> => {

  return customInstance<UploadConnectionsResponse>(getUploadLinkConnectionsUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadLinkConnectionsRequest)
  }
);}





export const getUploadLinkConnectionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLinkConnections>>, TError,{token: string;data: UploadLinkConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadLinkConnections>>, TError,{token: string;data: UploadLinkConnectionsRequest}, TContext> => {

const mutationKey = ['uploadLinkConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLinkConnections>>, {token: string;data: UploadLinkConnectionsRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  uploadLinkConnections(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadLinkConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLinkConnections>>>
    export type UploadLinkConnectionsMutationBody = UploadLinkConnectionsRequest
    export type UploadLinkConnectionsMutationError = HTTPValidationError

    /**
 * @summary Upload Link Connections
 */
export const useUploadLinkConnections = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLinkConnections>>, TError,{token: string;data: UploadLinkConnectionsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadLinkConnections>>,
        TError,
        {token: string;data: UploadLinkConnectionsRequest},
        TContext
      > => {
      return useMutation(getUploadLinkConnectionsMutationOptions(options), queryClient);
    }

export const getPollNotificationsUrl = (params: PollNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications/poll?${stringifiedParams}` : `/api/notifications/poll`
}

/**
 * Long-poll endpoint. Returns immediately with any rows created after
 * `since` (replay path, closes the gap between two polls), otherwise
 * subscribes to the user's Redis channel for up to _POLL_TIMEOUT_SECONDS.
 * The `server_time` field on the response is the cursor for the next poll.
 * @summary Poll Notifications
 */
export const pollNotifications = async (params: PollNotificationsParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getPollNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPollNotificationsQueryKey = (params?: PollNotificationsParams,) => {
    return [
    `/api/notifications/poll`, ...(params ? [params] : [])
    ] as const;
    }


export const getPollNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(params: PollNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollNotifications>>> = ({ signal }) => pollNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof pollNotifications>>>
export type PollNotificationsQueryError = HTTPValidationError


export function usePollNotifications<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollNotifications>>,
          TError,
          Awaited<ReturnType<typeof pollNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollNotifications<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollNotifications>>,
          TError,
          Awaited<ReturnType<typeof pollNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollNotifications<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Poll Notifications
 */

export function usePollNotifications<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPollNotificationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(params: PollNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollNotifications>>> = ({ signal }) => pollNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollNotificationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pollNotifications>>>
export type PollNotificationsSuspenseQueryError = HTTPValidationError


export function usePollNotificationsSuspense<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollNotificationsSuspense<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollNotificationsSuspense<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Poll Notifications
 */

export function usePollNotificationsSuspense<TData = Awaited<ReturnType<typeof pollNotifications>>, TError = HTTPValidationError>(
 params: PollNotificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollNotificationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getWorkosWebhookUrl = () => {




  return `/api/webhooks/workos`
}

/**
 * @summary Workos Webhook
 */
export const workosWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getWorkosWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWorkosWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workosWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof workosWebhook>>, TError,void, TContext> => {

const mutationKey = ['workosWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workosWebhook>>, void> = () => {


          return  workosWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkosWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof workosWebhook>>>

    export type WorkosWebhookMutationError = unknown

    /**
 * @summary Workos Webhook
 */
export const useWorkosWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workosWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workosWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getWorkosWebhookMutationOptions(options), queryClient);
    }

export const getRecallAccountWebhookUrl = () => {




  return `/api/webhooks/recall/account/`
}

/**
 * @summary Recall Account Webhook
 */
export const recallAccountWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<RecallAccountWebhook200> => {

  return customInstance<RecallAccountWebhook200>(getRecallAccountWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecallAccountWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recallAccountWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recallAccountWebhook>>, TError,void, TContext> => {

const mutationKey = ['recallAccountWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recallAccountWebhook>>, void> = () => {


          return  recallAccountWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecallAccountWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof recallAccountWebhook>>>

    export type RecallAccountWebhookMutationError = unknown

    /**
 * @summary Recall Account Webhook
 */
export const useRecallAccountWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recallAccountWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recallAccountWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRecallAccountWebhookMutationOptions(options), queryClient);
    }

export const getRecallRealtimeWebhookUrl = () => {




  return `/api/webhooks/recall/realtime/`
}

/**
 * @summary Recall Realtime Webhook
 */
export const recallRealtimeWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<RecallRealtimeWebhook200> => {

  return customInstance<RecallRealtimeWebhook200>(getRecallRealtimeWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecallRealtimeWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recallRealtimeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recallRealtimeWebhook>>, TError,void, TContext> => {

const mutationKey = ['recallRealtimeWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recallRealtimeWebhook>>, void> = () => {


          return  recallRealtimeWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecallRealtimeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof recallRealtimeWebhook>>>

    export type RecallRealtimeWebhookMutationError = unknown

    /**
 * @summary Recall Realtime Webhook
 */
export const useRecallRealtimeWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recallRealtimeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recallRealtimeWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRecallRealtimeWebhookMutationOptions(options), queryClient);
    }

export const getResendInboundWebhookUrl = () => {




  return `/api/webhooks/resend/inbound`
}

/**
 * @summary Resend Inbound Webhook
 */
export const resendInboundWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<ResendInboundWebhook200> => {

  return customInstance<ResendInboundWebhook200>(getResendInboundWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendInboundWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInboundWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInboundWebhook>>, TError,void, TContext> => {

const mutationKey = ['resendInboundWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInboundWebhook>>, void> = () => {


          return  resendInboundWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInboundWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof resendInboundWebhook>>>

    export type ResendInboundWebhookMutationError = unknown

    /**
 * @summary Resend Inbound Webhook
 */
export const useResendInboundWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInboundWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInboundWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResendInboundWebhookMutationOptions(options), queryClient);
    }

export const getGetConsentContextUrl = (token: string,) => {




  return `/api/public/consent/${token}/context`
}

/**
 * Never writes (decision 127 — link prefetchers issue GETs). One 404 code for every miss (§10.40).
 * @summary Get Consent Context
 */
export const getConsentContext = async (token: string, options?: Parameters<typeof customInstance>[1]): Promise<ConsentContextOut> => {

  return customInstance<ConsentContextOut>(getGetConsentContextUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConsentContextQueryKey = (token: string,) => {
    return [
    `/api/public/consent/${token}/context`
    ] as const;
    }


export const getGetConsentContextQueryOptions = <TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentContextQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentContext>>> = ({ signal }) => getConsentContext(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentContextQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentContext>>>
export type GetConsentContextQueryError = HTTPValidationError


export function useGetConsentContext<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentContext>>,
          TError,
          Awaited<ReturnType<typeof getConsentContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentContext<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentContext>>,
          TError,
          Awaited<ReturnType<typeof getConsentContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentContext<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Consent Context
 */

export function useGetConsentContext<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentContextQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConsentContextSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentContextQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentContext>>> = ({ signal }) => getConsentContext(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentContextSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentContext>>>
export type GetConsentContextSuspenseQueryError = HTTPValidationError


export function useGetConsentContextSuspense<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentContextSuspense<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentContextSuspense<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Consent Context
 */

export function useGetConsentContextSuspense<TData = Awaited<ReturnType<typeof getConsentContext>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentContextSuspenseQueryOptions(token,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostConsentChoiceUrl = (token: string,) => {




  return `/api/public/consent/${token}`
}

/**
 * @summary Post Consent Choice
 */
export const postConsentChoice = async (token: string,
    consentChoiceIn: ConsentChoiceIn, options?: Parameters<typeof customInstance>[1]): Promise<ConsentChoiceOut> => {

  return customInstance<ConsentChoiceOut>(getPostConsentChoiceUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consentChoiceIn)
  }
);}





export const getPostConsentChoiceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentChoice>>, TError,{token: string;data: ConsentChoiceIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postConsentChoice>>, TError,{token: string;data: ConsentChoiceIn}, TContext> => {

const mutationKey = ['postConsentChoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConsentChoice>>, {token: string;data: ConsentChoiceIn}> = (props) => {
          const {token,data} = props ?? {};

          return  postConsentChoice(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostConsentChoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postConsentChoice>>>
    export type PostConsentChoiceMutationBody = ConsentChoiceIn
    export type PostConsentChoiceMutationError = HTTPValidationError

    /**
 * @summary Post Consent Choice
 */
export const usePostConsentChoice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentChoice>>, TError,{token: string;data: ConsentChoiceIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postConsentChoice>>,
        TError,
        {token: string;data: ConsentChoiceIn},
        TContext
      > => {
      return useMutation(getPostConsentChoiceMutationOptions(options), queryClient);
    }

export const getNylasWebhookChallengeUrl = (params: NylasWebhookChallengeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/webhooks/nylas?${stringifiedParams}` : `/api/webhooks/nylas`
}

/**
 * @summary Nylas Webhook Challenge
 */
export const nylasWebhookChallenge = async (params: NylasWebhookChallengeParams, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getNylasWebhookChallengeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNylasWebhookChallengeQueryKey = (params?: NylasWebhookChallengeParams,) => {
    return [
    `/api/webhooks/nylas`, ...(params ? [params] : [])
    ] as const;
    }


export const getNylasWebhookChallengeQueryOptions = <TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(params: NylasWebhookChallengeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNylasWebhookChallengeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof nylasWebhookChallenge>>> = ({ signal }) => nylasWebhookChallenge(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NylasWebhookChallengeQueryResult = NonNullable<Awaited<ReturnType<typeof nylasWebhookChallenge>>>
export type NylasWebhookChallengeQueryError = HTTPValidationError


export function useNylasWebhookChallenge<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof nylasWebhookChallenge>>,
          TError,
          Awaited<ReturnType<typeof nylasWebhookChallenge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNylasWebhookChallenge<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof nylasWebhookChallenge>>,
          TError,
          Awaited<ReturnType<typeof nylasWebhookChallenge>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNylasWebhookChallenge<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Nylas Webhook Challenge
 */

export function useNylasWebhookChallenge<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNylasWebhookChallengeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNylasWebhookChallengeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(params: NylasWebhookChallengeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNylasWebhookChallengeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof nylasWebhookChallenge>>> = ({ signal }) => nylasWebhookChallenge(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NylasWebhookChallengeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof nylasWebhookChallenge>>>
export type NylasWebhookChallengeSuspenseQueryError = HTTPValidationError


export function useNylasWebhookChallengeSuspense<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNylasWebhookChallengeSuspense<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNylasWebhookChallengeSuspense<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Nylas Webhook Challenge
 */

export function useNylasWebhookChallengeSuspense<TData = Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError = HTTPValidationError>(
 params: NylasWebhookChallengeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof nylasWebhookChallenge>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNylasWebhookChallengeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getNylasWebhookUrl = () => {




  return `/api/webhooks/nylas`
}

/**
 * @summary Nylas Webhook
 */
export const nylasWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<NylasWebhook200> => {

  return customInstance<NylasWebhook200>(getNylasWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNylasWebhookMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nylasWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof nylasWebhook>>, TError,void, TContext> => {

const mutationKey = ['nylasWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof nylasWebhook>>, void> = () => {


          return  nylasWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NylasWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof nylasWebhook>>>

    export type NylasWebhookMutationError = HTTPValidationError

    /**
 * @summary Nylas Webhook
 */
export const useNylasWebhook = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nylasWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof nylasWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNylasWebhookMutationOptions(options), queryClient);
    }

export const getUnipileWebhookUrl = () => {




  return `/api/webhooks/unipile`
}

/**
 * @summary Unipile Webhook
 */
export const unipileWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<UnipileWebhook200> => {

  return customInstance<UnipileWebhook200>(getUnipileWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnipileWebhookMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unipileWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unipileWebhook>>, TError,void, TContext> => {

const mutationKey = ['unipileWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unipileWebhook>>, void> = () => {


          return  unipileWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnipileWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof unipileWebhook>>>

    export type UnipileWebhookMutationError = HTTPValidationError

    /**
 * @summary Unipile Webhook
 */
export const useUnipileWebhook = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unipileWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unipileWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUnipileWebhookMutationOptions(options), queryClient);
    }

export const getKomboWebhookUrl = () => {




  return `/api/webhooks/kombo`
}

/**
 * @summary Kombo Webhook
 */
export const komboWebhook = async ( options?: Parameters<typeof customInstance>[1]): Promise<KomboWebhook200> => {

  return customInstance<KomboWebhook200>(getKomboWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getKomboWebhookMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof komboWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof komboWebhook>>, TError,void, TContext> => {

const mutationKey = ['komboWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof komboWebhook>>, void> = () => {


          return  komboWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KomboWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof komboWebhook>>>

    export type KomboWebhookMutationError = HTTPValidationError

    /**
 * @summary Kombo Webhook
 */
export const useKomboWebhook = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof komboWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof komboWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getKomboWebhookMutationOptions(options), queryClient);
    }

export const getGetPublicShareUrl = (token: string,) => {




  return `/api/shares/${token}`
}

/**
 * @summary Get Public Share
 */
export const getPublicShare = async (token: string, options?: Parameters<typeof customInstance>[1]): Promise<PublicShareResponseSchema> => {

  return customInstance<PublicShareResponseSchema>(getGetPublicShareUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicShareQueryKey = (token: string,) => {
    return [
    `/api/shares/${token}`
    ] as const;
    }


export const getGetPublicShareQueryOptions = <TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicShareQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicShare>>> = ({ signal }) => getPublicShare(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicShareQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicShare>>>
export type GetPublicShareQueryError = HTTPValidationError


export function useGetPublicShare<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicShare>>,
          TError,
          Awaited<ReturnType<typeof getPublicShare>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicShare<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicShare>>,
          TError,
          Awaited<ReturnType<typeof getPublicShare>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicShare<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Share
 */

export function useGetPublicShare<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicShareQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicShareSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicShareQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicShare>>> = ({ signal }) => getPublicShare(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicShareSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicShare>>>
export type GetPublicShareSuspenseQueryError = HTTPValidationError


export function useGetPublicShareSuspense<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicShareSuspense<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicShareSuspense<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Share
 */

export function useGetPublicShareSuspense<TData = Awaited<ReturnType<typeof getPublicShare>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPublicShare>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicShareSuspenseQueryOptions(token,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadAvatarUrl = () => {




  return `/api/uploads/avatar`
}

/**
 * @summary Upload Avatar
 */
export const uploadAvatar = async (bodyUploadAvatarApiUploadsAvatarPost: BodyUploadAvatarApiUploadsAvatarPost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadAvatarApiUploadsAvatarPost.file);

  return customInstance<UploadResponse>(getUploadAvatarUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadAvatarMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAvatar>>, TError,{data: BodyUploadAvatarApiUploadsAvatarPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAvatar>>, TError,{data: BodyUploadAvatarApiUploadsAvatarPost}, TContext> => {

const mutationKey = ['uploadAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAvatar>>, {data: BodyUploadAvatarApiUploadsAvatarPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadAvatar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAvatar>>>
    export type UploadAvatarMutationBody = BodyUploadAvatarApiUploadsAvatarPost
    export type UploadAvatarMutationError = HTTPValidationError

    /**
 * @summary Upload Avatar
 */
export const useUploadAvatar = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAvatar>>, TError,{data: BodyUploadAvatarApiUploadsAvatarPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadAvatar>>,
        TError,
        {data: BodyUploadAvatarApiUploadsAvatarPost},
        TContext
      > => {
      return useMutation(getUploadAvatarMutationOptions(options), queryClient);
    }

export const getRemoveAvatarUrl = () => {




  return `/api/uploads/avatar`
}

/**
 * @summary Remove Avatar
 */
export const removeAvatar = async ( options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveAvatarUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveAvatarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAvatar>>, TError,void, TContext> => {

const mutationKey = ['removeAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAvatar>>, void> = () => {


          return  removeAvatar(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof removeAvatar>>>

    export type RemoveAvatarMutationError = unknown

    /**
 * @summary Remove Avatar
 */
export const useRemoveAvatar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAvatar>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRemoveAvatarMutationOptions(options), queryClient);
    }

export const getUploadOrgLogoUrl = () => {




  return `/api/uploads/org-logo`
}

/**
 * @summary Upload Org Logo
 */
export const uploadOrgLogo = async (bodyUploadOrgLogoApiUploadsOrgLogoPost: BodyUploadOrgLogoApiUploadsOrgLogoPost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadOrgLogoApiUploadsOrgLogoPost.file);

  return customInstance<UploadResponse>(getUploadOrgLogoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadOrgLogoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,{data: BodyUploadOrgLogoApiUploadsOrgLogoPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,{data: BodyUploadOrgLogoApiUploadsOrgLogoPost}, TContext> => {

const mutationKey = ['uploadOrgLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgLogo>>, {data: BodyUploadOrgLogoApiUploadsOrgLogoPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadOrgLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgLogo>>>
    export type UploadOrgLogoMutationBody = BodyUploadOrgLogoApiUploadsOrgLogoPost
    export type UploadOrgLogoMutationError = HTTPValidationError

    /**
 * @summary Upload Org Logo
 */
export const useUploadOrgLogo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,{data: BodyUploadOrgLogoApiUploadsOrgLogoPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgLogo>>,
        TError,
        {data: BodyUploadOrgLogoApiUploadsOrgLogoPost},
        TContext
      > => {
      return useMutation(getUploadOrgLogoMutationOptions(options), queryClient);
    }

export const getRemoveOrgLogoUrl = () => {




  return `/api/uploads/org-logo`
}

/**
 * @summary Remove Org Logo
 */
export const removeOrgLogo = async ( options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveOrgLogoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOrgLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext> => {

const mutationKey = ['removeOrgLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrgLogo>>, void> = () => {


          return  removeOrgLogo(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrgLogo>>>

    export type RemoveOrgLogoMutationError = unknown

    /**
 * @summary Remove Org Logo
 */
export const useRemoveOrgLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOrgLogo>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRemoveOrgLogoMutationOptions(options), queryClient);
    }

export const getUploadEmployerCoverUrl = () => {




  return `/api/uploads/employer-cover`
}

/**
 * @summary Upload Employer Cover
 */
export const uploadEmployerCover = async (bodyUploadEmployerCoverApiUploadsEmployerCoverPost: BodyUploadEmployerCoverApiUploadsEmployerCoverPost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadEmployerCoverApiUploadsEmployerCoverPost.file);

  return customInstance<UploadResponse>(getUploadEmployerCoverUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadEmployerCoverMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerCover>>, TError,{data: BodyUploadEmployerCoverApiUploadsEmployerCoverPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerCover>>, TError,{data: BodyUploadEmployerCoverApiUploadsEmployerCoverPost}, TContext> => {

const mutationKey = ['uploadEmployerCover'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadEmployerCover>>, {data: BodyUploadEmployerCoverApiUploadsEmployerCoverPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadEmployerCover(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadEmployerCoverMutationResult = NonNullable<Awaited<ReturnType<typeof uploadEmployerCover>>>
    export type UploadEmployerCoverMutationBody = BodyUploadEmployerCoverApiUploadsEmployerCoverPost
    export type UploadEmployerCoverMutationError = HTTPValidationError

    /**
 * @summary Upload Employer Cover
 */
export const useUploadEmployerCover = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerCover>>, TError,{data: BodyUploadEmployerCoverApiUploadsEmployerCoverPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadEmployerCover>>,
        TError,
        {data: BodyUploadEmployerCoverApiUploadsEmployerCoverPost},
        TContext
      > => {
      return useMutation(getUploadEmployerCoverMutationOptions(options), queryClient);
    }

export const getUploadDocumentUrl = () => {




  return `/api/uploads/document`
}

/**
 * @summary Upload Document
 */
export const uploadDocument = async (bodyUploadDocumentApiUploadsDocumentPost: BodyUploadDocumentApiUploadsDocumentPost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadDocumentApiUploadsDocumentPost.file);

  return customInstance<UploadResponse>(getUploadDocumentUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadDocumentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: BodyUploadDocumentApiUploadsDocumentPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: BodyUploadDocumentApiUploadsDocumentPost}, TContext> => {

const mutationKey = ['uploadDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, {data: BodyUploadDocumentApiUploadsDocumentPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = BodyUploadDocumentApiUploadsDocumentPost
    export type UploadDocumentMutationError = HTTPValidationError

    /**
 * @summary Upload Document
 */
export const useUploadDocument = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: BodyUploadDocumentApiUploadsDocumentPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        {data: BodyUploadDocumentApiUploadsDocumentPost},
        TContext
      > => {
      return useMutation(getUploadDocumentMutationOptions(options), queryClient);
    }

export const getUploadImageUrl = () => {




  return `/api/uploads/image`
}

/**
 * @summary Upload Image
 */
export const uploadImage = async (bodyUploadImageApiUploadsImagePost: BodyUploadImageApiUploadsImagePost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadImageApiUploadsImagePost.file);

  return customInstance<UploadResponse>(getUploadImageUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadImageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyUploadImageApiUploadsImagePost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyUploadImageApiUploadsImagePost}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: BodyUploadImageApiUploadsImagePost}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = BodyUploadImageApiUploadsImagePost
    export type UploadImageMutationError = HTTPValidationError

    /**
 * @summary Upload Image
 */
export const useUploadImage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyUploadImageApiUploadsImagePost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: BodyUploadImageApiUploadsImagePost},
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options), queryClient);
    }

export const getUploadSignatureAssetUrl = () => {




  return `/api/uploads/signature-asset`
}

/**
 * Upload a signature photo/logo to first-party S3 so it renders in
 * real email clients (no proxy). Returns a permanent public HTTPS URL.
 * @summary Upload Signature Asset
 */
export const uploadSignatureAsset = async (bodyUploadSignatureAssetApiUploadsSignatureAssetPost: BodyUploadSignatureAssetApiUploadsSignatureAssetPost, options?: Parameters<typeof customInstance>[1]): Promise<UploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadSignatureAssetApiUploadsSignatureAssetPost.file);

  return customInstance<UploadResponse>(getUploadSignatureAssetUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadSignatureAssetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSignatureAsset>>, TError,{data: BodyUploadSignatureAssetApiUploadsSignatureAssetPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadSignatureAsset>>, TError,{data: BodyUploadSignatureAssetApiUploadsSignatureAssetPost}, TContext> => {

const mutationKey = ['uploadSignatureAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadSignatureAsset>>, {data: BodyUploadSignatureAssetApiUploadsSignatureAssetPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadSignatureAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadSignatureAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadSignatureAsset>>>
    export type UploadSignatureAssetMutationBody = BodyUploadSignatureAssetApiUploadsSignatureAssetPost
    export type UploadSignatureAssetMutationError = HTTPValidationError

    /**
 * @summary Upload Signature Asset
 */
export const useUploadSignatureAsset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSignatureAsset>>, TError,{data: BodyUploadSignatureAssetApiUploadsSignatureAssetPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadSignatureAsset>>,
        TError,
        {data: BodyUploadSignatureAssetApiUploadsSignatureAssetPost},
        TContext
      > => {
      return useMutation(getUploadSignatureAssetMutationOptions(options), queryClient);
    }

export const getCreateSessionUrl = () => {




  return `/api/arbitrator/sessions`
}

/**
 * @summary Create Session
 */
export const createSession = async (createSessionRequest: CreateSessionRequest, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getCreateSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSessionRequest)
  }
);}





export const getCreateSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionRequest}, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, {data: CreateSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = CreateSessionRequest
    export type CreateSessionMutationError = HTTPValidationError

    /**
 * @summary Create Session
 */
export const useCreateSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        {data: CreateSessionRequest},
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options), queryClient);
    }

export const getGetSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}`
}

/**
 * @summary Get Session
 */
export const getSession = async (sessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getGetSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = HTTPValidationError


export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSessionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionSuspenseQueryError = HTTPValidationError


export function useGetSessionSuspense<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionSuspense<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionSuspense<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session
 */

export function useGetSessionSuspense<TData = Awaited<ReturnType<typeof getSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSessionByJobStageUrl = (jobId: string,
    stageId: string,) => {




  return `/api/arbitrator/sessions/by-job-stage/${jobId}/${stageId}`
}

/**
 * Look up the (single) Arbitrator session for a job stage. Returns the
 * session if one exists, or `null` otherwise.
 * @summary Get Session By Job Stage
 */
export const getSessionByJobStage = async (jobId: string,
    stageId: string, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema | null> => {

  return customInstance<SessionSchema | null>(getGetSessionByJobStageUrl(jobId,stageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionByJobStageQueryKey = (jobId: string,
    stageId: string,) => {
    return [
    `/api/arbitrator/sessions/by-job-stage/${jobId}/${stageId}`
    ] as const;
    }


export const getGetSessionByJobStageQueryOptions = <TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(jobId: string,
    stageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionByJobStageQueryKey(jobId,stageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionByJobStage>>> = ({ signal }) => getSessionByJobStage(jobId,stageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && stageId !== null && stageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionByJobStageQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionByJobStage>>>
export type GetSessionByJobStageQueryError = HTTPValidationError


export function useGetSessionByJobStage<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionByJobStage>>,
          TError,
          Awaited<ReturnType<typeof getSessionByJobStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionByJobStage<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionByJobStage>>,
          TError,
          Awaited<ReturnType<typeof getSessionByJobStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionByJobStage<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session By Job Stage
 */

export function useGetSessionByJobStage<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionByJobStageQueryOptions(jobId,stageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSessionByJobStageSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(jobId: string,
    stageId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionByJobStageQueryKey(jobId,stageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionByJobStage>>> = ({ signal }) => getSessionByJobStage(jobId,stageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionByJobStageSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionByJobStage>>>
export type GetSessionByJobStageSuspenseQueryError = HTTPValidationError


export function useGetSessionByJobStageSuspense<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionByJobStageSuspense<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionByJobStageSuspense<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session By Job Stage
 */

export function useGetSessionByJobStageSuspense<TData = Awaited<ReturnType<typeof getSessionByJobStage>>, TError = HTTPValidationError>(
 jobId: string,
    stageId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionByJobStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionByJobStageSuspenseQueryOptions(jobId,stageId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReplaceCriteriaUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/criteria`
}

/**
 * @summary Replace Criteria
 */
export const replaceCriteria = async (sessionId: string,
    updateCriteriaRequest: UpdateCriteriaRequest, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getReplaceCriteriaUrl(sessionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCriteriaRequest)
  }
);}





export const getReplaceCriteriaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCriteria>>, TError,{sessionId: string;data: UpdateCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceCriteria>>, TError,{sessionId: string;data: UpdateCriteriaRequest}, TContext> => {

const mutationKey = ['replaceCriteria'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCriteria>>, {sessionId: string;data: UpdateCriteriaRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  replaceCriteria(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCriteria>>>
    export type ReplaceCriteriaMutationBody = UpdateCriteriaRequest
    export type ReplaceCriteriaMutationError = HTTPValidationError

    /**
 * @summary Replace Criteria
 */
export const useReplaceCriteria = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCriteria>>, TError,{sessionId: string;data: UpdateCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCriteria>>,
        TError,
        {sessionId: string;data: UpdateCriteriaRequest},
        TContext
      > => {
      return useMutation(getReplaceCriteriaMutationOptions(options), queryClient);
    }

export const getSuggestForSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/criteria/suggest`
}

/**
 * Auto-suggest criteria from the session's job description.
 *
 * Sessions are job-stage only, so the backing context is always the job
 * description; the gate is a "non-empty description" check. We will not
 * invent criteria from thin air — an empty description returns
 * ``{"criteria": []}`` and the UI falls back to the empty state. This is the
 * single source of truth for the "sufficient context" check — the frontend
 * always calls this endpoint and relies on the response.
 * @summary Suggest For Session
 */
export const suggestForSession = async (sessionId: string,
    suggestCriteriaRequest: SuggestCriteriaRequest, options?: Parameters<typeof customInstance>[1]): Promise<SuggestForSession200> => {

  return customInstance<SuggestForSession200>(getSuggestForSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(suggestCriteriaRequest)
  }
);}





export const getSuggestForSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestForSession>>, TError,{sessionId: string;data: SuggestCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestForSession>>, TError,{sessionId: string;data: SuggestCriteriaRequest}, TContext> => {

const mutationKey = ['suggestForSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestForSession>>, {sessionId: string;data: SuggestCriteriaRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  suggestForSession(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestForSessionMutationResult = NonNullable<Awaited<ReturnType<typeof suggestForSession>>>
    export type SuggestForSessionMutationBody = SuggestCriteriaRequest
    export type SuggestForSessionMutationError = HTTPValidationError

    /**
 * @summary Suggest For Session
 */
export const useSuggestForSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestForSession>>, TError,{sessionId: string;data: SuggestCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suggestForSession>>,
        TError,
        {sessionId: string;data: SuggestCriteriaRequest},
        TContext
      > => {
      return useMutation(getSuggestForSessionMutationOptions(options), queryClient);
    }

export const getModifyForSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/criteria/modify`
}

/**
 * @summary Modify For Session
 */
export const modifyForSession = async (sessionId: string,
    modifyCriteriaRequest: ModifyCriteriaRequest, options?: Parameters<typeof customInstance>[1]): Promise<ModifyCriteriaResponse> => {

  return customInstance<ModifyCriteriaResponse>(getModifyForSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(modifyCriteriaRequest)
  }
);}





export const getModifyForSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modifyForSession>>, TError,{sessionId: string;data: ModifyCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof modifyForSession>>, TError,{sessionId: string;data: ModifyCriteriaRequest}, TContext> => {

const mutationKey = ['modifyForSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modifyForSession>>, {sessionId: string;data: ModifyCriteriaRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  modifyForSession(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModifyForSessionMutationResult = NonNullable<Awaited<ReturnType<typeof modifyForSession>>>
    export type ModifyForSessionMutationBody = ModifyCriteriaRequest
    export type ModifyForSessionMutationError = HTTPValidationError

    /**
 * @summary Modify For Session
 */
export const useModifyForSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modifyForSession>>, TError,{sessionId: string;data: ModifyCriteriaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modifyForSession>>,
        TError,
        {sessionId: string;data: ModifyCriteriaRequest},
        TContext
      > => {
      return useMutation(getModifyForSessionMutationOptions(options), queryClient);
    }

export const getLaunchSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/launch`
}

/**
 * @summary Launch Session
 */
export const launchSession = async (sessionId: string,
    launchRequest: LaunchRequest, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getLaunchSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(launchRequest)
  }
);}





export const getLaunchSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchSession>>, TError,{sessionId: string;data: LaunchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof launchSession>>, TError,{sessionId: string;data: LaunchRequest}, TContext> => {

const mutationKey = ['launchSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchSession>>, {sessionId: string;data: LaunchRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  launchSession(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchSessionMutationResult = NonNullable<Awaited<ReturnType<typeof launchSession>>>
    export type LaunchSessionMutationBody = LaunchRequest
    export type LaunchSessionMutationError = HTTPValidationError

    /**
 * @summary Launch Session
 */
export const useLaunchSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchSession>>, TError,{sessionId: string;data: LaunchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof launchSession>>,
        TError,
        {sessionId: string;data: LaunchRequest},
        TContext
      > => {
      return useMutation(getLaunchSessionMutationOptions(options), queryClient);
    }

export const getCancelSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/cancel`
}

/**
 * @summary Cancel Session
 */
export const cancelSession = async (sessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getCancelSessionUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['cancelSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  cancelSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelSessionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSession>>>

    export type CancelSessionMutationError = HTTPValidationError

    /**
 * @summary Cancel Session
 */
export const useCancelSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getCancelSessionMutationOptions(options), queryClient);
    }

export const getRerunSessionUrl = (sessionId: string,
    params?: RerunSessionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/arbitrator/sessions/${sessionId}/rerun?${stringifiedParams}` : `/api/arbitrator/sessions/${sessionId}/rerun`
}

/**
 * Re-run the arbitrator after the source has changed (new candidates
 * added to the stage).
 *
 * Clears all existing targets and evaluations, then pulls the current
 * profiles from the job stage.
 *
 * Requires the session to be stale unless ``force=true``, which re-runs
 * even when not stale (re-evaluate all current stage candidates against the
 * same criteria).
 * @summary Rerun Session
 */
export const rerunSession = async (sessionId: string,
    params?: RerunSessionParams, options?: Parameters<typeof customInstance>[1]): Promise<SessionSchema> => {

  return customInstance<SessionSchema>(getRerunSessionUrl(sessionId,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRerunSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rerunSession>>, TError,{sessionId: string;params?: RerunSessionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rerunSession>>, TError,{sessionId: string;params?: RerunSessionParams}, TContext> => {

const mutationKey = ['rerunSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rerunSession>>, {sessionId: string;params?: RerunSessionParams}> = (props) => {
          const {sessionId,params} = props ?? {};

          return  rerunSession(sessionId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RerunSessionMutationResult = NonNullable<Awaited<ReturnType<typeof rerunSession>>>

    export type RerunSessionMutationError = HTTPValidationError

    /**
 * @summary Rerun Session
 */
export const useRerunSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rerunSession>>, TError,{sessionId: string;params?: RerunSessionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rerunSession>>,
        TError,
        {sessionId: string;params?: RerunSessionParams},
        TContext
      > => {
      return useMutation(getRerunSessionMutationOptions(options), queryClient);
    }

export const getListResultsUrl = (sessionId: string,
    params?: ListResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/arbitrator/sessions/${sessionId}/results?${stringifiedParams}` : `/api/arbitrator/sessions/${sessionId}/results`
}

/**
 * @summary List Results
 */
export const listResults = async (sessionId: string,
    params?: ListResultsParams, options?: Parameters<typeof customInstance>[1]): Promise<EvaluationListResponse> => {

  return customInstance<EvaluationListResponse>(getListResultsUrl(sessionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListResultsQueryKey = (sessionId: string,
    params?: ListResultsParams,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getListResultsQueryOptions = <TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResultsQueryKey(sessionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResults>>> = ({ signal }) => listResults(sessionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listResults>>>
export type ListResultsQueryError = HTTPValidationError


export function useListResults<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params: undefined |  ListResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResults>>,
          TError,
          Awaited<ReturnType<typeof listResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResults<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResults>>,
          TError,
          Awaited<ReturnType<typeof listResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResults<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Results
 */

export function useListResults<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListResultsQueryOptions(sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResultsQueryKey(sessionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResults>>> = ({ signal }) => listResults(sessionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listResults>>>
export type ListResultsSuspenseQueryError = HTTPValidationError


export function useListResultsSuspense<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params: undefined |  ListResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResultsSuspense<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResultsSuspense<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Results
 */

export function useListResultsSuspense<TData = Awaited<ReturnType<typeof listResults>>, TError = HTTPValidationError>(
 sessionId: string,
    params?: ListResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListResultsSuspenseQueryOptions(sessionId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEvaluationUrl = (sessionId: string,
    profileId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/results/${profileId}`
}

/**
 * Return the single evaluation row for one profile in a session.
 *
 * The review sheet uses this so a profile's match data loads regardless of
 * which results page (or sort/filter) it was opened from. 404 when the
 * profile has no evaluation in this session.
 * @summary Get Evaluation
 */
export const getEvaluation = async (sessionId: string,
    profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<EvaluationRowSchema> => {

  return customInstance<EvaluationRowSchema>(getGetEvaluationUrl(sessionId,profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvaluationQueryKey = (sessionId: string,
    profileId: string,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}/results/${profileId}`
    ] as const;
    }


export const getGetEvaluationQueryOptions = <TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvaluationQueryKey(sessionId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaluation>>> = ({ signal }) => getEvaluation(sessionId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined && profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvaluationQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaluation>>>
export type GetEvaluationQueryError = HTTPValidationError


export function useGetEvaluation<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getEvaluation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvaluation<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getEvaluation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvaluation<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Evaluation
 */

export function useGetEvaluation<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvaluationQueryOptions(sessionId,profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEvaluationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvaluationQueryKey(sessionId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaluation>>> = ({ signal }) => getEvaluation(sessionId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvaluationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaluation>>>
export type GetEvaluationSuspenseQueryError = HTTPValidationError


export function useGetEvaluationSuspense<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvaluationSuspense<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvaluationSuspense<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Evaluation
 */

export function useGetEvaluationSuspense<TData = Awaited<ReturnType<typeof getEvaluation>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvaluationSuspenseQueryOptions(sessionId,profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProfileSummaryUrl = (sessionId: string,
    profileId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/profile/${profileId}/summary`
}

/**
 * @summary Get Profile Summary
 */
export const getProfileSummary = async (sessionId: string,
    profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<CriteriaSummarySchema> => {

  return customInstance<CriteriaSummarySchema>(getGetProfileSummaryUrl(sessionId,profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileSummaryQueryKey = (sessionId: string,
    profileId: string,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}/profile/${profileId}/summary`
    ] as const;
    }


export const getGetProfileSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileSummaryQueryKey(sessionId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileSummary>>> = ({ signal }) => getProfileSummary(sessionId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined && profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileSummary>>>
export type GetProfileSummaryQueryError = HTTPValidationError


export function useGetProfileSummary<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileSummary>>,
          TError,
          Awaited<ReturnType<typeof getProfileSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSummary<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileSummary>>,
          TError,
          Awaited<ReturnType<typeof getProfileSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSummary<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Summary
 */

export function useGetProfileSummary<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSummaryQueryOptions(sessionId,profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfileSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileSummaryQueryKey(sessionId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileSummary>>> = ({ signal }) => getProfileSummary(sessionId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileSummary>>>
export type GetProfileSummarySuspenseQueryError = HTTPValidationError


export function useGetProfileSummarySuspense<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSummarySuspense<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSummarySuspense<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Summary
 */

export function useGetProfileSummarySuspense<TData = Awaited<ReturnType<typeof getProfileSummary>>, TError = HTTPValidationError>(
 sessionId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSummarySuspenseQueryOptions(sessionId,profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListArbitratorCriteriaPresetsUrl = () => {




  return `/api/arbitrator/criteria-presets`
}

/**
 * @summary List Presets
 */
export const listArbitratorCriteriaPresets = async ( options?: Parameters<typeof customInstance>[1]): Promise<ListArbitratorCriteriaPresets200> => {

  return customInstance<ListArbitratorCriteriaPresets200>(getListArbitratorCriteriaPresetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListArbitratorCriteriaPresetsQueryKey = () => {
    return [
    `/api/arbitrator/criteria-presets`
    ] as const;
    }


export const getListArbitratorCriteriaPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListArbitratorCriteriaPresetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>> = ({ signal }) => listArbitratorCriteriaPresets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListArbitratorCriteriaPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>>
export type ListArbitratorCriteriaPresetsQueryError = unknown


export function useListArbitratorCriteriaPresets<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>,
          TError,
          Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArbitratorCriteriaPresets<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>,
          TError,
          Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArbitratorCriteriaPresets<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Presets
 */

export function useListArbitratorCriteriaPresets<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListArbitratorCriteriaPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListArbitratorCriteriaPresetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListArbitratorCriteriaPresetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>> = ({ signal }) => listArbitratorCriteriaPresets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListArbitratorCriteriaPresetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>>
export type ListArbitratorCriteriaPresetsSuspenseQueryError = unknown


export function useListArbitratorCriteriaPresetsSuspense<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArbitratorCriteriaPresetsSuspense<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArbitratorCriteriaPresetsSuspense<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Presets
 */

export function useListArbitratorCriteriaPresetsSuspense<TData = Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listArbitratorCriteriaPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListArbitratorCriteriaPresetsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateArbitratorCriteriaPresetUrl = () => {




  return `/api/arbitrator/criteria-presets`
}

/**
 * @summary Create Preset
 */
export const createArbitratorCriteriaPreset = async (createPresetRequest: CreatePresetRequest, options?: Parameters<typeof customInstance>[1]): Promise<CreateArbitratorCriteriaPreset200> => {

  return customInstance<CreateArbitratorCriteriaPreset200>(getCreateArbitratorCriteriaPresetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPresetRequest)
  }
);}





export const getCreateArbitratorCriteriaPresetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>, TError,{data: CreatePresetRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>, TError,{data: CreatePresetRequest}, TContext> => {

const mutationKey = ['createArbitratorCriteriaPreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>, {data: CreatePresetRequest}> = (props) => {
          const {data} = props ?? {};

          return  createArbitratorCriteriaPreset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateArbitratorCriteriaPresetMutationResult = NonNullable<Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>>
    export type CreateArbitratorCriteriaPresetMutationBody = CreatePresetRequest
    export type CreateArbitratorCriteriaPresetMutationError = HTTPValidationError

    /**
 * @summary Create Preset
 */
export const useCreateArbitratorCriteriaPreset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>, TError,{data: CreatePresetRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createArbitratorCriteriaPreset>>,
        TError,
        {data: CreatePresetRequest},
        TContext
      > => {
      return useMutation(getCreateArbitratorCriteriaPresetMutationOptions(options), queryClient);
    }

export const getGetScoreBandCountsUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/score-band-counts`
}

/**
 * Return profile counts at each score threshold for the advanced selector.
 * @summary Get Score Band Counts
 */
export const getScoreBandCounts = async (sessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<GetScoreBandCounts200> => {

  return customInstance<GetScoreBandCounts200>(getGetScoreBandCountsUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScoreBandCountsQueryKey = (sessionId: string,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}/score-band-counts`
    ] as const;
    }


export const getGetScoreBandCountsQueryOptions = <TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScoreBandCountsQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScoreBandCounts>>> = ({ signal }) => getScoreBandCounts(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScoreBandCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getScoreBandCounts>>>
export type GetScoreBandCountsQueryError = HTTPValidationError


export function useGetScoreBandCounts<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScoreBandCounts>>,
          TError,
          Awaited<ReturnType<typeof getScoreBandCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScoreBandCounts<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScoreBandCounts>>,
          TError,
          Awaited<ReturnType<typeof getScoreBandCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScoreBandCounts<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Score Band Counts
 */

export function useGetScoreBandCounts<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScoreBandCountsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetScoreBandCountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScoreBandCountsQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScoreBandCounts>>> = ({ signal }) => getScoreBandCounts(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScoreBandCountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getScoreBandCounts>>>
export type GetScoreBandCountsSuspenseQueryError = HTTPValidationError


export function useGetScoreBandCountsSuspense<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScoreBandCountsSuspense<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScoreBandCountsSuspense<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Score Band Counts
 */

export function useGetScoreBandCountsSuspense<TData = Awaited<ReturnType<typeof getScoreBandCounts>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getScoreBandCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScoreBandCountsSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkAdvanceSessionCandidatesUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/bulk-advance`
}

/**
 * @summary Bulk Advance Session Candidates
 */
export const bulkAdvanceSessionCandidates = async (sessionId: string,
    arbitratorBulkActionRequest: ArbitratorBulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<ArbitratorBulkActionResponse> => {

  return customInstance<ArbitratorBulkActionResponse>(getBulkAdvanceSessionCandidatesUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(arbitratorBulkActionRequest)
  }
);}





export const getBulkAdvanceSessionCandidatesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext> => {

const mutationKey = ['bulkAdvanceSessionCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>, {sessionId: string;data: ArbitratorBulkActionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  bulkAdvanceSessionCandidates(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAdvanceSessionCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>>
    export type BulkAdvanceSessionCandidatesMutationBody = ArbitratorBulkActionRequest
    export type BulkAdvanceSessionCandidatesMutationError = HTTPValidationError

    /**
 * @summary Bulk Advance Session Candidates
 */
export const useBulkAdvanceSessionCandidates = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkAdvanceSessionCandidates>>,
        TError,
        {sessionId: string;data: ArbitratorBulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkAdvanceSessionCandidatesMutationOptions(options), queryClient);
    }

export const getBulkRejectSessionCandidatesUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/bulk-reject`
}

/**
 * @summary Bulk Reject Session Candidates
 */
export const bulkRejectSessionCandidates = async (sessionId: string,
    arbitratorBulkActionRequest: ArbitratorBulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<ArbitratorBulkActionResponse> => {

  return customInstance<ArbitratorBulkActionResponse>(getBulkRejectSessionCandidatesUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(arbitratorBulkActionRequest)
  }
);}





export const getBulkRejectSessionCandidatesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRejectSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkRejectSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext> => {

const mutationKey = ['bulkRejectSessionCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkRejectSessionCandidates>>, {sessionId: string;data: ArbitratorBulkActionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  bulkRejectSessionCandidates(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkRejectSessionCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkRejectSessionCandidates>>>
    export type BulkRejectSessionCandidatesMutationBody = ArbitratorBulkActionRequest
    export type BulkRejectSessionCandidatesMutationError = HTTPValidationError

    /**
 * @summary Bulk Reject Session Candidates
 */
export const useBulkRejectSessionCandidates = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRejectSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkRejectSessionCandidates>>,
        TError,
        {sessionId: string;data: ArbitratorBulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkRejectSessionCandidatesMutationOptions(options), queryClient);
    }

export const getBulkArchiveSessionCandidatesUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/bulk-archive`
}

/**
 * @summary Bulk Archive Session Candidates
 */
export const bulkArchiveSessionCandidates = async (sessionId: string,
    arbitratorBulkActionRequest: ArbitratorBulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<ArbitratorBulkActionResponse> => {

  return customInstance<ArbitratorBulkActionResponse>(getBulkArchiveSessionCandidatesUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(arbitratorBulkActionRequest)
  }
);}





export const getBulkArchiveSessionCandidatesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext> => {

const mutationKey = ['bulkArchiveSessionCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>, {sessionId: string;data: ArbitratorBulkActionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  bulkArchiveSessionCandidates(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveSessionCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>>
    export type BulkArchiveSessionCandidatesMutationBody = ArbitratorBulkActionRequest
    export type BulkArchiveSessionCandidatesMutationError = HTTPValidationError

    /**
 * @summary Bulk Archive Session Candidates
 */
export const useBulkArchiveSessionCandidates = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>, TError,{sessionId: string;data: ArbitratorBulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchiveSessionCandidates>>,
        TError,
        {sessionId: string;data: ArbitratorBulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkArchiveSessionCandidatesMutationOptions(options), queryClient);
    }

export const getStreamSessionUrl = (sessionId: string,) => {




  return `/api/arbitrator/sessions/${sessionId}/stream`
}

/**
 * @summary Stream Session
 */
export const streamSession = async (sessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getStreamSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/arbitrator/sessions/${sessionId}/stream`
    ] as const;
    }


export const getStreamSessionQueryOptions = <TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamSession>>> = ({ signal }) => streamSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamSessionQueryResult = NonNullable<Awaited<ReturnType<typeof streamSession>>>
export type StreamSessionQueryError = HTTPValidationError


export function useStreamSession<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSession>>,
          TError,
          Awaited<ReturnType<typeof streamSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamSession<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSession>>,
          TError,
          Awaited<ReturnType<typeof streamSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamSession<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Session
 */

export function useStreamSession<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStreamSessionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamSession>>> = ({ signal }) => streamSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamSessionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof streamSession>>>
export type StreamSessionSuspenseQueryError = HTTPValidationError


export function useStreamSessionSuspense<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamSessionSuspense<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamSessionSuspense<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Session
 */

export function useStreamSessionSuspense<TData = Awaited<ReturnType<typeof streamSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamSessionSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAssistantMessagesUrl = (searchId: string,) => {




  return `/api/assistant/${searchId}/messages`
}

/**
 * @summary Get Assistant Messages
 */
export const getAssistantMessages = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<StoredMessageResponse[]> => {

  return customInstance<StoredMessageResponse[]>(getGetAssistantMessagesUrl(searchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssistantMessagesQueryKey = (searchId: string,) => {
    return [
    `/api/assistant/${searchId}/messages`
    ] as const;
    }


export const getGetAssistantMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantMessagesQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantMessages>>> = ({ signal }) => getAssistantMessages(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantMessages>>>
export type GetAssistantMessagesQueryError = HTTPValidationError


export function useGetAssistantMessages<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMessages>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantMessages<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMessages>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantMessages<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assistant Messages
 */

export function useGetAssistantMessages<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantMessagesQueryOptions(searchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAssistantMessagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantMessagesQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantMessages>>> = ({ signal }) => getAssistantMessages(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantMessagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantMessages>>>
export type GetAssistantMessagesSuspenseQueryError = HTTPValidationError


export function useGetAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assistant Messages
 */

export function useGetAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getAssistantMessages>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantMessagesSuspenseQueryOptions(searchId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSeedAssistantMessagesUrl = (searchId: string,) => {




  return `/api/assistant/${searchId}/seed`
}

/**
 * Bulk-insert initial conversation from the new-search page into a newly created search.
 * @summary Seed Assistant Messages
 */
export const seedAssistantMessages = async (searchId: string,
    seedRequest: SeedRequest, options?: Parameters<typeof customInstance>[1]): Promise<SeedAssistantMessages200> => {

  return customInstance<SeedAssistantMessages200>(getSeedAssistantMessagesUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seedRequest)
  }
);}





export const getSeedAssistantMessagesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedAssistantMessages>>, TError,{searchId: string;data: SeedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof seedAssistantMessages>>, TError,{searchId: string;data: SeedRequest}, TContext> => {

const mutationKey = ['seedAssistantMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seedAssistantMessages>>, {searchId: string;data: SeedRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  seedAssistantMessages(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SeedAssistantMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof seedAssistantMessages>>>
    export type SeedAssistantMessagesMutationBody = SeedRequest
    export type SeedAssistantMessagesMutationError = HTTPValidationError

    /**
 * @summary Seed Assistant Messages
 */
export const useSeedAssistantMessages = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedAssistantMessages>>, TError,{searchId: string;data: SeedRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof seedAssistantMessages>>,
        TError,
        {searchId: string;data: SeedRequest},
        TContext
      > => {
      return useMutation(getSeedAssistantMessagesMutationOptions(options), queryClient);
    }

export const getAssistantChatStatelessUrl = () => {




  return `/api/assistant/chat`
}

/**
 * @summary Assistant Chat Stateless
 */
export const assistantChatStateless = async (assistantChatRequest: AssistantChatRequest, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getAssistantChatStatelessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assistantChatRequest)
  }
);}





export const getAssistantChatStatelessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChatStateless>>, TError,{data: AssistantChatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantChatStateless>>, TError,{data: AssistantChatRequest}, TContext> => {

const mutationKey = ['assistantChatStateless'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantChatStateless>>, {data: AssistantChatRequest}> = (props) => {
          const {data} = props ?? {};

          return  assistantChatStateless(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssistantChatStatelessMutationResult = NonNullable<Awaited<ReturnType<typeof assistantChatStateless>>>
    export type AssistantChatStatelessMutationBody = AssistantChatRequest
    export type AssistantChatStatelessMutationError = HTTPValidationError

    /**
 * @summary Assistant Chat Stateless
 */
export const useAssistantChatStateless = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChatStateless>>, TError,{data: AssistantChatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantChatStateless>>,
        TError,
        {data: AssistantChatRequest},
        TContext
      > => {
      return useMutation(getAssistantChatStatelessMutationOptions(options), queryClient);
    }

export const getAssistantChatPersistedUrl = (searchId: string,) => {




  return `/api/assistant/${searchId}/chat`
}

/**
 * @summary Assistant Chat Persisted
 */
export const assistantChatPersisted = async (searchId: string,
    searchChatRequest: SearchChatRequest, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getAssistantChatPersistedUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchChatRequest)
  }
);}





export const getAssistantChatPersistedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChatPersisted>>, TError,{searchId: string;data: SearchChatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantChatPersisted>>, TError,{searchId: string;data: SearchChatRequest}, TContext> => {

const mutationKey = ['assistantChatPersisted'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantChatPersisted>>, {searchId: string;data: SearchChatRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  assistantChatPersisted(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssistantChatPersistedMutationResult = NonNullable<Awaited<ReturnType<typeof assistantChatPersisted>>>
    export type AssistantChatPersistedMutationBody = SearchChatRequest
    export type AssistantChatPersistedMutationError = HTTPValidationError

    /**
 * @summary Assistant Chat Persisted
 */
export const useAssistantChatPersisted = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChatPersisted>>, TError,{searchId: string;data: SearchChatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantChatPersisted>>,
        TError,
        {searchId: string;data: SearchChatRequest},
        TContext
      > => {
      return useMutation(getAssistantChatPersistedMutationOptions(options), queryClient);
    }

export const getAssistantAnswerToolUrl = (searchId: string,) => {




  return `/api/assistant/${searchId}/answer`
}

/**
 * Submit an answer to a clarifying question (tool_result) and continue the agent.
 * @summary Assistant Answer Tool
 */
export const assistantAnswerTool = async (searchId: string,
    toolAnswerRequest: ToolAnswerRequest, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getAssistantAnswerToolUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(toolAnswerRequest)
  }
);}





export const getAssistantAnswerToolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantAnswerTool>>, TError,{searchId: string;data: ToolAnswerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantAnswerTool>>, TError,{searchId: string;data: ToolAnswerRequest}, TContext> => {

const mutationKey = ['assistantAnswerTool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantAnswerTool>>, {searchId: string;data: ToolAnswerRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  assistantAnswerTool(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssistantAnswerToolMutationResult = NonNullable<Awaited<ReturnType<typeof assistantAnswerTool>>>
    export type AssistantAnswerToolMutationBody = ToolAnswerRequest
    export type AssistantAnswerToolMutationError = HTTPValidationError

    /**
 * @summary Assistant Answer Tool
 */
export const useAssistantAnswerTool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantAnswerTool>>, TError,{searchId: string;data: ToolAnswerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantAnswerTool>>,
        TError,
        {searchId: string;data: ToolAnswerRequest},
        TContext
      > => {
      return useMutation(getAssistantAnswerToolMutationOptions(options), queryClient);
    }

export const getGetCompanyAnalyticsUrl = (companyId: string,) => {




  return `/api/companies/${companyId}/analytics`
}

/**
 * Fetch slow company analytics by PDL company id.
 * @summary Get Company Analytics
 */
export const getCompanyAnalytics = async (companyId: string, options?: Parameters<typeof customInstance>[1]): Promise<CompanyAnalyticsResponse> => {

  return customInstance<CompanyAnalyticsResponse>(getGetCompanyAnalyticsUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyAnalyticsQueryKey = (companyId: string,) => {
    return [
    `/api/companies/${companyId}/analytics`
    ] as const;
    }


export const getGetCompanyAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyAnalyticsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyAnalytics>>> = ({ signal }) => getCompanyAnalytics(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyAnalytics>>>
export type GetCompanyAnalyticsQueryError = HTTPValidationError


export function useGetCompanyAnalytics<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCompanyAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyAnalytics<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCompanyAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyAnalytics<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Analytics
 */

export function useGetCompanyAnalytics<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyAnalyticsQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanyAnalyticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyAnalyticsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyAnalytics>>> = ({ signal }) => getCompanyAnalytics(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyAnalyticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyAnalytics>>>
export type GetCompanyAnalyticsSuspenseQueryError = HTTPValidationError


export function useGetCompanyAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Analytics
 */

export function useGetCompanyAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyAnalyticsSuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCompanyWorkforceAnalyticsUrl = (companyId: string,) => {




  return `/api/companies/${companyId}/workforce-analytics`
}

/**
 * Vendor-supplied workforce analytics by PDL company id.
 *
 * Distinct from /analytics, which derives its numbers from our own profile
 * data at query time. These are read straight from the ingest tables.
 * @summary Get Company Workforce Analytics
 */
export const getCompanyWorkforceAnalytics = async (companyId: string, options?: Parameters<typeof customInstance>[1]): Promise<CompanyWorkforceAnalyticsResponse> => {

  return customInstance<CompanyWorkforceAnalyticsResponse>(getGetCompanyWorkforceAnalyticsUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyWorkforceAnalyticsQueryKey = (companyId: string,) => {
    return [
    `/api/companies/${companyId}/workforce-analytics`
    ] as const;
    }


export const getGetCompanyWorkforceAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyWorkforceAnalyticsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>> = ({ signal }) => getCompanyWorkforceAnalytics(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyWorkforceAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>>
export type GetCompanyWorkforceAnalyticsQueryError = HTTPValidationError


export function useGetCompanyWorkforceAnalytics<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyWorkforceAnalytics<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyWorkforceAnalytics<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Workforce Analytics
 */

export function useGetCompanyWorkforceAnalytics<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyWorkforceAnalyticsQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanyWorkforceAnalyticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyWorkforceAnalyticsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>> = ({ signal }) => getCompanyWorkforceAnalytics(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyWorkforceAnalyticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>>
export type GetCompanyWorkforceAnalyticsSuspenseQueryError = HTTPValidationError


export function useGetCompanyWorkforceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyWorkforceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyWorkforceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Workforce Analytics
 */

export function useGetCompanyWorkforceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyWorkforceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyWorkforceAnalyticsSuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCompanyUrl = (companyId: string,) => {




  return `/api/companies/${companyId}`
}

/**
 * Fetch fast company metadata by PDL company id.
 * @summary Get Company
 */
export const getCompany = async (companyId: string, options?: Parameters<typeof customInstance>[1]): Promise<CompanySummaryResponse> => {

  return customInstance<CompanySummaryResponse>(getGetCompanyUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyQueryKey = (companyId: string,) => {
    return [
    `/api/companies/${companyId}`
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = HTTPValidationError


export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCompanySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanySuspenseQueryError = HTTPValidationError


export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company
 */

export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = HTTPValidationError>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanySuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProfileContactsUrl = (profileId: string,) => {




  return `/api/profiles/${profileId}/contacts`
}

/**
 * @summary Get Profile Contacts
 */
export const getProfileContacts = async (profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<ContactRevealResponse> => {

  return customInstance<ContactRevealResponse>(getGetProfileContactsUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileContactsQueryKey = (profileId: string,) => {
    return [
    `/api/profiles/${profileId}/contacts`
    ] as const;
    }


export const getGetProfileContactsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContactsQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContacts>>> = ({ signal }) => getProfileContacts(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContacts>>>
export type GetProfileContactsQueryError = HTTPValidationError


export function useGetProfileContacts<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContacts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContacts<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContacts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContacts<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Contacts
 */

export function useGetProfileContacts<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileContactsQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfileContactsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContactsQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContacts>>> = ({ signal }) => getProfileContacts(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContacts>>>
export type GetProfileContactsSuspenseQueryError = HTTPValidationError


export function useGetProfileContactsSuspense<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContactsSuspense<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContactsSuspense<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Contacts
 */

export function useGetProfileContactsSuspense<TData = Awaited<ReturnType<typeof getProfileContacts>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileContactsSuspenseQueryOptions(profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddManualContactUrl = (profileId: string,) => {




  return `/api/profiles/${profileId}/contacts/manual`
}

/**
 * @summary Add Manual Contact
 */
export const addManualContact = async (profileId: string,
    manualContactCreate: ManualContactCreate, options?: Parameters<typeof customInstance>[1]): Promise<ProfileContactResponse> => {

  return customInstance<ProfileContactResponse>(getAddManualContactUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(manualContactCreate)
  }
);}





export const getAddManualContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addManualContact>>, TError,{profileId: string;data: ManualContactCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addManualContact>>, TError,{profileId: string;data: ManualContactCreate}, TContext> => {

const mutationKey = ['addManualContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addManualContact>>, {profileId: string;data: ManualContactCreate}> = (props) => {
          const {profileId,data} = props ?? {};

          return  addManualContact(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddManualContactMutationResult = NonNullable<Awaited<ReturnType<typeof addManualContact>>>
    export type AddManualContactMutationBody = ManualContactCreate
    export type AddManualContactMutationError = HTTPValidationError

    /**
 * @summary Add Manual Contact
 */
export const useAddManualContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addManualContact>>, TError,{profileId: string;data: ManualContactCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addManualContact>>,
        TError,
        {profileId: string;data: ManualContactCreate},
        TContext
      > => {
      return useMutation(getAddManualContactMutationOptions(options), queryClient);
    }

export const getRevealProfileContactUrl = (profileId: string,) => {




  return `/api/profiles/${profileId}/reveal-contact`
}

/**
 * @summary Reveal Profile Contact
 */
export const revealProfileContact = async (profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<ContactRevealResponse> => {

  return customInstance<ContactRevealResponse>(getRevealProfileContactUrl(profileId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevealProfileContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealProfileContact>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revealProfileContact>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['revealProfileContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revealProfileContact>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  revealProfileContact(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevealProfileContactMutationResult = NonNullable<Awaited<ReturnType<typeof revealProfileContact>>>

    export type RevealProfileContactMutationError = HTTPValidationError

    /**
 * @summary Reveal Profile Contact
 */
export const useRevealProfileContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealProfileContact>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revealProfileContact>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getRevealProfileContactMutationOptions(options), queryClient);
    }

export const getRefreshProfileContactUrl = (profileId: string,) => {




  return `/api/profiles/${profileId}/refresh-contact`
}

/**
 * @summary Refresh Profile Contact
 */
export const refreshProfileContact = async (profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<ContactRevealResponse> => {

  return customInstance<ContactRevealResponse>(getRefreshProfileContactUrl(profileId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshProfileContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshProfileContact>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshProfileContact>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['refreshProfileContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshProfileContact>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  refreshProfileContact(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshProfileContactMutationResult = NonNullable<Awaited<ReturnType<typeof refreshProfileContact>>>

    export type RefreshProfileContactMutationError = HTTPValidationError

    /**
 * @summary Refresh Profile Contact
 */
export const useRefreshProfileContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshProfileContact>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshProfileContact>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getRefreshProfileContactMutationOptions(options), queryClient);
    }

export const getSubmitContactFeedbackUrl = (contactId: string,) => {




  return `/api/contacts/${contactId}/feedback`
}

/**
 * @summary Submit Contact Feedback
 */
export const submitContactFeedback = async (contactId: string,
    contactFeedbackRequest: ContactFeedbackRequest, options?: Parameters<typeof customInstance>[1]): Promise<ProfileContactResponse> => {

  return customInstance<ProfileContactResponse>(getSubmitContactFeedbackUrl(contactId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactFeedbackRequest)
  }
);}





export const getSubmitContactFeedbackMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContactFeedback>>, TError,{contactId: string;data: ContactFeedbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContactFeedback>>, TError,{contactId: string;data: ContactFeedbackRequest}, TContext> => {

const mutationKey = ['submitContactFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContactFeedback>>, {contactId: string;data: ContactFeedbackRequest}> = (props) => {
          const {contactId,data} = props ?? {};

          return  submitContactFeedback(contactId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof submitContactFeedback>>>
    export type SubmitContactFeedbackMutationBody = ContactFeedbackRequest
    export type SubmitContactFeedbackMutationError = HTTPValidationError

    /**
 * @summary Submit Contact Feedback
 */
export const useSubmitContactFeedback = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContactFeedback>>, TError,{contactId: string;data: ContactFeedbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitContactFeedback>>,
        TError,
        {contactId: string;data: ContactFeedbackRequest},
        TContext
      > => {
      return useMutation(getSubmitContactFeedbackMutationOptions(options), queryClient);
    }

export const getDeleteManualContactUrl = (contactId: string,) => {




  return `/api/contacts/${contactId}`
}

/**
 * @summary Delete Manual Contact
 */
export const deleteManualContact = async (contactId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteManualContactUrl(contactId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteManualContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManualContact>>, TError,{contactId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteManualContact>>, TError,{contactId: string}, TContext> => {

const mutationKey = ['deleteManualContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteManualContact>>, {contactId: string}> = (props) => {
          const {contactId} = props ?? {};

          return  deleteManualContact(contactId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteManualContactMutationResult = NonNullable<Awaited<ReturnType<typeof deleteManualContact>>>

    export type DeleteManualContactMutationError = HTTPValidationError

    /**
 * @summary Delete Manual Contact
 */
export const useDeleteManualContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManualContact>>, TError,{contactId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteManualContact>>,
        TError,
        {contactId: string},
        TContext
      > => {
      return useMutation(getDeleteManualContactMutationOptions(options), queryClient);
    }

export const getListEmployersUrl = (params?: ListEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/employers?${stringifiedParams}` : `/api/employers`
}

/**
 * @summary List Employers
 */
export const listEmployers = async (params?: ListEmployersParams, options?: Parameters<typeof customInstance>[1]): Promise<EmployerListResponse> => {

  return customInstance<EmployerListResponse>(getListEmployersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployersQueryKey = (params?: ListEmployersParams,) => {
    return [
    `/api/employers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmployersQueryOptions = <TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(params?: ListEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployers>>> = ({ signal }) => listEmployers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployers>>>
export type ListEmployersQueryError = HTTPValidationError


export function useListEmployers<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params: undefined |  ListEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployers>>,
          TError,
          Awaited<ReturnType<typeof listEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployers<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployers>>,
          TError,
          Awaited<ReturnType<typeof listEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployers<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Employers
 */

export function useListEmployers<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEmployersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(params?: ListEmployersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployers>>> = ({ signal }) => listEmployers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmployersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployers>>>
export type ListEmployersSuspenseQueryError = HTTPValidationError


export function useListEmployersSuspense<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params: undefined |  ListEmployersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployersSuspense<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployersSuspense<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Employers
 */

export function useListEmployersSuspense<TData = Awaited<ReturnType<typeof listEmployers>>, TError = HTTPValidationError>(
 params?: ListEmployersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmployersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateEmployerUrl = () => {




  return `/api/employers`
}

/**
 * @summary Create Employer
 */
export const createEmployer = async (employerCreate: EmployerCreate, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getCreateEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(employerCreate)
  }
);}





export const getCreateEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreate}, TContext> => {

const mutationKey = ['createEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployer>>, {data: EmployerCreate}> = (props) => {
          const {data} = props ?? {};

          return  createEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployer>>>
    export type CreateEmployerMutationBody = EmployerCreate
    export type CreateEmployerMutationError = HTTPValidationError

    /**
 * @summary Create Employer
 */
export const useCreateEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmployer>>,
        TError,
        {data: EmployerCreate},
        TContext
      > => {
      return useMutation(getCreateEmployerMutationOptions(options), queryClient);
    }

export const getEnrichEmployerProfileUrl = () => {




  return `/api/employers/enrich`
}

/**
 * Research a company by website and return enrichment data for employer profile fields.
 * @summary Enrich Employer Profile
 */
export const enrichEmployerProfile = async (employerEnrichRequest: EmployerEnrichRequest, options?: Parameters<typeof customInstance>[1]): Promise<EmployerEnrichResponse> => {

  return customInstance<EmployerEnrichResponse>(getEnrichEmployerProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(employerEnrichRequest)
  }
);}





export const getEnrichEmployerProfileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrichEmployerProfile>>, TError,{data: EmployerEnrichRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enrichEmployerProfile>>, TError,{data: EmployerEnrichRequest}, TContext> => {

const mutationKey = ['enrichEmployerProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrichEmployerProfile>>, {data: EmployerEnrichRequest}> = (props) => {
          const {data} = props ?? {};

          return  enrichEmployerProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnrichEmployerProfileMutationResult = NonNullable<Awaited<ReturnType<typeof enrichEmployerProfile>>>
    export type EnrichEmployerProfileMutationBody = EmployerEnrichRequest
    export type EnrichEmployerProfileMutationError = HTTPValidationError

    /**
 * @summary Enrich Employer Profile
 */
export const useEnrichEmployerProfile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrichEmployerProfile>>, TError,{data: EmployerEnrichRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enrichEmployerProfile>>,
        TError,
        {data: EmployerEnrichRequest},
        TContext
      > => {
      return useMutation(getEnrichEmployerProfileMutationOptions(options), queryClient);
    }

export const getGetEmployerUrl = (employerId: string,) => {




  return `/api/employers/${employerId}`
}

/**
 * @summary Get Employer
 */
export const getEmployer = async (employerId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getGetEmployerUrl(employerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployerQueryKey = (employerId: string,) => {
    return [
    `/api/employers/${employerId}`
    ] as const;
    }


export const getGetEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerQueryKey(employerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployer>>> = ({ signal }) => getEmployer(employerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: employerId !== null && employerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployer>>>
export type GetEmployerQueryError = HTTPValidationError


export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Employer
 */

export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEmployerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(employerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerQueryKey(employerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployer>>> = ({ signal }) => getEmployer(employerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployer>>>
export type GetEmployerSuspenseQueryError = HTTPValidationError


export function useGetEmployerSuspense<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerSuspense<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerSuspense<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Employer
 */

export function useGetEmployerSuspense<TData = Awaited<ReturnType<typeof getEmployer>>, TError = HTTPValidationError>(
 employerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerSuspenseQueryOptions(employerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateEmployerUrl = (employerId: string,) => {




  return `/api/employers/${employerId}`
}

/**
 * @summary Update Employer
 */
export const updateEmployer = async (employerId: string,
    employerUpdate: EmployerUpdate, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getUpdateEmployerUrl(employerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(employerUpdate)
  }
);}





export const getUpdateEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{employerId: string;data: EmployerUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{employerId: string;data: EmployerUpdate}, TContext> => {

const mutationKey = ['updateEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployer>>, {employerId: string;data: EmployerUpdate}> = (props) => {
          const {employerId,data} = props ?? {};

          return  updateEmployer(employerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployer>>>
    export type UpdateEmployerMutationBody = EmployerUpdate
    export type UpdateEmployerMutationError = HTTPValidationError

    /**
 * @summary Update Employer
 */
export const useUpdateEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{employerId: string;data: EmployerUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployer>>,
        TError,
        {employerId: string;data: EmployerUpdate},
        TContext
      > => {
      return useMutation(getUpdateEmployerMutationOptions(options), queryClient);
    }

export const getArchiveEmployerUrl = (employerId: string,) => {




  return `/api/employers/${employerId}/archive`
}

/**
 * @summary Archive Employer
 */
export const archiveEmployer = async (employerId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getArchiveEmployerUrl(employerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveEmployer>>, TError,{employerId: string}, TContext> => {

const mutationKey = ['archiveEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveEmployer>>, {employerId: string}> = (props) => {
          const {employerId} = props ?? {};

          return  archiveEmployer(employerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof archiveEmployer>>>

    export type ArchiveEmployerMutationError = HTTPValidationError

    /**
 * @summary Archive Employer
 */
export const useArchiveEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveEmployer>>,
        TError,
        {employerId: string},
        TContext
      > => {
      return useMutation(getArchiveEmployerMutationOptions(options), queryClient);
    }

export const getUnarchiveEmployerUrl = (employerId: string,) => {




  return `/api/employers/${employerId}/unarchive`
}

/**
 * @summary Unarchive Employer
 */
export const unarchiveEmployer = async (employerId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getUnarchiveEmployerUrl(employerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveEmployer>>, TError,{employerId: string}, TContext> => {

const mutationKey = ['unarchiveEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveEmployer>>, {employerId: string}> = (props) => {
          const {employerId} = props ?? {};

          return  unarchiveEmployer(employerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveEmployer>>>

    export type UnarchiveEmployerMutationError = HTTPValidationError

    /**
 * @summary Unarchive Employer
 */
export const useUnarchiveEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveEmployer>>,
        TError,
        {employerId: string},
        TContext
      > => {
      return useMutation(getUnarchiveEmployerMutationOptions(options), queryClient);
    }

export const getSetDefaultEmployerUrl = (employerId: string,) => {




  return `/api/employers/${employerId}/set-default`
}

/**
 * @summary Set Default Employer
 */
export const setDefaultEmployer = async (employerId: string, options?: Parameters<typeof customInstance>[1]): Promise<EmployerResponse> => {

  return customInstance<EmployerResponse>(getSetDefaultEmployerUrl(employerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetDefaultEmployerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultEmployer>>, TError,{employerId: string}, TContext> => {

const mutationKey = ['setDefaultEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultEmployer>>, {employerId: string}> = (props) => {
          const {employerId} = props ?? {};

          return  setDefaultEmployer(employerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultEmployer>>>

    export type SetDefaultEmployerMutationError = HTTPValidationError

    /**
 * @summary Set Default Employer
 */
export const useSetDefaultEmployer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultEmployer>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultEmployer>>,
        TError,
        {employerId: string},
        TContext
      > => {
      return useMutation(getSetDefaultEmployerMutationOptions(options), queryClient);
    }

export const getListExcludedCompaniesUrl = (params?: ListExcludedCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/exclusions/companies?${stringifiedParams}` : `/api/exclusions/companies`
}

/**
 * @summary List Excluded Companies
 */
export const listExcludedCompanies = async (params?: ListExcludedCompaniesParams, options?: Parameters<typeof customInstance>[1]): Promise<ExcludedCompanyListResponse> => {

  return customInstance<ExcludedCompanyListResponse>(getListExcludedCompaniesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExcludedCompaniesQueryKey = (params?: ListExcludedCompaniesParams,) => {
    return [
    `/api/exclusions/companies`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExcludedCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExcludedCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExcludedCompanies>>> = ({ signal }) => listExcludedCompanies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExcludedCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listExcludedCompanies>>>
export type ListExcludedCompaniesQueryError = HTTPValidationError


export function useListExcludedCompanies<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params: undefined |  ListExcludedCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedCompanies>>,
          TError,
          Awaited<ReturnType<typeof listExcludedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedCompanies<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedCompanies>>,
          TError,
          Awaited<ReturnType<typeof listExcludedCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedCompanies<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Excluded Companies
 */

export function useListExcludedCompanies<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExcludedCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListExcludedCompaniesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExcludedCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExcludedCompanies>>> = ({ signal }) => listExcludedCompanies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExcludedCompaniesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listExcludedCompanies>>>
export type ListExcludedCompaniesSuspenseQueryError = HTTPValidationError


export function useListExcludedCompaniesSuspense<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params: undefined |  ListExcludedCompaniesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedCompaniesSuspense<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedCompaniesSuspense<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Excluded Companies
 */

export function useListExcludedCompaniesSuspense<TData = Awaited<ReturnType<typeof listExcludedCompanies>>, TError = HTTPValidationError>(
 params?: ListExcludedCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExcludedCompaniesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddExcludedCompaniesUrl = () => {




  return `/api/exclusions/companies`
}

/**
 * @summary Add Excluded Companies
 */
export const addExcludedCompanies = async (addExcludedCompaniesRequest: AddExcludedCompaniesRequest, options?: Parameters<typeof customInstance>[1]): Promise<ExcludedCompanyListResponse> => {

  return customInstance<ExcludedCompanyListResponse>(getAddExcludedCompaniesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addExcludedCompaniesRequest)
  }
);}





export const getAddExcludedCompaniesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExcludedCompanies>>, TError,{data: AddExcludedCompaniesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addExcludedCompanies>>, TError,{data: AddExcludedCompaniesRequest}, TContext> => {

const mutationKey = ['addExcludedCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addExcludedCompanies>>, {data: AddExcludedCompaniesRequest}> = (props) => {
          const {data} = props ?? {};

          return  addExcludedCompanies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddExcludedCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof addExcludedCompanies>>>
    export type AddExcludedCompaniesMutationBody = AddExcludedCompaniesRequest
    export type AddExcludedCompaniesMutationError = HTTPValidationError

    /**
 * @summary Add Excluded Companies
 */
export const useAddExcludedCompanies = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExcludedCompanies>>, TError,{data: AddExcludedCompaniesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addExcludedCompanies>>,
        TError,
        {data: AddExcludedCompaniesRequest},
        TContext
      > => {
      return useMutation(getAddExcludedCompaniesMutationOptions(options), queryClient);
    }

export const getClearAllExcludedCompaniesUrl = () => {




  return `/api/exclusions/companies/clear-all`
}

/**
 * @summary Clear All Excluded Companies
 */
export const clearAllExcludedCompanies = async ( options?: Parameters<typeof customInstance>[1]): Promise<ClearAllExclusionsResponse> => {

  return customInstance<ClearAllExclusionsResponse>(getClearAllExcludedCompaniesUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearAllExcludedCompaniesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedCompanies>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedCompanies>>, TError,void, TContext> => {

const mutationKey = ['clearAllExcludedCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearAllExcludedCompanies>>, void> = () => {


          return  clearAllExcludedCompanies(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearAllExcludedCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof clearAllExcludedCompanies>>>

    export type ClearAllExcludedCompaniesMutationError = unknown

    /**
 * @summary Clear All Excluded Companies
 */
export const useClearAllExcludedCompanies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedCompanies>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearAllExcludedCompanies>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearAllExcludedCompaniesMutationOptions(options), queryClient);
    }

export const getRemoveExcludedCompanyUrl = (exclusionId: string,) => {




  return `/api/exclusions/companies/${exclusionId}`
}

/**
 * @summary Remove Excluded Company
 */
export const removeExcludedCompany = async (exclusionId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveExcludedCompanyUrl(exclusionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveExcludedCompanyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeExcludedCompany>>, TError,{exclusionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeExcludedCompany>>, TError,{exclusionId: string}, TContext> => {

const mutationKey = ['removeExcludedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeExcludedCompany>>, {exclusionId: string}> = (props) => {
          const {exclusionId} = props ?? {};

          return  removeExcludedCompany(exclusionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveExcludedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof removeExcludedCompany>>>

    export type RemoveExcludedCompanyMutationError = HTTPValidationError

    /**
 * @summary Remove Excluded Company
 */
export const useRemoveExcludedCompany = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeExcludedCompany>>, TError,{exclusionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeExcludedCompany>>,
        TError,
        {exclusionId: string},
        TContext
      > => {
      return useMutation(getRemoveExcludedCompanyMutationOptions(options), queryClient);
    }

export const getListExcludedPeopleUrl = (params?: ListExcludedPeopleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/exclusions/people?${stringifiedParams}` : `/api/exclusions/people`
}

/**
 * @summary List Excluded People
 */
export const listExcludedPeople = async (params?: ListExcludedPeopleParams, options?: Parameters<typeof customInstance>[1]): Promise<ExcludedProfileListResponse> => {

  return customInstance<ExcludedProfileListResponse>(getListExcludedPeopleUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExcludedPeopleQueryKey = (params?: ListExcludedPeopleParams,) => {
    return [
    `/api/exclusions/people`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExcludedPeopleQueryOptions = <TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(params?: ListExcludedPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExcludedPeopleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExcludedPeople>>> = ({ signal }) => listExcludedPeople(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExcludedPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof listExcludedPeople>>>
export type ListExcludedPeopleQueryError = HTTPValidationError


export function useListExcludedPeople<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params: undefined |  ListExcludedPeopleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedPeople>>,
          TError,
          Awaited<ReturnType<typeof listExcludedPeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedPeople<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExcludedPeople>>,
          TError,
          Awaited<ReturnType<typeof listExcludedPeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedPeople<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Excluded People
 */

export function useListExcludedPeople<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExcludedPeopleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListExcludedPeopleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(params?: ListExcludedPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExcludedPeopleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExcludedPeople>>> = ({ signal }) => listExcludedPeople(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExcludedPeopleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listExcludedPeople>>>
export type ListExcludedPeopleSuspenseQueryError = HTTPValidationError


export function useListExcludedPeopleSuspense<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params: undefined |  ListExcludedPeopleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedPeopleSuspense<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExcludedPeopleSuspense<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Excluded People
 */

export function useListExcludedPeopleSuspense<TData = Awaited<ReturnType<typeof listExcludedPeople>>, TError = HTTPValidationError>(
 params?: ListExcludedPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExcludedPeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExcludedPeopleSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddExcludedPeopleUrl = () => {




  return `/api/exclusions/people`
}

/**
 * @summary Add Excluded People
 */
export const addExcludedPeople = async (addExcludedPeopleRequest: AddExcludedPeopleRequest, options?: Parameters<typeof customInstance>[1]): Promise<ExcludedProfileListResponse> => {

  return customInstance<ExcludedProfileListResponse>(getAddExcludedPeopleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addExcludedPeopleRequest)
  }
);}





export const getAddExcludedPeopleMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExcludedPeople>>, TError,{data: AddExcludedPeopleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addExcludedPeople>>, TError,{data: AddExcludedPeopleRequest}, TContext> => {

const mutationKey = ['addExcludedPeople'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addExcludedPeople>>, {data: AddExcludedPeopleRequest}> = (props) => {
          const {data} = props ?? {};

          return  addExcludedPeople(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddExcludedPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof addExcludedPeople>>>
    export type AddExcludedPeopleMutationBody = AddExcludedPeopleRequest
    export type AddExcludedPeopleMutationError = HTTPValidationError

    /**
 * @summary Add Excluded People
 */
export const useAddExcludedPeople = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addExcludedPeople>>, TError,{data: AddExcludedPeopleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addExcludedPeople>>,
        TError,
        {data: AddExcludedPeopleRequest},
        TContext
      > => {
      return useMutation(getAddExcludedPeopleMutationOptions(options), queryClient);
    }

export const getResolveExcludedPeopleByLinkedinUrlsUrl = () => {




  return `/api/exclusions/people/resolve-linkedin-urls`
}

/**
 * @summary Resolve Excluded People By Linkedin Urls
 */
export const resolveExcludedPeopleByLinkedinUrls = async (resolveExcludedPeopleByLinkedinUrlsRequest: ResolveExcludedPeopleByLinkedinUrlsRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResolveExcludedPeopleByLinkedinUrlsResponse> => {

  return customInstance<ResolveExcludedPeopleByLinkedinUrlsResponse>(getResolveExcludedPeopleByLinkedinUrlsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveExcludedPeopleByLinkedinUrlsRequest)
  }
);}





export const getResolveExcludedPeopleByLinkedinUrlsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>, TError,{data: ResolveExcludedPeopleByLinkedinUrlsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>, TError,{data: ResolveExcludedPeopleByLinkedinUrlsRequest}, TContext> => {

const mutationKey = ['resolveExcludedPeopleByLinkedinUrls'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>, {data: ResolveExcludedPeopleByLinkedinUrlsRequest}> = (props) => {
          const {data} = props ?? {};

          return  resolveExcludedPeopleByLinkedinUrls(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveExcludedPeopleByLinkedinUrlsMutationResult = NonNullable<Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>>
    export type ResolveExcludedPeopleByLinkedinUrlsMutationBody = ResolveExcludedPeopleByLinkedinUrlsRequest
    export type ResolveExcludedPeopleByLinkedinUrlsMutationError = HTTPValidationError

    /**
 * @summary Resolve Excluded People By Linkedin Urls
 */
export const useResolveExcludedPeopleByLinkedinUrls = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>, TError,{data: ResolveExcludedPeopleByLinkedinUrlsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveExcludedPeopleByLinkedinUrls>>,
        TError,
        {data: ResolveExcludedPeopleByLinkedinUrlsRequest},
        TContext
      > => {
      return useMutation(getResolveExcludedPeopleByLinkedinUrlsMutationOptions(options), queryClient);
    }

export const getClearAllExcludedPeopleUrl = () => {




  return `/api/exclusions/people/clear-all`
}

/**
 * @summary Clear All Excluded People
 */
export const clearAllExcludedPeople = async ( options?: Parameters<typeof customInstance>[1]): Promise<ClearAllExclusionsResponse> => {

  return customInstance<ClearAllExclusionsResponse>(getClearAllExcludedPeopleUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearAllExcludedPeopleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedPeople>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedPeople>>, TError,void, TContext> => {

const mutationKey = ['clearAllExcludedPeople'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearAllExcludedPeople>>, void> = () => {


          return  clearAllExcludedPeople(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearAllExcludedPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof clearAllExcludedPeople>>>

    export type ClearAllExcludedPeopleMutationError = unknown

    /**
 * @summary Clear All Excluded People
 */
export const useClearAllExcludedPeople = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAllExcludedPeople>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearAllExcludedPeople>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearAllExcludedPeopleMutationOptions(options), queryClient);
    }

export const getRemoveExcludedPersonUrl = (exclusionId: string,) => {




  return `/api/exclusions/people/${exclusionId}`
}

/**
 * @summary Remove Excluded Person
 */
export const removeExcludedPerson = async (exclusionId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveExcludedPersonUrl(exclusionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveExcludedPersonMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeExcludedPerson>>, TError,{exclusionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeExcludedPerson>>, TError,{exclusionId: string}, TContext> => {

const mutationKey = ['removeExcludedPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeExcludedPerson>>, {exclusionId: string}> = (props) => {
          const {exclusionId} = props ?? {};

          return  removeExcludedPerson(exclusionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveExcludedPersonMutationResult = NonNullable<Awaited<ReturnType<typeof removeExcludedPerson>>>

    export type RemoveExcludedPersonMutationError = HTTPValidationError

    /**
 * @summary Remove Excluded Person
 */
export const useRemoveExcludedPerson = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeExcludedPerson>>, TError,{exclusionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeExcludedPerson>>,
        TError,
        {exclusionId: string},
        TContext
      > => {
      return useMutation(getRemoveExcludedPersonMutationOptions(options), queryClient);
    }

export const getStartExportUrl = () => {




  return `/api/exports`
}

/**
 * @summary Start Export
 */
export const startExport = async (startExportRequestSchema: StartExportRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<ExportProfilesResponseSchema> => {

  return customInstance<ExportProfilesResponseSchema>(getStartExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startExportRequestSchema)
  }
);}





export const getStartExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExport>>, TError,{data: StartExportRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startExport>>, TError,{data: StartExportRequestSchema}, TContext> => {

const mutationKey = ['startExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startExport>>, {data: StartExportRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  startExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartExportMutationResult = NonNullable<Awaited<ReturnType<typeof startExport>>>
    export type StartExportMutationBody = StartExportRequestSchema
    export type StartExportMutationError = HTTPValidationError

    /**
 * @summary Start Export
 */
export const useStartExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExport>>, TError,{data: StartExportRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startExport>>,
        TError,
        {data: StartExportRequestSchema},
        TContext
      > => {
      return useMutation(getStartExportMutationOptions(options), queryClient);
    }

export const getEstimateExportUrl = () => {




  return `/api/exports/estimate`
}

/**
 * @summary Estimate Export
 */
export const estimateExport = async (exportEstimateRequestSchema: ExportEstimateRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<ExportEstimateSchema> => {

  return customInstance<ExportEstimateSchema>(getEstimateExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exportEstimateRequestSchema)
  }
);}





export const getEstimateExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateExport>>, TError,{data: ExportEstimateRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof estimateExport>>, TError,{data: ExportEstimateRequestSchema}, TContext> => {

const mutationKey = ['estimateExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof estimateExport>>, {data: ExportEstimateRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  estimateExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EstimateExportMutationResult = NonNullable<Awaited<ReturnType<typeof estimateExport>>>
    export type EstimateExportMutationBody = ExportEstimateRequestSchema
    export type EstimateExportMutationError = HTTPValidationError

    /**
 * @summary Estimate Export
 */
export const useEstimateExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateExport>>, TError,{data: ExportEstimateRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof estimateExport>>,
        TError,
        {data: ExportEstimateRequestSchema},
        TContext
      > => {
      return useMutation(getEstimateExportMutationOptions(options), queryClient);
    }

export const getGetExportJobUrl = (jobId: string,) => {




  return `/api/export/${jobId}`
}

/**
 * @summary Get Export Job
 */
export const getExportJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<ExportJobStatusSchema> => {

  return customInstance<ExportJobStatusSchema>(getGetExportJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExportJobQueryKey = (jobId: string,) => {
    return [
    `/api/export/${jobId}`
    ] as const;
    }


export const getGetExportJobQueryOptions = <TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExportJob>>> = ({ signal }) => getExportJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExportJobQueryResult = NonNullable<Awaited<ReturnType<typeof getExportJob>>>
export type GetExportJobQueryError = HTTPValidationError


export function useGetExportJob<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportJob>>,
          TError,
          Awaited<ReturnType<typeof getExportJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportJob<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportJob>>,
          TError,
          Awaited<ReturnType<typeof getExportJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportJob<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Export Job
 */

export function useGetExportJob<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExportJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExportJobSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExportJob>>> = ({ signal }) => getExportJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExportJobSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getExportJob>>>
export type GetExportJobSuspenseQueryError = HTTPValidationError


export function useGetExportJobSuspense<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportJobSuspense<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportJobSuspense<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Export Job
 */

export function useGetExportJobSuspense<TData = Awaited<ReturnType<typeof getExportJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExportJobSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListExportHistoryUrl = (params?: ListExportHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/exports/history?${stringifiedParams}` : `/api/exports/history`
}

/**
 * @summary List Export History
 */
export const listExportHistory = async (params?: ListExportHistoryParams, options?: Parameters<typeof customInstance>[1]): Promise<ExportHistoryListSchema> => {

  return customInstance<ExportHistoryListSchema>(getListExportHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExportHistoryQueryKey = (params?: ListExportHistoryParams,) => {
    return [
    `/api/exports/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExportHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(params?: ListExportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExportHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExportHistory>>> = ({ signal }) => listExportHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExportHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listExportHistory>>>
export type ListExportHistoryQueryError = HTTPValidationError


export function useListExportHistory<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params: undefined |  ListExportHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExportHistory>>,
          TError,
          Awaited<ReturnType<typeof listExportHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExportHistory<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExportHistory>>,
          TError,
          Awaited<ReturnType<typeof listExportHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExportHistory<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Export History
 */

export function useListExportHistory<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExportHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListExportHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(params?: ListExportHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExportHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExportHistory>>> = ({ signal }) => listExportHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExportHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listExportHistory>>>
export type ListExportHistorySuspenseQueryError = HTTPValidationError


export function useListExportHistorySuspense<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params: undefined |  ListExportHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExportHistorySuspense<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExportHistorySuspense<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Export History
 */

export function useListExportHistorySuspense<TData = Awaited<ReturnType<typeof listExportHistory>>, TError = HTTPValidationError>(
 params?: ListExportHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listExportHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExportHistorySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryExportUrl = (exportHistoryId: string,) => {




  return `/api/exports/${exportHistoryId}/retry`
}

/**
 * @summary Retry Export
 */
export const retryExport = async (exportHistoryId: string, options?: Parameters<typeof customInstance>[1]): Promise<ExportProfilesResponseSchema> => {

  return customInstance<ExportProfilesResponseSchema>(getRetryExportUrl(exportHistoryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryExport>>, TError,{exportHistoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryExport>>, TError,{exportHistoryId: string}, TContext> => {

const mutationKey = ['retryExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryExport>>, {exportHistoryId: string}> = (props) => {
          const {exportHistoryId} = props ?? {};

          return  retryExport(exportHistoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryExportMutationResult = NonNullable<Awaited<ReturnType<typeof retryExport>>>

    export type RetryExportMutationError = HTTPValidationError

    /**
 * @summary Retry Export
 */
export const useRetryExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryExport>>, TError,{exportHistoryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryExport>>,
        TError,
        {exportHistoryId: string},
        TContext
      > => {
      return useMutation(getRetryExportMutationOptions(options), queryClient);
    }

export const getGetInboxSummaryUrl = (sequenceId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/summary`
}

/**
 * Tab counts + channel availability flags.
 * @summary Get Inbox Summary
 */
export const getInboxSummary = async (sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<SummaryResponse> => {

  return customInstance<SummaryResponse>(getGetInboxSummaryUrl(sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInboxSummaryQueryKey = (sequenceId: string,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/summary`
    ] as const;
    }


export const getGetInboxSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxSummaryQueryKey(sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxSummary>>> = ({ signal }) => getInboxSummary(sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxSummary>>>
export type GetInboxSummaryQueryError = HTTPValidationError


export function useGetInboxSummary<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxSummary>>,
          TError,
          Awaited<ReturnType<typeof getInboxSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxSummary<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxSummary>>,
          TError,
          Awaited<ReturnType<typeof getInboxSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxSummary<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Summary
 */

export function useGetInboxSummary<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxSummaryQueryOptions(sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInboxSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxSummaryQueryKey(sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxSummary>>> = ({ signal }) => getInboxSummary(sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxSummary>>>
export type GetInboxSummarySuspenseQueryError = HTTPValidationError


export function useGetInboxSummarySuspense<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxSummarySuspense<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxSummarySuspense<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Summary
 */

export function useGetInboxSummarySuspense<TData = Awaited<ReturnType<typeof getInboxSummary>>, TError = HTTPValidationError>(
 sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxSummarySuspenseQueryOptions(sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInboxThreadsUrl = (sequenceId: string,
    params?: ListInboxThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sequences/${sequenceId}/inbox/threads?${stringifiedParams}` : `/api/sequences/${sequenceId}/inbox/threads`
}

/**
 * List threads (or chats) per tab + channel.
 *
 * ``channel='linkedin'`` returns LinkedIn chats; the schema is
 * intentionally compatible with thread list items so the UI can
 * render either over the same row component (per spec §11).
 * Cross-org is impossible — every query filters by
 * ``current_user.org_id``.
 * @summary List Inbox Threads
 */
export const listInboxThreads = async (sequenceId: string,
    params?: ListInboxThreadsParams, options?: Parameters<typeof customInstance>[1]): Promise<InboxThreadListResponse> => {

  return customInstance<InboxThreadListResponse>(getListInboxThreadsUrl(sequenceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInboxThreadsQueryKey = (sequenceId: string,
    params?: ListInboxThreadsParams,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInboxThreadsQueryOptions = <TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInboxThreadsQueryKey(sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInboxThreads>>> = ({ signal }) => listInboxThreads(sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInboxThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listInboxThreads>>>
export type ListInboxThreadsQueryError = HTTPValidationError


export function useListInboxThreads<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params: undefined |  ListInboxThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInboxThreads>>,
          TError,
          Awaited<ReturnType<typeof listInboxThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxThreads<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInboxThreads>>,
          TError,
          Awaited<ReturnType<typeof listInboxThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxThreads<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Inbox Threads
 */

export function useListInboxThreads<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInboxThreadsQueryOptions(sequenceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListInboxThreadsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInboxThreadsQueryKey(sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInboxThreads>>> = ({ signal }) => listInboxThreads(sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInboxThreadsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listInboxThreads>>>
export type ListInboxThreadsSuspenseQueryError = HTTPValidationError


export function useListInboxThreadsSuspense<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params: undefined |  ListInboxThreadsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxThreadsSuspense<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxThreadsSuspense<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Inbox Threads
 */

export function useListInboxThreadsSuspense<TData = Awaited<ReturnType<typeof listInboxThreads>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxThreadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInboxThreadsSuspenseQueryOptions(sequenceId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInboxThreadUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}`
}

/**
 * @summary Get Inbox Thread
 */
export const getInboxThread = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<InboxThreadResponse> => {

  return customInstance<InboxThreadResponse>(getGetInboxThreadUrl(sequenceId,threadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInboxThreadQueryKey = (sequenceId: string,
    threadId: string,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/threads/${threadId}`
    ] as const;
    }


export const getGetInboxThreadQueryOptions = <TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxThreadQueryKey(sequenceId,threadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxThread>>> = ({ signal }) => getInboxThread(sequenceId,threadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined && threadId !== null && threadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxThread>>>
export type GetInboxThreadQueryError = HTTPValidationError


export function useGetInboxThread<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxThread>>,
          TError,
          Awaited<ReturnType<typeof getInboxThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThread<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxThread>>,
          TError,
          Awaited<ReturnType<typeof getInboxThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThread<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Thread
 */

export function useGetInboxThread<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxThreadQueryOptions(sequenceId,threadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInboxThreadSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxThreadQueryKey(sequenceId,threadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxThread>>> = ({ signal }) => getInboxThread(sequenceId,threadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxThreadSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxThread>>>
export type GetInboxThreadSuspenseQueryError = HTTPValidationError


export function useGetInboxThreadSuspense<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadSuspense<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadSuspense<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Thread
 */

export function useGetInboxThreadSuspense<TData = Awaited<ReturnType<typeof getInboxThread>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxThreadSuspenseQueryOptions(sequenceId,threadId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInboxThreadVariablesUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/variables`
}

/**
 * Resolve every V1 template variable against the thread's live
 * candidate / sender / job context.
 *
 * The reply composer fetches this once when it opens and inserts the
 * resolved value as literal text when a recruiter picks a variable —
 * a manual reply is final copy and must never embed an unresolved
 * ``{{variable}}`` chip.
 * @summary Get Inbox Thread Variables
 */
export const getInboxThreadVariables = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<ThreadVariablesResponse> => {

  return customInstance<ThreadVariablesResponse>(getGetInboxThreadVariablesUrl(sequenceId,threadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInboxThreadVariablesQueryKey = (sequenceId: string,
    threadId: string,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/threads/${threadId}/variables`
    ] as const;
    }


export const getGetInboxThreadVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxThreadVariablesQueryKey(sequenceId,threadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxThreadVariables>>> = ({ signal }) => getInboxThreadVariables(sequenceId,threadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined && threadId !== null && threadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxThreadVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxThreadVariables>>>
export type GetInboxThreadVariablesQueryError = HTTPValidationError


export function useGetInboxThreadVariables<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxThreadVariables>>,
          TError,
          Awaited<ReturnType<typeof getInboxThreadVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadVariables<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxThreadVariables>>,
          TError,
          Awaited<ReturnType<typeof getInboxThreadVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadVariables<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Thread Variables
 */

export function useGetInboxThreadVariables<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxThreadVariablesQueryOptions(sequenceId,threadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInboxThreadVariablesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxThreadVariablesQueryKey(sequenceId,threadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxThreadVariables>>> = ({ signal }) => getInboxThreadVariables(sequenceId,threadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxThreadVariablesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxThreadVariables>>>
export type GetInboxThreadVariablesSuspenseQueryError = HTTPValidationError


export function useGetInboxThreadVariablesSuspense<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadVariablesSuspense<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxThreadVariablesSuspense<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Thread Variables
 */

export function useGetInboxThreadVariablesSuspense<TData = Awaited<ReturnType<typeof getInboxThreadVariables>>, TError = HTTPValidationError>(
 sequenceId: string,
    threadId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxThreadVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxThreadVariablesSuspenseQueryOptions(sequenceId,threadId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendInboxThreadReplyUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/reply`
}

/**
 * Persist an outbound ``inbox_messages`` row in the appropriate
 * status (``sending`` for immediate, ``scheduled`` for deferred) and
 * start ``SendInboxReplyWorkflow``.
 *
 * Idempotent: an ``ApplicationError`` from the unique
 * ``idempotency_key`` constraint surfaces as 202 with the same
 * workflow id (the route layer's contract — repeated POSTs from a
 * flaky network never double-send).
 * @summary Send Inbox Thread Reply
 */
export const sendInboxThreadReply = async (sequenceId: string,
    threadId: string,
    replyRequest: ReplyRequest, options?: Parameters<typeof customInstance>[1]): Promise<ReplySendResponse> => {

  return customInstance<ReplySendResponse>(getSendInboxThreadReplyUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replyRequest)
  }
);}





export const getSendInboxThreadReplyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInboxThreadReply>>, TError,{sequenceId: string;threadId: string;data: ReplyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendInboxThreadReply>>, TError,{sequenceId: string;threadId: string;data: ReplyRequest}, TContext> => {

const mutationKey = ['sendInboxThreadReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInboxThreadReply>>, {sequenceId: string;threadId: string;data: ReplyRequest}> = (props) => {
          const {sequenceId,threadId,data} = props ?? {};

          return  sendInboxThreadReply(sequenceId,threadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendInboxThreadReplyMutationResult = NonNullable<Awaited<ReturnType<typeof sendInboxThreadReply>>>
    export type SendInboxThreadReplyMutationBody = ReplyRequest
    export type SendInboxThreadReplyMutationError = HTTPValidationError

    /**
 * @summary Send Inbox Thread Reply
 */
export const useSendInboxThreadReply = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInboxThreadReply>>, TError,{sequenceId: string;threadId: string;data: ReplyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInboxThreadReply>>,
        TError,
        {sequenceId: string;threadId: string;data: ReplyRequest},
        TContext
      > => {
      return useMutation(getSendInboxThreadReplyMutationOptions(options), queryClient);
    }

export const getMarkInboxThreadReadUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/mark-read`
}

/**
 * Remove ``current_user.id`` from the thread's
 * ``unread_for_user_ids`` array.
 *
 * Per-user unread state is stored as ``ARRAY[UUID]`` on the row
 * (migration ``aadb1ca592c6``); this route is the only consumer
 * of the column today. Idempotent — the array operator is safe
 * against missing entries.
 * @summary Mark Inbox Thread Read
 */
export const markInboxThreadRead = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkInboxThreadReadUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkInboxThreadReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadRead>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadRead>>, TError,{sequenceId: string;threadId: string}, TContext> => {

const mutationKey = ['markInboxThreadRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markInboxThreadRead>>, {sequenceId: string;threadId: string}> = (props) => {
          const {sequenceId,threadId} = props ?? {};

          return  markInboxThreadRead(sequenceId,threadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkInboxThreadReadMutationResult = NonNullable<Awaited<ReturnType<typeof markInboxThreadRead>>>

    export type MarkInboxThreadReadMutationError = HTTPValidationError

    /**
 * @summary Mark Inbox Thread Read
 */
export const useMarkInboxThreadRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadRead>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markInboxThreadRead>>,
        TError,
        {sequenceId: string;threadId: string},
        TContext
      > => {
      return useMutation(getMarkInboxThreadReadMutationOptions(options), queryClient);
    }

export const getMarkInboxThreadUnreadUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/mark-unread`
}

/**
 * Add ``current_user.id`` to the thread's ``unread_for_user_ids``
 * array. Inverse of :func:`mark_inbox_thread_read`; idempotent — a
 * user already in the array is a no-op.
 * @summary Mark Inbox Thread Unread
 */
export const markInboxThreadUnread = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkInboxThreadUnreadUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkInboxThreadUnreadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadUnread>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadUnread>>, TError,{sequenceId: string;threadId: string}, TContext> => {

const mutationKey = ['markInboxThreadUnread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markInboxThreadUnread>>, {sequenceId: string;threadId: string}> = (props) => {
          const {sequenceId,threadId} = props ?? {};

          return  markInboxThreadUnread(sequenceId,threadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkInboxThreadUnreadMutationResult = NonNullable<Awaited<ReturnType<typeof markInboxThreadUnread>>>

    export type MarkInboxThreadUnreadMutationError = HTTPValidationError

    /**
 * @summary Mark Inbox Thread Unread
 */
export const useMarkInboxThreadUnread = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxThreadUnread>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markInboxThreadUnread>>,
        TError,
        {sequenceId: string;threadId: string},
        TContext
      > => {
      return useMutation(getMarkInboxThreadUnreadMutationOptions(options), queryClient);
    }

export const getBulkMarkInboxThreadsUrl = (sequenceId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/bulk-mark`
}

/**
 * Mark up to 50 threads read/unread for the caller in ONE statement.
 *
 * ``read=True`` removes the caller from each thread's ``unread_for_user_ids``;
 * ``read=False`` adds them. Far cheaper than the client firing a per-thread
 * mark-read/unread request. The 50-id cap is enforced by the request schema
 * (422 over the limit); the repo scopes every update to ``org_id`` +
 * ``sequence_id`` so ids from another tenant/sequence are silently no-ops.
 * @summary Bulk Mark Inbox Threads
 */
export const bulkMarkInboxThreads = async (sequenceId: string,
    bulkMarkThreadsRequest: BulkMarkThreadsRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getBulkMarkInboxThreadsUrl(sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkMarkThreadsRequest)
  }
);}





export const getBulkMarkInboxThreadsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxThreads>>, TError,{sequenceId: string;data: BulkMarkThreadsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxThreads>>, TError,{sequenceId: string;data: BulkMarkThreadsRequest}, TContext> => {

const mutationKey = ['bulkMarkInboxThreads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMarkInboxThreads>>, {sequenceId: string;data: BulkMarkThreadsRequest}> = (props) => {
          const {sequenceId,data} = props ?? {};

          return  bulkMarkInboxThreads(sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMarkInboxThreadsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMarkInboxThreads>>>
    export type BulkMarkInboxThreadsMutationBody = BulkMarkThreadsRequest
    export type BulkMarkInboxThreadsMutationError = HTTPValidationError

    /**
 * @summary Bulk Mark Inbox Threads
 */
export const useBulkMarkInboxThreads = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxThreads>>, TError,{sequenceId: string;data: BulkMarkThreadsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMarkInboxThreads>>,
        TError,
        {sequenceId: string;data: BulkMarkThreadsRequest},
        TContext
      > => {
      return useMutation(getBulkMarkInboxThreadsMutationOptions(options), queryClient);
    }

export const getAcceptInboxThreadAutoDraftUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/auto-draft/accept`
}

/**
 * Flip ``draft_status='accepted'`` and return the updated thread.
 *
 * Spec §9.3: ``ready → accepted`` is the only legal transition into
 * accepted. ``DRAFT_NOT_READY`` 409 if the row is in any other
 * state.
 * @summary Accept Inbox Thread Auto Draft
 */
export const acceptInboxThreadAutoDraft = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<InboxThreadResponse> => {

  return customInstance<InboxThreadResponse>(getAcceptInboxThreadAutoDraftUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptInboxThreadAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext> => {

const mutationKey = ['acceptInboxThreadAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>, {sequenceId: string;threadId: string}> = (props) => {
          const {sequenceId,threadId} = props ?? {};

          return  acceptInboxThreadAutoDraft(sequenceId,threadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInboxThreadAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>>

    export type AcceptInboxThreadAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Accept Inbox Thread Auto Draft
 */
export const useAcceptInboxThreadAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInboxThreadAutoDraft>>,
        TError,
        {sequenceId: string;threadId: string},
        TContext
      > => {
      return useMutation(getAcceptInboxThreadAutoDraftMutationOptions(options), queryClient);
    }

export const getRegenerateInboxThreadAutoDraftUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/auto-draft/regenerate`
}

/**
 * Start a regenerate ``DraftReplyWorkflow``.
 *
 * Rate-limited per-user-per-thread via Redis (15s window) — spec
 * §17.10. Surfaces as 429 ``REGENERATE_RATE_LIMIT`` on collision.
 * @summary Regenerate Inbox Thread Auto Draft
 */
export const regenerateInboxThreadAutoDraft = async (sequenceId: string,
    threadId: string,
    autoDraftRegenerateRequest: AutoDraftRegenerateRequest, options?: Parameters<typeof customInstance>[1]): Promise<WorkflowAcknowledgement> => {

  return customInstance<WorkflowAcknowledgement>(getRegenerateInboxThreadAutoDraftUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(autoDraftRegenerateRequest)
  }
);}





export const getRegenerateInboxThreadAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string;data: AutoDraftRegenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string;data: AutoDraftRegenerateRequest}, TContext> => {

const mutationKey = ['regenerateInboxThreadAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>, {sequenceId: string;threadId: string;data: AutoDraftRegenerateRequest}> = (props) => {
          const {sequenceId,threadId,data} = props ?? {};

          return  regenerateInboxThreadAutoDraft(sequenceId,threadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateInboxThreadAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>>
    export type RegenerateInboxThreadAutoDraftMutationBody = AutoDraftRegenerateRequest
    export type RegenerateInboxThreadAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Regenerate Inbox Thread Auto Draft
 */
export const useRegenerateInboxThreadAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string;data: AutoDraftRegenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateInboxThreadAutoDraft>>,
        TError,
        {sequenceId: string;threadId: string;data: AutoDraftRegenerateRequest},
        TContext
      > => {
      return useMutation(getRegenerateInboxThreadAutoDraftMutationOptions(options), queryClient);
    }

export const getDenyInboxThreadAutoDraftUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/auto-draft`
}

/**
 * Clear the draft + flip status to ``denied``.
 *
 * Idempotent: re-deleting an already-denied draft is a 204 no-op.
 * @summary Deny Inbox Thread Auto Draft
 */
export const denyInboxThreadAutoDraft = async (sequenceId: string,
    threadId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDenyInboxThreadAutoDraftUrl(sequenceId,threadId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDenyInboxThreadAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext> => {

const mutationKey = ['denyInboxThreadAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>, {sequenceId: string;threadId: string}> = (props) => {
          const {sequenceId,threadId} = props ?? {};

          return  denyInboxThreadAutoDraft(sequenceId,threadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyInboxThreadAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>>

    export type DenyInboxThreadAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Deny Inbox Thread Auto Draft
 */
export const useDenyInboxThreadAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>, TError,{sequenceId: string;threadId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof denyInboxThreadAutoDraft>>,
        TError,
        {sequenceId: string;threadId: string},
        TContext
      > => {
      return useMutation(getDenyInboxThreadAutoDraftMutationOptions(options), queryClient);
    }

export const getOverrideInboxThreadClassificationUrl = (sequenceId: string,
    threadId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/threads/${threadId}/classify`
}

/**
 * @summary Override Inbox Thread Classification
 */
export const overrideInboxThreadClassification = async (sequenceId: string,
    threadId: string,
    classificationOverrideRequest: ClassificationOverrideRequest, options?: Parameters<typeof customInstance>[1]): Promise<InboxThreadResponse> => {

  return customInstance<InboxThreadResponse>(getOverrideInboxThreadClassificationUrl(sequenceId,threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(classificationOverrideRequest)
  }
);}





export const getOverrideInboxThreadClassificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideInboxThreadClassification>>, TError,{sequenceId: string;threadId: string;data: ClassificationOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof overrideInboxThreadClassification>>, TError,{sequenceId: string;threadId: string;data: ClassificationOverrideRequest}, TContext> => {

const mutationKey = ['overrideInboxThreadClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof overrideInboxThreadClassification>>, {sequenceId: string;threadId: string;data: ClassificationOverrideRequest}> = (props) => {
          const {sequenceId,threadId,data} = props ?? {};

          return  overrideInboxThreadClassification(sequenceId,threadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OverrideInboxThreadClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof overrideInboxThreadClassification>>>
    export type OverrideInboxThreadClassificationMutationBody = ClassificationOverrideRequest
    export type OverrideInboxThreadClassificationMutationError = HTTPValidationError

    /**
 * @summary Override Inbox Thread Classification
 */
export const useOverrideInboxThreadClassification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideInboxThreadClassification>>, TError,{sequenceId: string;threadId: string;data: ClassificationOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof overrideInboxThreadClassification>>,
        TError,
        {sequenceId: string;threadId: string;data: ClassificationOverrideRequest},
        TContext
      > => {
      return useMutation(getOverrideInboxThreadClassificationMutationOptions(options), queryClient);
    }

export const getCancelScheduledInboxSendUrl = (sequenceId: string,
    messageId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/messages/${messageId}/cancel-schedule`
}

/**
 * Cancel a still-pending scheduled outbound send.
 *
 * Looks up the persisted ``inbox_messages`` row, signals the
 * Temporal workflow with ``CancelScheduledSendSignal``, and lets
 * the workflow's cancel branch clean up the row. Returns a small
 * ack envelope; the row itself drops on the next workflow step.
 *
 * 409 on already-sent or non-existent messages.
 * @summary Cancel Scheduled Inbox Send
 */
export const cancelScheduledInboxSend = async (sequenceId: string,
    messageId: string, options?: Parameters<typeof customInstance>[1]): Promise<CancelScheduledInboxSend200> => {

  return customInstance<CancelScheduledInboxSend200>(getCancelScheduledInboxSendUrl(sequenceId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelScheduledInboxSendMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxSend>>, TError,{sequenceId: string;messageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxSend>>, TError,{sequenceId: string;messageId: string}, TContext> => {

const mutationKey = ['cancelScheduledInboxSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelScheduledInboxSend>>, {sequenceId: string;messageId: string}> = (props) => {
          const {sequenceId,messageId} = props ?? {};

          return  cancelScheduledInboxSend(sequenceId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelScheduledInboxSendMutationResult = NonNullable<Awaited<ReturnType<typeof cancelScheduledInboxSend>>>

    export type CancelScheduledInboxSendMutationError = HTTPValidationError

    /**
 * @summary Cancel Scheduled Inbox Send
 */
export const useCancelScheduledInboxSend = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxSend>>, TError,{sequenceId: string;messageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelScheduledInboxSend>>,
        TError,
        {sequenceId: string;messageId: string},
        TContext
      > => {
      return useMutation(getCancelScheduledInboxSendMutationOptions(options), queryClient);
    }

export const getListInboxChatsUrl = (sequenceId: string,
    params?: ListInboxChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sequences/${sequenceId}/inbox/chats?${stringifiedParams}` : `/api/sequences/${sequenceId}/inbox/chats`
}

/**
 * @summary List Inbox Chats
 */
export const listInboxChats = async (sequenceId: string,
    params?: ListInboxChatsParams, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInChatListResponse> => {

  return customInstance<LinkedInChatListResponse>(getListInboxChatsUrl(sequenceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInboxChatsQueryKey = (sequenceId: string,
    params?: ListInboxChatsParams,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/chats`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInboxChatsQueryOptions = <TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInboxChatsQueryKey(sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInboxChats>>> = ({ signal }) => listInboxChats(sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInboxChatsQueryResult = NonNullable<Awaited<ReturnType<typeof listInboxChats>>>
export type ListInboxChatsQueryError = HTTPValidationError


export function useListInboxChats<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params: undefined |  ListInboxChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInboxChats>>,
          TError,
          Awaited<ReturnType<typeof listInboxChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxChats<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInboxChats>>,
          TError,
          Awaited<ReturnType<typeof listInboxChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxChats<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Inbox Chats
 */

export function useListInboxChats<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInboxChatsQueryOptions(sequenceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListInboxChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInboxChatsQueryKey(sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInboxChats>>> = ({ signal }) => listInboxChats(sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInboxChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listInboxChats>>>
export type ListInboxChatsSuspenseQueryError = HTTPValidationError


export function useListInboxChatsSuspense<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params: undefined |  ListInboxChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxChatsSuspense<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInboxChatsSuspense<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Inbox Chats
 */

export function useListInboxChatsSuspense<TData = Awaited<ReturnType<typeof listInboxChats>>, TError = HTTPValidationError>(
 sequenceId: string,
    params?: ListInboxChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInboxChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInboxChatsSuspenseQueryOptions(sequenceId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInboxChatUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}`
}

/**
 * @summary Get Inbox Chat
 */
export const getInboxChat = async (sequenceId: string,
    chatId: string, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInChatResponse> => {

  return customInstance<LinkedInChatResponse>(getGetInboxChatUrl(sequenceId,chatId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInboxChatQueryKey = (sequenceId: string,
    chatId: string,) => {
    return [
    `/api/sequences/${sequenceId}/inbox/chats/${chatId}`
    ] as const;
    }


export const getGetInboxChatQueryOptions = <TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(sequenceId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxChatQueryKey(sequenceId,chatId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxChat>>> = ({ signal }) => getInboxChat(sequenceId,chatId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sequenceId !== null && sequenceId !== undefined && chatId !== null && chatId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxChatQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxChat>>>
export type GetInboxChatQueryError = HTTPValidationError


export function useGetInboxChat<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxChat>>,
          TError,
          Awaited<ReturnType<typeof getInboxChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxChat<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInboxChat>>,
          TError,
          Awaited<ReturnType<typeof getInboxChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxChat<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Chat
 */

export function useGetInboxChat<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxChatQueryOptions(sequenceId,chatId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInboxChatSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(sequenceId: string,
    chatId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInboxChatQueryKey(sequenceId,chatId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboxChat>>> = ({ signal }) => getInboxChat(sequenceId,chatId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInboxChatSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInboxChat>>>
export type GetInboxChatSuspenseQueryError = HTTPValidationError


export function useGetInboxChatSuspense<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxChatSuspense<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInboxChatSuspense<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Inbox Chat
 */

export function useGetInboxChatSuspense<TData = Awaited<ReturnType<typeof getInboxChat>>, TError = HTTPValidationError>(
 sequenceId: string,
    chatId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInboxChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInboxChatSuspenseQueryOptions(sequenceId,chatId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendInboxChatMessageUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/messages`
}

/**
 * @summary Send Inbox Chat Message
 */
export const sendInboxChatMessage = async (sequenceId: string,
    chatId: string,
    chatMessageRequest: ChatMessageRequest, options?: Parameters<typeof customInstance>[1]): Promise<ChatMessageSendResponse> => {

  return customInstance<ChatMessageSendResponse>(getSendInboxChatMessageUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatMessageRequest)
  }
);}





export const getSendInboxChatMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInboxChatMessage>>, TError,{sequenceId: string;chatId: string;data: ChatMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendInboxChatMessage>>, TError,{sequenceId: string;chatId: string;data: ChatMessageRequest}, TContext> => {

const mutationKey = ['sendInboxChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInboxChatMessage>>, {sequenceId: string;chatId: string;data: ChatMessageRequest}> = (props) => {
          const {sequenceId,chatId,data} = props ?? {};

          return  sendInboxChatMessage(sequenceId,chatId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendInboxChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendInboxChatMessage>>>
    export type SendInboxChatMessageMutationBody = ChatMessageRequest
    export type SendInboxChatMessageMutationError = HTTPValidationError

    /**
 * @summary Send Inbox Chat Message
 */
export const useSendInboxChatMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInboxChatMessage>>, TError,{sequenceId: string;chatId: string;data: ChatMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInboxChatMessage>>,
        TError,
        {sequenceId: string;chatId: string;data: ChatMessageRequest},
        TContext
      > => {
      return useMutation(getSendInboxChatMessageMutationOptions(options), queryClient);
    }

export const getMarkInboxChatReadUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/mark-read`
}

/**
 * Mirror of :func:`mark_inbox_thread_read` for LinkedIn chats.
 *
 * Removes ``current_user.id`` from ``unread_for_user_ids``;
 * idempotent.
 * @summary Mark Inbox Chat Read
 */
export const markInboxChatRead = async (sequenceId: string,
    chatId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkInboxChatReadUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkInboxChatReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxChatRead>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markInboxChatRead>>, TError,{sequenceId: string;chatId: string}, TContext> => {

const mutationKey = ['markInboxChatRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markInboxChatRead>>, {sequenceId: string;chatId: string}> = (props) => {
          const {sequenceId,chatId} = props ?? {};

          return  markInboxChatRead(sequenceId,chatId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkInboxChatReadMutationResult = NonNullable<Awaited<ReturnType<typeof markInboxChatRead>>>

    export type MarkInboxChatReadMutationError = HTTPValidationError

    /**
 * @summary Mark Inbox Chat Read
 */
export const useMarkInboxChatRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxChatRead>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markInboxChatRead>>,
        TError,
        {sequenceId: string;chatId: string},
        TContext
      > => {
      return useMutation(getMarkInboxChatReadMutationOptions(options), queryClient);
    }

export const getMarkInboxChatUnreadUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/mark-unread`
}

/**
 * Mirror of :func:`mark_inbox_thread_unread` for LinkedIn chats.
 * @summary Mark Inbox Chat Unread
 */
export const markInboxChatUnread = async (sequenceId: string,
    chatId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkInboxChatUnreadUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkInboxChatUnreadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxChatUnread>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markInboxChatUnread>>, TError,{sequenceId: string;chatId: string}, TContext> => {

const mutationKey = ['markInboxChatUnread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markInboxChatUnread>>, {sequenceId: string;chatId: string}> = (props) => {
          const {sequenceId,chatId} = props ?? {};

          return  markInboxChatUnread(sequenceId,chatId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkInboxChatUnreadMutationResult = NonNullable<Awaited<ReturnType<typeof markInboxChatUnread>>>

    export type MarkInboxChatUnreadMutationError = HTTPValidationError

    /**
 * @summary Mark Inbox Chat Unread
 */
export const useMarkInboxChatUnread = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInboxChatUnread>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markInboxChatUnread>>,
        TError,
        {sequenceId: string;chatId: string},
        TContext
      > => {
      return useMutation(getMarkInboxChatUnreadMutationOptions(options), queryClient);
    }

export const getBulkMarkInboxChatsUrl = (sequenceId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/bulk-mark`
}

/**
 * LinkedIn mirror of :func:`bulk_mark_inbox_threads` (≤ 50 chats).
 * @summary Bulk Mark Inbox Chats
 */
export const bulkMarkInboxChats = async (sequenceId: string,
    bulkMarkChatsRequest: BulkMarkChatsRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getBulkMarkInboxChatsUrl(sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkMarkChatsRequest)
  }
);}





export const getBulkMarkInboxChatsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxChats>>, TError,{sequenceId: string;data: BulkMarkChatsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxChats>>, TError,{sequenceId: string;data: BulkMarkChatsRequest}, TContext> => {

const mutationKey = ['bulkMarkInboxChats'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMarkInboxChats>>, {sequenceId: string;data: BulkMarkChatsRequest}> = (props) => {
          const {sequenceId,data} = props ?? {};

          return  bulkMarkInboxChats(sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMarkInboxChatsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMarkInboxChats>>>
    export type BulkMarkInboxChatsMutationBody = BulkMarkChatsRequest
    export type BulkMarkInboxChatsMutationError = HTTPValidationError

    /**
 * @summary Bulk Mark Inbox Chats
 */
export const useBulkMarkInboxChats = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMarkInboxChats>>, TError,{sequenceId: string;data: BulkMarkChatsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMarkInboxChats>>,
        TError,
        {sequenceId: string;data: BulkMarkChatsRequest},
        TContext
      > => {
      return useMutation(getBulkMarkInboxChatsMutationOptions(options), queryClient);
    }

export const getAcceptInboxChatAutoDraftUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/auto-draft/accept`
}

/**
 * @summary Accept Inbox Chat Auto Draft
 */
export const acceptInboxChatAutoDraft = async (sequenceId: string,
    chatId: string, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInChatResponse> => {

  return customInstance<LinkedInChatResponse>(getAcceptInboxChatAutoDraftUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptInboxChatAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext> => {

const mutationKey = ['acceptInboxChatAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>, {sequenceId: string;chatId: string}> = (props) => {
          const {sequenceId,chatId} = props ?? {};

          return  acceptInboxChatAutoDraft(sequenceId,chatId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInboxChatAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>>

    export type AcceptInboxChatAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Accept Inbox Chat Auto Draft
 */
export const useAcceptInboxChatAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInboxChatAutoDraft>>,
        TError,
        {sequenceId: string;chatId: string},
        TContext
      > => {
      return useMutation(getAcceptInboxChatAutoDraftMutationOptions(options), queryClient);
    }

export const getRegenerateInboxChatAutoDraftUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/auto-draft/regenerate`
}

/**
 * @summary Regenerate Inbox Chat Auto Draft
 */
export const regenerateInboxChatAutoDraft = async (sequenceId: string,
    chatId: string,
    autoDraftRegenerateRequest: AutoDraftRegenerateRequest, options?: Parameters<typeof customInstance>[1]): Promise<WorkflowAcknowledgement> => {

  return customInstance<WorkflowAcknowledgement>(getRegenerateInboxChatAutoDraftUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(autoDraftRegenerateRequest)
  }
);}





export const getRegenerateInboxChatAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string;data: AutoDraftRegenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string;data: AutoDraftRegenerateRequest}, TContext> => {

const mutationKey = ['regenerateInboxChatAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>, {sequenceId: string;chatId: string;data: AutoDraftRegenerateRequest}> = (props) => {
          const {sequenceId,chatId,data} = props ?? {};

          return  regenerateInboxChatAutoDraft(sequenceId,chatId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateInboxChatAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>>
    export type RegenerateInboxChatAutoDraftMutationBody = AutoDraftRegenerateRequest
    export type RegenerateInboxChatAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Regenerate Inbox Chat Auto Draft
 */
export const useRegenerateInboxChatAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string;data: AutoDraftRegenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateInboxChatAutoDraft>>,
        TError,
        {sequenceId: string;chatId: string;data: AutoDraftRegenerateRequest},
        TContext
      > => {
      return useMutation(getRegenerateInboxChatAutoDraftMutationOptions(options), queryClient);
    }

export const getDenyInboxChatAutoDraftUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/auto-draft`
}

/**
 * @summary Deny Inbox Chat Auto Draft
 */
export const denyInboxChatAutoDraft = async (sequenceId: string,
    chatId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDenyInboxChatAutoDraftUrl(sequenceId,chatId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDenyInboxChatAutoDraftMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof denyInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext> => {

const mutationKey = ['denyInboxChatAutoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyInboxChatAutoDraft>>, {sequenceId: string;chatId: string}> = (props) => {
          const {sequenceId,chatId} = props ?? {};

          return  denyInboxChatAutoDraft(sequenceId,chatId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyInboxChatAutoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof denyInboxChatAutoDraft>>>

    export type DenyInboxChatAutoDraftMutationError = HTTPValidationError

    /**
 * @summary Deny Inbox Chat Auto Draft
 */
export const useDenyInboxChatAutoDraft = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyInboxChatAutoDraft>>, TError,{sequenceId: string;chatId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof denyInboxChatAutoDraft>>,
        TError,
        {sequenceId: string;chatId: string},
        TContext
      > => {
      return useMutation(getDenyInboxChatAutoDraftMutationOptions(options), queryClient);
    }

export const getOverrideInboxChatClassificationUrl = (sequenceId: string,
    chatId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/${chatId}/classify`
}

/**
 * @summary Override Inbox Chat Classification
 */
export const overrideInboxChatClassification = async (sequenceId: string,
    chatId: string,
    classificationOverrideRequest: ClassificationOverrideRequest, options?: Parameters<typeof customInstance>[1]): Promise<LinkedInChatResponse> => {

  return customInstance<LinkedInChatResponse>(getOverrideInboxChatClassificationUrl(sequenceId,chatId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(classificationOverrideRequest)
  }
);}





export const getOverrideInboxChatClassificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideInboxChatClassification>>, TError,{sequenceId: string;chatId: string;data: ClassificationOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof overrideInboxChatClassification>>, TError,{sequenceId: string;chatId: string;data: ClassificationOverrideRequest}, TContext> => {

const mutationKey = ['overrideInboxChatClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof overrideInboxChatClassification>>, {sequenceId: string;chatId: string;data: ClassificationOverrideRequest}> = (props) => {
          const {sequenceId,chatId,data} = props ?? {};

          return  overrideInboxChatClassification(sequenceId,chatId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OverrideInboxChatClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof overrideInboxChatClassification>>>
    export type OverrideInboxChatClassificationMutationBody = ClassificationOverrideRequest
    export type OverrideInboxChatClassificationMutationError = HTTPValidationError

    /**
 * @summary Override Inbox Chat Classification
 */
export const useOverrideInboxChatClassification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideInboxChatClassification>>, TError,{sequenceId: string;chatId: string;data: ClassificationOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof overrideInboxChatClassification>>,
        TError,
        {sequenceId: string;chatId: string;data: ClassificationOverrideRequest},
        TContext
      > => {
      return useMutation(getOverrideInboxChatClassificationMutationOptions(options), queryClient);
    }

export const getCancelScheduledInboxChatSendUrl = (sequenceId: string,
    messageId: string,) => {




  return `/api/sequences/${sequenceId}/inbox/chats/messages/${messageId}/cancel-schedule`
}

/**
 * @summary Cancel Scheduled Inbox Chat Send
 */
export const cancelScheduledInboxChatSend = async (sequenceId: string,
    messageId: string, options?: Parameters<typeof customInstance>[1]): Promise<CancelScheduledInboxChatSend200> => {

  return customInstance<CancelScheduledInboxChatSend200>(getCancelScheduledInboxChatSendUrl(sequenceId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelScheduledInboxChatSendMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>, TError,{sequenceId: string;messageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>, TError,{sequenceId: string;messageId: string}, TContext> => {

const mutationKey = ['cancelScheduledInboxChatSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>, {sequenceId: string;messageId: string}> = (props) => {
          const {sequenceId,messageId} = props ?? {};

          return  cancelScheduledInboxChatSend(sequenceId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelScheduledInboxChatSendMutationResult = NonNullable<Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>>

    export type CancelScheduledInboxChatSendMutationError = HTTPValidationError

    /**
 * @summary Cancel Scheduled Inbox Chat Send
 */
export const useCancelScheduledInboxChatSend = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>, TError,{sequenceId: string;messageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelScheduledInboxChatSend>>,
        TError,
        {sequenceId: string;messageId: string},
        TContext
      > => {
      return useMutation(getCancelScheduledInboxChatSendMutationOptions(options), queryClient);
    }

export const getCreateJobUrl = () => {




  return `/api/jobs`
}

/**
 * @summary Create Job
 */
export const createJob = async (jobCreate: JobCreate, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getCreateJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobCreate)
  }
);}





export const getCreateJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobCreate}, TContext> => {

const mutationKey = ['createJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJob>>, {data: JobCreate}> = (props) => {
          const {data} = props ?? {};

          return  createJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof createJob>>>
    export type CreateJobMutationBody = JobCreate
    export type CreateJobMutationError = HTTPValidationError

    /**
 * @summary Create Job
 */
export const useCreateJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createJob>>,
        TError,
        {data: JobCreate},
        TContext
      > => {
      return useMutation(getCreateJobMutationOptions(options), queryClient);
    }

export const getListJobsUrl = (params?: ListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs?${stringifiedParams}` : `/api/jobs`
}

/**
 * @summary List Jobs
 */
export const listJobs = async (params?: ListJobsParams, options?: Parameters<typeof customInstance>[1]): Promise<JobListResponse> => {

  return customInstance<JobListResponse>(getListJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobsQueryKey = (params?: ListJobsParams,) => {
    return [
    `/api/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobsQueryOptions = <TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({ signal }) => listJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobs>>>
export type ListJobsQueryError = HTTPValidationError


export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params: undefined |  ListJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobs>>,
          TError,
          Awaited<ReturnType<typeof listJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobs>>,
          TError,
          Awaited<ReturnType<typeof listJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Jobs
 */

export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListJobsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(params?: ListJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({ signal }) => listJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listJobs>>>
export type ListJobsSuspenseQueryError = HTTPValidationError


export function useListJobsSuspense<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params: undefined |  ListJobsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobsSuspense<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobsSuspense<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Jobs
 */

export function useListJobsSuspense<TData = Awaited<ReturnType<typeof listJobs>>, TError = HTTPValidationError>(
 params?: ListJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCloneJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/clone`
}

/**
 * Clone ``{job_id}`` into a new draft job.
 *
 * The destination project comes from ``body.project_id`` (any project the
 * actor can edit — it does not need to be their currently selected project).
 * The new job takes its title / description / manager / employer / status
 * from the request body (the clone wizard prefills these from the source
 * but the user may edit them) and copies the source's stages only.
 * @summary Clone Job
 */
export const cloneJob = async (jobId: string,
    jobCreate: JobCreate, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getCloneJobUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobCreate)
  }
);}





export const getCloneJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneJob>>, TError,{jobId: string;data: JobCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneJob>>, TError,{jobId: string;data: JobCreate}, TContext> => {

const mutationKey = ['cloneJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneJob>>, {jobId: string;data: JobCreate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  cloneJob(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneJobMutationResult = NonNullable<Awaited<ReturnType<typeof cloneJob>>>
    export type CloneJobMutationBody = JobCreate
    export type CloneJobMutationError = HTTPValidationError

    /**
 * @summary Clone Job
 */
export const useCloneJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneJob>>, TError,{jobId: string;data: JobCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneJob>>,
        TError,
        {jobId: string;data: JobCreate},
        TContext
      > => {
      return useMutation(getCloneJobMutationOptions(options), queryClient);
    }

export const getGetJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}`
}

/**
 * @summary Get Job
 */
export const getJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getGetJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}`
    ] as const;
    }


export const getGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobQueryError = HTTPValidationError


export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJob>>,
          TError,
          Awaited<ReturnType<typeof getJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJob>>,
          TError,
          Awaited<ReturnType<typeof getJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job
 */

export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobSuspenseQueryError = HTTPValidationError


export function useGetJobSuspense<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSuspense<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSuspense<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job
 */

export function useGetJobSuspense<TData = Awaited<ReturnType<typeof getJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}`
}

/**
 * @summary Update Job
 */
export const updateJob = async (jobId: string,
    jobUpdate: JobUpdate, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getUpdateJobUrl(jobId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobUpdate)
  }
);}





export const getUpdateJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{jobId: string;data: JobUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{jobId: string;data: JobUpdate}, TContext> => {

const mutationKey = ['updateJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJob>>, {jobId: string;data: JobUpdate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  updateJob(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateJob>>>
    export type UpdateJobMutationBody = JobUpdate
    export type UpdateJobMutationError = HTTPValidationError

    /**
 * @summary Update Job
 */
export const useUpdateJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{jobId: string;data: JobUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateJob>>,
        TError,
        {jobId: string;data: JobUpdate},
        TContext
      > => {
      return useMutation(getUpdateJobMutationOptions(options), queryClient);
    }

export const getCloseJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/close`
}

/**
 * @summary Close Job
 */
export const closeJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getCloseJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCloseJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['closeJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeJob>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  closeJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseJobMutationResult = NonNullable<Awaited<ReturnType<typeof closeJob>>>

    export type CloseJobMutationError = HTTPValidationError

    /**
 * @summary Close Job
 */
export const useCloseJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeJob>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getCloseJobMutationOptions(options), queryClient);
    }

export const getReopenJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/reopen`
}

/**
 * @summary Reopen Job
 */
export const reopenJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getReopenJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReopenJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenJob>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['reopenJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenJob>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  reopenJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenJobMutationResult = NonNullable<Awaited<ReturnType<typeof reopenJob>>>

    export type ReopenJobMutationError = HTTPValidationError

    /**
 * @summary Reopen Job
 */
export const useReopenJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenJob>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getReopenJobMutationOptions(options), queryClient);
    }

export const getArchiveJobUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/archive`
}

/**
 * @summary Archive Job
 */
export const archiveJob = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobResponse> => {

  return customInstance<JobResponse>(getArchiveJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveJob>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['archiveJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveJob>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  archiveJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveJobMutationResult = NonNullable<Awaited<ReturnType<typeof archiveJob>>>

    export type ArchiveJobMutationError = HTTPValidationError

    /**
 * @summary Archive Job
 */
export const useArchiveJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveJob>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveJob>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getArchiveJobMutationOptions(options), queryClient);
    }

export const getListErasureRequestsUrl = () => {




  return `/api/conversations/erasure`
}

/**
 * @summary List Erasure Requests
 */
export const listErasureRequests = async ( options?: Parameters<typeof customInstance>[1]): Promise<ErasureRequestListOut> => {

  return customInstance<ErasureRequestListOut>(getListErasureRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListErasureRequestsQueryKey = () => {
    return [
    `/api/conversations/erasure`
    ] as const;
    }


export const getListErasureRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListErasureRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listErasureRequests>>> = ({ signal }) => listErasureRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListErasureRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listErasureRequests>>>
export type ListErasureRequestsQueryError = unknown


export function useListErasureRequests<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listErasureRequests>>,
          TError,
          Awaited<ReturnType<typeof listErasureRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErasureRequests<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listErasureRequests>>,
          TError,
          Awaited<ReturnType<typeof listErasureRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErasureRequests<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Erasure Requests
 */

export function useListErasureRequests<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListErasureRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListErasureRequestsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListErasureRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listErasureRequests>>> = ({ signal }) => listErasureRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListErasureRequestsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listErasureRequests>>>
export type ListErasureRequestsSuspenseQueryError = unknown


export function useListErasureRequestsSuspense<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErasureRequestsSuspense<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErasureRequestsSuspense<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Erasure Requests
 */

export function useListErasureRequestsSuspense<TData = Awaited<ReturnType<typeof listErasureRequests>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listErasureRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListErasureRequestsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestErasureUrl = () => {




  return `/api/conversations/erasure`
}

/**
 * @summary Request Erasure
 */
export const requestErasure = async (erasureIn: ErasureIn, options?: Parameters<typeof customInstance>[1]): Promise<ErasureRequestOut> => {

  return customInstance<ErasureRequestOut>(getRequestErasureUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(erasureIn)
  }
);}





export const getRequestErasureMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestErasure>>, TError,{data: ErasureIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestErasure>>, TError,{data: ErasureIn}, TContext> => {

const mutationKey = ['requestErasure'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestErasure>>, {data: ErasureIn}> = (props) => {
          const {data} = props ?? {};

          return  requestErasure(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestErasureMutationResult = NonNullable<Awaited<ReturnType<typeof requestErasure>>>
    export type RequestErasureMutationBody = ErasureIn
    export type RequestErasureMutationError = HTTPValidationError

    /**
 * @summary Request Erasure
 */
export const useRequestErasure = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestErasure>>, TError,{data: ErasureIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestErasure>>,
        TError,
        {data: ErasureIn},
        TContext
      > => {
      return useMutation(getRequestErasureMutationOptions(options), queryClient);
    }

export const getGetErasureRequestUrl = (erasureRequestId: string,) => {




  return `/api/conversations/erasure/${erasureRequestId}`
}

/**
 * @summary Get Erasure Request
 */
export const getErasureRequest = async (erasureRequestId: string, options?: Parameters<typeof customInstance>[1]): Promise<ErasureRequestOut> => {

  return customInstance<ErasureRequestOut>(getGetErasureRequestUrl(erasureRequestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetErasureRequestQueryKey = (erasureRequestId: string,) => {
    return [
    `/api/conversations/erasure/${erasureRequestId}`
    ] as const;
    }


export const getGetErasureRequestQueryOptions = <TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(erasureRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetErasureRequestQueryKey(erasureRequestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getErasureRequest>>> = ({ signal }) => getErasureRequest(erasureRequestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: erasureRequestId !== null && erasureRequestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetErasureRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getErasureRequest>>>
export type GetErasureRequestQueryError = HTTPValidationError


export function useGetErasureRequest<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErasureRequest>>,
          TError,
          Awaited<ReturnType<typeof getErasureRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErasureRequest<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErasureRequest>>,
          TError,
          Awaited<ReturnType<typeof getErasureRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErasureRequest<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Erasure Request
 */

export function useGetErasureRequest<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetErasureRequestQueryOptions(erasureRequestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetErasureRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(erasureRequestId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetErasureRequestQueryKey(erasureRequestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getErasureRequest>>> = ({ signal }) => getErasureRequest(erasureRequestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetErasureRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getErasureRequest>>>
export type GetErasureRequestSuspenseQueryError = HTTPValidationError


export function useGetErasureRequestSuspense<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErasureRequestSuspense<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErasureRequestSuspense<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Erasure Request
 */

export function useGetErasureRequestSuspense<TData = Awaited<ReturnType<typeof getErasureRequest>>, TError = HTTPValidationError>(
 erasureRequestId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getErasureRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetErasureRequestSuspenseQueryOptions(erasureRequestId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestDsarExportUrl = () => {




  return `/api/conversations/dsar`
}

/**
 * @summary Request Dsar Export
 */
export const requestDsarExport = async (erasureIn: ErasureIn, options?: Parameters<typeof customInstance>[1]): Promise<DsarExportOut> => {

  return customInstance<DsarExportOut>(getRequestDsarExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(erasureIn)
  }
);}





export const getRequestDsarExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestDsarExport>>, TError,{data: ErasureIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestDsarExport>>, TError,{data: ErasureIn}, TContext> => {

const mutationKey = ['requestDsarExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestDsarExport>>, {data: ErasureIn}> = (props) => {
          const {data} = props ?? {};

          return  requestDsarExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestDsarExportMutationResult = NonNullable<Awaited<ReturnType<typeof requestDsarExport>>>
    export type RequestDsarExportMutationBody = ErasureIn
    export type RequestDsarExportMutationError = HTTPValidationError

    /**
 * @summary Request Dsar Export
 */
export const useRequestDsarExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestDsarExport>>, TError,{data: ErasureIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestDsarExport>>,
        TError,
        {data: ErasureIn},
        TContext
      > => {
      return useMutation(getRequestDsarExportMutationOptions(options), queryClient);
    }

export const getSetLegalHoldUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/legal-hold`
}

/**
 * @summary Set Legal Hold
 */
export const setLegalHold = async (conversationId: string,
    legalHoldIn: LegalHoldIn, options?: Parameters<typeof customInstance>[1]): Promise<LegalHoldOut> => {

  return customInstance<LegalHoldOut>(getSetLegalHoldUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(legalHoldIn)
  }
);}





export const getSetLegalHoldMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLegalHold>>, TError,{conversationId: string;data: LegalHoldIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setLegalHold>>, TError,{conversationId: string;data: LegalHoldIn}, TContext> => {

const mutationKey = ['setLegalHold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLegalHold>>, {conversationId: string;data: LegalHoldIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  setLegalHold(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLegalHoldMutationResult = NonNullable<Awaited<ReturnType<typeof setLegalHold>>>
    export type SetLegalHoldMutationBody = LegalHoldIn
    export type SetLegalHoldMutationError = HTTPValidationError

    /**
 * @summary Set Legal Hold
 */
export const useSetLegalHold = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLegalHold>>, TError,{conversationId: string;data: LegalHoldIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLegalHold>>,
        TError,
        {conversationId: string;data: LegalHoldIn},
        TContext
      > => {
      return useMutation(getSetLegalHoldMutationOptions(options), queryClient);
    }

export const getQueryConversationsUrl = () => {




  return `/api/conversations/query`
}

/**
 * @summary Query Conversations
 */
export const queryConversations = async (queryIn: QueryIn, options?: Parameters<typeof customInstance>[1]): Promise<QueryOut> => {

  return customInstance<QueryOut>(getQueryConversationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryIn)
  }
);}





export const getQueryConversationsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryConversations>>, TError,{data: QueryIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof queryConversations>>, TError,{data: QueryIn}, TContext> => {

const mutationKey = ['queryConversations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryConversations>>, {data: QueryIn}> = (props) => {
          const {data} = props ?? {};

          return  queryConversations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryConversationsMutationResult = NonNullable<Awaited<ReturnType<typeof queryConversations>>>
    export type QueryConversationsMutationBody = QueryIn
    export type QueryConversationsMutationError = HTTPValidationError

    /**
 * @summary Query Conversations
 */
export const useQueryConversations = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryConversations>>, TError,{data: QueryIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryConversations>>,
        TError,
        {data: QueryIn},
        TContext
      > => {
      return useMutation(getQueryConversationsMutationOptions(options), queryClient);
    }

export const getAttentionCountsUrl = (params?: AttentionCountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/attention-counts?${stringifiedParams}` : `/api/conversations/attention-counts`
}

/**
 * @summary Attention Counts
 */
export const attentionCounts = async (params?: AttentionCountsParams, options?: Parameters<typeof customInstance>[1]): Promise<AttentionCountsOut> => {

  return customInstance<AttentionCountsOut>(getAttentionCountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAttentionCountsQueryKey = (params?: AttentionCountsParams,) => {
    return [
    `/api/conversations/attention-counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAttentionCountsQueryOptions = <TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(params?: AttentionCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttentionCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof attentionCounts>>> = ({ signal }) => attentionCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AttentionCountsQueryResult = NonNullable<Awaited<ReturnType<typeof attentionCounts>>>
export type AttentionCountsQueryError = HTTPValidationError


export function useAttentionCounts<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params: undefined |  AttentionCountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof attentionCounts>>,
          TError,
          Awaited<ReturnType<typeof attentionCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttentionCounts<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof attentionCounts>>,
          TError,
          Awaited<ReturnType<typeof attentionCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttentionCounts<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attention Counts
 */

export function useAttentionCounts<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAttentionCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAttentionCountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(params?: AttentionCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttentionCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof attentionCounts>>> = ({ signal }) => attentionCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AttentionCountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof attentionCounts>>>
export type AttentionCountsSuspenseQueryError = HTTPValidationError


export function useAttentionCountsSuspense<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params: undefined |  AttentionCountsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttentionCountsSuspense<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttentionCountsSuspense<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attention Counts
 */

export function useAttentionCountsSuspense<TData = Awaited<ReturnType<typeof attentionCounts>>, TError = HTTPValidationError>(
 params?: AttentionCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof attentionCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAttentionCountsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReportColumnsUrl = () => {




  return `/api/conversations/reports/columns`
}

/**
 * @summary Report Columns
 */
export const reportColumns = async ( options?: Parameters<typeof customInstance>[1]): Promise<ColumnsOut> => {

  return customInstance<ColumnsOut>(getReportColumnsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReportColumnsQueryKey = () => {
    return [
    `/api/conversations/reports/columns`
    ] as const;
    }


export const getReportColumnsQueryOptions = <TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportColumns>>> = ({ signal }) => reportColumns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof reportColumns>>>
export type ReportColumnsQueryError = unknown


export function useReportColumns<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportColumns>>,
          TError,
          Awaited<ReturnType<typeof reportColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportColumns<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportColumns>>,
          TError,
          Awaited<ReturnType<typeof reportColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportColumns<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report Columns
 */

export function useReportColumns<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportColumnsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReportColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportColumns>>> = ({ signal }) => reportColumns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof reportColumns>>>
export type ReportColumnsSuspenseQueryError = unknown


export function useReportColumnsSuspense<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportColumnsSuspense<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportColumnsSuspense<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report Columns
 */

export function useReportColumnsSuspense<TData = Awaited<ReturnType<typeof reportColumns>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportColumns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetConversationOrgSettingsUrl = () => {




  return `/api/conversations/settings/org`
}

/**
 * @summary Get Conversation Org Settings
 */
export const getConversationOrgSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgSettingsOut> => {

  return customInstance<OrgSettingsOut>(getGetConversationOrgSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationOrgSettingsQueryKey = () => {
    return [
    `/api/conversations/settings/org`
    ] as const;
    }


export const getGetConversationOrgSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationOrgSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversationOrgSettings>>> = ({ signal }) => getConversationOrgSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationOrgSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getConversationOrgSettings>>>
export type GetConversationOrgSettingsQueryError = unknown


export function useGetConversationOrgSettings<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getConversationOrgSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationOrgSettings<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getConversationOrgSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationOrgSettings<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation Org Settings
 */

export function useGetConversationOrgSettings<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationOrgSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConversationOrgSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationOrgSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversationOrgSettings>>> = ({ signal }) => getConversationOrgSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationOrgSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConversationOrgSettings>>>
export type GetConversationOrgSettingsSuspenseQueryError = unknown


export function useGetConversationOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation Org Settings
 */

export function useGetConversationOrgSettingsSuspense<TData = Awaited<ReturnType<typeof getConversationOrgSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationOrgSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationOrgSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutOrgSettingsUrl = () => {




  return `/api/conversations/settings/org`
}

/**
 * @summary Put Org Settings
 */
export const putOrgSettings = async (orgSettingsPut: OrgSettingsPut, options?: Parameters<typeof customInstance>[1]): Promise<OrgSettingsOut> => {

  return customInstance<OrgSettingsOut>(getPutOrgSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orgSettingsPut)
  }
);}





export const getPutOrgSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgSettings>>, TError,{data: OrgSettingsPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrgSettings>>, TError,{data: OrgSettingsPut}, TContext> => {

const mutationKey = ['putOrgSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrgSettings>>, {data: OrgSettingsPut}> = (props) => {
          const {data} = props ?? {};

          return  putOrgSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutOrgSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putOrgSettings>>>
    export type PutOrgSettingsMutationBody = OrgSettingsPut
    export type PutOrgSettingsMutationError = HTTPValidationError

    /**
 * @summary Put Org Settings
 */
export const usePutOrgSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgSettings>>, TError,{data: OrgSettingsPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrgSettings>>,
        TError,
        {data: OrgSettingsPut},
        TContext
      > => {
      return useMutation(getPutOrgSettingsMutationOptions(options), queryClient);
    }

export const getPreviewRetentionUrl = () => {




  return `/api/conversations/settings/org/retention-preview`
}

/**
 * @summary Preview Retention
 */
export const previewRetention = async (retentionPreviewIn: RetentionPreviewIn, options?: Parameters<typeof customInstance>[1]): Promise<RetentionPreviewOut> => {

  return customInstance<RetentionPreviewOut>(getPreviewRetentionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retentionPreviewIn)
  }
);}





export const getPreviewRetentionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewRetention>>, TError,{data: RetentionPreviewIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewRetention>>, TError,{data: RetentionPreviewIn}, TContext> => {

const mutationKey = ['previewRetention'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewRetention>>, {data: RetentionPreviewIn}> = (props) => {
          const {data} = props ?? {};

          return  previewRetention(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewRetentionMutationResult = NonNullable<Awaited<ReturnType<typeof previewRetention>>>
    export type PreviewRetentionMutationBody = RetentionPreviewIn
    export type PreviewRetentionMutationError = HTTPValidationError

    /**
 * @summary Preview Retention
 */
export const usePreviewRetention = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewRetention>>, TError,{data: RetentionPreviewIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewRetention>>,
        TError,
        {data: RetentionPreviewIn},
        TContext
      > => {
      return useMutation(getPreviewRetentionMutationOptions(options), queryClient);
    }

export const getGetPropertiesSchemaUrl = () => {




  return `/api/conversations/settings/org/properties`
}

/**
 * @summary Get Properties Schema
 */
export const getPropertiesSchema = async ( options?: Parameters<typeof customInstance>[1]): Promise<PropertyOut[]> => {

  return customInstance<PropertyOut[]>(getGetPropertiesSchemaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertiesSchemaQueryKey = () => {
    return [
    `/api/conversations/settings/org/properties`
    ] as const;
    }


export const getGetPropertiesSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesSchema>>> = ({ signal }) => getPropertiesSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertiesSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesSchema>>>
export type GetPropertiesSchemaQueryError = unknown


export function useGetPropertiesSchema<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertiesSchema>>,
          TError,
          Awaited<ReturnType<typeof getPropertiesSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSchema<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertiesSchema>>,
          TError,
          Awaited<ReturnType<typeof getPropertiesSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSchema<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Properties Schema
 */

export function useGetPropertiesSchema<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertiesSchemaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPropertiesSchemaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertiesSchema>>> = ({ signal }) => getPropertiesSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertiesSchemaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertiesSchema>>>
export type GetPropertiesSchemaSuspenseQueryError = unknown


export function useGetPropertiesSchemaSuspense<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSchemaSuspense<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSchemaSuspense<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Properties Schema
 */

export function useGetPropertiesSchemaSuspense<TData = Awaited<ReturnType<typeof getPropertiesSchema>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPropertiesSchema>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertiesSchemaSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutPropertiesSchemaUrl = () => {




  return `/api/conversations/settings/org/properties`
}

/**
 * @summary Put Properties Schema
 */
export const putPropertiesSchema = async (propertiesSchemaPut: PropertiesSchemaPut, options?: Parameters<typeof customInstance>[1]): Promise<PropertyOut[]> => {

  return customInstance<PropertyOut[]>(getPutPropertiesSchemaUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertiesSchemaPut)
  }
);}





export const getPutPropertiesSchemaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPropertiesSchema>>, TError,{data: PropertiesSchemaPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPropertiesSchema>>, TError,{data: PropertiesSchemaPut}, TContext> => {

const mutationKey = ['putPropertiesSchema'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPropertiesSchema>>, {data: PropertiesSchemaPut}> = (props) => {
          const {data} = props ?? {};

          return  putPropertiesSchema(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPropertiesSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof putPropertiesSchema>>>
    export type PutPropertiesSchemaMutationBody = PropertiesSchemaPut
    export type PutPropertiesSchemaMutationError = HTTPValidationError

    /**
 * @summary Put Properties Schema
 */
export const usePutPropertiesSchema = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPropertiesSchema>>, TError,{data: PropertiesSchemaPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPropertiesSchema>>,
        TError,
        {data: PropertiesSchemaPut},
        TContext
      > => {
      return useMutation(getPutPropertiesSchemaMutationOptions(options), queryClient);
    }

export const getGetMySettingsUrl = () => {




  return `/api/conversations/settings/me`
}

/**
 * @summary Get My Settings
 */
export const getMySettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<UserSettingsOut> => {

  return customInstance<UserSettingsOut>(getGetMySettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySettingsQueryKey = () => {
    return [
    `/api/conversations/settings/me`
    ] as const;
    }


export const getGetMySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySettings>>> = ({ signal }) => getMySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getMySettings>>>
export type GetMySettingsQueryError = unknown


export function useGetMySettings<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySettings>>,
          TError,
          Awaited<ReturnType<typeof getMySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMySettings<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySettings>>,
          TError,
          Awaited<ReturnType<typeof getMySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMySettings<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Settings
 */

export function useGetMySettings<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMySettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMySettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySettings>>> = ({ signal }) => getMySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMySettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMySettings>>>
export type GetMySettingsSuspenseQueryError = unknown


export function useGetMySettingsSuspense<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMySettingsSuspense<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMySettingsSuspense<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Settings
 */

export function useGetMySettingsSuspense<TData = Awaited<ReturnType<typeof getMySettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMySettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutMySettingsUrl = () => {




  return `/api/conversations/settings/me`
}

/**
 * @summary Put My Settings
 */
export const putMySettings = async (userSettingsPut: UserSettingsPut, options?: Parameters<typeof customInstance>[1]): Promise<UserSettingsOut> => {

  return customInstance<UserSettingsOut>(getPutMySettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userSettingsPut)
  }
);}





export const getPutMySettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMySettings>>, TError,{data: UserSettingsPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMySettings>>, TError,{data: UserSettingsPut}, TContext> => {

const mutationKey = ['putMySettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMySettings>>, {data: UserSettingsPut}> = (props) => {
          const {data} = props ?? {};

          return  putMySettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putMySettings>>>
    export type PutMySettingsMutationBody = UserSettingsPut
    export type PutMySettingsMutationError = HTTPValidationError

    /**
 * @summary Put My Settings
 */
export const usePutMySettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMySettings>>, TError,{data: UserSettingsPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMySettings>>,
        TError,
        {data: UserSettingsPut},
        TContext
      > => {
      return useMutation(getPutMySettingsMutationOptions(options), queryClient);
    }

export const getGetCaptureAvailabilityUrl = () => {




  return `/api/conversations/settings/capture-availability`
}

/**
 * What the caller may start from the Meetings list, by the same rules the write routes enforce: upload and
 * import follow the org's `upload` channel (`upload_service.gate`), a pasted-link bot follows the caller's
 * `capture_enabled` (`AdhocService.create`). Members can't read the org settings, so this is their view of them.
 * @summary Get Capture Availability
 */
export const getCaptureAvailability = async ( options?: Parameters<typeof customInstance>[1]): Promise<CaptureAvailabilityOut> => {

  return customInstance<CaptureAvailabilityOut>(getGetCaptureAvailabilityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCaptureAvailabilityQueryKey = () => {
    return [
    `/api/conversations/settings/capture-availability`
    ] as const;
    }


export const getGetCaptureAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCaptureAvailabilityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaptureAvailability>>> = ({ signal }) => getCaptureAvailability({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCaptureAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getCaptureAvailability>>>
export type GetCaptureAvailabilityQueryError = unknown


export function useGetCaptureAvailability<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaptureAvailability>>,
          TError,
          Awaited<ReturnType<typeof getCaptureAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaptureAvailability<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaptureAvailability>>,
          TError,
          Awaited<ReturnType<typeof getCaptureAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaptureAvailability<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Capture Availability
 */

export function useGetCaptureAvailability<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCaptureAvailabilityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCaptureAvailabilitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCaptureAvailabilityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaptureAvailability>>> = ({ signal }) => getCaptureAvailability({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCaptureAvailabilitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCaptureAvailability>>>
export type GetCaptureAvailabilitySuspenseQueryError = unknown


export function useGetCaptureAvailabilitySuspense<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaptureAvailabilitySuspense<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaptureAvailabilitySuspense<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Capture Availability
 */

export function useGetCaptureAvailabilitySuspense<TData = Awaited<ReturnType<typeof getCaptureAvailability>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaptureAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCaptureAvailabilitySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrgContextUrl = () => {




  return `/api/conversations/settings/org/context`
}

/**
 * @summary Get Org Context
 */
export const getOrgContext = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgContextOut> => {

  return customInstance<OrgContextOut>(getGetOrgContextUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgContextQueryKey = () => {
    return [
    `/api/conversations/settings/org/context`
    ] as const;
    }


export const getGetOrgContextQueryOptions = <TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgContextQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgContext>>> = ({ signal }) => getOrgContext({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgContextQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgContext>>>
export type GetOrgContextQueryError = unknown


export function useGetOrgContext<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgContext>>,
          TError,
          Awaited<ReturnType<typeof getOrgContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgContext<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgContext>>,
          TError,
          Awaited<ReturnType<typeof getOrgContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgContext<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Context
 */

export function useGetOrgContext<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgContextQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgContextSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgContextQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgContext>>> = ({ signal }) => getOrgContext({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgContextSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgContext>>>
export type GetOrgContextSuspenseQueryError = unknown


export function useGetOrgContextSuspense<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgContextSuspense<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgContextSuspense<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Context
 */

export function useGetOrgContextSuspense<TData = Awaited<ReturnType<typeof getOrgContext>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgContextSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutOrgContextUrl = () => {




  return `/api/conversations/settings/org/context`
}

/**
 * @summary Put Org Context
 */
export const putOrgContext = async (orgContextPut: OrgContextPut, options?: Parameters<typeof customInstance>[1]): Promise<OrgContextOut> => {

  return customInstance<OrgContextOut>(getPutOrgContextUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orgContextPut)
  }
);}





export const getPutOrgContextMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgContext>>, TError,{data: OrgContextPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrgContext>>, TError,{data: OrgContextPut}, TContext> => {

const mutationKey = ['putOrgContext'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrgContext>>, {data: OrgContextPut}> = (props) => {
          const {data} = props ?? {};

          return  putOrgContext(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutOrgContextMutationResult = NonNullable<Awaited<ReturnType<typeof putOrgContext>>>
    export type PutOrgContextMutationBody = OrgContextPut
    export type PutOrgContextMutationError = HTTPValidationError

    /**
 * @summary Put Org Context
 */
export const usePutOrgContext = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgContext>>, TError,{data: OrgContextPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrgContext>>,
        TError,
        {data: OrgContextPut},
        TContext
      > => {
      return useMutation(getPutOrgContextMutationOptions(options), queryClient);
    }

export const getListOrgContextVersionsUrl = (params?: ListOrgContextVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/settings/org/context/versions?${stringifiedParams}` : `/api/conversations/settings/org/context/versions`
}

/**
 * @summary List Org Context Versions
 */
export const listOrgContextVersions = async (params?: ListOrgContextVersionsParams, options?: Parameters<typeof customInstance>[1]): Promise<OrgContextVersionOut[]> => {

  return customInstance<OrgContextVersionOut[]>(getListOrgContextVersionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrgContextVersionsQueryKey = (params?: ListOrgContextVersionsParams,) => {
    return [
    `/api/conversations/settings/org/context/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgContextVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgContextVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgContextVersions>>> = ({ signal }) => listOrgContextVersions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgContextVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgContextVersions>>>
export type ListOrgContextVersionsQueryError = HTTPValidationError


export function useListOrgContextVersions<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params: undefined |  ListOrgContextVersionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgContextVersions>>,
          TError,
          Awaited<ReturnType<typeof listOrgContextVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgContextVersions<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgContextVersions>>,
          TError,
          Awaited<ReturnType<typeof listOrgContextVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgContextVersions<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Context Versions
 */

export function useListOrgContextVersions<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgContextVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOrgContextVersionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgContextVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgContextVersions>>> = ({ signal }) => listOrgContextVersions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgContextVersionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgContextVersions>>>
export type ListOrgContextVersionsSuspenseQueryError = HTTPValidationError


export function useListOrgContextVersionsSuspense<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params: undefined |  ListOrgContextVersionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgContextVersionsSuspense<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgContextVersionsSuspense<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Context Versions
 */

export function useListOrgContextVersionsSuspense<TData = Awaited<ReturnType<typeof listOrgContextVersions>>, TError = HTTPValidationError>(
 params?: ListOrgContextVersionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrgContextVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgContextVersionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevertOrgContextUrl = () => {




  return `/api/conversations/settings/org/context/revert`
}

/**
 * @summary Revert Org Context
 */
export const revertOrgContext = async (orgContextRevert: OrgContextRevert, options?: Parameters<typeof customInstance>[1]): Promise<OrgContextOut> => {

  return customInstance<OrgContextOut>(getRevertOrgContextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orgContextRevert)
  }
);}





export const getRevertOrgContextMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertOrgContext>>, TError,{data: OrgContextRevert}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revertOrgContext>>, TError,{data: OrgContextRevert}, TContext> => {

const mutationKey = ['revertOrgContext'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revertOrgContext>>, {data: OrgContextRevert}> = (props) => {
          const {data} = props ?? {};

          return  revertOrgContext(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevertOrgContextMutationResult = NonNullable<Awaited<ReturnType<typeof revertOrgContext>>>
    export type RevertOrgContextMutationBody = OrgContextRevert
    export type RevertOrgContextMutationError = HTTPValidationError

    /**
 * @summary Revert Org Context
 */
export const useRevertOrgContext = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertOrgContext>>, TError,{data: OrgContextRevert}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revertOrgContext>>,
        TError,
        {data: OrgContextRevert},
        TContext
      > => {
      return useMutation(getRevertOrgContextMutationOptions(options), queryClient);
    }

export const getListVerifiedDomainsUrl = () => {




  return `/api/conversations/settings/org/verified-domains`
}

/**
 * @summary List Verified Domains
 */
export const listVerifiedDomains = async ( options?: Parameters<typeof customInstance>[1]): Promise<VerifiedDomainListOut> => {

  return customInstance<VerifiedDomainListOut>(getListVerifiedDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVerifiedDomainsQueryKey = () => {
    return [
    `/api/conversations/settings/org/verified-domains`
    ] as const;
    }


export const getListVerifiedDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVerifiedDomainsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVerifiedDomains>>> = ({ signal }) => listVerifiedDomains({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVerifiedDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listVerifiedDomains>>>
export type ListVerifiedDomainsQueryError = unknown


export function useListVerifiedDomains<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVerifiedDomains>>,
          TError,
          Awaited<ReturnType<typeof listVerifiedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVerifiedDomains<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVerifiedDomains>>,
          TError,
          Awaited<ReturnType<typeof listVerifiedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVerifiedDomains<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Verified Domains
 */

export function useListVerifiedDomains<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVerifiedDomainsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListVerifiedDomainsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVerifiedDomainsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVerifiedDomains>>> = ({ signal }) => listVerifiedDomains({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVerifiedDomainsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listVerifiedDomains>>>
export type ListVerifiedDomainsSuspenseQueryError = unknown


export function useListVerifiedDomainsSuspense<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVerifiedDomainsSuspense<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVerifiedDomainsSuspense<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Verified Domains
 */

export function useListVerifiedDomainsSuspense<TData = Awaited<ReturnType<typeof listVerifiedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVerifiedDomainsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddVerifiedDomainUrl = () => {




  return `/api/conversations/settings/org/verified-domains`
}

/**
 * @summary Add Verified Domain
 */
export const addVerifiedDomain = async (verifiedDomainIn: VerifiedDomainIn, options?: Parameters<typeof customInstance>[1]): Promise<VerifiedDomainOut> => {

  return customInstance<VerifiedDomainOut>(getAddVerifiedDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifiedDomainIn)
  }
);}





export const getAddVerifiedDomainMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVerifiedDomain>>, TError,{data: VerifiedDomainIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addVerifiedDomain>>, TError,{data: VerifiedDomainIn}, TContext> => {

const mutationKey = ['addVerifiedDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addVerifiedDomain>>, {data: VerifiedDomainIn}> = (props) => {
          const {data} = props ?? {};

          return  addVerifiedDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddVerifiedDomainMutationResult = NonNullable<Awaited<ReturnType<typeof addVerifiedDomain>>>
    export type AddVerifiedDomainMutationBody = VerifiedDomainIn
    export type AddVerifiedDomainMutationError = HTTPValidationError

    /**
 * @summary Add Verified Domain
 */
export const useAddVerifiedDomain = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addVerifiedDomain>>, TError,{data: VerifiedDomainIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addVerifiedDomain>>,
        TError,
        {data: VerifiedDomainIn},
        TContext
      > => {
      return useMutation(getAddVerifiedDomainMutationOptions(options), queryClient);
    }

export const getRemoveVerifiedDomainUrl = (verifiedDomainId: string,) => {




  return `/api/conversations/settings/org/verified-domains/${verifiedDomainId}`
}

/**
 * @summary Remove Verified Domain
 */
export const removeVerifiedDomain = async (verifiedDomainId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveVerifiedDomainUrl(verifiedDomainId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveVerifiedDomainMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVerifiedDomain>>, TError,{verifiedDomainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeVerifiedDomain>>, TError,{verifiedDomainId: string}, TContext> => {

const mutationKey = ['removeVerifiedDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeVerifiedDomain>>, {verifiedDomainId: string}> = (props) => {
          const {verifiedDomainId} = props ?? {};

          return  removeVerifiedDomain(verifiedDomainId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveVerifiedDomainMutationResult = NonNullable<Awaited<ReturnType<typeof removeVerifiedDomain>>>

    export type RemoveVerifiedDomainMutationError = HTTPValidationError

    /**
 * @summary Remove Verified Domain
 */
export const useRemoveVerifiedDomain = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVerifiedDomain>>, TError,{verifiedDomainId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeVerifiedDomain>>,
        TError,
        {verifiedDomainId: string},
        TContext
      > => {
      return useMutation(getRemoveVerifiedDomainMutationOptions(options), queryClient);
    }

export const getGetOrgBrandingUrl = () => {




  return `/api/conversations/settings/org/branding`
}

/**
 * @summary Get Org Branding
 */
export const getOrgBranding = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {

  return customInstance<OrgBrandingOut>(getGetOrgBrandingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgBrandingQueryKey = () => {
    return [
    `/api/conversations/settings/org/branding`
    ] as const;
    }


export const getGetOrgBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgBrandingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgBranding>>> = ({ signal }) => getOrgBranding({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgBranding>>>
export type GetOrgBrandingQueryError = unknown


export function useGetOrgBranding<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgBranding>>,
          TError,
          Awaited<ReturnType<typeof getOrgBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgBranding<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgBranding>>,
          TError,
          Awaited<ReturnType<typeof getOrgBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgBranding<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Branding
 */

export function useGetOrgBranding<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgBrandingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgBrandingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgBrandingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgBranding>>> = ({ signal }) => getOrgBranding({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgBrandingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgBranding>>>
export type GetOrgBrandingSuspenseQueryError = unknown


export function useGetOrgBrandingSuspense<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgBrandingSuspense<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgBrandingSuspense<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Branding
 */

export function useGetOrgBrandingSuspense<TData = Awaited<ReturnType<typeof getOrgBranding>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgBranding>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgBrandingSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrgBrandingUrl = () => {




  return `/api/conversations/settings/org/branding`
}

/**
 * @summary Update Org Branding
 */
export const updateOrgBranding = async (botNamePatch: BotNamePatch, options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {

  return customInstance<OrgBrandingOut>(getUpdateOrgBrandingUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botNamePatch)
  }
);}





export const getUpdateOrgBrandingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgBranding>>, TError,{data: BotNamePatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgBranding>>, TError,{data: BotNamePatch}, TContext> => {

const mutationKey = ['updateOrgBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgBranding>>, {data: BotNamePatch}> = (props) => {
          const {data} = props ?? {};

          return  updateOrgBranding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgBranding>>>
    export type UpdateOrgBrandingMutationBody = BotNamePatch
    export type UpdateOrgBrandingMutationError = HTTPValidationError

    /**
 * @summary Update Org Branding
 */
export const useUpdateOrgBranding = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgBranding>>, TError,{data: BotNamePatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgBranding>>,
        TError,
        {data: BotNamePatch},
        TContext
      > => {
      return useMutation(getUpdateOrgBrandingMutationOptions(options), queryClient);
    }

export const getUploadOrgBotTileUrl = () => {




  return `/api/conversations/settings/org/branding/tile`
}

/**
 * @summary Upload Org Bot Tile
 */
export const uploadOrgBotTile = async (bodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost, options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost.file);

  return customInstance<OrgBrandingOut>(getUploadOrgBotTileUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadOrgBotTileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotTile>>, TError,{data: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotTile>>, TError,{data: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost}, TContext> => {

const mutationKey = ['uploadOrgBotTile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgBotTile>>, {data: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost}> = (props) => {
          const {data} = props ?? {};

          return  uploadOrgBotTile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgBotTileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgBotTile>>>
    export type UploadOrgBotTileMutationBody = BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost
    export type UploadOrgBotTileMutationError = HTTPValidationError

    /**
 * @summary Upload Org Bot Tile
 */
export const useUploadOrgBotTile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotTile>>, TError,{data: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgBotTile>>,
        TError,
        {data: BodyUploadOrgBotTileApiConversationsSettingsOrgBrandingTilePost},
        TContext
      > => {
      return useMutation(getUploadOrgBotTileMutationOptions(options), queryClient);
    }

export const getDeleteOrgBotTileUrl = () => {




  return `/api/conversations/settings/org/branding/tile`
}

/**
 * @summary Delete Org Bot Tile
 */
export const deleteOrgBotTile = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {

  return customInstance<OrgBrandingOut>(getDeleteOrgBotTileUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrgBotTileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotTile>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotTile>>, TError,void, TContext> => {

const mutationKey = ['deleteOrgBotTile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgBotTile>>, void> = () => {


          return  deleteOrgBotTile(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgBotTileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgBotTile>>>

    export type DeleteOrgBotTileMutationError = unknown

    /**
 * @summary Delete Org Bot Tile
 */
export const useDeleteOrgBotTile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotTile>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgBotTile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteOrgBotTileMutationOptions(options), queryClient);
    }

export const getUploadOrgBotLogoUrl = () => {




  return `/api/conversations/settings/org/branding/logo`
}

/**
 * @summary Upload Org Bot Logo
 */
export const uploadOrgBotLogo = async (bodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost, options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost.file);

  return customInstance<OrgBrandingOut>(getUploadOrgBotLogoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadOrgBotLogoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotLogo>>, TError,{data: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotLogo>>, TError,{data: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost}, TContext> => {

const mutationKey = ['uploadOrgBotLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgBotLogo>>, {data: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost}> = (props) => {
          const {data} = props ?? {};

          return  uploadOrgBotLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgBotLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgBotLogo>>>
    export type UploadOrgBotLogoMutationBody = BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost
    export type UploadOrgBotLogoMutationError = HTTPValidationError

    /**
 * @summary Upload Org Bot Logo
 */
export const useUploadOrgBotLogo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgBotLogo>>, TError,{data: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgBotLogo>>,
        TError,
        {data: BodyUploadOrgBotLogoApiConversationsSettingsOrgBrandingLogoPost},
        TContext
      > => {
      return useMutation(getUploadOrgBotLogoMutationOptions(options), queryClient);
    }

export const getDeleteOrgBotLogoUrl = () => {




  return `/api/conversations/settings/org/branding/logo`
}

/**
 * @summary Delete Org Bot Logo
 */
export const deleteOrgBotLogo = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgBrandingOut> => {

  return customInstance<OrgBrandingOut>(getDeleteOrgBotLogoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrgBotLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotLogo>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotLogo>>, TError,void, TContext> => {

const mutationKey = ['deleteOrgBotLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgBotLogo>>, void> = () => {


          return  deleteOrgBotLogo(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgBotLogoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgBotLogo>>>

    export type DeleteOrgBotLogoMutationError = unknown

    /**
 * @summary Delete Org Bot Logo
 */
export const useDeleteOrgBotLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgBotLogo>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgBotLogo>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteOrgBotLogoMutationOptions(options), queryClient);
    }

export const getPreviewOrgBotTileUrl = (params?: PreviewOrgBotTileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/settings/org/branding/preview?${stringifiedParams}` : `/api/conversations/settings/org/branding/preview`
}

/**
 * A Pillow render per call, hence the per-user limit. `card: PreviewCard` gives FastAPI's
 * own 422 for `?card=bogus`, with no hand-written code.
 * @summary Preview Org Bot Tile
 */
export const previewOrgBotTile = async (params?: PreviewOrgBotTileParams, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getPreviewOrgBotTileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewOrgBotTileQueryKey = (params?: PreviewOrgBotTileParams,) => {
    return [
    `/api/conversations/settings/org/branding/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewOrgBotTileQueryOptions = <TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewOrgBotTileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewOrgBotTile>>> = ({ signal }) => previewOrgBotTile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewOrgBotTileQueryResult = NonNullable<Awaited<ReturnType<typeof previewOrgBotTile>>>
export type PreviewOrgBotTileQueryError = HTTPValidationError


export function usePreviewOrgBotTile<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params: undefined |  PreviewOrgBotTileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewOrgBotTile>>,
          TError,
          Awaited<ReturnType<typeof previewOrgBotTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewOrgBotTile<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewOrgBotTile>>,
          TError,
          Awaited<ReturnType<typeof previewOrgBotTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewOrgBotTile<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Org Bot Tile
 */

export function usePreviewOrgBotTile<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewOrgBotTileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPreviewOrgBotTileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewOrgBotTileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewOrgBotTile>>> = ({ signal }) => previewOrgBotTile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewOrgBotTileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof previewOrgBotTile>>>
export type PreviewOrgBotTileSuspenseQueryError = HTTPValidationError


export function usePreviewOrgBotTileSuspense<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params: undefined |  PreviewOrgBotTileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewOrgBotTileSuspense<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewOrgBotTileSuspense<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Org Bot Tile
 */

export function usePreviewOrgBotTileSuspense<TData = Awaited<ReturnType<typeof previewOrgBotTile>>, TError = HTTPValidationError>(
 params?: PreviewOrgBotTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewOrgBotTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewOrgBotTileSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadPresignUrl = () => {




  return `/api/conversations/upload/presign`
}

/**
 * @summary Upload Presign
 */
export const uploadPresign = async (presignIn: PresignIn, options?: Parameters<typeof customInstance>[1]): Promise<PresignOut> => {

  return customInstance<PresignOut>(getUploadPresignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presignIn)
  }
);}





export const getUploadPresignMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPresign>>, TError,{data: PresignIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadPresign>>, TError,{data: PresignIn}, TContext> => {

const mutationKey = ['uploadPresign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPresign>>, {data: PresignIn}> = (props) => {
          const {data} = props ?? {};

          return  uploadPresign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadPresignMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPresign>>>
    export type UploadPresignMutationBody = PresignIn
    export type UploadPresignMutationError = HTTPValidationError

    /**
 * @summary Upload Presign
 */
export const useUploadPresign = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPresign>>, TError,{data: PresignIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadPresign>>,
        TError,
        {data: PresignIn},
        TContext
      > => {
      return useMutation(getUploadPresignMutationOptions(options), queryClient);
    }

export const getUploadCompleteUrl = () => {




  return `/api/conversations/upload/complete`
}

/**
 * @summary Upload Complete
 */
export const uploadComplete = async (completeIn: CompleteIn, options?: Parameters<typeof customInstance>[1]): Promise<CompleteOut> => {

  return customInstance<CompleteOut>(getUploadCompleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeIn)
  }
);}





export const getUploadCompleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadComplete>>, TError,{data: CompleteIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadComplete>>, TError,{data: CompleteIn}, TContext> => {

const mutationKey = ['uploadComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadComplete>>, {data: CompleteIn}> = (props) => {
          const {data} = props ?? {};

          return  uploadComplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof uploadComplete>>>
    export type UploadCompleteMutationBody = CompleteIn
    export type UploadCompleteMutationError = HTTPValidationError

    /**
 * @summary Upload Complete
 */
export const useUploadComplete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadComplete>>, TError,{data: CompleteIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadComplete>>,
        TError,
        {data: CompleteIn},
        TContext
      > => {
      return useMutation(getUploadCompleteMutationOptions(options), queryClient);
    }

export const getUploadAbortUrl = () => {




  return `/api/conversations/upload/abort`
}

/**
 * @summary Upload Abort
 */
export const uploadAbort = async (abortIn: AbortIn, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getUploadAbortUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(abortIn)
  }
);}





export const getUploadAbortMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAbort>>, TError,{data: AbortIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAbort>>, TError,{data: AbortIn}, TContext> => {

const mutationKey = ['uploadAbort'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAbort>>, {data: AbortIn}> = (props) => {
          const {data} = props ?? {};

          return  uploadAbort(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadAbortMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAbort>>>
    export type UploadAbortMutationBody = AbortIn
    export type UploadAbortMutationError = HTTPValidationError

    /**
 * @summary Upload Abort
 */
export const useUploadAbort = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAbort>>, TError,{data: AbortIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadAbort>>,
        TError,
        {data: AbortIn},
        TContext
      > => {
      return useMutation(getUploadAbortMutationOptions(options), queryClient);
    }

export const getImportTranscriptUrl = () => {




  return `/api/conversations/import`
}

/**
 * @summary Import Transcript
 */
export const importTranscript = async (importIn: ImportIn, options?: Parameters<typeof customInstance>[1]): Promise<CompleteOut> => {

  return customInstance<CompleteOut>(getImportTranscriptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importIn)
  }
);}





export const getImportTranscriptMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTranscript>>, TError,{data: ImportIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importTranscript>>, TError,{data: ImportIn}, TContext> => {

const mutationKey = ['importTranscript'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTranscript>>, {data: ImportIn}> = (props) => {
          const {data} = props ?? {};

          return  importTranscript(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTranscriptMutationResult = NonNullable<Awaited<ReturnType<typeof importTranscript>>>
    export type ImportTranscriptMutationBody = ImportIn
    export type ImportTranscriptMutationError = HTTPValidationError

    /**
 * @summary Import Transcript
 */
export const useImportTranscript = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTranscript>>, TError,{data: ImportIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTranscript>>,
        TError,
        {data: ImportIn},
        TContext
      > => {
      return useMutation(getImportTranscriptMutationOptions(options), queryClient);
    }

export const getCreateAdhocUrl = () => {




  return `/api/conversations/adhoc`
}

/**
 * @summary Create Adhoc
 */
export const createAdhoc = async (adhocIn: AdhocIn, options?: Parameters<typeof customInstance>[1]): Promise<AdhocOut> => {

  return customInstance<AdhocOut>(getCreateAdhocUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adhocIn)
  }
);}





export const getCreateAdhocMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdhoc>>, TError,{data: AdhocIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdhoc>>, TError,{data: AdhocIn}, TContext> => {

const mutationKey = ['createAdhoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdhoc>>, {data: AdhocIn}> = (props) => {
          const {data} = props ?? {};

          return  createAdhoc(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdhocMutationResult = NonNullable<Awaited<ReturnType<typeof createAdhoc>>>
    export type CreateAdhocMutationBody = AdhocIn
    export type CreateAdhocMutationError = HTTPValidationError

    /**
 * @summary Create Adhoc
 */
export const useCreateAdhoc = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdhoc>>, TError,{data: AdhocIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdhoc>>,
        TError,
        {data: AdhocIn},
        TContext
      > => {
      return useMutation(getCreateAdhocMutationOptions(options), queryClient);
    }

export const getCaptureCommandUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/capture/command`
}

/**
 * @summary Capture Command
 */
export const captureCommand = async (conversationId: string,
    captureCommandIn: CaptureCommandIn, options?: Parameters<typeof customInstance>[1]): Promise<CaptureCommandOut> => {

  return customInstance<CaptureCommandOut>(getCaptureCommandUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(captureCommandIn)
  }
);}





export const getCaptureCommandMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureCommand>>, TError,{conversationId: string;data: CaptureCommandIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof captureCommand>>, TError,{conversationId: string;data: CaptureCommandIn}, TContext> => {

const mutationKey = ['captureCommand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureCommand>>, {conversationId: string;data: CaptureCommandIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  captureCommand(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CaptureCommandMutationResult = NonNullable<Awaited<ReturnType<typeof captureCommand>>>
    export type CaptureCommandMutationBody = CaptureCommandIn
    export type CaptureCommandMutationError = HTTPValidationError

    /**
 * @summary Capture Command
 */
export const useCaptureCommand = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureCommand>>, TError,{conversationId: string;data: CaptureCommandIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof captureCommand>>,
        TError,
        {conversationId: string;data: CaptureCommandIn},
        TContext
      > => {
      return useMutation(getCaptureCommandMutationOptions(options), queryClient);
    }

export const getGetScheduleUrl = (params: GetScheduleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/schedule?${stringifiedParams}` : `/api/conversations/schedule`
}

/**
 * @summary Get Schedule
 */
export const getSchedule = async (params: GetScheduleParams, options?: Parameters<typeof customInstance>[1]): Promise<ScheduleOut> => {

  return customInstance<ScheduleOut>(getGetScheduleUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScheduleQueryKey = (params?: GetScheduleParams,) => {
    return [
    `/api/conversations/schedule`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(params: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = HTTPValidationError


export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Schedule
 */

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetScheduleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(params: GetScheduleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleSuspenseQueryError = HTTPValidationError


export function useGetScheduleSuspense<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleSuspense<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleSuspense<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Schedule
 */

export function useGetScheduleSuspense<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
 params: GetScheduleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetScheduleOverrideUrl = (calendarEventId: string,) => {




  return `/api/conversations/schedule/${calendarEventId}/override`
}

/**
 * @summary Set Schedule Override
 */
export const setScheduleOverride = async (calendarEventId: string,
    overrideIn: OverrideIn, options?: Parameters<typeof customInstance>[1]): Promise<OverrideOut> => {

  return customInstance<OverrideOut>(getSetScheduleOverrideUrl(calendarEventId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideIn)
  }
);}





export const getSetScheduleOverrideMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScheduleOverride>>, TError,{calendarEventId: string;data: OverrideIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setScheduleOverride>>, TError,{calendarEventId: string;data: OverrideIn}, TContext> => {

const mutationKey = ['setScheduleOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setScheduleOverride>>, {calendarEventId: string;data: OverrideIn}> = (props) => {
          const {calendarEventId,data} = props ?? {};

          return  setScheduleOverride(calendarEventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetScheduleOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setScheduleOverride>>>
    export type SetScheduleOverrideMutationBody = OverrideIn
    export type SetScheduleOverrideMutationError = HTTPValidationError

    /**
 * @summary Set Schedule Override
 */
export const useSetScheduleOverride = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setScheduleOverride>>, TError,{calendarEventId: string;data: OverrideIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setScheduleOverride>>,
        TError,
        {calendarEventId: string;data: OverrideIn},
        TContext
      > => {
      return useMutation(getSetScheduleOverrideMutationOptions(options), queryClient);
    }

export const getClearScheduleOverrideUrl = (calendarEventId: string,
    params: ClearScheduleOverrideParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/schedule/${calendarEventId}/override?${stringifiedParams}` : `/api/conversations/schedule/${calendarEventId}/override`
}

/**
 * Drop the EventPreference row for the occurrence (or the series) and re-run the ladder.
 *
 * `scope` is a REQUIRED query param so Orval's `ClearScheduleOverrideParams.scope` is required too.
 * Same permission rule as the POST.
 * @summary Clear Schedule Override
 */
export const clearScheduleOverride = async (calendarEventId: string,
    params: ClearScheduleOverrideParams, options?: Parameters<typeof customInstance>[1]): Promise<OverrideClearedOut> => {

  return customInstance<OverrideClearedOut>(getClearScheduleOverrideUrl(calendarEventId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearScheduleOverrideMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearScheduleOverride>>, TError,{calendarEventId: string;params: ClearScheduleOverrideParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearScheduleOverride>>, TError,{calendarEventId: string;params: ClearScheduleOverrideParams}, TContext> => {

const mutationKey = ['clearScheduleOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearScheduleOverride>>, {calendarEventId: string;params: ClearScheduleOverrideParams}> = (props) => {
          const {calendarEventId,params} = props ?? {};

          return  clearScheduleOverride(calendarEventId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearScheduleOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof clearScheduleOverride>>>

    export type ClearScheduleOverrideMutationError = HTTPValidationError

    /**
 * @summary Clear Schedule Override
 */
export const useClearScheduleOverride = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearScheduleOverride>>, TError,{calendarEventId: string;params: ClearScheduleOverrideParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearScheduleOverride>>,
        TError,
        {calendarEventId: string;params: ClearScheduleOverrideParams},
        TContext
      > => {
      return useMutation(getClearScheduleOverrideMutationOptions(options), queryClient);
    }

export const getGetConversationConsentUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/consent`
}

/**
 * @summary Get Conversation Consent
 */
export const getConversationConsent = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConsentOut> => {

  return customInstance<ConsentOut>(getGetConversationConsentUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationConsentQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/consent`
    ] as const;
    }


export const getGetConversationConsentQueryOptions = <TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationConsentQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversationConsent>>> = ({ signal }) => getConversationConsent(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationConsentQueryResult = NonNullable<Awaited<ReturnType<typeof getConversationConsent>>>
export type GetConversationConsentQueryError = HTTPValidationError


export function useGetConversationConsent<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationConsent>>,
          TError,
          Awaited<ReturnType<typeof getConversationConsent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationConsent<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationConsent>>,
          TError,
          Awaited<ReturnType<typeof getConversationConsent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationConsent<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation Consent
 */

export function useGetConversationConsent<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationConsentQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConversationConsentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationConsentQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversationConsent>>> = ({ signal }) => getConversationConsent(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationConsentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConversationConsent>>>
export type GetConversationConsentSuspenseQueryError = HTTPValidationError


export function useGetConversationConsentSuspense<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationConsentSuspense<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationConsentSuspense<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation Consent
 */

export function useGetConversationConsentSuspense<TData = Awaited<ReturnType<typeof getConversationConsent>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversationConsent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationConsentSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecordConsentOnBehalfUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/consent/on-behalf`
}

/**
 * @summary Record Consent On Behalf
 */
export const recordConsentOnBehalf = async (conversationId: string,
    onBehalfIn: OnBehalfIn, options?: Parameters<typeof customInstance>[1]): Promise<ConsentOut> => {

  return customInstance<ConsentOut>(getRecordConsentOnBehalfUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(onBehalfIn)
  }
);}





export const getRecordConsentOnBehalfMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordConsentOnBehalf>>, TError,{conversationId: string;data: OnBehalfIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordConsentOnBehalf>>, TError,{conversationId: string;data: OnBehalfIn}, TContext> => {

const mutationKey = ['recordConsentOnBehalf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordConsentOnBehalf>>, {conversationId: string;data: OnBehalfIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  recordConsentOnBehalf(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordConsentOnBehalfMutationResult = NonNullable<Awaited<ReturnType<typeof recordConsentOnBehalf>>>
    export type RecordConsentOnBehalfMutationBody = OnBehalfIn
    export type RecordConsentOnBehalfMutationError = HTTPValidationError

    /**
 * @summary Record Consent On Behalf
 */
export const useRecordConsentOnBehalf = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordConsentOnBehalf>>, TError,{conversationId: string;data: OnBehalfIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordConsentOnBehalf>>,
        TError,
        {conversationId: string;data: OnBehalfIn},
        TContext
      > => {
      return useMutation(getRecordConsentOnBehalfMutationOptions(options), queryClient);
    }

export const getWithdrawConsentUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/consent/withdraw`
}

/**
 * @summary Withdraw Consent
 */
export const withdrawConsent = async (conversationId: string,
    withdrawIn: WithdrawIn, options?: Parameters<typeof customInstance>[1]): Promise<CutQueuedOut> => {

  return customInstance<CutQueuedOut>(getWithdrawConsentUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(withdrawIn)
  }
);}





export const getWithdrawConsentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawConsent>>, TError,{conversationId: string;data: WithdrawIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof withdrawConsent>>, TError,{conversationId: string;data: WithdrawIn}, TContext> => {

const mutationKey = ['withdrawConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawConsent>>, {conversationId: string;data: WithdrawIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  withdrawConsent(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawConsentMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawConsent>>>
    export type WithdrawConsentMutationBody = WithdrawIn
    export type WithdrawConsentMutationError = HTTPValidationError

    /**
 * @summary Withdraw Consent
 */
export const useWithdrawConsent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawConsent>>, TError,{conversationId: string;data: WithdrawIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof withdrawConsent>>,
        TError,
        {conversationId: string;data: WithdrawIn},
        TContext
      > => {
      return useMutation(getWithdrawConsentMutationOptions(options), queryClient);
    }

export const getRevokeRecordingUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/revoke`
}

/**
 * @summary Revoke Recording
 */
export const revokeRecording = async (conversationId: string,
    revokeIn: RevokeIn, options?: Parameters<typeof customInstance>[1]): Promise<CutQueuedOut> => {

  return customInstance<CutQueuedOut>(getRevokeRecordingUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revokeIn)
  }
);}





export const getRevokeRecordingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeRecording>>, TError,{conversationId: string;data: RevokeIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeRecording>>, TError,{conversationId: string;data: RevokeIn}, TContext> => {

const mutationKey = ['revokeRecording'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeRecording>>, {conversationId: string;data: RevokeIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  revokeRecording(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof revokeRecording>>>
    export type RevokeRecordingMutationBody = RevokeIn
    export type RevokeRecordingMutationError = HTTPValidationError

    /**
 * @summary Revoke Recording
 */
export const useRevokeRecording = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeRecording>>, TError,{conversationId: string;data: RevokeIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeRecording>>,
        TError,
        {conversationId: string;data: RevokeIn},
        TContext
      > => {
      return useMutation(getRevokeRecordingMutationOptions(options), queryClient);
    }

export const getHandleNoticeReplyUrl = (conversationId: string,
    replyId: string,) => {




  return `/api/conversations/${conversationId}/replies/${replyId}/handle`
}

/**
 * @summary Handle Notice Reply
 */
export const handleNoticeReply = async (conversationId: string,
    replyId: string,
    handleReplyIn: HandleReplyIn, options?: Parameters<typeof customInstance>[1]): Promise<HandleReplyOut> => {

  return customInstance<HandleReplyOut>(getHandleNoticeReplyUrl(conversationId,replyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(handleReplyIn)
  }
);}





export const getHandleNoticeReplyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleNoticeReply>>, TError,{conversationId: string;replyId: string;data: HandleReplyIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof handleNoticeReply>>, TError,{conversationId: string;replyId: string;data: HandleReplyIn}, TContext> => {

const mutationKey = ['handleNoticeReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleNoticeReply>>, {conversationId: string;replyId: string;data: HandleReplyIn}> = (props) => {
          const {conversationId,replyId,data} = props ?? {};

          return  handleNoticeReply(conversationId,replyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandleNoticeReplyMutationResult = NonNullable<Awaited<ReturnType<typeof handleNoticeReply>>>
    export type HandleNoticeReplyMutationBody = HandleReplyIn
    export type HandleNoticeReplyMutationError = HTTPValidationError

    /**
 * @summary Handle Notice Reply
 */
export const useHandleNoticeReply = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleNoticeReply>>, TError,{conversationId: string;replyId: string;data: HandleReplyIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handleNoticeReply>>,
        TError,
        {conversationId: string;replyId: string;data: HandleReplyIn},
        TContext
      > => {
      return useMutation(getHandleNoticeReplyMutationOptions(options), queryClient);
    }

export const getResendNoticesUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/notices/resend`
}

/**
 * @summary Resend Notices
 */
export const resendNotices = async (conversationId: string,
    noticeResendIn: NoticeResendIn, options?: Parameters<typeof customInstance>[1]): Promise<NoticeResendOut> => {

  return customInstance<NoticeResendOut>(getResendNoticesUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noticeResendIn)
  }
);}





export const getResendNoticesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendNotices>>, TError,{conversationId: string;data: NoticeResendIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendNotices>>, TError,{conversationId: string;data: NoticeResendIn}, TContext> => {

const mutationKey = ['resendNotices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendNotices>>, {conversationId: string;data: NoticeResendIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  resendNotices(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendNoticesMutationResult = NonNullable<Awaited<ReturnType<typeof resendNotices>>>
    export type ResendNoticesMutationBody = NoticeResendIn
    export type ResendNoticesMutationError = HTTPValidationError

    /**
 * @summary Resend Notices
 */
export const useResendNotices = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendNotices>>, TError,{conversationId: string;data: NoticeResendIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendNotices>>,
        TError,
        {conversationId: string;data: NoticeResendIn},
        TContext
      > => {
      return useMutation(getResendNoticesMutationOptions(options), queryClient);
    }

export const getUpdateConversationNoteUrl = (noteId: string,) => {




  return `/api/conversation-notes/${noteId}`
}

/**
 * @summary Update Conversation Note
 */
export const updateConversationNote = async (noteId: string,
    conversationNoteUpdate: ConversationNoteUpdate, options?: Parameters<typeof customInstance>[1]): Promise<ConversationNoteOut> => {

  return customInstance<ConversationNoteOut>(getUpdateConversationNoteUrl(noteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversationNoteUpdate)
  }
);}





export const getUpdateConversationNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversationNote>>, TError,{noteId: string;data: ConversationNoteUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConversationNote>>, TError,{noteId: string;data: ConversationNoteUpdate}, TContext> => {

const mutationKey = ['updateConversationNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConversationNote>>, {noteId: string;data: ConversationNoteUpdate}> = (props) => {
          const {noteId,data} = props ?? {};

          return  updateConversationNote(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConversationNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateConversationNote>>>
    export type UpdateConversationNoteMutationBody = ConversationNoteUpdate
    export type UpdateConversationNoteMutationError = HTTPValidationError

    /**
 * @summary Update Conversation Note
 */
export const useUpdateConversationNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversationNote>>, TError,{noteId: string;data: ConversationNoteUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConversationNote>>,
        TError,
        {noteId: string;data: ConversationNoteUpdate},
        TContext
      > => {
      return useMutation(getUpdateConversationNoteMutationOptions(options), queryClient);
    }

export const getDeleteConversationNoteUrl = (noteId: string,) => {




  return `/api/conversation-notes/${noteId}`
}

/**
 * @summary Delete Conversation Note
 */
export const deleteConversationNote = async (noteId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteConversationNoteUrl(noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteConversationNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversationNote>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversationNote>>, TError,{noteId: string}, TContext> => {

const mutationKey = ['deleteConversationNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversationNote>>, {noteId: string}> = (props) => {
          const {noteId} = props ?? {};

          return  deleteConversationNote(noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversationNote>>>

    export type DeleteConversationNoteMutationError = HTTPValidationError

    /**
 * @summary Delete Conversation Note
 */
export const useDeleteConversationNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversationNote>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversationNote>>,
        TError,
        {noteId: string},
        TContext
      > => {
      return useMutation(getDeleteConversationNoteMutationOptions(options), queryClient);
    }

export const getSetConversationNoteReactionUrl = (noteId: string,) => {




  return `/api/conversation-notes/${noteId}/reaction`
}

/**
 * @summary Set Conversation Note Reaction
 */
export const setConversationNoteReaction = async (noteId: string,
    conversationNoteReactionIn: ConversationNoteReactionIn, options?: Parameters<typeof customInstance>[1]): Promise<ConversationNoteOut> => {

  return customInstance<ConversationNoteOut>(getSetConversationNoteReactionUrl(noteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversationNoteReactionIn)
  }
);}





export const getSetConversationNoteReactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setConversationNoteReaction>>, TError,{noteId: string;data: ConversationNoteReactionIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setConversationNoteReaction>>, TError,{noteId: string;data: ConversationNoteReactionIn}, TContext> => {

const mutationKey = ['setConversationNoteReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setConversationNoteReaction>>, {noteId: string;data: ConversationNoteReactionIn}> = (props) => {
          const {noteId,data} = props ?? {};

          return  setConversationNoteReaction(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetConversationNoteReactionMutationResult = NonNullable<Awaited<ReturnType<typeof setConversationNoteReaction>>>
    export type SetConversationNoteReactionMutationBody = ConversationNoteReactionIn
    export type SetConversationNoteReactionMutationError = HTTPValidationError

    /**
 * @summary Set Conversation Note Reaction
 */
export const useSetConversationNoteReaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setConversationNoteReaction>>, TError,{noteId: string;data: ConversationNoteReactionIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setConversationNoteReaction>>,
        TError,
        {noteId: string;data: ConversationNoteReactionIn},
        TContext
      > => {
      return useMutation(getSetConversationNoteReactionMutationOptions(options), queryClient);
    }

export const getClearConversationNoteReactionUrl = (noteId: string,) => {




  return `/api/conversation-notes/${noteId}/reaction`
}

/**
 * @summary Clear Conversation Note Reaction
 */
export const clearConversationNoteReaction = async (noteId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConversationNoteOut> => {

  return customInstance<ConversationNoteOut>(getClearConversationNoteReactionUrl(noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearConversationNoteReactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConversationNoteReaction>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearConversationNoteReaction>>, TError,{noteId: string}, TContext> => {

const mutationKey = ['clearConversationNoteReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearConversationNoteReaction>>, {noteId: string}> = (props) => {
          const {noteId} = props ?? {};

          return  clearConversationNoteReaction(noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearConversationNoteReactionMutationResult = NonNullable<Awaited<ReturnType<typeof clearConversationNoteReaction>>>

    export type ClearConversationNoteReactionMutationError = HTTPValidationError

    /**
 * @summary Clear Conversation Note Reaction
 */
export const useClearConversationNoteReaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConversationNoteReaction>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearConversationNoteReaction>>,
        TError,
        {noteId: string},
        TContext
      > => {
      return useMutation(getClearConversationNoteReactionMutationOptions(options), queryClient);
    }

export const getGetConversationUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}`
}

/**
 * @summary Get Conversation
 */
export const getConversation = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConversationOut> => {

  return customInstance<ConversationOut>(getGetConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}`
    ] as const;
    }


export const getGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationQueryError = HTTPValidationError


export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation
 */

export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConversationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationSuspenseQueryError = HTTPValidationError


export function useGetConversationSuspense<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationSuspense<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversationSuspense<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Conversation
 */

export function useGetConversationSuspense<TData = Awaited<ReturnType<typeof getConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchConversationUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}`
}

/**
 * @summary Patch Conversation
 */
export const patchConversation = async (conversationId: string,
    conversationPatch: ConversationPatch, options?: Parameters<typeof customInstance>[1]): Promise<ConversationOut> => {

  return customInstance<ConversationOut>(getPatchConversationUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversationPatch)
  }
);}





export const getPatchConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchConversation>>, TError,{conversationId: string;data: ConversationPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchConversation>>, TError,{conversationId: string;data: ConversationPatch}, TContext> => {

const mutationKey = ['patchConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchConversation>>, {conversationId: string;data: ConversationPatch}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  patchConversation(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchConversationMutationResult = NonNullable<Awaited<ReturnType<typeof patchConversation>>>
    export type PatchConversationMutationBody = ConversationPatch
    export type PatchConversationMutationError = HTTPValidationError

    /**
 * @summary Patch Conversation
 */
export const usePatchConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchConversation>>, TError,{conversationId: string;data: ConversationPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchConversation>>,
        TError,
        {conversationId: string;data: ConversationPatch},
        TContext
      > => {
      return useMutation(getPatchConversationMutationOptions(options), queryClient);
    }

export const getDeleteConversationUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}`
}

/**
 * @summary Delete Conversation
 */
export const deleteConversation = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteConversationUrl(conversationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['deleteConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversation>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  deleteConversation(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversation>>>

    export type DeleteConversationMutationError = HTTPValidationError

    /**
 * @summary Delete Conversation
 */
export const useDeleteConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversation>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getDeleteConversationMutationOptions(options), queryClient);
    }

export const getGetStateUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/state`
}

/**
 * @summary Get State
 */
export const getState = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<StateOut> => {

  return customInstance<StateOut>(getGetStateUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStateQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/state`
    ] as const;
    }


export const getGetStateQueryOptions = <TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStateQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getState>>> = ({ signal }) => getState(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStateQueryResult = NonNullable<Awaited<ReturnType<typeof getState>>>
export type GetStateQueryError = HTTPValidationError


export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getState>>,
          TError,
          Awaited<ReturnType<typeof getState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getState>>,
          TError,
          Awaited<ReturnType<typeof getState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get State
 */

export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStateQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetStateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStateQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getState>>> = ({ signal }) => getState(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getState>>>
export type GetStateSuspenseQueryError = HTTPValidationError


export function useGetStateSuspense<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStateSuspense<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStateSuspense<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get State
 */

export function useGetStateSuspense<TData = Awaited<ReturnType<typeof getState>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStateSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetThreadsUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/threads`
}

/**
 * @summary Get Threads
 */
export const getThreads = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ThreadOut[]> => {

  return customInstance<ThreadOut[]>(getGetThreadsUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetThreadsQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/threads`
    ] as const;
    }


export const getGetThreadsQueryOptions = <TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetThreadsQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getThreads>>> = ({ signal }) => getThreads(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof getThreads>>>
export type GetThreadsQueryError = HTTPValidationError


export function useGetThreads<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreads>>,
          TError,
          Awaited<ReturnType<typeof getThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreads<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreads>>,
          TError,
          Awaited<ReturnType<typeof getThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreads<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Threads
 */

export function useGetThreads<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetThreadsQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetThreadsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetThreadsQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getThreads>>> = ({ signal }) => getThreads(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetThreadsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getThreads>>>
export type GetThreadsSuspenseQueryError = HTTPValidationError


export function useGetThreadsSuspense<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreadsSuspense<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreadsSuspense<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Threads
 */

export function useGetThreadsSuspense<TData = Awaited<ReturnType<typeof getThreads>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getThreads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetThreadsSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSegmentsUrl = (conversationId: string,
    params?: GetSegmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/${conversationId}/segments?${stringifiedParams}` : `/api/conversations/${conversationId}/segments`
}

/**
 * @summary Get Segments
 */
export const getSegments = async (conversationId: string,
    params?: GetSegmentsParams, options?: Parameters<typeof customInstance>[1]): Promise<SegmentOut[]> => {

  return customInstance<SegmentOut[]>(getGetSegmentsUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSegmentsQueryKey = (conversationId: string,
    params?: GetSegmentsParams,) => {
    return [
    `/api/conversations/${conversationId}/segments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSegmentsQueryOptions = <TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSegmentsQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSegments>>> = ({ signal }) => getSegments(conversationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSegmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getSegments>>>
export type GetSegmentsQueryError = HTTPValidationError


export function useGetSegments<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params: undefined |  GetSegmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSegments>>,
          TError,
          Awaited<ReturnType<typeof getSegments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSegments<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSegments>>,
          TError,
          Awaited<ReturnType<typeof getSegments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSegments<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Segments
 */

export function useGetSegments<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSegmentsQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSegmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSegmentsQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSegments>>> = ({ signal }) => getSegments(conversationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSegmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSegments>>>
export type GetSegmentsSuspenseQueryError = HTTPValidationError


export function useGetSegmentsSuspense<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params: undefined |  GetSegmentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSegmentsSuspense<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSegmentsSuspense<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Segments
 */

export function useGetSegmentsSuspense<TData = Awaited<ReturnType<typeof getSegments>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: GetSegmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSegments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSegmentsSuspenseQueryOptions(conversationId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarkersUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/markers`
}

/**
 * The player's marker timeline: screen-share spans from the `screen_share` Source
 * blob, clipped at a cut the server establishes, at `scope="media"` so a document-only
 * grantee cannot learn that a screen share happened (timeline design §2.2, §2.3).
 * @summary Get Markers
 */
export const getMarkers = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<MarkersOut> => {

  return customInstance<MarkersOut>(getGetMarkersUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarkersQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/markers`
    ] as const;
    }


export const getGetMarkersQueryOptions = <TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarkersQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarkers>>> = ({ signal }) => getMarkers(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarkersQueryResult = NonNullable<Awaited<ReturnType<typeof getMarkers>>>
export type GetMarkersQueryError = void | HTTPValidationError


export function useGetMarkers<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarkers>>,
          TError,
          Awaited<ReturnType<typeof getMarkers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarkers<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarkers>>,
          TError,
          Awaited<ReturnType<typeof getMarkers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarkers<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Markers
 */

export function useGetMarkers<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarkersQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMarkersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarkersQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarkers>>> = ({ signal }) => getMarkers(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarkersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMarkers>>>
export type GetMarkersSuspenseQueryError = void | HTTPValidationError


export function useGetMarkersSuspense<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarkersSuspense<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarkersSuspense<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Markers
 */

export function useGetMarkersSuspense<TData = Awaited<ReturnType<typeof getMarkers>>, TError = void | HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarkers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarkersSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMediaUrlUrl = (conversationId: string,
    params: GetMediaUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/${conversationId}/media-url?${stringifiedParams}` : `/api/conversations/${conversationId}/media-url`
}

/**
 * @summary Get Media Url
 */
export const getMediaUrl = async (conversationId: string,
    params: GetMediaUrlParams, options?: Parameters<typeof customInstance>[1]): Promise<MediaUrlOut> => {

  return customInstance<MediaUrlOut>(getGetMediaUrlUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMediaUrlQueryKey = (conversationId: string,
    params?: GetMediaUrlParams,) => {
    return [
    `/api/conversations/${conversationId}/media-url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMediaUrlQueryOptions = <TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaUrlQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaUrl>>> = ({ signal }) => getMediaUrl(conversationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMediaUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaUrl>>>
export type GetMediaUrlQueryError = HTTPValidationError


export function useGetMediaUrl<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaUrl>>,
          TError,
          Awaited<ReturnType<typeof getMediaUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaUrl<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaUrl>>,
          TError,
          Awaited<ReturnType<typeof getMediaUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaUrl<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Media Url
 */

export function useGetMediaUrl<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMediaUrlQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMediaUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaUrlQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaUrl>>> = ({ signal }) => getMediaUrl(conversationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMediaUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaUrl>>>
export type GetMediaUrlSuspenseQueryError = HTTPValidationError


export function useGetMediaUrlSuspense<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaUrlSuspense<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaUrlSuspense<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Media Url
 */

export function useGetMediaUrlSuspense<TData = Awaited<ReturnType<typeof getMediaUrl>>, TError = HTTPValidationError>(
 conversationId: string,
    params: GetMediaUrlParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMediaUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMediaUrlSuspenseQueryOptions(conversationId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getArchiveUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/archive`
}

/**
 * @summary Archive
 */
export const archive = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConversationOut> => {

  return customInstance<ConversationOut>(getArchiveUrl(conversationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archive>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archive>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['archive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archive>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  archive(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof archive>>>

    export type ArchiveMutationError = HTTPValidationError

    /**
 * @summary Archive
 */
export const useArchive = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archive>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archive>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getArchiveMutationOptions(options), queryClient);
    }

export const getUnarchiveUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/archive`
}

/**
 * @summary Unarchive
 */
export const unarchive = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConversationOut> => {

  return customInstance<ConversationOut>(getUnarchiveUrl(conversationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnarchiveMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchive>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchive>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['unarchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchive>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  unarchive(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof unarchive>>>

    export type UnarchiveMutationError = HTTPValidationError

    /**
 * @summary Unarchive
 */
export const useUnarchive = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchive>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchive>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getUnarchiveMutationOptions(options), queryClient);
    }

export const getRetryConversationSummaryUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/summary`
}

/**
 * @summary Retry Conversation Summary
 */
export const retryConversationSummary = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getRetryConversationSummaryUrl(conversationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryConversationSummaryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryConversationSummary>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryConversationSummary>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['retryConversationSummary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryConversationSummary>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  retryConversationSummary(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryConversationSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof retryConversationSummary>>>

    export type RetryConversationSummaryMutationError = HTTPValidationError

    /**
 * @summary Retry Conversation Summary
 */
export const useRetryConversationSummary = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryConversationSummary>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryConversationSummary>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getRetryConversationSummaryMutationOptions(options), queryClient);
    }

export const getDownloadConversationSummaryPdfUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/summary/pdf`
}

/**
 * @summary Download Conversation Summary Pdf
 */
export const downloadConversationSummaryPdf = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<Blob> => {

  return customInstance<Blob>(getDownloadConversationSummaryPdfUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadConversationSummaryPdfQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/summary/pdf`
    ] as const;
    }


export const getDownloadConversationSummaryPdfQueryOptions = <TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadConversationSummaryPdfQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>> = ({ signal }) => downloadConversationSummaryPdf(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadConversationSummaryPdfQueryResult = NonNullable<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>>
export type DownloadConversationSummaryPdfQueryError = HTTPValidationError


export function useDownloadConversationSummaryPdf<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadConversationSummaryPdf>>,
          TError,
          Awaited<ReturnType<typeof downloadConversationSummaryPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadConversationSummaryPdf<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadConversationSummaryPdf>>,
          TError,
          Awaited<ReturnType<typeof downloadConversationSummaryPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadConversationSummaryPdf<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Conversation Summary Pdf
 */

export function useDownloadConversationSummaryPdf<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadConversationSummaryPdfQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDownloadConversationSummaryPdfSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadConversationSummaryPdfQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>> = ({ signal }) => downloadConversationSummaryPdf(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadConversationSummaryPdfSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>>
export type DownloadConversationSummaryPdfSuspenseQueryError = HTTPValidationError


export function useDownloadConversationSummaryPdfSuspense<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadConversationSummaryPdfSuspense<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadConversationSummaryPdfSuspense<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Conversation Summary Pdf
 */

export function useDownloadConversationSummaryPdfSuspense<TData = Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadConversationSummaryPdf>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadConversationSummaryPdfSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetLanguageUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/language`
}

/**
 * @summary Set Language
 */
export const setLanguage = async (conversationId: string,
    languageIn: LanguageIn, options?: Parameters<typeof customInstance>[1]): Promise<LanguageOut> => {

  return customInstance<LanguageOut>(getSetLanguageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(languageIn)
  }
);}





export const getSetLanguageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLanguage>>, TError,{conversationId: string;data: LanguageIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setLanguage>>, TError,{conversationId: string;data: LanguageIn}, TContext> => {

const mutationKey = ['setLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLanguage>>, {conversationId: string;data: LanguageIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  setLanguage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof setLanguage>>>
    export type SetLanguageMutationBody = LanguageIn
    export type SetLanguageMutationError = HTTPValidationError

    /**
 * @summary Set Language
 */
export const useSetLanguage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLanguage>>, TError,{conversationId: string;data: LanguageIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLanguage>>,
        TError,
        {conversationId: string;data: LanguageIn},
        TContext
      > => {
      return useMutation(getSetLanguageMutationOptions(options), queryClient);
    }

export const getListConversationNotesUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/notes`
}

/**
 * @summary List Conversation Notes
 */
export const listConversationNotes = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<ConversationNoteListOut> => {

  return customInstance<ConversationNoteListOut>(getListConversationNotesUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConversationNotesQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/notes`
    ] as const;
    }


export const getListConversationNotesQueryOptions = <TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationNotesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversationNotes>>> = ({ signal }) => listConversationNotes(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConversationNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listConversationNotes>>>
export type ListConversationNotesQueryError = HTTPValidationError


export function useListConversationNotes<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversationNotes>>,
          TError,
          Awaited<ReturnType<typeof listConversationNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversationNotes<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversationNotes>>,
          TError,
          Awaited<ReturnType<typeof listConversationNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversationNotes<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Conversation Notes
 */

export function useListConversationNotes<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConversationNotesQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListConversationNotesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationNotesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversationNotes>>> = ({ signal }) => listConversationNotes(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConversationNotesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listConversationNotes>>>
export type ListConversationNotesSuspenseQueryError = HTTPValidationError


export function useListConversationNotesSuspense<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversationNotesSuspense<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversationNotesSuspense<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Conversation Notes
 */

export function useListConversationNotesSuspense<TData = Awaited<ReturnType<typeof listConversationNotes>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listConversationNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConversationNotesSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateConversationNoteUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/notes`
}

/**
 * @summary Create Conversation Note
 */
export const createConversationNote = async (conversationId: string,
    conversationNoteCreate: ConversationNoteCreate, options?: Parameters<typeof customInstance>[1]): Promise<ConversationNoteOut> => {

  return customInstance<ConversationNoteOut>(getCreateConversationNoteUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversationNoteCreate)
  }
);}





export const getCreateConversationNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversationNote>>, TError,{conversationId: string;data: ConversationNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversationNote>>, TError,{conversationId: string;data: ConversationNoteCreate}, TContext> => {

const mutationKey = ['createConversationNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversationNote>>, {conversationId: string;data: ConversationNoteCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createConversationNote(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConversationNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createConversationNote>>>
    export type CreateConversationNoteMutationBody = ConversationNoteCreate
    export type CreateConversationNoteMutationError = HTTPValidationError

    /**
 * @summary Create Conversation Note
 */
export const useCreateConversationNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversationNote>>, TError,{conversationId: string;data: ConversationNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConversationNote>>,
        TError,
        {conversationId: string;data: ConversationNoteCreate},
        TContext
      > => {
      return useMutation(getCreateConversationNoteMutationOptions(options), queryClient);
    }

export const getAttachDocumentSourceUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/sources/document`
}

/**
 * @summary Attach Document Source
 */
export const attachDocumentSource = async (conversationId: string,
    documentSourceIn: DocumentSourceIn, options?: Parameters<typeof customInstance>[1]): Promise<SourceOut> => {

  return customInstance<SourceOut>(getAttachDocumentSourceUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(documentSourceIn)
  }
);}





export const getAttachDocumentSourceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachDocumentSource>>, TError,{conversationId: string;data: DocumentSourceIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof attachDocumentSource>>, TError,{conversationId: string;data: DocumentSourceIn}, TContext> => {

const mutationKey = ['attachDocumentSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachDocumentSource>>, {conversationId: string;data: DocumentSourceIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  attachDocumentSource(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachDocumentSourceMutationResult = NonNullable<Awaited<ReturnType<typeof attachDocumentSource>>>
    export type AttachDocumentSourceMutationBody = DocumentSourceIn
    export type AttachDocumentSourceMutationError = HTTPValidationError

    /**
 * @summary Attach Document Source
 */
export const useAttachDocumentSource = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachDocumentSource>>, TError,{conversationId: string;data: DocumentSourceIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachDocumentSource>>,
        TError,
        {conversationId: string;data: DocumentSourceIn},
        TContext
      > => {
      return useMutation(getAttachDocumentSourceMutationOptions(options), queryClient);
    }

export const getDetachSourceUrl = (conversationId: string,
    sourceId: string,) => {




  return `/api/conversations/${conversationId}/sources/${sourceId}`
}

/**
 * @summary Detach Source
 */
export const detachSource = async (conversationId: string,
    sourceId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDetachSourceUrl(conversationId,sourceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDetachSourceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detachSource>>, TError,{conversationId: string;sourceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof detachSource>>, TError,{conversationId: string;sourceId: string}, TContext> => {

const mutationKey = ['detachSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof detachSource>>, {conversationId: string;sourceId: string}> = (props) => {
          const {conversationId,sourceId} = props ?? {};

          return  detachSource(conversationId,sourceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DetachSourceMutationResult = NonNullable<Awaited<ReturnType<typeof detachSource>>>

    export type DetachSourceMutationError = HTTPValidationError

    /**
 * @summary Detach Source
 */
export const useDetachSource = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detachSource>>, TError,{conversationId: string;sourceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof detachSource>>,
        TError,
        {conversationId: string;sourceId: string},
        TContext
      > => {
      return useMutation(getDetachSourceMutationOptions(options), queryClient);
    }

export const getRelinkUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/relink`
}

/**
 * @summary Relink
 */
export const relink = async (conversationId: string,
    relinkIn: RelinkIn, options?: Parameters<typeof customInstance>[1]): Promise<ConversationOut> => {

  return customInstance<ConversationOut>(getRelinkUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(relinkIn)
  }
);}





export const getRelinkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof relink>>, TError,{conversationId: string;data: RelinkIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof relink>>, TError,{conversationId: string;data: RelinkIn}, TContext> => {

const mutationKey = ['relink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof relink>>, {conversationId: string;data: RelinkIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  relink(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RelinkMutationResult = NonNullable<Awaited<ReturnType<typeof relink>>>
    export type RelinkMutationBody = RelinkIn
    export type RelinkMutationError = HTTPValidationError

    /**
 * @summary Relink
 */
export const useRelink = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof relink>>, TError,{conversationId: string;data: RelinkIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof relink>>,
        TError,
        {conversationId: string;data: RelinkIn},
        TContext
      > => {
      return useMutation(getRelinkMutationOptions(options), queryClient);
    }

export const getGetPropertiesUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/properties`
}

/**
 * @summary Get Properties
 */
export const getProperties = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<PropertiesOut> => {

  return customInstance<PropertiesOut>(getGetPropertiesUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertiesQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/properties`
    ] as const;
    }


export const getGetPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperties>>> = ({ signal }) => getProperties(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProperties>>>
export type GetPropertiesQueryError = HTTPValidationError


export function useGetProperties<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperties>>,
          TError,
          Awaited<ReturnType<typeof getProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperties<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperties>>,
          TError,
          Awaited<ReturnType<typeof getProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperties<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Properties
 */

export function useGetProperties<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertiesQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPropertiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertiesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperties>>> = ({ signal }) => getProperties(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProperties>>>
export type GetPropertiesSuspenseQueryError = HTTPValidationError


export function useGetPropertiesSuspense<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSuspense<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertiesSuspense<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Properties
 */

export function useGetPropertiesSuspense<TData = Awaited<ReturnType<typeof getProperties>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertiesSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutPropertiesUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/properties`
}

/**
 * @summary Put Properties
 */
export const putProperties = async (conversationId: string,
    propertiesPut: PropertiesPut, options?: Parameters<typeof customInstance>[1]): Promise<PropertiesOut> => {

  return customInstance<PropertiesOut>(getPutPropertiesUrl(conversationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertiesPut)
  }
);}





export const getPutPropertiesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProperties>>, TError,{conversationId: string;data: PropertiesPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putProperties>>, TError,{conversationId: string;data: PropertiesPut}, TContext> => {

const mutationKey = ['putProperties'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProperties>>, {conversationId: string;data: PropertiesPut}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  putProperties(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof putProperties>>>
    export type PutPropertiesMutationBody = PropertiesPut
    export type PutPropertiesMutationError = HTTPValidationError

    /**
 * @summary Put Properties
 */
export const usePutProperties = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProperties>>, TError,{conversationId: string;data: PropertiesPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProperties>>,
        TError,
        {conversationId: string;data: PropertiesPut},
        TContext
      > => {
      return useMutation(getPutPropertiesMutationOptions(options), queryClient);
    }

export const getPatchScorecardTypeUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/properties`
}

/**
 * @summary Patch Scorecard Type
 */
export const patchScorecardType = async (conversationId: string,
    scorecardTypePatch: ScorecardTypePatch, options?: Parameters<typeof customInstance>[1]): Promise<PropertiesOut> => {

  return customInstance<PropertiesOut>(getPatchScorecardTypeUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardTypePatch)
  }
);}





export const getPatchScorecardTypeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchScorecardType>>, TError,{conversationId: string;data: ScorecardTypePatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchScorecardType>>, TError,{conversationId: string;data: ScorecardTypePatch}, TContext> => {

const mutationKey = ['patchScorecardType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchScorecardType>>, {conversationId: string;data: ScorecardTypePatch}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  patchScorecardType(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchScorecardTypeMutationResult = NonNullable<Awaited<ReturnType<typeof patchScorecardType>>>
    export type PatchScorecardTypeMutationBody = ScorecardTypePatch
    export type PatchScorecardTypeMutationError = HTTPValidationError

    /**
 * @summary Patch Scorecard Type
 */
export const usePatchScorecardType = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchScorecardType>>, TError,{conversationId: string;data: ScorecardTypePatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchScorecardType>>,
        TError,
        {conversationId: string;data: ScorecardTypePatch},
        TContext
      > => {
      return useMutation(getPatchScorecardTypeMutationOptions(options), queryClient);
    }

export const getListGrantsUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/grants`
}

/**
 * @summary List Grants
 */
export const listGrants = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<GrantOut[]> => {

  return customInstance<GrantOut[]>(getListGrantsUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGrantsQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/grants`
    ] as const;
    }


export const getListGrantsQueryOptions = <TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGrantsQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGrants>>> = ({ signal }) => listGrants(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listGrants>>>
export type ListGrantsQueryError = HTTPValidationError


export function useListGrants<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGrants>>,
          TError,
          Awaited<ReturnType<typeof listGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGrants<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGrants>>,
          TError,
          Awaited<ReturnType<typeof listGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGrants<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Grants
 */

export function useListGrants<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGrantsQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListGrantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGrantsQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGrants>>> = ({ signal }) => listGrants(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGrantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listGrants>>>
export type ListGrantsSuspenseQueryError = HTTPValidationError


export function useListGrantsSuspense<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGrantsSuspense<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGrantsSuspense<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Grants
 */

export function useListGrantsSuspense<TData = Awaited<ReturnType<typeof listGrants>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGrantsSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateGrantUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/grants`
}

/**
 * @summary Create Grant
 */
export const createGrant = async (conversationId: string,
    grantCreate: GrantCreate, options?: Parameters<typeof customInstance>[1]): Promise<GrantOut> => {

  return customInstance<GrantOut>(getCreateGrantUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantCreate)
  }
);}





export const getCreateGrantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGrant>>, TError,{conversationId: string;data: GrantCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGrant>>, TError,{conversationId: string;data: GrantCreate}, TContext> => {

const mutationKey = ['createGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGrant>>, {conversationId: string;data: GrantCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createGrant(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGrantMutationResult = NonNullable<Awaited<ReturnType<typeof createGrant>>>
    export type CreateGrantMutationBody = GrantCreate
    export type CreateGrantMutationError = HTTPValidationError

    /**
 * @summary Create Grant
 */
export const useCreateGrant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGrant>>, TError,{conversationId: string;data: GrantCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGrant>>,
        TError,
        {conversationId: string;data: GrantCreate},
        TContext
      > => {
      return useMutation(getCreateGrantMutationOptions(options), queryClient);
    }

export const getRevokeGrantUrl = (conversationId: string,
    grantId: string,) => {




  return `/api/conversations/${conversationId}/grants/${grantId}`
}

/**
 * @summary Revoke Grant
 */
export const revokeGrant = async (conversationId: string,
    grantId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRevokeGrantUrl(conversationId,grantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeGrantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeGrant>>, TError,{conversationId: string;grantId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeGrant>>, TError,{conversationId: string;grantId: string}, TContext> => {

const mutationKey = ['revokeGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeGrant>>, {conversationId: string;grantId: string}> = (props) => {
          const {conversationId,grantId} = props ?? {};

          return  revokeGrant(conversationId,grantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeGrantMutationResult = NonNullable<Awaited<ReturnType<typeof revokeGrant>>>

    export type RevokeGrantMutationError = HTTPValidationError

    /**
 * @summary Revoke Grant
 */
export const useRevokeGrant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeGrant>>, TError,{conversationId: string;grantId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeGrant>>,
        TError,
        {conversationId: string;grantId: string},
        TContext
      > => {
      return useMutation(getRevokeGrantMutationOptions(options), queryClient);
    }

export const getGetSpeakersUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/speakers`
}

/**
 * @summary Get Speakers
 */
export const getSpeakers = async (conversationId: string, options?: Parameters<typeof customInstance>[1]): Promise<SpeakersOut> => {

  return customInstance<SpeakersOut>(getGetSpeakersUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpeakersQueryKey = (conversationId: string,) => {
    return [
    `/api/conversations/${conversationId}/speakers`
    ] as const;
    }


export const getGetSpeakersQueryOptions = <TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpeakersQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpeakers>>> = ({ signal }) => getSpeakers(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpeakersQueryResult = NonNullable<Awaited<ReturnType<typeof getSpeakers>>>
export type GetSpeakersQueryError = HTTPValidationError


export function useGetSpeakers<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpeakers>>,
          TError,
          Awaited<ReturnType<typeof getSpeakers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpeakers<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpeakers>>,
          TError,
          Awaited<ReturnType<typeof getSpeakers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpeakers<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Speakers
 */

export function useGetSpeakers<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpeakersQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSpeakersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpeakersQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpeakers>>> = ({ signal }) => getSpeakers(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpeakersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSpeakers>>>
export type GetSpeakersSuspenseQueryError = HTTPValidationError


export function useGetSpeakersSuspense<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpeakersSuspense<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpeakersSuspense<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Speakers
 */

export function useGetSpeakersSuspense<TData = Awaited<ReturnType<typeof getSpeakers>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpeakers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpeakersSuspenseQueryOptions(conversationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignSpeakersUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/speakers`
}

/**
 * @summary Assign Speakers
 */
export const assignSpeakers = async (conversationId: string,
    assignIn: AssignIn, options?: Parameters<typeof customInstance>[1]): Promise<SpeakersOut> => {

  return customInstance<SpeakersOut>(getAssignSpeakersUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignIn)
  }
);}





export const getAssignSpeakersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignSpeakers>>, TError,{conversationId: string;data: AssignIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignSpeakers>>, TError,{conversationId: string;data: AssignIn}, TContext> => {

const mutationKey = ['assignSpeakers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignSpeakers>>, {conversationId: string;data: AssignIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  assignSpeakers(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignSpeakersMutationResult = NonNullable<Awaited<ReturnType<typeof assignSpeakers>>>
    export type AssignSpeakersMutationBody = AssignIn
    export type AssignSpeakersMutationError = HTTPValidationError

    /**
 * @summary Assign Speakers
 */
export const useAssignSpeakers = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignSpeakers>>, TError,{conversationId: string;data: AssignIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignSpeakers>>,
        TError,
        {conversationId: string;data: AssignIn},
        TContext
      > => {
      return useMutation(getAssignSpeakersMutationOptions(options), queryClient);
    }

export const getPatchParticipantUrl = (conversationId: string,
    participantId: string,
    params?: PatchParticipantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations/${conversationId}/participants/${participantId}?${stringifiedParams}` : `/api/conversations/${conversationId}/participants/${participantId}`
}

/**
 * @summary Patch Participant
 */
export const patchParticipant = async (conversationId: string,
    participantId: string,
    participantPatch: ParticipantPatch,
    params?: PatchParticipantParams, options?: Parameters<typeof customInstance>[1]): Promise<DryRunOut> => {

  return customInstance<DryRunOut>(getPatchParticipantUrl(conversationId,participantId,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(participantPatch)
  }
);}





export const getPatchParticipantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchParticipant>>, TError,{conversationId: string;participantId: string;data: ParticipantPatch;params?: PatchParticipantParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchParticipant>>, TError,{conversationId: string;participantId: string;data: ParticipantPatch;params?: PatchParticipantParams}, TContext> => {

const mutationKey = ['patchParticipant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchParticipant>>, {conversationId: string;participantId: string;data: ParticipantPatch;params?: PatchParticipantParams}> = (props) => {
          const {conversationId,participantId,data,params} = props ?? {};

          return  patchParticipant(conversationId,participantId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof patchParticipant>>>
    export type PatchParticipantMutationBody = ParticipantPatch
    export type PatchParticipantMutationError = HTTPValidationError

    /**
 * @summary Patch Participant
 */
export const usePatchParticipant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchParticipant>>, TError,{conversationId: string;participantId: string;data: ParticipantPatch;params?: PatchParticipantParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchParticipant>>,
        TError,
        {conversationId: string;participantId: string;data: ParticipantPatch;params?: PatchParticipantParams},
        TContext
      > => {
      return useMutation(getPatchParticipantMutationOptions(options), queryClient);
    }

export const getTriageConversationUrl = (conversationId: string,) => {




  return `/api/conversations/${conversationId}/triage`
}

/**
 * @summary Triage Conversation
 */
export const triageConversation = async (conversationId: string,
    triageAssignOneInTriagePerCandidateIn: TriageAssignOneIn | TriagePerCandidateIn, options?: Parameters<typeof customInstance>[1]): Promise<TriageOut> => {

  return customInstance<TriageOut>(getTriageConversationUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(triageAssignOneInTriagePerCandidateIn)
  }
);}





export const getTriageConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triageConversation>>, TError,{conversationId: string;data: TriageAssignOneIn | TriagePerCandidateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triageConversation>>, TError,{conversationId: string;data: TriageAssignOneIn | TriagePerCandidateIn}, TContext> => {

const mutationKey = ['triageConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triageConversation>>, {conversationId: string;data: TriageAssignOneIn | TriagePerCandidateIn}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  triageConversation(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriageConversationMutationResult = NonNullable<Awaited<ReturnType<typeof triageConversation>>>
    export type TriageConversationMutationBody = TriageAssignOneIn | TriagePerCandidateIn
    export type TriageConversationMutationError = HTTPValidationError

    /**
 * @summary Triage Conversation
 */
export const useTriageConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triageConversation>>, TError,{conversationId: string;data: TriageAssignOneIn | TriagePerCandidateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triageConversation>>,
        TError,
        {conversationId: string;data: TriageAssignOneIn | TriagePerCandidateIn},
        TContext
      > => {
      return useMutation(getTriageConversationMutationOptions(options), queryClient);
    }

export const getListJobScorecardDefinitionsUrl = (jobId: string,
    params?: ListJobScorecardDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/scorecard-definitions?${stringifiedParams}` : `/api/jobs/${jobId}/scorecard-definitions`
}

/**
 * @summary List Job Scorecard Definitions
 */
export const listJobScorecardDefinitions = async (jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: Parameters<typeof customInstance>[1]): Promise<ResolvedScorecardSet> => {

  return customInstance<ResolvedScorecardSet>(getListJobScorecardDefinitionsUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobScorecardDefinitionsQueryKey = (jobId: string,
    params?: ListJobScorecardDefinitionsParams,) => {
    return [
    `/api/jobs/${jobId}/scorecard-definitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobScorecardDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobScorecardDefinitionsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobScorecardDefinitions>>> = ({ signal }) => listJobScorecardDefinitions(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobScorecardDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobScorecardDefinitions>>>
export type ListJobScorecardDefinitionsQueryError = HTTPValidationError


export function useListJobScorecardDefinitions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListJobScorecardDefinitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobScorecardDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listJobScorecardDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobScorecardDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listJobScorecardDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Scorecard Definitions
 */

export function useListJobScorecardDefinitions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobScorecardDefinitionsQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListJobScorecardDefinitionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobScorecardDefinitionsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobScorecardDefinitions>>> = ({ signal }) => listJobScorecardDefinitions(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobScorecardDefinitionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listJobScorecardDefinitions>>>
export type ListJobScorecardDefinitionsSuspenseQueryError = HTTPValidationError


export function useListJobScorecardDefinitionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListJobScorecardDefinitionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Scorecard Definitions
 */

export function useListJobScorecardDefinitionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListJobScorecardDefinitionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobScorecardDefinitionsSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateJobScorecardDefinitionUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions`
}

/**
 * @summary Create Job Scorecard Definition
 */
export const createJobScorecardDefinition = async (jobId: string,
    scorecardDefinitionCreate: ScorecardDefinitionCreate, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut> => {

  return customInstance<ScorecardDefinitionOut>(getCreateJobScorecardDefinitionUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardDefinitionCreate)
  }
);}





export const getCreateJobScorecardDefinitionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobScorecardDefinition>>, TError,{jobId: string;data: ScorecardDefinitionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobScorecardDefinition>>, TError,{jobId: string;data: ScorecardDefinitionCreate}, TContext> => {

const mutationKey = ['createJobScorecardDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobScorecardDefinition>>, {jobId: string;data: ScorecardDefinitionCreate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  createJobScorecardDefinition(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobScorecardDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof createJobScorecardDefinition>>>
    export type CreateJobScorecardDefinitionMutationBody = ScorecardDefinitionCreate
    export type CreateJobScorecardDefinitionMutationError = HTTPValidationError

    /**
 * @summary Create Job Scorecard Definition
 */
export const useCreateJobScorecardDefinition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobScorecardDefinition>>, TError,{jobId: string;data: ScorecardDefinitionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createJobScorecardDefinition>>,
        TError,
        {jobId: string;data: ScorecardDefinitionCreate},
        TContext
      > => {
      return useMutation(getCreateJobScorecardDefinitionMutationOptions(options), queryClient);
    }

export const getCustomizeJobScorecardDefinitionsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions/customize`
}

/**
 * @summary Customize Job Scorecard Definitions
 */
export const customizeJobScorecardDefinitions = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<ResolvedScorecardSet> => {

  return customInstance<ResolvedScorecardSet>(getCustomizeJobScorecardDefinitionsUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCustomizeJobScorecardDefinitionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['customizeJobScorecardDefinitions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  customizeJobScorecardDefinitions(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CustomizeJobScorecardDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>>

    export type CustomizeJobScorecardDefinitionsMutationError = HTTPValidationError

    /**
 * @summary Customize Job Scorecard Definitions
 */
export const useCustomizeJobScorecardDefinitions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customizeJobScorecardDefinitions>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getCustomizeJobScorecardDefinitionsMutationOptions(options), queryClient);
    }

export const getAddJobScorecardDefinitionFromLibraryUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions/from-library`
}

/**
 * @summary Add Job Scorecard Definition From Library
 */
export const addJobScorecardDefinitionFromLibrary = async (jobId: string,
    scorecardDefinitionFromLibrary: ScorecardDefinitionFromLibrary, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut> => {

  return customInstance<ScorecardDefinitionOut>(getAddJobScorecardDefinitionFromLibraryUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardDefinitionFromLibrary)
  }
);}





export const getAddJobScorecardDefinitionFromLibraryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>, TError,{jobId: string;data: ScorecardDefinitionFromLibrary}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>, TError,{jobId: string;data: ScorecardDefinitionFromLibrary}, TContext> => {

const mutationKey = ['addJobScorecardDefinitionFromLibrary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>, {jobId: string;data: ScorecardDefinitionFromLibrary}> = (props) => {
          const {jobId,data} = props ?? {};

          return  addJobScorecardDefinitionFromLibrary(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddJobScorecardDefinitionFromLibraryMutationResult = NonNullable<Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>>
    export type AddJobScorecardDefinitionFromLibraryMutationBody = ScorecardDefinitionFromLibrary
    export type AddJobScorecardDefinitionFromLibraryMutationError = HTTPValidationError

    /**
 * @summary Add Job Scorecard Definition From Library
 */
export const useAddJobScorecardDefinitionFromLibrary = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>, TError,{jobId: string;data: ScorecardDefinitionFromLibrary}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addJobScorecardDefinitionFromLibrary>>,
        TError,
        {jobId: string;data: ScorecardDefinitionFromLibrary},
        TContext
      > => {
      return useMutation(getAddJobScorecardDefinitionFromLibraryMutationOptions(options), queryClient);
    }

export const getReorderJobScorecardDefinitionsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions/order`
}

/**
 * @summary Reorder Job Scorecard Definitions
 */
export const reorderJobScorecardDefinitions = async (jobId: string,
    scorecardOrderUpdate: ScorecardOrderUpdate, options?: Parameters<typeof customInstance>[1]): Promise<ResolvedScorecardSet> => {

  return customInstance<ResolvedScorecardSet>(getReorderJobScorecardDefinitionsUrl(jobId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardOrderUpdate)
  }
);}





export const getReorderJobScorecardDefinitionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>, TError,{jobId: string;data: ScorecardOrderUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>, TError,{jobId: string;data: ScorecardOrderUpdate}, TContext> => {

const mutationKey = ['reorderJobScorecardDefinitions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>, {jobId: string;data: ScorecardOrderUpdate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  reorderJobScorecardDefinitions(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderJobScorecardDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>>
    export type ReorderJobScorecardDefinitionsMutationBody = ScorecardOrderUpdate
    export type ReorderJobScorecardDefinitionsMutationError = HTTPValidationError

    /**
 * @summary Reorder Job Scorecard Definitions
 */
export const useReorderJobScorecardDefinitions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>, TError,{jobId: string;data: ScorecardOrderUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderJobScorecardDefinitions>>,
        TError,
        {jobId: string;data: ScorecardOrderUpdate},
        TContext
      > => {
      return useMutation(getReorderJobScorecardDefinitionsMutationOptions(options), queryClient);
    }

export const getUpdateJobScorecardDefinitionUrl = (jobId: string,
    definitionId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions/${definitionId}`
}

/**
 * @summary Update Job Scorecard Definition
 */
export const updateJobScorecardDefinition = async (jobId: string,
    definitionId: string,
    scorecardDefinitionPatch: ScorecardDefinitionPatch, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardDefinitionOut> => {

  return customInstance<ScorecardDefinitionOut>(getUpdateJobScorecardDefinitionUrl(jobId,definitionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardDefinitionPatch)
  }
);}





export const getUpdateJobScorecardDefinitionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobScorecardDefinition>>, TError,{jobId: string;definitionId: string;data: ScorecardDefinitionPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobScorecardDefinition>>, TError,{jobId: string;definitionId: string;data: ScorecardDefinitionPatch}, TContext> => {

const mutationKey = ['updateJobScorecardDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobScorecardDefinition>>, {jobId: string;definitionId: string;data: ScorecardDefinitionPatch}> = (props) => {
          const {jobId,definitionId,data} = props ?? {};

          return  updateJobScorecardDefinition(jobId,definitionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobScorecardDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobScorecardDefinition>>>
    export type UpdateJobScorecardDefinitionMutationBody = ScorecardDefinitionPatch
    export type UpdateJobScorecardDefinitionMutationError = HTTPValidationError

    /**
 * @summary Update Job Scorecard Definition
 */
export const useUpdateJobScorecardDefinition = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobScorecardDefinition>>, TError,{jobId: string;definitionId: string;data: ScorecardDefinitionPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateJobScorecardDefinition>>,
        TError,
        {jobId: string;definitionId: string;data: ScorecardDefinitionPatch},
        TContext
      > => {
      return useMutation(getUpdateJobScorecardDefinitionMutationOptions(options), queryClient);
    }

export const getListJobScorecardDefinitionVersionsUrl = (jobId: string,
    definitionId: string,) => {




  return `/api/jobs/${jobId}/scorecard-definitions/${definitionId}/versions`
}

/**
 * @summary List Job Scorecard Definition Versions
 */
export const listJobScorecardDefinitionVersions = async (jobId: string,
    definitionId: string, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardVersionOut[]> => {

  return customInstance<ScorecardVersionOut[]>(getListJobScorecardDefinitionVersionsUrl(jobId,definitionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobScorecardDefinitionVersionsQueryKey = (jobId: string,
    definitionId: string,) => {
    return [
    `/api/jobs/${jobId}/scorecard-definitions/${definitionId}/versions`
    ] as const;
    }


export const getListJobScorecardDefinitionVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(jobId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobScorecardDefinitionVersionsQueryKey(jobId,definitionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>> = ({ signal }) => listJobScorecardDefinitionVersions(jobId,definitionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && definitionId !== null && definitionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobScorecardDefinitionVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>>
export type ListJobScorecardDefinitionVersionsQueryError = HTTPValidationError


export function useListJobScorecardDefinitionVersions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>,
          TError,
          Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionVersions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>,
          TError,
          Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionVersions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Scorecard Definition Versions
 */

export function useListJobScorecardDefinitionVersions<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobScorecardDefinitionVersionsQueryOptions(jobId,definitionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListJobScorecardDefinitionVersionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(jobId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobScorecardDefinitionVersionsQueryKey(jobId,definitionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>> = ({ signal }) => listJobScorecardDefinitionVersions(jobId,definitionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobScorecardDefinitionVersionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>>
export type ListJobScorecardDefinitionVersionsSuspenseQueryError = HTTPValidationError


export function useListJobScorecardDefinitionVersionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionVersionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobScorecardDefinitionVersionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Scorecard Definition Versions
 */

export function useListJobScorecardDefinitionVersionsSuspense<TData = Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError = HTTPValidationError>(
 jobId: string,
    definitionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobScorecardDefinitionVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobScorecardDefinitionVersionsSuspenseQueryOptions(jobId,definitionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListScorecardFillsUrl = (jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/candidates/${jcId}/scorecard-fills?${stringifiedParams}` : `/api/jobs/${jobId}/candidates/${jcId}/scorecard-fills`
}

/**
 * @summary List Scorecard Fills
 */
export const listScorecardFills = async (jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardFillsOut> => {

  return customInstance<ScorecardFillsOut>(getListScorecardFillsUrl(jobId,jcId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScorecardFillsQueryKey = (jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams,) => {
    return [
    `/api/jobs/${jobId}/candidates/${jcId}/scorecard-fills`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScorecardFillsQueryOptions = <TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScorecardFillsQueryKey(jobId,jcId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScorecardFills>>> = ({ signal }) => listScorecardFills(jobId,jcId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && jcId !== null && jcId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScorecardFillsQueryResult = NonNullable<Awaited<ReturnType<typeof listScorecardFills>>>
export type ListScorecardFillsQueryError = HTTPValidationError


export function useListScorecardFills<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params: undefined |  ListScorecardFillsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScorecardFills>>,
          TError,
          Awaited<ReturnType<typeof listScorecardFills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardFills<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScorecardFills>>,
          TError,
          Awaited<ReturnType<typeof listScorecardFills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardFills<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Scorecard Fills
 */

export function useListScorecardFills<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScorecardFillsQueryOptions(jobId,jcId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListScorecardFillsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScorecardFillsQueryKey(jobId,jcId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScorecardFills>>> = ({ signal }) => listScorecardFills(jobId,jcId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScorecardFillsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listScorecardFills>>>
export type ListScorecardFillsSuspenseQueryError = HTTPValidationError


export function useListScorecardFillsSuspense<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params: undefined |  ListScorecardFillsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardFillsSuspense<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScorecardFillsSuspense<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Scorecard Fills
 */

export function useListScorecardFillsSuspense<TData = Awaited<ReturnType<typeof listScorecardFills>>, TError = HTTPValidationError>(
 jobId: string,
    jcId: string,
    params?: ListScorecardFillsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listScorecardFills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScorecardFillsSuspenseQueryOptions(jobId,jcId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScorecardFillUrl = (jobId: string,
    jcId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jcId}/scorecard-fills`
}

/**
 * @summary Create Scorecard Fill
 */
export const createScorecardFill = async (jobId: string,
    jcId: string,
    scorecardFillCreate: ScorecardFillCreate, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardFillOut> => {

  return customInstance<ScorecardFillOut>(getCreateScorecardFillUrl(jobId,jcId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardFillCreate)
  }
);}





export const getCreateScorecardFillMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScorecardFill>>, TError,{jobId: string;jcId: string;data: ScorecardFillCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createScorecardFill>>, TError,{jobId: string;jcId: string;data: ScorecardFillCreate}, TContext> => {

const mutationKey = ['createScorecardFill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScorecardFill>>, {jobId: string;jcId: string;data: ScorecardFillCreate}> = (props) => {
          const {jobId,jcId,data} = props ?? {};

          return  createScorecardFill(jobId,jcId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScorecardFillMutationResult = NonNullable<Awaited<ReturnType<typeof createScorecardFill>>>
    export type CreateScorecardFillMutationBody = ScorecardFillCreate
    export type CreateScorecardFillMutationError = HTTPValidationError

    /**
 * @summary Create Scorecard Fill
 */
export const useCreateScorecardFill = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScorecardFill>>, TError,{jobId: string;jcId: string;data: ScorecardFillCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScorecardFill>>,
        TError,
        {jobId: string;jcId: string;data: ScorecardFillCreate},
        TContext
      > => {
      return useMutation(getCreateScorecardFillMutationOptions(options), queryClient);
    }

export const getUpdateScorecardFillUrl = (jobId: string,
    jcId: string,
    fillId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jcId}/scorecard-fills/${fillId}`
}

/**
 * @summary Update Scorecard Fill
 */
export const updateScorecardFill = async (jobId: string,
    jcId: string,
    fillId: string,
    scorecardFillPatch: ScorecardFillPatch, options?: Parameters<typeof customInstance>[1]): Promise<ScorecardFillOut> => {

  return customInstance<ScorecardFillOut>(getUpdateScorecardFillUrl(jobId,jcId,fillId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scorecardFillPatch)
  }
);}





export const getUpdateScorecardFillMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScorecardFill>>, TError,{jobId: string;jcId: string;fillId: string;data: ScorecardFillPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScorecardFill>>, TError,{jobId: string;jcId: string;fillId: string;data: ScorecardFillPatch}, TContext> => {

const mutationKey = ['updateScorecardFill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScorecardFill>>, {jobId: string;jcId: string;fillId: string;data: ScorecardFillPatch}> = (props) => {
          const {jobId,jcId,fillId,data} = props ?? {};

          return  updateScorecardFill(jobId,jcId,fillId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScorecardFillMutationResult = NonNullable<Awaited<ReturnType<typeof updateScorecardFill>>>
    export type UpdateScorecardFillMutationBody = ScorecardFillPatch
    export type UpdateScorecardFillMutationError = HTTPValidationError

    /**
 * @summary Update Scorecard Fill
 */
export const useUpdateScorecardFill = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScorecardFill>>, TError,{jobId: string;jcId: string;fillId: string;data: ScorecardFillPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScorecardFill>>,
        TError,
        {jobId: string;jcId: string;fillId: string;data: ScorecardFillPatch},
        TContext
      > => {
      return useMutation(getUpdateScorecardFillMutationOptions(options), queryClient);
    }

export const getListAuditActionsUrl = () => {




  return `/api/org/audit/actions`
}

/**
 * @summary List Audit Actions
 */
export const listAuditActions = async ( options?: Parameters<typeof customInstance>[1]): Promise<AuditActionListResponse> => {

  return customInstance<AuditActionListResponse>(getListAuditActionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditActionsQueryKey = () => {
    return [
    `/api/org/audit/actions`
    ] as const;
    }


export const getListAuditActionsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditActionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditActions>>> = ({ signal }) => listAuditActions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditActionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditActions>>>
export type ListAuditActionsQueryError = unknown


export function useListAuditActions<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditActions>>,
          TError,
          Awaited<ReturnType<typeof listAuditActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActions<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditActions>>,
          TError,
          Awaited<ReturnType<typeof listAuditActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActions<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Actions
 */

export function useListAuditActions<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditActionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditActionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditActionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditActions>>> = ({ signal }) => listAuditActions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditActionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditActions>>>
export type ListAuditActionsSuspenseQueryError = unknown


export function useListAuditActionsSuspense<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionsSuspense<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionsSuspense<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Actions
 */

export function useListAuditActionsSuspense<TData = Awaited<ReturnType<typeof listAuditActions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditActionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAuditFilterOptionsUrl = () => {




  return `/api/org/audit/filter-options`
}

/**
 * @summary List Audit Filter Options
 */
export const listAuditFilterOptions = async ( options?: Parameters<typeof customInstance>[1]): Promise<AuditFilterOptionsResponse> => {

  return customInstance<AuditFilterOptionsResponse>(getListAuditFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditFilterOptionsQueryKey = () => {
    return [
    `/api/org/audit/filter-options`
    ] as const;
    }


export const getListAuditFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditFilterOptions>>> = ({ signal }) => listAuditFilterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditFilterOptions>>>
export type ListAuditFilterOptionsQueryError = unknown


export function useListAuditFilterOptions<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof listAuditFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditFilterOptions<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof listAuditFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditFilterOptions<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Filter Options
 */

export function useListAuditFilterOptions<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditFilterOptions>>> = ({ signal }) => listAuditFilterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditFilterOptions>>>
export type ListAuditFilterOptionsSuspenseQueryError = unknown


export function useListAuditFilterOptionsSuspense<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditFilterOptionsSuspense<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditFilterOptionsSuspense<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Filter Options
 */

export function useListAuditFilterOptionsSuspense<TData = Awaited<ReturnType<typeof listAuditFilterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAuditActionSchemasUrl = (action: string,) => {




  return `/api/org/audit/actions/${action}/schemas`
}

/**
 * @summary List Audit Action Schemas
 */
export const listAuditActionSchemas = async (action: string, options?: Parameters<typeof customInstance>[1]): Promise<AuditActionSchemaListResponse> => {

  return customInstance<AuditActionSchemaListResponse>(getListAuditActionSchemasUrl(action),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditActionSchemasQueryKey = (action: string,) => {
    return [
    `/api/org/audit/actions/${action}/schemas`
    ] as const;
    }


export const getListAuditActionSchemasQueryOptions = <TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(action: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditActionSchemasQueryKey(action);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditActionSchemas>>> = ({ signal }) => listAuditActionSchemas(action, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: action !== null && action !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditActionSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditActionSchemas>>>
export type ListAuditActionSchemasQueryError = HTTPValidationError


export function useListAuditActionSchemas<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditActionSchemas>>,
          TError,
          Awaited<ReturnType<typeof listAuditActionSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionSchemas<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditActionSchemas>>,
          TError,
          Awaited<ReturnType<typeof listAuditActionSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionSchemas<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Action Schemas
 */

export function useListAuditActionSchemas<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditActionSchemasQueryOptions(action,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditActionSchemasSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(action: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditActionSchemasQueryKey(action);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditActionSchemas>>> = ({ signal }) => listAuditActionSchemas(action, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditActionSchemasSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditActionSchemas>>>
export type ListAuditActionSchemasSuspenseQueryError = HTTPValidationError


export function useListAuditActionSchemasSuspense<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionSchemasSuspense<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditActionSchemasSuspense<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Action Schemas
 */

export function useListAuditActionSchemasSuspense<TData = Awaited<ReturnType<typeof listAuditActionSchemas>>, TError = HTTPValidationError>(
 action: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditActionSchemas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditActionSchemasSuspenseQueryOptions(action,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAuditEventsUrl = (params?: ListAuditEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["action","severity"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/org/audit/events?${stringifiedParams}` : `/api/org/audit/events`
}

/**
 * @summary List Audit Events
 */
export const listAuditEvents = async (params?: ListAuditEventsParams, options?: Parameters<typeof customInstance>[1]): Promise<AuditEventListResponse> => {

  return customInstance<AuditEventListResponse>(getListAuditEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditEventsQueryKey = (params?: ListAuditEventsParams,) => {
    return [
    `/api/org/audit/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditEventsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(params?: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditEvents>>> = ({ signal }) => listAuditEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditEvents>>>
export type ListAuditEventsQueryError = HTTPValidationError


export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params: undefined |  ListAuditEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof listAuditEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof listAuditEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Events
 */

export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(params?: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditEvents>>> = ({ signal }) => listAuditEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditEvents>>>
export type ListAuditEventsSuspenseQueryError = HTTPValidationError


export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params: undefined |  ListAuditEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit Events
 */

export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HTTPValidationError>(
 params?: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditEventsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAuditConfigurationUrl = () => {




  return `/api/org/audit/configuration`
}

/**
 * @summary Get Audit Configuration
 */
export const getAuditConfiguration = async ( options?: Parameters<typeof customInstance>[1]): Promise<AuditConfigurationResponse> => {

  return customInstance<AuditConfigurationResponse>(getGetAuditConfigurationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuditConfigurationQueryKey = () => {
    return [
    `/api/org/audit/configuration`
    ] as const;
    }


export const getGetAuditConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditConfigurationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditConfiguration>>> = ({ signal }) => getAuditConfiguration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditConfiguration>>>
export type GetAuditConfigurationQueryError = unknown


export function useGetAuditConfiguration<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getAuditConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditConfiguration<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getAuditConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditConfiguration<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Configuration
 */

export function useGetAuditConfiguration<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditConfigurationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuditConfigurationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditConfigurationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditConfiguration>>> = ({ signal }) => getAuditConfiguration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditConfigurationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditConfiguration>>>
export type GetAuditConfigurationSuspenseQueryError = unknown


export function useGetAuditConfigurationSuspense<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditConfigurationSuspense<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditConfigurationSuspense<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Configuration
 */

export function useGetAuditConfigurationSuspense<TData = Awaited<ReturnType<typeof getAuditConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditConfigurationSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAuditRetentionUrl = () => {




  return `/api/org/audit/retention`
}

/**
 * @summary Get Audit Retention
 */
export const getAuditRetention = async ( options?: Parameters<typeof customInstance>[1]): Promise<AuditRetentionResponse> => {

  return customInstance<AuditRetentionResponse>(getGetAuditRetentionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuditRetentionQueryKey = () => {
    return [
    `/api/org/audit/retention`
    ] as const;
    }


export const getGetAuditRetentionQueryOptions = <TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditRetentionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditRetention>>> = ({ signal }) => getAuditRetention({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditRetentionQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditRetention>>>
export type GetAuditRetentionQueryError = unknown


export function useGetAuditRetention<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditRetention>>,
          TError,
          Awaited<ReturnType<typeof getAuditRetention>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditRetention<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditRetention>>,
          TError,
          Awaited<ReturnType<typeof getAuditRetention>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditRetention<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Retention
 */

export function useGetAuditRetention<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditRetentionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuditRetentionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditRetentionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditRetention>>> = ({ signal }) => getAuditRetention({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditRetentionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditRetention>>>
export type GetAuditRetentionSuspenseQueryError = unknown


export function useGetAuditRetentionSuspense<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditRetentionSuspense<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditRetentionSuspense<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Retention
 */

export function useGetAuditRetentionSuspense<TData = Awaited<ReturnType<typeof getAuditRetention>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditRetentionSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAuditRetentionUrl = () => {




  return `/api/org/audit/retention`
}

/**
 * @summary Update Audit Retention
 */
export const updateAuditRetention = async (auditRetentionUpdateRequest: AuditRetentionUpdateRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuditRetentionResponse> => {

  return customInstance<AuditRetentionResponse>(getUpdateAuditRetentionUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(auditRetentionUpdateRequest)
  }
);}





export const getUpdateAuditRetentionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAuditRetention>>, TError,{data: AuditRetentionUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAuditRetention>>, TError,{data: AuditRetentionUpdateRequest}, TContext> => {

const mutationKey = ['updateAuditRetention'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAuditRetention>>, {data: AuditRetentionUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAuditRetention(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAuditRetentionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAuditRetention>>>
    export type UpdateAuditRetentionMutationBody = AuditRetentionUpdateRequest
    export type UpdateAuditRetentionMutationError = HTTPValidationError

    /**
 * @summary Update Audit Retention
 */
export const useUpdateAuditRetention = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAuditRetention>>, TError,{data: AuditRetentionUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAuditRetention>>,
        TError,
        {data: AuditRetentionUpdateRequest},
        TContext
      > => {
      return useMutation(getUpdateAuditRetentionMutationOptions(options), queryClient);
    }

export const getCreateAuditExportUrl = () => {




  return `/api/org/audit/exports`
}

/**
 * @summary Create Audit Export
 */
export const createAuditExport = async (auditExportRequest: AuditExportRequest, options?: Parameters<typeof customInstance>[1]): Promise<AuditExportResponse> => {

  return customInstance<AuditExportResponse>(getCreateAuditExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(auditExportRequest)
  }
);}





export const getCreateAuditExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAuditExport>>, TError,{data: AuditExportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAuditExport>>, TError,{data: AuditExportRequest}, TContext> => {

const mutationKey = ['createAuditExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAuditExport>>, {data: AuditExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAuditExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAuditExportMutationResult = NonNullable<Awaited<ReturnType<typeof createAuditExport>>>
    export type CreateAuditExportMutationBody = AuditExportRequest
    export type CreateAuditExportMutationError = HTTPValidationError

    /**
 * @summary Create Audit Export
 */
export const useCreateAuditExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAuditExport>>, TError,{data: AuditExportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAuditExport>>,
        TError,
        {data: AuditExportRequest},
        TContext
      > => {
      return useMutation(getCreateAuditExportMutationOptions(options), queryClient);
    }

export const getGetAuditExportUrl = (exportId: string,) => {




  return `/api/org/audit/exports/${exportId}`
}

/**
 * @summary Get Audit Export
 */
export const getAuditExport = async (exportId: string, options?: Parameters<typeof customInstance>[1]): Promise<AuditExportResponse> => {

  return customInstance<AuditExportResponse>(getGetAuditExportUrl(exportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuditExportQueryKey = (exportId: string,) => {
    return [
    `/api/org/audit/exports/${exportId}`
    ] as const;
    }


export const getGetAuditExportQueryOptions = <TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditExportQueryKey(exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditExport>>> = ({ signal }) => getAuditExport(exportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: exportId !== null && exportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditExportQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditExport>>>
export type GetAuditExportQueryError = HTTPValidationError


export function useGetAuditExport<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditExport>>,
          TError,
          Awaited<ReturnType<typeof getAuditExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditExport<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditExport>>,
          TError,
          Awaited<ReturnType<typeof getAuditExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditExport<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Export
 */

export function useGetAuditExport<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditExportQueryOptions(exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuditExportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(exportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditExportQueryKey(exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditExport>>> = ({ signal }) => getAuditExport(exportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditExportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditExport>>>
export type GetAuditExportSuspenseQueryError = HTTPValidationError


export function useGetAuditExportSuspense<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditExportSuspense<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditExportSuspense<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Export
 */

export function useGetAuditExportSuspense<TData = Awaited<ReturnType<typeof getAuditExport>>, TError = HTTPValidationError>(
 exportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditExportSuspenseQueryOptions(exportId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrgOutreachSettingsUrl = () => {




  return `/api/org/outreach-settings`
}

/**
 * @summary Get Org Outreach Settings
 */
export const getOrgOutreachSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<OrgOutreachSettingsResponse> => {

  return customInstance<OrgOutreachSettingsResponse>(getGetOrgOutreachSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgOutreachSettingsQueryKey = () => {
    return [
    `/api/org/outreach-settings`
    ] as const;
    }


export const getGetOrgOutreachSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgOutreachSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgOutreachSettings>>> = ({ signal }) => getOrgOutreachSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgOutreachSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgOutreachSettings>>>
export type GetOrgOutreachSettingsQueryError = unknown


export function useGetOrgOutreachSettings<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgOutreachSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgOutreachSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgOutreachSettings<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgOutreachSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgOutreachSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgOutreachSettings<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Outreach Settings
 */

export function useGetOrgOutreachSettings<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgOutreachSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrgOutreachSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgOutreachSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgOutreachSettings>>> = ({ signal }) => getOrgOutreachSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgOutreachSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgOutreachSettings>>>
export type GetOrgOutreachSettingsSuspenseQueryError = unknown


export function useGetOrgOutreachSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgOutreachSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgOutreachSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Outreach Settings
 */

export function useGetOrgOutreachSettingsSuspense<TData = Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrgOutreachSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgOutreachSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrgOutreachSettingsUrl = () => {




  return `/api/org/outreach-settings`
}

/**
 * @summary Update Org Outreach Settings
 */
export const updateOrgOutreachSettings = async (orgOutreachSettingsRequest: OrgOutreachSettingsRequest, options?: Parameters<typeof customInstance>[1]): Promise<OrgOutreachSettingsResponse> => {

  return customInstance<OrgOutreachSettingsResponse>(getUpdateOrgOutreachSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orgOutreachSettingsRequest)
  }
);}





export const getUpdateOrgOutreachSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgOutreachSettings>>, TError,{data: OrgOutreachSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgOutreachSettings>>, TError,{data: OrgOutreachSettingsRequest}, TContext> => {

const mutationKey = ['updateOrgOutreachSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgOutreachSettings>>, {data: OrgOutreachSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateOrgOutreachSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgOutreachSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgOutreachSettings>>>
    export type UpdateOrgOutreachSettingsMutationBody = OrgOutreachSettingsRequest
    export type UpdateOrgOutreachSettingsMutationError = HTTPValidationError

    /**
 * @summary Update Org Outreach Settings
 */
export const useUpdateOrgOutreachSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgOutreachSettings>>, TError,{data: OrgOutreachSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgOutreachSettings>>,
        TError,
        {data: OrgOutreachSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateOrgOutreachSettingsMutationOptions(options), queryClient);
    }

export const getListPipelineUrl = (jobId: string,
    params?: ListPipelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/pipeline?${stringifiedParams}` : `/api/jobs/${jobId}/pipeline`
}

/**
 * Stage + name-search list. Panel filters go through ``POST /query``.
 * @summary List Pipeline
 */
export const listPipeline = async (jobId: string,
    params?: ListPipelineParams, options?: Parameters<typeof customInstance>[1]): Promise<PipelineListResponse> => {

  return customInstance<PipelineListResponse>(getListPipelineUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPipelineQueryKey = (jobId: string,
    params?: ListPipelineParams,) => {
    return [
    `/api/jobs/${jobId}/pipeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPipelineQueryOptions = <TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPipelineQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPipeline>>> = ({ signal }) => listPipeline(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof listPipeline>>>
export type ListPipelineQueryError = HTTPValidationError


export function useListPipeline<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListPipelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipeline>>,
          TError,
          Awaited<ReturnType<typeof listPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPipeline<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipeline>>,
          TError,
          Awaited<ReturnType<typeof listPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPipeline<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Pipeline
 */

export function useListPipeline<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPipelineQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPipelineSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPipelineQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPipeline>>> = ({ signal }) => listPipeline(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPipelineSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPipeline>>>
export type ListPipelineSuspenseQueryError = HTTPValidationError


export function useListPipelineSuspense<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListPipelineParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPipelineSuspense<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPipelineSuspense<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Pipeline
 */

export function useListPipelineSuspense<TData = Awaited<ReturnType<typeof listPipeline>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListPipelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPipelineSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getQueryPipelineUrl = (jobId: string,
    params?: QueryPipelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/pipeline/query?${stringifiedParams}` : `/api/jobs/${jobId}/pipeline/query`
}

/**
 * Filtered pipeline list.
 *
 * A POST rather than more query params because free-text filters are
 * multi-value and may contain commas ("San Francisco, CA"), which Orval's
 * comma-joined array serialisation would corrupt. Read-only: no state is
 * mutated, and the response is identical in shape to ``GET ""`` so both share
 * one frontend type.
 *
 * The toolbar's name search stays a query param so it remains visible in
 * logs/analytics alongside the existing GET.
 * @summary Query Pipeline
 */
export const queryPipeline = async (jobId: string,
    pipelineQueryRequest: PipelineQueryRequest,
    params?: QueryPipelineParams, options?: Parameters<typeof customInstance>[1]): Promise<PipelineListResponse> => {

  return customInstance<PipelineListResponse>(getQueryPipelineUrl(jobId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pipelineQueryRequest)
  }
);}





export const getQueryPipelineMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryPipeline>>, TError,{jobId: string;data: PipelineQueryRequest;params?: QueryPipelineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof queryPipeline>>, TError,{jobId: string;data: PipelineQueryRequest;params?: QueryPipelineParams}, TContext> => {

const mutationKey = ['queryPipeline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryPipeline>>, {jobId: string;data: PipelineQueryRequest;params?: QueryPipelineParams}> = (props) => {
          const {jobId,data,params} = props ?? {};

          return  queryPipeline(jobId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryPipelineMutationResult = NonNullable<Awaited<ReturnType<typeof queryPipeline>>>
    export type QueryPipelineMutationBody = PipelineQueryRequest
    export type QueryPipelineMutationError = HTTPValidationError

    /**
 * @summary Query Pipeline
 */
export const useQueryPipeline = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryPipeline>>, TError,{jobId: string;data: PipelineQueryRequest;params?: QueryPipelineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryPipeline>>,
        TError,
        {jobId: string;data: PipelineQueryRequest;params?: QueryPipelineParams},
        TContext
      > => {
      return useMutation(getQueryPipelineMutationOptions(options), queryClient);
    }

export const getGetPipelineFilterOptionsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/filter-options`
}

/**
 * Selectable filter values for this job's pipeline.
 *
 * Declared before ``GET /{job_candidate_id}`` so "filter-options" is not
 * parsed as a candidate UUID.
 * @summary Get Pipeline Filter Options
 */
export const getPipelineFilterOptions = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<PipelineFilterOptionsResponse> => {

  return customInstance<PipelineFilterOptionsResponse>(getGetPipelineFilterOptionsUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPipelineFilterOptionsQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/pipeline/filter-options`
    ] as const;
    }


export const getGetPipelineFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineFilterOptionsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineFilterOptions>>> = ({ signal }) => getPipelineFilterOptions(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineFilterOptions>>>
export type GetPipelineFilterOptionsQueryError = HTTPValidationError


export function useGetPipelineFilterOptions<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getPipelineFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineFilterOptions<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getPipelineFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineFilterOptions<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pipeline Filter Options
 */

export function useGetPipelineFilterOptions<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineFilterOptionsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPipelineFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineFilterOptionsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineFilterOptions>>> = ({ signal }) => getPipelineFilterOptions(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineFilterOptions>>>
export type GetPipelineFilterOptionsSuspenseQueryError = HTTPValidationError


export function useGetPipelineFilterOptionsSuspense<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineFilterOptionsSuspense<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineFilterOptionsSuspense<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pipeline Filter Options
 */

export function useGetPipelineFilterOptionsSuspense<TData = Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPipelineFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineFilterOptionsSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdvanceCandidateUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/advance`
}

/**
 * @summary Advance Candidate
 */
export const advanceCandidate = async (jobId: string,
    singleCandidateActionRequest: SingleCandidateActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<SingleCandidateActionResponse> => {

  return customInstance<SingleCandidateActionResponse>(getAdvanceCandidateUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(singleCandidateActionRequest)
  }
);}





export const getAdvanceCandidateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof advanceCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext> => {

const mutationKey = ['advanceCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advanceCandidate>>, {jobId: string;data: SingleCandidateActionRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  advanceCandidate(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvanceCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof advanceCandidate>>>
    export type AdvanceCandidateMutationBody = SingleCandidateActionRequest
    export type AdvanceCandidateMutationError = HTTPValidationError

    /**
 * @summary Advance Candidate
 */
export const useAdvanceCandidate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advanceCandidate>>,
        TError,
        {jobId: string;data: SingleCandidateActionRequest},
        TContext
      > => {
      return useMutation(getAdvanceCandidateMutationOptions(options), queryClient);
    }

export const getRejectCandidateUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/reject`
}

/**
 * @summary Reject Candidate
 */
export const rejectCandidate = async (jobId: string,
    singleCandidateActionRequest: SingleCandidateActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<SingleCandidateActionResponse> => {

  return customInstance<SingleCandidateActionResponse>(getRejectCandidateUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(singleCandidateActionRequest)
  }
);}





export const getRejectCandidateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext> => {

const mutationKey = ['rejectCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectCandidate>>, {jobId: string;data: SingleCandidateActionRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  rejectCandidate(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof rejectCandidate>>>
    export type RejectCandidateMutationBody = SingleCandidateActionRequest
    export type RejectCandidateMutationError = HTTPValidationError

    /**
 * @summary Reject Candidate
 */
export const useRejectCandidate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{jobId: string;data: SingleCandidateActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectCandidate>>,
        TError,
        {jobId: string;data: SingleCandidateActionRequest},
        TContext
      > => {
      return useMutation(getRejectCandidateMutationOptions(options), queryClient);
    }

export const getBulkMoveUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/bulk-move`
}

/**
 * @summary Bulk Move
 */
export const bulkMove = async (jobId: string,
    bulkActionRequest: BulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkActionResponse> => {

  return customInstance<BulkActionResponse>(getBulkMoveUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkActionRequest)
  }
);}





export const getBulkMoveMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMove>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMove>>, TError,{jobId: string;data: BulkActionRequest}, TContext> => {

const mutationKey = ['bulkMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMove>>, {jobId: string;data: BulkActionRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  bulkMove(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMoveMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMove>>>
    export type BulkMoveMutationBody = BulkActionRequest
    export type BulkMoveMutationError = HTTPValidationError

    /**
 * @summary Bulk Move
 */
export const useBulkMove = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMove>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMove>>,
        TError,
        {jobId: string;data: BulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkMoveMutationOptions(options), queryClient);
    }

export const getGetBulkMoveJobStatusUrl = (jobId: string,
    bulkMoveJobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/bulk-move-jobs/${bulkMoveJobId}`
}

/**
 * @summary Get Bulk Move Job Status
 */
export const getBulkMoveJobStatus = async (jobId: string,
    bulkMoveJobId: string, options?: Parameters<typeof customInstance>[1]): Promise<BulkMoveJobResponse> => {

  return customInstance<BulkMoveJobResponse>(getGetBulkMoveJobStatusUrl(jobId,bulkMoveJobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBulkMoveJobStatusQueryKey = (jobId: string,
    bulkMoveJobId: string,) => {
    return [
    `/api/jobs/${jobId}/pipeline/bulk-move-jobs/${bulkMoveJobId}`
    ] as const;
    }


export const getGetBulkMoveJobStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkMoveJobStatusQueryKey(jobId,bulkMoveJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkMoveJobStatus>>> = ({ signal }) => getBulkMoveJobStatus(jobId,bulkMoveJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && bulkMoveJobId !== null && bulkMoveJobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkMoveJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkMoveJobStatus>>>
export type GetBulkMoveJobStatusQueryError = HTTPValidationError


export function useGetBulkMoveJobStatus<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkMoveJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getBulkMoveJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkMoveJobStatus<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkMoveJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getBulkMoveJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkMoveJobStatus<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Move Job Status
 */

export function useGetBulkMoveJobStatus<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkMoveJobStatusQueryOptions(jobId,bulkMoveJobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBulkMoveJobStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkMoveJobStatusQueryKey(jobId,bulkMoveJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkMoveJobStatus>>> = ({ signal }) => getBulkMoveJobStatus(jobId,bulkMoveJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkMoveJobStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkMoveJobStatus>>>
export type GetBulkMoveJobStatusSuspenseQueryError = HTTPValidationError


export function useGetBulkMoveJobStatusSuspense<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkMoveJobStatusSuspense<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkMoveJobStatusSuspense<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Move Job Status
 */

export function useGetBulkMoveJobStatusSuspense<TData = Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    bulkMoveJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkMoveJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkMoveJobStatusSuspenseQueryOptions(jobId,bulkMoveJobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSyncJobStatusUrl = (jobId: string,
    syncJobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/sync-jobs/${syncJobId}`
}

/**
 * @summary Get Sync Job Status
 */
export const getSyncJobStatus = async (jobId: string,
    syncJobId: string, options?: Parameters<typeof customInstance>[1]): Promise<SyncJobResponse> => {

  return customInstance<SyncJobResponse>(getGetSyncJobStatusUrl(jobId,syncJobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSyncJobStatusQueryKey = (jobId: string,
    syncJobId: string,) => {
    return [
    `/api/jobs/${jobId}/pipeline/sync-jobs/${syncJobId}`
    ] as const;
    }


export const getGetSyncJobStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(jobId: string,
    syncJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncJobStatusQueryKey(jobId,syncJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncJobStatus>>> = ({ signal }) => getSyncJobStatus(jobId,syncJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && syncJobId !== null && syncJobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSyncJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncJobStatus>>>
export type GetSyncJobStatusQueryError = HTTPValidationError


export function useGetSyncJobStatus<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getSyncJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncJobStatus<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getSyncJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncJobStatus<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sync Job Status
 */

export function useGetSyncJobStatus<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSyncJobStatusQueryOptions(jobId,syncJobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSyncJobStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(jobId: string,
    syncJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncJobStatusQueryKey(jobId,syncJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncJobStatus>>> = ({ signal }) => getSyncJobStatus(jobId,syncJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSyncJobStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncJobStatus>>>
export type GetSyncJobStatusSuspenseQueryError = HTTPValidationError


export function useGetSyncJobStatusSuspense<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncJobStatusSuspense<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncJobStatusSuspense<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sync Job Status
 */

export function useGetSyncJobStatusSuspense<TData = Awaited<ReturnType<typeof getSyncJobStatus>>, TError = HTTPValidationError>(
 jobId: string,
    syncJobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSyncJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSyncJobStatusSuspenseQueryOptions(jobId,syncJobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkArchiveUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/bulk-archive`
}

/**
 * @summary Bulk Archive
 */
export const bulkArchive = async (jobId: string,
    bulkActionRequest: BulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkActionResponse> => {

  return customInstance<BulkActionResponse>(getBulkArchiveUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkActionRequest)
  }
);}





export const getBulkArchiveMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchive>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchive>>, TError,{jobId: string;data: BulkActionRequest}, TContext> => {

const mutationKey = ['bulkArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchive>>, {jobId: string;data: BulkActionRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  bulkArchive(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchive>>>
    export type BulkArchiveMutationBody = BulkActionRequest
    export type BulkArchiveMutationError = HTTPValidationError

    /**
 * @summary Bulk Archive
 */
export const useBulkArchive = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchive>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchive>>,
        TError,
        {jobId: string;data: BulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkArchiveMutationOptions(options), queryClient);
    }

export const getBulkAdvanceUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/bulk-advance`
}

/**
 * @summary Bulk Advance
 */
export const bulkAdvance = async (jobId: string,
    bulkActionRequest: BulkActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkActionResponse> => {

  return customInstance<BulkActionResponse>(getBulkAdvanceUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkActionRequest)
  }
);}





export const getBulkAdvanceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdvance>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAdvance>>, TError,{jobId: string;data: BulkActionRequest}, TContext> => {

const mutationKey = ['bulkAdvance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAdvance>>, {jobId: string;data: BulkActionRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  bulkAdvance(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAdvanceMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAdvance>>>
    export type BulkAdvanceMutationBody = BulkActionRequest
    export type BulkAdvanceMutationError = HTTPValidationError

    /**
 * @summary Bulk Advance
 */
export const useBulkAdvance = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdvance>>, TError,{jobId: string;data: BulkActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkAdvance>>,
        TError,
        {jobId: string;data: BulkActionRequest},
        TContext
      > => {
      return useMutation(getBulkAdvanceMutationOptions(options), queryClient);
    }

export const getAddFromSearchUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/add-from-search`
}

/**
 * @summary Add From Search
 */
export const addFromSearch = async (jobId: string,
    addFromSearchRequest: AddFromSearchRequest, options?: Parameters<typeof customInstance>[1]): Promise<AddFromSearchResponse> => {

  return customInstance<AddFromSearchResponse>(getAddFromSearchUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addFromSearchRequest)
  }
);}





export const getAddFromSearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFromSearch>>, TError,{jobId: string;data: AddFromSearchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addFromSearch>>, TError,{jobId: string;data: AddFromSearchRequest}, TContext> => {

const mutationKey = ['addFromSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFromSearch>>, {jobId: string;data: AddFromSearchRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  addFromSearch(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFromSearchMutationResult = NonNullable<Awaited<ReturnType<typeof addFromSearch>>>
    export type AddFromSearchMutationBody = AddFromSearchRequest
    export type AddFromSearchMutationError = HTTPValidationError

    /**
 * @summary Add From Search
 */
export const useAddFromSearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFromSearch>>, TError,{jobId: string;data: AddFromSearchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFromSearch>>,
        TError,
        {jobId: string;data: AddFromSearchRequest},
        TContext
      > => {
      return useMutation(getAddFromSearchMutationOptions(options), queryClient);
    }

export const getResolveCandidatesUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/resolve-candidates`
}

/**
 * @summary Resolve Candidates
 */
export const resolveCandidates = async (jobId: string,
    resolveCandidatesRequest: ResolveCandidatesRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResolveCandidatesResponse> => {

  return customInstance<ResolveCandidatesResponse>(getResolveCandidatesUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveCandidatesRequest)
  }
);}





export const getResolveCandidatesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveCandidates>>, TError,{jobId: string;data: ResolveCandidatesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveCandidates>>, TError,{jobId: string;data: ResolveCandidatesRequest}, TContext> => {

const mutationKey = ['resolveCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveCandidates>>, {jobId: string;data: ResolveCandidatesRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  resolveCandidates(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof resolveCandidates>>>
    export type ResolveCandidatesMutationBody = ResolveCandidatesRequest
    export type ResolveCandidatesMutationError = HTTPValidationError

    /**
 * @summary Resolve Candidates
 */
export const useResolveCandidates = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveCandidates>>, TError,{jobId: string;data: ResolveCandidatesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveCandidates>>,
        TError,
        {jobId: string;data: ResolveCandidatesRequest},
        TContext
      > => {
      return useMutation(getResolveCandidatesMutationOptions(options), queryClient);
    }

export const getGetCandidateDetailUrl = (jobId: string,
    jobCandidateId: string,) => {




  return `/api/jobs/${jobId}/pipeline/${jobCandidateId}`
}

/**
 * @summary Get Candidate Detail
 */
export const getCandidateDetail = async (jobId: string,
    jobCandidateId: string, options?: Parameters<typeof customInstance>[1]): Promise<GetCandidateDetail200> => {

  return customInstance<GetCandidateDetail200>(getGetCandidateDetailUrl(jobId,jobCandidateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCandidateDetailQueryKey = (jobId: string,
    jobCandidateId: string,) => {
    return [
    `/api/jobs/${jobId}/pipeline/${jobCandidateId}`
    ] as const;
    }


export const getGetCandidateDetailQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateDetailQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateDetail>>> = ({ signal }) => getCandidateDetail(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && jobCandidateId !== null && jobCandidateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateDetail>>>
export type GetCandidateDetailQueryError = HTTPValidationError


export function useGetCandidateDetail<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateDetail>>,
          TError,
          Awaited<ReturnType<typeof getCandidateDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateDetail<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateDetail>>,
          TError,
          Awaited<ReturnType<typeof getCandidateDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateDetail<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Candidate Detail
 */

export function useGetCandidateDetail<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateDetailQueryOptions(jobId,jobCandidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCandidateDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateDetailQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateDetail>>> = ({ signal }) => getCandidateDetail(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateDetail>>>
export type GetCandidateDetailSuspenseQueryError = HTTPValidationError


export function useGetCandidateDetailSuspense<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateDetailSuspense<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateDetailSuspense<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Candidate Detail
 */

export function useGetCandidateDetailSuspense<TData = Awaited<ReturnType<typeof getCandidateDetail>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateDetailSuspenseQueryOptions(jobId,jobCandidateId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCandidateResumeUrlUrl = (jobId: string,
    jobCandidateId: string,) => {




  return `/api/jobs/${jobId}/pipeline/${jobCandidateId}/resume-url`
}

/**
 * Return a short-lived presigned URL for the candidate's uploaded resume.
 *
 * Only available for candidates that were added via Profile Import (the
 * file lives in S3 under the org's `documents/` prefix). Resume objects
 * are uploaded privately — this endpoint is the ONLY way the UI can
 * access them.
 * @summary Get Candidate Resume Url
 */
export const getCandidateResumeUrl = async (jobId: string,
    jobCandidateId: string, options?: Parameters<typeof customInstance>[1]): Promise<ResumeUrlResponse> => {

  return customInstance<ResumeUrlResponse>(getGetCandidateResumeUrlUrl(jobId,jobCandidateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCandidateResumeUrlQueryKey = (jobId: string,
    jobCandidateId: string,) => {
    return [
    `/api/jobs/${jobId}/pipeline/${jobCandidateId}/resume-url`
    ] as const;
    }


export const getGetCandidateResumeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateResumeUrlQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateResumeUrl>>> = ({ signal }) => getCandidateResumeUrl(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && jobCandidateId !== null && jobCandidateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateResumeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateResumeUrl>>>
export type GetCandidateResumeUrlQueryError = HTTPValidationError


export function useGetCandidateResumeUrl<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateResumeUrl>>,
          TError,
          Awaited<ReturnType<typeof getCandidateResumeUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateResumeUrl<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateResumeUrl>>,
          TError,
          Awaited<ReturnType<typeof getCandidateResumeUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateResumeUrl<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Candidate Resume Url
 */

export function useGetCandidateResumeUrl<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateResumeUrlQueryOptions(jobId,jobCandidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCandidateResumeUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateResumeUrlQueryKey(jobId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateResumeUrl>>> = ({ signal }) => getCandidateResumeUrl(jobId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateResumeUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateResumeUrl>>>
export type GetCandidateResumeUrlSuspenseQueryError = HTTPValidationError


export function useGetCandidateResumeUrlSuspense<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateResumeUrlSuspense<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateResumeUrlSuspense<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Candidate Resume Url
 */

export function useGetCandidateResumeUrlSuspense<TData = Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError = HTTPValidationError>(
 jobId: string,
    jobCandidateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCandidateResumeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateResumeUrlSuspenseQueryOptions(jobId,jobCandidateId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncPreflightUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/sync/preflight`
}

/**
 * Bucket a set of candidates for sync enrollment and return cost + balance.
 *
 * 409s when the job has no active, sync-enabled ATS link — sync only applies
 * to ATS-linked jobs. Candidates already in Sourced (local-only), already
 * synced, or with a sync in flight are surfaced as ``ineligible`` with a
 * reason; HARD_BLOCKED classification is surfaced as ``hard_blocked``; the
 * rest are ``syncable`` (NEEDS_REVEAL syncs with a placeholder unless the
 * caller opts into enrichment). Candidates that don't belong to ``job_id``
 * are silently skipped (defensive; the frontend never sends cross-job ids).
 * @summary Sync Preflight
 */
export const syncPreflight = async (jobId: string,
    syncPreflightRequest: SyncPreflightRequest, options?: Parameters<typeof customInstance>[1]): Promise<SyncPreflightResponse> => {

  return customInstance<SyncPreflightResponse>(getSyncPreflightUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncPreflightRequest)
  }
);}





export const getSyncPreflightMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPreflight>>, TError,{jobId: string;data: SyncPreflightRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof syncPreflight>>, TError,{jobId: string;data: SyncPreflightRequest}, TContext> => {

const mutationKey = ['syncPreflight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncPreflight>>, {jobId: string;data: SyncPreflightRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  syncPreflight(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncPreflightMutationResult = NonNullable<Awaited<ReturnType<typeof syncPreflight>>>
    export type SyncPreflightMutationBody = SyncPreflightRequest
    export type SyncPreflightMutationError = HTTPValidationError

    /**
 * @summary Sync Preflight
 */
export const useSyncPreflight = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPreflight>>, TError,{jobId: string;data: SyncPreflightRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncPreflight>>,
        TError,
        {jobId: string;data: SyncPreflightRequest},
        TContext
      > => {
      return useMutation(getSyncPreflightMutationOptions(options), queryClient);
    }

export const getSyncUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/pipeline/sync`
}

/**
 * Accept an async ATS sync job: persist ``SyncJob`` + start parent workflow.
 *
 * Mutating + credit-charging, so this requires EDIT (not just VIEW) project
 * permission. 409s when the job has no active, sync-enabled ATS link.
 *
 * Affordability is checked for the *whole* batch up front: worst case assumes
 * every syncable-state candidate both enriches (when flagged) and syncs — if
 * the org can't cover it, the entire request 402s before any SyncJob insert.
 * Per-candidate enroll / charge / Temporal create pushes run in
 * ``SyncPushWorkflow``, not on this request thread.
 *
 * Candidates that don't belong to ``job_id`` are silently skipped (defensive;
 * the frontend never sends cross-job ids). Zero in-scope items → 422.
 * @summary Sync
 */
export const sync = async (jobId: string,
    syncRequest: SyncRequest, options?: Parameters<typeof customInstance>[1]): Promise<SyncResponse> => {

  return customInstance<SyncResponse>(getSyncUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncRequest)
  }
);}





export const getSyncMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,{jobId: string;data: SyncRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,{jobId: string;data: SyncRequest}, TContext> => {

const mutationKey = ['sync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sync>>, {jobId: string;data: SyncRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  sync(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncMutationResult = NonNullable<Awaited<ReturnType<typeof sync>>>
    export type SyncMutationBody = SyncRequest
    export type SyncMutationError = HTTPValidationError

    /**
 * @summary Sync
 */
export const useSync = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,{jobId: string;data: SyncRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sync>>,
        TError,
        {jobId: string;data: SyncRequest},
        TContext
      > => {
      return useMutation(getSyncMutationOptions(options), queryClient);
    }

export const getStreamPipelineEventsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/events`
}

/**
 * @summary Stream Pipeline Events
 */
export const streamPipelineEvents = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getStreamPipelineEventsUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamPipelineEventsQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/events`
    ] as const;
    }


export const getStreamPipelineEventsQueryOptions = <TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamPipelineEventsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamPipelineEvents>>> = ({ signal }) => streamPipelineEvents(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamPipelineEventsQueryResult = NonNullable<Awaited<ReturnType<typeof streamPipelineEvents>>>
export type StreamPipelineEventsQueryError = HTTPValidationError


export function useStreamPipelineEvents<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamPipelineEvents>>,
          TError,
          Awaited<ReturnType<typeof streamPipelineEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamPipelineEvents<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamPipelineEvents>>,
          TError,
          Awaited<ReturnType<typeof streamPipelineEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamPipelineEvents<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Pipeline Events
 */

export function useStreamPipelineEvents<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamPipelineEventsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStreamPipelineEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamPipelineEventsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamPipelineEvents>>> = ({ signal }) => streamPipelineEvents(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamPipelineEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof streamPipelineEvents>>>
export type StreamPipelineEventsSuspenseQueryError = HTTPValidationError


export function useStreamPipelineEventsSuspense<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamPipelineEventsSuspense<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamPipelineEventsSuspense<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Pipeline Events
 */

export function useStreamPipelineEventsSuspense<TData = Awaited<ReturnType<typeof streamPipelineEvents>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamPipelineEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamPipelineEventsSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getChangePrimaryEmailUrl = (jobId: string,
    jcId: string,) => {




  return `/api/jobs/${jobId}/candidates/${jcId}/ats/primary-email`
}

/**
 * Change which email is primary for an already-promoted candidate and
 * push a real ``update_candidate`` write to the ATS.
 *
 * This does NOT charge a new export credit — the candidate was already
 * promoted (that push carried the export charge). ``body.email`` is honored
 * only when it's one of the candidate's real email options
 * (``resolve_promotion_email``); ``None`` re-runs the waterfall auto-pick.
 *
 * Preconditions: the job has an active, sync-enabled ATS link, the candidate
 * belongs to the job, it already has an ``application`` link upstream (409
 * ``CANDIDATE_NOT_PROMOTED`` otherwise — use ``/sync`` first), and it has
 * a ``candidate`` link upstream (409 ``CANDIDATE_UPDATE_UNAVAILABLE``
 * otherwise — a legacy candidate promoted before per-candidate links were
 * persisted, whose ``update_candidate`` push would otherwise terminally fail
 * for want of a remote candidate id; re-sync it instead).
 *
 * Pushes ``action="update_candidate"`` — never ``create_application`` — so
 * this can never mint a duplicate candidate upstream (that was the bug this
 * endpoint used to have). The workflow id folds a short hash of the target
 * email so a double-click on the *same* new email joins the in-flight
 * workflow, while changing to a *different* email starts a fresh one.
 * @summary Change Primary Email
 */
export const changePrimaryEmail = async (jobId: string,
    jcId: string,
    changePrimaryEmailRequest: ChangePrimaryEmailRequest, options?: Parameters<typeof customInstance>[1]): Promise<PromoteResultView> => {

  return customInstance<PromoteResultView>(getChangePrimaryEmailUrl(jobId,jcId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePrimaryEmailRequest)
  }
);}





export const getChangePrimaryEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePrimaryEmail>>, TError,{jobId: string;jcId: string;data: ChangePrimaryEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePrimaryEmail>>, TError,{jobId: string;jcId: string;data: ChangePrimaryEmailRequest}, TContext> => {

const mutationKey = ['changePrimaryEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePrimaryEmail>>, {jobId: string;jcId: string;data: ChangePrimaryEmailRequest}> = (props) => {
          const {jobId,jcId,data} = props ?? {};

          return  changePrimaryEmail(jobId,jcId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePrimaryEmailMutationResult = NonNullable<Awaited<ReturnType<typeof changePrimaryEmail>>>
    export type ChangePrimaryEmailMutationBody = ChangePrimaryEmailRequest
    export type ChangePrimaryEmailMutationError = HTTPValidationError

    /**
 * @summary Change Primary Email
 */
export const useChangePrimaryEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePrimaryEmail>>, TError,{jobId: string;jcId: string;data: ChangePrimaryEmailRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePrimaryEmail>>,
        TError,
        {jobId: string;jcId: string;data: ChangePrimaryEmailRequest},
        TContext
      > => {
      return useMutation(getChangePrimaryEmailMutationOptions(options), queryClient);
    }

export const getListPresetsUrl = (params?: ListPresetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/presets?${stringifiedParams}` : `/api/presets`
}

/**
 * @summary List Presets
 */
export const listPresets = async (params?: ListPresetsParams, options?: Parameters<typeof customInstance>[1]): Promise<PresetListResponse> => {

  return customInstance<PresetListResponse>(getListPresetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPresetsQueryKey = (params?: ListPresetsParams,) => {
    return [
    `/api/presets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(params?: ListPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPresetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPresets>>> = ({ signal }) => listPresets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listPresets>>>
export type ListPresetsQueryError = HTTPValidationError


export function useListPresets<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params: undefined |  ListPresetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPresets>>,
          TError,
          Awaited<ReturnType<typeof listPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPresets<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPresets>>,
          TError,
          Awaited<ReturnType<typeof listPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPresets<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Presets
 */

export function useListPresets<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPresetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPresetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(params?: ListPresetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPresetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPresets>>> = ({ signal }) => listPresets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPresetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPresets>>>
export type ListPresetsSuspenseQueryError = HTTPValidationError


export function useListPresetsSuspense<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params: undefined |  ListPresetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPresetsSuspense<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPresetsSuspense<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Presets
 */

export function useListPresetsSuspense<TData = Awaited<ReturnType<typeof listPresets>>, TError = HTTPValidationError>(
 params?: ListPresetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPresetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePresetUrl = () => {




  return `/api/presets`
}

/**
 * @summary Create Preset
 */
export const createPreset = async (presetCreate: PresetCreate, options?: Parameters<typeof customInstance>[1]): Promise<PresetResponse> => {

  return customInstance<PresetResponse>(getCreatePresetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presetCreate)
  }
);}





export const getCreatePresetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreset>>, TError,{data: PresetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPreset>>, TError,{data: PresetCreate}, TContext> => {

const mutationKey = ['createPreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPreset>>, {data: PresetCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPreset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePresetMutationResult = NonNullable<Awaited<ReturnType<typeof createPreset>>>
    export type CreatePresetMutationBody = PresetCreate
    export type CreatePresetMutationError = HTTPValidationError

    /**
 * @summary Create Preset
 */
export const useCreatePreset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreset>>, TError,{data: PresetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPreset>>,
        TError,
        {data: PresetCreate},
        TContext
      > => {
      return useMutation(getCreatePresetMutationOptions(options), queryClient);
    }

export const getBulkMatchNamesUrl = () => {




  return `/api/presets/bulk-match`
}

/**
 * Match a list of names against the org's default pools' autocomplete to find real entities.
 * @summary Bulk Match Names
 */
export const bulkMatchNames = async (bulkMatchRequest: BulkMatchRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkMatchResponse> => {

  return customInstance<BulkMatchResponse>(getBulkMatchNamesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkMatchRequest)
  }
);}





export const getBulkMatchNamesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMatchNames>>, TError,{data: BulkMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMatchNames>>, TError,{data: BulkMatchRequest}, TContext> => {

const mutationKey = ['bulkMatchNames'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMatchNames>>, {data: BulkMatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  bulkMatchNames(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMatchNamesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMatchNames>>>
    export type BulkMatchNamesMutationBody = BulkMatchRequest
    export type BulkMatchNamesMutationError = HTTPValidationError

    /**
 * @summary Bulk Match Names
 */
export const useBulkMatchNames = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMatchNames>>, TError,{data: BulkMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkMatchNames>>,
        TError,
        {data: BulkMatchRequest},
        TContext
      > => {
      return useMutation(getBulkMatchNamesMutationOptions(options), queryClient);
    }

export const getGetPresetUrl = (presetId: string,) => {




  return `/api/presets/${presetId}`
}

/**
 * @summary Get Preset
 */
export const getPreset = async (presetId: string, options?: Parameters<typeof customInstance>[1]): Promise<PresetResponse> => {

  return customInstance<PresetResponse>(getGetPresetUrl(presetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPresetQueryKey = (presetId: string,) => {
    return [
    `/api/presets/${presetId}`
    ] as const;
    }


export const getGetPresetQueryOptions = <TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPresetQueryKey(presetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreset>>> = ({ signal }) => getPreset(presetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: presetId !== null && presetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPresetQueryResult = NonNullable<Awaited<ReturnType<typeof getPreset>>>
export type GetPresetQueryError = HTTPValidationError


export function useGetPreset<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreset>>,
          TError,
          Awaited<ReturnType<typeof getPreset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreset<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreset>>,
          TError,
          Awaited<ReturnType<typeof getPreset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreset<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preset
 */

export function useGetPreset<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPresetQueryOptions(presetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPresetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(presetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPresetQueryKey(presetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreset>>> = ({ signal }) => getPreset(presetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPresetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPreset>>>
export type GetPresetSuspenseQueryError = HTTPValidationError


export function useGetPresetSuspense<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPresetSuspense<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPresetSuspense<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preset
 */

export function useGetPresetSuspense<TData = Awaited<ReturnType<typeof getPreset>>, TError = HTTPValidationError>(
 presetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPresetSuspenseQueryOptions(presetId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePresetUrl = (presetId: string,) => {




  return `/api/presets/${presetId}`
}

/**
 * @summary Update Preset
 */
export const updatePreset = async (presetId: string,
    presetUpdate: PresetUpdate, options?: Parameters<typeof customInstance>[1]): Promise<PresetResponse> => {

  return customInstance<PresetResponse>(getUpdatePresetUrl(presetId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presetUpdate)
  }
);}





export const getUpdatePresetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreset>>, TError,{presetId: string;data: PresetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreset>>, TError,{presetId: string;data: PresetUpdate}, TContext> => {

const mutationKey = ['updatePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreset>>, {presetId: string;data: PresetUpdate}> = (props) => {
          const {presetId,data} = props ?? {};

          return  updatePreset(presetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePresetMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreset>>>
    export type UpdatePresetMutationBody = PresetUpdate
    export type UpdatePresetMutationError = HTTPValidationError

    /**
 * @summary Update Preset
 */
export const useUpdatePreset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreset>>, TError,{presetId: string;data: PresetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePreset>>,
        TError,
        {presetId: string;data: PresetUpdate},
        TContext
      > => {
      return useMutation(getUpdatePresetMutationOptions(options), queryClient);
    }

export const getDeletePresetUrl = (presetId: string,) => {




  return `/api/presets/${presetId}`
}

/**
 * @summary Delete Preset
 */
export const deletePreset = async (presetId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeletePresetUrl(presetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePresetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePreset>>, TError,{presetId: string}, TContext> => {

const mutationKey = ['deletePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePreset>>, {presetId: string}> = (props) => {
          const {presetId} = props ?? {};

          return  deletePreset(presetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePresetMutationResult = NonNullable<Awaited<ReturnType<typeof deletePreset>>>

    export type DeletePresetMutationError = HTTPValidationError

    /**
 * @summary Delete Preset
 */
export const useDeletePreset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePreset>>,
        TError,
        {presetId: string},
        TContext
      > => {
      return useMutation(getDeletePresetMutationOptions(options), queryClient);
    }

export const getAppendPresetItemsUrl = (presetId: string,) => {




  return `/api/presets/${presetId}/items`
}

/**
 * @summary Append Preset Items
 */
export const appendPresetItems = async (presetId: string,
    presetAppendItemsRequest: PresetAppendItemsRequest, options?: Parameters<typeof customInstance>[1]): Promise<PresetAppendItemsResponse> => {

  return customInstance<PresetAppendItemsResponse>(getAppendPresetItemsUrl(presetId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presetAppendItemsRequest)
  }
);}





export const getAppendPresetItemsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendPresetItems>>, TError,{presetId: string;data: PresetAppendItemsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof appendPresetItems>>, TError,{presetId: string;data: PresetAppendItemsRequest}, TContext> => {

const mutationKey = ['appendPresetItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appendPresetItems>>, {presetId: string;data: PresetAppendItemsRequest}> = (props) => {
          const {presetId,data} = props ?? {};

          return  appendPresetItems(presetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppendPresetItemsMutationResult = NonNullable<Awaited<ReturnType<typeof appendPresetItems>>>
    export type AppendPresetItemsMutationBody = PresetAppendItemsRequest
    export type AppendPresetItemsMutationError = HTTPValidationError

    /**
 * @summary Append Preset Items
 */
export const useAppendPresetItems = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendPresetItems>>, TError,{presetId: string;data: PresetAppendItemsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appendPresetItems>>,
        TError,
        {presetId: string;data: PresetAppendItemsRequest},
        TContext
      > => {
      return useMutation(getAppendPresetItemsMutationOptions(options), queryClient);
    }

export const getCreateImportsUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/imports`
}

/**
 * @summary Create Imports
 */
export const createImports = async (jobId: string,
    bodyCreateImportsApiJobsJobIdImportsPost: BodyCreateImportsApiJobsJobIdImportsPost, options?: Parameters<typeof customInstance>[1]): Promise<ProfileImportCreateResponse> => {
    const formData = new FormData();
formData.append(`stage_id`, bodyCreateImportsApiJobsJobIdImportsPost.stage_id);
bodyCreateImportsApiJobsJobIdImportsPost.files.forEach(value => formData.append(`files`, value));

  return customInstance<ProfileImportCreateResponse>(getCreateImportsUrl(jobId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCreateImportsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImports>>, TError,{jobId: string;data: BodyCreateImportsApiJobsJobIdImportsPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createImports>>, TError,{jobId: string;data: BodyCreateImportsApiJobsJobIdImportsPost}, TContext> => {

const mutationKey = ['createImports'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImports>>, {jobId: string;data: BodyCreateImportsApiJobsJobIdImportsPost}> = (props) => {
          const {jobId,data} = props ?? {};

          return  createImports(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImportsMutationResult = NonNullable<Awaited<ReturnType<typeof createImports>>>
    export type CreateImportsMutationBody = BodyCreateImportsApiJobsJobIdImportsPost
    export type CreateImportsMutationError = HTTPValidationError

    /**
 * @summary Create Imports
 */
export const useCreateImports = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImports>>, TError,{jobId: string;data: BodyCreateImportsApiJobsJobIdImportsPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImports>>,
        TError,
        {jobId: string;data: BodyCreateImportsApiJobsJobIdImportsPost},
        TContext
      > => {
      return useMutation(getCreateImportsMutationOptions(options), queryClient);
    }

export const getListImportsUrl = (jobId: string,
    params?: ListImportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status","source_type"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/imports?${stringifiedParams}` : `/api/jobs/${jobId}/imports`
}

/**
 * @summary List Imports
 */
export const listImports = async (jobId: string,
    params?: ListImportsParams, options?: Parameters<typeof customInstance>[1]): Promise<ProfileImportListResponse> => {

  return customInstance<ProfileImportListResponse>(getListImportsUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImportsQueryKey = (jobId: string,
    params?: ListImportsParams,) => {
    return [
    `/api/jobs/${jobId}/imports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListImportsQueryOptions = <TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImports>>> = ({ signal }) => listImports(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImportsQueryResult = NonNullable<Awaited<ReturnType<typeof listImports>>>
export type ListImportsQueryError = HTTPValidationError


export function useListImports<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListImportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImports>>,
          TError,
          Awaited<ReturnType<typeof listImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImports<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImports>>,
          TError,
          Awaited<ReturnType<typeof listImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImports<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Imports
 */

export function useListImports<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImportsQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListImportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImports>>> = ({ signal }) => listImports(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listImports>>>
export type ListImportsSuspenseQueryError = HTTPValidationError


export function useListImportsSuspense<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListImportsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImportsSuspense<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImportsSuspense<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Imports
 */

export function useListImportsSuspense<TData = Awaited<ReturnType<typeof listImports>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listImports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImportsSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProgressUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/imports/progress`
}

/**
 * @summary Get Progress
 */
export const getProgress = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProfileImportProgressResponse> => {

  return customInstance<ProfileImportProgressResponse>(getGetProgressUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProgressQueryKey = (jobId: string,) => {
    return [
    `/api/jobs/${jobId}/imports/progress`
    ] as const;
    }


export const getGetProgressQueryOptions = <TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgressQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgress>>> = ({ signal }) => getProgress(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getProgress>>>
export type GetProgressQueryError = HTTPValidationError


export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgress>>,
          TError,
          Awaited<ReturnType<typeof getProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgress>>,
          TError,
          Awaited<ReturnType<typeof getProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Progress
 */

export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProgressQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgressQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgress>>> = ({ signal }) => getProgress(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProgress>>>
export type GetProgressSuspenseQueryError = HTTPValidationError


export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Progress
 */

export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProgressSuspenseQueryOptions(jobId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryImportUrl = (jobId: string,
    importId: string,) => {




  return `/api/jobs/${jobId}/imports/${importId}/retry`
}

/**
 * @summary Retry Import
 */
export const retryImport = async (jobId: string,
    importId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProfileImportActionResponse> => {

  return customInstance<ProfileImportActionResponse>(getRetryImportUrl(jobId,importId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryImportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryImport>>, TError,{jobId: string;importId: string}, TContext> => {

const mutationKey = ['retryImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryImport>>, {jobId: string;importId: string}> = (props) => {
          const {jobId,importId} = props ?? {};

          return  retryImport(jobId,importId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryImportMutationResult = NonNullable<Awaited<ReturnType<typeof retryImport>>>

    export type RetryImportMutationError = HTTPValidationError

    /**
 * @summary Retry Import
 */
export const useRetryImport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryImport>>,
        TError,
        {jobId: string;importId: string},
        TContext
      > => {
      return useMutation(getRetryImportMutationOptions(options), queryClient);
    }

export const getCancelImportUrl = (jobId: string,
    importId: string,) => {




  return `/api/jobs/${jobId}/imports/${importId}/cancel`
}

/**
 * @summary Cancel Import
 */
export const cancelImport = async (jobId: string,
    importId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProfileImportActionResponse> => {

  return customInstance<ProfileImportActionResponse>(getCancelImportUrl(jobId,importId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelImportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelImport>>, TError,{jobId: string;importId: string}, TContext> => {

const mutationKey = ['cancelImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelImport>>, {jobId: string;importId: string}> = (props) => {
          const {jobId,importId} = props ?? {};

          return  cancelImport(jobId,importId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelImportMutationResult = NonNullable<Awaited<ReturnType<typeof cancelImport>>>

    export type CancelImportMutationError = HTTPValidationError

    /**
 * @summary Cancel Import
 */
export const useCancelImport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelImport>>,
        TError,
        {jobId: string;importId: string},
        TContext
      > => {
      return useMutation(getCancelImportMutationOptions(options), queryClient);
    }

export const getDeleteAllFailedUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/imports/failed`
}

/**
 * Bulk-delete every `failed` profile import for this job.
 *
 * Defined BEFORE the `/{import_id}` route so FastAPI's router doesn't
 * try to parse the literal "failed" as a UUID.
 * @summary Delete All Failed
 */
export const deleteAllFailed = async (jobId: string, options?: Parameters<typeof customInstance>[1]): Promise<DeleteAllFailed200> => {

  return customInstance<DeleteAllFailed200>(getDeleteAllFailedUrl(jobId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAllFailedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllFailed>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAllFailed>>, TError,{jobId: string}, TContext> => {

const mutationKey = ['deleteAllFailed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAllFailed>>, {jobId: string}> = (props) => {
          const {jobId} = props ?? {};

          return  deleteAllFailed(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAllFailedMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAllFailed>>>

    export type DeleteAllFailedMutationError = HTTPValidationError

    /**
 * @summary Delete All Failed
 */
export const useDeleteAllFailed = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllFailed>>, TError,{jobId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAllFailed>>,
        TError,
        {jobId: string},
        TContext
      > => {
      return useMutation(getDeleteAllFailedMutationOptions(options), queryClient);
    }

export const getDeleteImportUrl = (jobId: string,
    importId: string,) => {




  return `/api/jobs/${jobId}/imports/${importId}`
}

/**
 * @summary Delete Import
 */
export const deleteImport = async (jobId: string,
    importId: string, options?: Parameters<typeof customInstance>[1]): Promise<DeleteImport200> => {

  return customInstance<DeleteImport200>(getDeleteImportUrl(jobId,importId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteImportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImport>>, TError,{jobId: string;importId: string}, TContext> => {

const mutationKey = ['deleteImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImport>>, {jobId: string;importId: string}> = (props) => {
          const {jobId,importId} = props ?? {};

          return  deleteImport(jobId,importId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteImportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImport>>>

    export type DeleteImportMutationError = HTTPValidationError

    /**
 * @summary Delete Import
 */
export const useDeleteImport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImport>>, TError,{jobId: string;importId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImport>>,
        TError,
        {jobId: string;importId: string},
        TContext
      > => {
      return useMutation(getDeleteImportMutationOptions(options), queryClient);
    }

export const getListProjectProfileNotesUrl = (projectId: string,
    profileId: string,) => {




  return `/api/projects/${projectId}/profiles/${profileId}/notes`
}

/**
 * @summary List Project Profile Notes
 */
export const listProjectProfileNotes = async (projectId: string,
    profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteListResponse> => {

  return customInstance<ProfileNoteListResponse>(getListProjectProfileNotesUrl(projectId,profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectProfileNotesQueryKey = (projectId: string,
    profileId: string,) => {
    return [
    `/api/projects/${projectId}/profiles/${profileId}/notes`
    ] as const;
    }


export const getListProjectProfileNotesQueryOptions = <TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(projectId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectProfileNotesQueryKey(projectId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectProfileNotes>>> = ({ signal }) => listProjectProfileNotes(projectId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectProfileNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectProfileNotes>>>
export type ListProjectProfileNotesQueryError = HTTPValidationError


export function useListProjectProfileNotes<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProfileNotes>>,
          TError,
          Awaited<ReturnType<typeof listProjectProfileNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProfileNotes<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProfileNotes>>,
          TError,
          Awaited<ReturnType<typeof listProjectProfileNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProfileNotes<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Profile Notes
 */

export function useListProjectProfileNotes<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectProfileNotesQueryOptions(projectId,profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectProfileNotesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(projectId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectProfileNotesQueryKey(projectId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectProfileNotes>>> = ({ signal }) => listProjectProfileNotes(projectId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectProfileNotesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectProfileNotes>>>
export type ListProjectProfileNotesSuspenseQueryError = HTTPValidationError


export function useListProjectProfileNotesSuspense<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProfileNotesSuspense<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProfileNotesSuspense<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Profile Notes
 */

export function useListProjectProfileNotesSuspense<TData = Awaited<ReturnType<typeof listProjectProfileNotes>>, TError = HTTPValidationError>(
 projectId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectProfileNotesSuspenseQueryOptions(projectId,profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProjectProfileNoteUrl = (projectId: string,
    profileId: string,) => {




  return `/api/projects/${projectId}/profiles/${profileId}/notes`
}

/**
 * @summary Create Project Profile Note
 */
export const createProjectProfileNote = async (projectId: string,
    profileId: string,
    profileNoteCreate: ProfileNoteCreate, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteResponse> => {

  return customInstance<ProfileNoteResponse>(getCreateProjectProfileNoteUrl(projectId,profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileNoteCreate)
  }
);}





export const getCreateProjectProfileNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectProfileNote>>, TError,{projectId: string;profileId: string;data: ProfileNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectProfileNote>>, TError,{projectId: string;profileId: string;data: ProfileNoteCreate}, TContext> => {

const mutationKey = ['createProjectProfileNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectProfileNote>>, {projectId: string;profileId: string;data: ProfileNoteCreate}> = (props) => {
          const {projectId,profileId,data} = props ?? {};

          return  createProjectProfileNote(projectId,profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectProfileNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectProfileNote>>>
    export type CreateProjectProfileNoteMutationBody = ProfileNoteCreate
    export type CreateProjectProfileNoteMutationError = HTTPValidationError

    /**
 * @summary Create Project Profile Note
 */
export const useCreateProjectProfileNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectProfileNote>>, TError,{projectId: string;profileId: string;data: ProfileNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectProfileNote>>,
        TError,
        {projectId: string;profileId: string;data: ProfileNoteCreate},
        TContext
      > => {
      return useMutation(getCreateProjectProfileNoteMutationOptions(options), queryClient);
    }

export const getListJobProfileNotesUrl = (jobId: string,
    profileId: string,) => {




  return `/api/jobs/${jobId}/profiles/${profileId}/notes`
}

/**
 * @summary List Job Profile Notes
 */
export const listJobProfileNotes = async (jobId: string,
    profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<JobProfileNoteListResponse> => {

  return customInstance<JobProfileNoteListResponse>(getListJobProfileNotesUrl(jobId,profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobProfileNotesQueryKey = (jobId: string,
    profileId: string,) => {
    return [
    `/api/jobs/${jobId}/profiles/${profileId}/notes`
    ] as const;
    }


export const getListJobProfileNotesQueryOptions = <TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(jobId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobProfileNotesQueryKey(jobId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobProfileNotes>>> = ({ signal }) => listJobProfileNotes(jobId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobProfileNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobProfileNotes>>>
export type ListJobProfileNotesQueryError = HTTPValidationError


export function useListJobProfileNotes<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobProfileNotes>>,
          TError,
          Awaited<ReturnType<typeof listJobProfileNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobProfileNotes<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobProfileNotes>>,
          TError,
          Awaited<ReturnType<typeof listJobProfileNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobProfileNotes<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Profile Notes
 */

export function useListJobProfileNotes<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobProfileNotesQueryOptions(jobId,profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListJobProfileNotesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(jobId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobProfileNotesQueryKey(jobId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobProfileNotes>>> = ({ signal }) => listJobProfileNotes(jobId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobProfileNotesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listJobProfileNotes>>>
export type ListJobProfileNotesSuspenseQueryError = HTTPValidationError


export function useListJobProfileNotesSuspense<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobProfileNotesSuspense<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobProfileNotesSuspense<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Profile Notes
 */

export function useListJobProfileNotesSuspense<TData = Awaited<ReturnType<typeof listJobProfileNotes>>, TError = HTTPValidationError>(
 jobId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listJobProfileNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobProfileNotesSuspenseQueryOptions(jobId,profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateJobProfileNoteUrl = (jobId: string,
    profileId: string,) => {




  return `/api/jobs/${jobId}/profiles/${profileId}/notes`
}

/**
 * @summary Create Job Profile Note
 */
export const createJobProfileNote = async (jobId: string,
    profileId: string,
    profileNoteCreate: ProfileNoteCreate, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteResponse> => {

  return customInstance<ProfileNoteResponse>(getCreateJobProfileNoteUrl(jobId,profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileNoteCreate)
  }
);}





export const getCreateJobProfileNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobProfileNote>>, TError,{jobId: string;profileId: string;data: ProfileNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobProfileNote>>, TError,{jobId: string;profileId: string;data: ProfileNoteCreate}, TContext> => {

const mutationKey = ['createJobProfileNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobProfileNote>>, {jobId: string;profileId: string;data: ProfileNoteCreate}> = (props) => {
          const {jobId,profileId,data} = props ?? {};

          return  createJobProfileNote(jobId,profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobProfileNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createJobProfileNote>>>
    export type CreateJobProfileNoteMutationBody = ProfileNoteCreate
    export type CreateJobProfileNoteMutationError = HTTPValidationError

    /**
 * @summary Create Job Profile Note
 */
export const useCreateJobProfileNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobProfileNote>>, TError,{jobId: string;profileId: string;data: ProfileNoteCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createJobProfileNote>>,
        TError,
        {jobId: string;profileId: string;data: ProfileNoteCreate},
        TContext
      > => {
      return useMutation(getCreateJobProfileNoteMutationOptions(options), queryClient);
    }

export const getUpdateProfileNoteUrl = (noteId: string,) => {




  return `/api/profile-notes/${noteId}`
}

/**
 * @summary Update Profile Note
 */
export const updateProfileNote = async (noteId: string,
    profileNoteUpdate: ProfileNoteUpdate, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteResponse> => {

  return customInstance<ProfileNoteResponse>(getUpdateProfileNoteUrl(noteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileNoteUpdate)
  }
);}





export const getUpdateProfileNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileNote>>, TError,{noteId: string;data: ProfileNoteUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfileNote>>, TError,{noteId: string;data: ProfileNoteUpdate}, TContext> => {

const mutationKey = ['updateProfileNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfileNote>>, {noteId: string;data: ProfileNoteUpdate}> = (props) => {
          const {noteId,data} = props ?? {};

          return  updateProfileNote(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfileNote>>>
    export type UpdateProfileNoteMutationBody = ProfileNoteUpdate
    export type UpdateProfileNoteMutationError = HTTPValidationError

    /**
 * @summary Update Profile Note
 */
export const useUpdateProfileNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileNote>>, TError,{noteId: string;data: ProfileNoteUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfileNote>>,
        TError,
        {noteId: string;data: ProfileNoteUpdate},
        TContext
      > => {
      return useMutation(getUpdateProfileNoteMutationOptions(options), queryClient);
    }

export const getDeleteProfileNoteUrl = (noteId: string,) => {




  return `/api/profile-notes/${noteId}`
}

/**
 * @summary Delete Profile Note
 */
export const deleteProfileNote = async (noteId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteProfileNoteUrl(noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProfileNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNote>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNote>>, TError,{noteId: string}, TContext> => {

const mutationKey = ['deleteProfileNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProfileNote>>, {noteId: string}> = (props) => {
          const {noteId} = props ?? {};

          return  deleteProfileNote(noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProfileNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProfileNote>>>

    export type DeleteProfileNoteMutationError = HTTPValidationError

    /**
 * @summary Delete Profile Note
 */
export const useDeleteProfileNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNote>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProfileNote>>,
        TError,
        {noteId: string},
        TContext
      > => {
      return useMutation(getDeleteProfileNoteMutationOptions(options), queryClient);
    }

export const getSetProfileNoteReactionUrl = (noteId: string,) => {




  return `/api/profile-notes/${noteId}/reaction`
}

/**
 * @summary Set Profile Note Reaction
 */
export const setProfileNoteReaction = async (noteId: string,
    profileNoteReactionRequest: ProfileNoteReactionRequest, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteResponse> => {

  return customInstance<ProfileNoteResponse>(getSetProfileNoteReactionUrl(noteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileNoteReactionRequest)
  }
);}





export const getSetProfileNoteReactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProfileNoteReaction>>, TError,{noteId: string;data: ProfileNoteReactionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setProfileNoteReaction>>, TError,{noteId: string;data: ProfileNoteReactionRequest}, TContext> => {

const mutationKey = ['setProfileNoteReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setProfileNoteReaction>>, {noteId: string;data: ProfileNoteReactionRequest}> = (props) => {
          const {noteId,data} = props ?? {};

          return  setProfileNoteReaction(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetProfileNoteReactionMutationResult = NonNullable<Awaited<ReturnType<typeof setProfileNoteReaction>>>
    export type SetProfileNoteReactionMutationBody = ProfileNoteReactionRequest
    export type SetProfileNoteReactionMutationError = HTTPValidationError

    /**
 * @summary Set Profile Note Reaction
 */
export const useSetProfileNoteReaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProfileNoteReaction>>, TError,{noteId: string;data: ProfileNoteReactionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setProfileNoteReaction>>,
        TError,
        {noteId: string;data: ProfileNoteReactionRequest},
        TContext
      > => {
      return useMutation(getSetProfileNoteReactionMutationOptions(options), queryClient);
    }

export const getDeleteProfileNoteReactionUrl = (noteId: string,) => {




  return `/api/profile-notes/${noteId}/reaction`
}

/**
 * @summary Delete Profile Note Reaction
 */
export const deleteProfileNoteReaction = async (noteId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProfileNoteResponse> => {

  return customInstance<ProfileNoteResponse>(getDeleteProfileNoteReactionUrl(noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProfileNoteReactionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNoteReaction>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNoteReaction>>, TError,{noteId: string}, TContext> => {

const mutationKey = ['deleteProfileNoteReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProfileNoteReaction>>, {noteId: string}> = (props) => {
          const {noteId} = props ?? {};

          return  deleteProfileNoteReaction(noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProfileNoteReactionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProfileNoteReaction>>>

    export type DeleteProfileNoteReactionMutationError = HTTPValidationError

    /**
 * @summary Delete Profile Note Reaction
 */
export const useDeleteProfileNoteReaction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileNoteReaction>>, TError,{noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProfileNoteReaction>>,
        TError,
        {noteId: string},
        TContext
      > => {
      return useMutation(getDeleteProfileNoteReactionMutationOptions(options), queryClient);
    }

export const getUpsertCandidateReviewsUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/reviews`
}

/**
 * @summary Upsert Candidate Reviews
 */
export const upsertCandidateReviews = async (searchId: string,
    upsertReviewsRequest: UpsertReviewsRequest, options?: Parameters<typeof customInstance>[1]): Promise<ReviewsResponse> => {

  return customInstance<ReviewsResponse>(getUpsertCandidateReviewsUrl(searchId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertReviewsRequest)
  }
);}





export const getUpsertCandidateReviewsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateReviews>>, TError,{searchId: string;data: UpsertReviewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateReviews>>, TError,{searchId: string;data: UpsertReviewsRequest}, TContext> => {

const mutationKey = ['upsertCandidateReviews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCandidateReviews>>, {searchId: string;data: UpsertReviewsRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  upsertCandidateReviews(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertCandidateReviewsMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCandidateReviews>>>
    export type UpsertCandidateReviewsMutationBody = UpsertReviewsRequest
    export type UpsertCandidateReviewsMutationError = HTTPValidationError

    /**
 * @summary Upsert Candidate Reviews
 */
export const useUpsertCandidateReviews = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateReviews>>, TError,{searchId: string;data: UpsertReviewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertCandidateReviews>>,
        TError,
        {searchId: string;data: UpsertReviewsRequest},
        TContext
      > => {
      return useMutation(getUpsertCandidateReviewsMutationOptions(options), queryClient);
    }

export const getDeleteCandidateReviewsUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/reviews`
}

/**
 * @summary Delete Candidate Reviews
 */
export const deleteCandidateReviews = async (searchId: string,
    deleteReviewsRequest: DeleteReviewsRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteCandidateReviewsUrl(searchId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteReviewsRequest)
  }
);}





export const getDeleteCandidateReviewsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateReviews>>, TError,{searchId: string;data: DeleteReviewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateReviews>>, TError,{searchId: string;data: DeleteReviewsRequest}, TContext> => {

const mutationKey = ['deleteCandidateReviews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCandidateReviews>>, {searchId: string;data: DeleteReviewsRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  deleteCandidateReviews(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCandidateReviewsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCandidateReviews>>>
    export type DeleteCandidateReviewsMutationBody = DeleteReviewsRequest
    export type DeleteCandidateReviewsMutationError = HTTPValidationError

    /**
 * @summary Delete Candidate Reviews
 */
export const useDeleteCandidateReviews = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateReviews>>, TError,{searchId: string;data: DeleteReviewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCandidateReviews>>,
        TError,
        {searchId: string;data: DeleteReviewsRequest},
        TContext
      > => {
      return useMutation(getDeleteCandidateReviewsMutationOptions(options), queryClient);
    }

export const getGetNextUnreviewedCandidateUrl = (searchId: string,
    params?: GetNextUnreviewedCandidateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/searches/${searchId}/reviews/next-unreviewed?${stringifiedParams}` : `/api/searches/${searchId}/reviews/next-unreviewed`
}

/**
 * @summary Get Next Unreviewed Candidate
 */
export const getNextUnreviewedCandidate = async (searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: Parameters<typeof customInstance>[1]): Promise<NextUnreviewedResponse> => {

  return customInstance<NextUnreviewedResponse>(getGetNextUnreviewedCandidateUrl(searchId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNextUnreviewedCandidateQueryKey = (searchId: string,
    params?: GetNextUnreviewedCandidateParams,) => {
    return [
    `/api/searches/${searchId}/reviews/next-unreviewed`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNextUnreviewedCandidateQueryOptions = <TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNextUnreviewedCandidateQueryKey(searchId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>> = ({ signal }) => getNextUnreviewedCandidate(searchId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNextUnreviewedCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>>
export type GetNextUnreviewedCandidateQueryError = HTTPValidationError


export function useGetNextUnreviewedCandidate<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params: undefined |  GetNextUnreviewedCandidateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextUnreviewedCandidate>>,
          TError,
          Awaited<ReturnType<typeof getNextUnreviewedCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextUnreviewedCandidate<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextUnreviewedCandidate>>,
          TError,
          Awaited<ReturnType<typeof getNextUnreviewedCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextUnreviewedCandidate<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Next Unreviewed Candidate
 */

export function useGetNextUnreviewedCandidate<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNextUnreviewedCandidateQueryOptions(searchId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNextUnreviewedCandidateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNextUnreviewedCandidateQueryKey(searchId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>> = ({ signal }) => getNextUnreviewedCandidate(searchId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNextUnreviewedCandidateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>>
export type GetNextUnreviewedCandidateSuspenseQueryError = HTTPValidationError


export function useGetNextUnreviewedCandidateSuspense<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params: undefined |  GetNextUnreviewedCandidateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextUnreviewedCandidateSuspense<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextUnreviewedCandidateSuspense<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Next Unreviewed Candidate
 */

export function useGetNextUnreviewedCandidateSuspense<TData = Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetNextUnreviewedCandidateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextUnreviewedCandidate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNextUnreviewedCandidateSuspenseQueryOptions(searchId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProfileReviewsUrl = (profileId: string,
    params?: ListProfileReviewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/profiles/${profileId}/reviews?${stringifiedParams}` : `/api/profiles/${profileId}/reviews`
}

/**
 * @summary List Profile Reviews
 */
export const listProfileReviews = async (profileId: string,
    params?: ListProfileReviewsParams, options?: Parameters<typeof customInstance>[1]): Promise<ReviewsResponse> => {

  return customInstance<ReviewsResponse>(getListProfileReviewsUrl(profileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProfileReviewsQueryKey = (profileId: string,
    params?: ListProfileReviewsParams,) => {
    return [
    `/api/profiles/${profileId}/reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProfileReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProfileReviewsQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfileReviews>>> = ({ signal }) => listProfileReviews(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProfileReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listProfileReviews>>>
export type ListProfileReviewsQueryError = HTTPValidationError


export function useListProfileReviews<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  ListProfileReviewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProfileReviews>>,
          TError,
          Awaited<ReturnType<typeof listProfileReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfileReviews<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProfileReviews>>,
          TError,
          Awaited<ReturnType<typeof listProfileReviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfileReviews<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Profile Reviews
 */

export function useListProfileReviews<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProfileReviewsQueryOptions(profileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProfileReviewsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProfileReviewsQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfileReviews>>> = ({ signal }) => listProfileReviews(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProfileReviewsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProfileReviews>>>
export type ListProfileReviewsSuspenseQueryError = HTTPValidationError


export function useListProfileReviewsSuspense<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  ListProfileReviewsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfileReviewsSuspense<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProfileReviewsSuspense<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Profile Reviews
 */

export function useListProfileReviewsSuspense<TData = Awaited<ReturnType<typeof listProfileReviews>>, TError = HTTPValidationError>(
 profileId: string,
    params?: ListProfileReviewsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProfileReviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProfileReviewsSuspenseQueryOptions(profileId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSummarizeProfileEndpointUrl = (profileId: string,
    params: SummarizeProfileEndpointParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/profiles/${profileId}/summarize?${stringifiedParams}` : `/api/profiles/${profileId}/summarize`
}

/**
 * @summary Summarize Profile Endpoint
 */
export const summarizeProfileEndpoint = async (profileId: string,
    params: SummarizeProfileEndpointParams, options?: Parameters<typeof customInstance>[1]): Promise<ProfileSummaryResponse> => {

  return customInstance<ProfileSummaryResponse>(getSummarizeProfileEndpointUrl(profileId,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSummarizeProfileEndpointMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeProfileEndpoint>>, TError,{profileId: string;params: SummarizeProfileEndpointParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof summarizeProfileEndpoint>>, TError,{profileId: string;params: SummarizeProfileEndpointParams}, TContext> => {

const mutationKey = ['summarizeProfileEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof summarizeProfileEndpoint>>, {profileId: string;params: SummarizeProfileEndpointParams}> = (props) => {
          const {profileId,params} = props ?? {};

          return  summarizeProfileEndpoint(profileId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SummarizeProfileEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof summarizeProfileEndpoint>>>

    export type SummarizeProfileEndpointMutationError = HTTPValidationError

    /**
 * @summary Summarize Profile Endpoint
 */
export const useSummarizeProfileEndpoint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof summarizeProfileEndpoint>>, TError,{profileId: string;params: SummarizeProfileEndpointParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof summarizeProfileEndpoint>>,
        TError,
        {profileId: string;params: SummarizeProfileEndpointParams},
        TContext
      > => {
      return useMutation(getSummarizeProfileEndpointMutationOptions(options), queryClient);
    }

export const getListProjectsUrl = (params?: ListProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects?${stringifiedParams}` : `/api/projects`
}

/**
 * @summary List Projects
 */
export const listProjects = async (params?: ListProjectsParams, options?: Parameters<typeof customInstance>[1]): Promise<ProjectListResponse> => {

  return customInstance<ProjectListResponse>(getListProjectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectsQueryKey = (params?: ListProjectsParams,) => {
    return [
    `/api/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = HTTPValidationError


export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params: undefined |  ListProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Projects
 */

export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsSuspenseQueryError = HTTPValidationError


export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params: undefined |  ListProjectsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Projects
 */

export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = HTTPValidationError>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProjectUrl = () => {




  return `/api/projects`
}

/**
 * @summary Create Project
 */
export const createProject = async (bodyCreateProjectApiProjectsPost: BodyCreateProjectApiProjectsPost, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {
    const formData = new FormData();
formData.append(`title`, bodyCreateProjectApiProjectsPost.title);
if(bodyCreateProjectApiProjectsPost.description !== undefined && bodyCreateProjectApiProjectsPost.description !== null) {
 formData.append(`description`, bodyCreateProjectApiProjectsPost.description);
 }
if(bodyCreateProjectApiProjectsPost.access_level !== undefined) {
 formData.append(`access_level`, bodyCreateProjectApiProjectsPost.access_level);
 }
if(bodyCreateProjectApiProjectsPost.collaborator_ids !== undefined) {
 bodyCreateProjectApiProjectsPost.collaborator_ids.forEach(value => formData.append(`collaborator_ids`, value));
 }
if(bodyCreateProjectApiProjectsPost.cover !== undefined && bodyCreateProjectApiProjectsPost.cover !== null) {
 formData.append(`cover`, bodyCreateProjectApiProjectsPost.cover);
 }

  return customInstance<ProjectResponse>(getCreateProjectUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCreateProjectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyCreateProjectApiProjectsPost}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyCreateProjectApiProjectsPost}, TContext> => {

const mutationKey = ['createProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {data: BodyCreateProjectApiProjectsPost}> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = BodyCreateProjectApiProjectsPost
    export type CreateProjectMutationError = HTTPValidationError

    /**
 * @summary Create Project
 */
export const useCreateProject = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyCreateProjectApiProjectsPost}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {data: BodyCreateProjectApiProjectsPost},
        TContext
      > => {
      return useMutation(getCreateProjectMutationOptions(options), queryClient);
    }

export const getGetProjectUrl = (projectId: string,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Get Project
 */
export const getProject = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {

  return customInstance<ProjectResponse>(getGetProjectUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProjectQueryKey = (projectId: string,) => {
    return [
    `/api/projects/${projectId}`
    ] as const;
    }


export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = HTTPValidationError


export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectSuspenseQueryError = HTTPValidationError


export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Project
 */

export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateProjectUrl = (projectId: string,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Update Project
 */
export const updateProject = async (projectId: string,
    projectUpdate: ProjectUpdate, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {

  return customInstance<ProjectResponse>(getUpdateProjectUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(projectUpdate)
  }
);}





export const getUpdateProjectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: string;data: ProjectUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: string;data: ProjectUpdate}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {projectId: string;data: ProjectUpdate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  updateProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = ProjectUpdate
    export type UpdateProjectMutationError = HTTPValidationError

    /**
 * @summary Update Project
 */
export const useUpdateProject = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: string;data: ProjectUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {projectId: string;data: ProjectUpdate},
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options), queryClient);
    }

export const getDeleteProjectUrl = (projectId: string,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Delete Project
 */
export const deleteProject = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteProjectUrl(projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProjectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['deleteProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  deleteProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = HTTPValidationError

    /**
 * @summary Delete Project
 */
export const useDeleteProject = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {projectId: string},
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options), queryClient);
    }

export const getArchiveProjectUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/archive`
}

/**
 * @summary Archive Project
 */
export const archiveProject = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {

  return customInstance<ProjectResponse>(getArchiveProjectUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveProjectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['archiveProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  archiveProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof archiveProject>>>

    export type ArchiveProjectMutationError = HTTPValidationError

    /**
 * @summary Archive Project
 */
export const useArchiveProject = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveProject>>,
        TError,
        {projectId: string},
        TContext
      > => {
      return useMutation(getArchiveProjectMutationOptions(options), queryClient);
    }

export const getSetProjectCoverUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/cover`
}

/**
 * @summary Set Project Cover
 */
export const setProjectCover = async (projectId: string,
    bodySetProjectCoverApiProjectsProjectIdCoverPut: BodySetProjectCoverApiProjectsProjectIdCoverPut, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {
    const formData = new FormData();
formData.append(`file`, bodySetProjectCoverApiProjectsProjectIdCoverPut.file);

  return customInstance<ProjectResponse>(getSetProjectCoverUrl(projectId),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}





export const getSetProjectCoverMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProjectCover>>, TError,{projectId: string;data: BodySetProjectCoverApiProjectsProjectIdCoverPut}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setProjectCover>>, TError,{projectId: string;data: BodySetProjectCoverApiProjectsProjectIdCoverPut}, TContext> => {

const mutationKey = ['setProjectCover'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setProjectCover>>, {projectId: string;data: BodySetProjectCoverApiProjectsProjectIdCoverPut}> = (props) => {
          const {projectId,data} = props ?? {};

          return  setProjectCover(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetProjectCoverMutationResult = NonNullable<Awaited<ReturnType<typeof setProjectCover>>>
    export type SetProjectCoverMutationBody = BodySetProjectCoverApiProjectsProjectIdCoverPut
    export type SetProjectCoverMutationError = HTTPValidationError

    /**
 * @summary Set Project Cover
 */
export const useSetProjectCover = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProjectCover>>, TError,{projectId: string;data: BodySetProjectCoverApiProjectsProjectIdCoverPut}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setProjectCover>>,
        TError,
        {projectId: string;data: BodySetProjectCoverApiProjectsProjectIdCoverPut},
        TContext
      > => {
      return useMutation(getSetProjectCoverMutationOptions(options), queryClient);
    }

export const getClearProjectCoverUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/cover`
}

/**
 * @summary Clear Project Cover
 */
export const clearProjectCover = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {

  return customInstance<ProjectResponse>(getClearProjectCoverUrl(projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearProjectCoverMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearProjectCover>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearProjectCover>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['clearProjectCover'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearProjectCover>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  clearProjectCover(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearProjectCoverMutationResult = NonNullable<Awaited<ReturnType<typeof clearProjectCover>>>

    export type ClearProjectCoverMutationError = HTTPValidationError

    /**
 * @summary Clear Project Cover
 */
export const useClearProjectCover = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearProjectCover>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearProjectCover>>,
        TError,
        {projectId: string},
        TContext
      > => {
      return useMutation(getClearProjectCoverMutationOptions(options), queryClient);
    }

export const getSelectProjectUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/select`
}

/**
 * @summary Select Project
 */
export const selectProject = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<ProjectResponse> => {

  return customInstance<ProjectResponse>(getSelectProjectUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSelectProjectMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof selectProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['selectProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  selectProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectProjectMutationResult = NonNullable<Awaited<ReturnType<typeof selectProject>>>

    export type SelectProjectMutationError = HTTPValidationError

    /**
 * @summary Select Project
 */
export const useSelectProject = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selectProject>>,
        TError,
        {projectId: string},
        TContext
      > => {
      return useMutation(getSelectProjectMutationOptions(options), queryClient);
    }

export const getListCollaboratorsUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/collaborators`
}

/**
 * @summary List Collaborators
 */
export const listCollaborators = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<CollaboratorResponse[]> => {

  return customInstance<CollaboratorResponse[]>(getListCollaboratorsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCollaboratorsQueryKey = (projectId: string,) => {
    return [
    `/api/projects/${projectId}/collaborators`
    ] as const;
    }


export const getListCollaboratorsQueryOptions = <TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCollaboratorsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollaborators>>> = ({ signal }) => listCollaborators(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCollaboratorsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollaborators>>>
export type ListCollaboratorsQueryError = HTTPValidationError


export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollaborators>>,
          TError,
          Awaited<ReturnType<typeof listCollaborators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollaborators>>,
          TError,
          Awaited<ReturnType<typeof listCollaborators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Collaborators
 */

export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollaboratorsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListCollaboratorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCollaboratorsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollaborators>>> = ({ signal }) => listCollaborators(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCollaboratorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCollaborators>>>
export type ListCollaboratorsSuspenseQueryError = HTTPValidationError


export function useListCollaboratorsSuspense<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaboratorsSuspense<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaboratorsSuspense<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Collaborators
 */

export function useListCollaboratorsSuspense<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollaboratorsSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddCollaboratorUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/collaborators`
}

/**
 * @summary Add Collaborator
 */
export const addCollaborator = async (projectId: string,
    collaboratorAdd: CollaboratorAdd, options?: Parameters<typeof customInstance>[1]): Promise<CollaboratorResponse> => {

  return customInstance<CollaboratorResponse>(getAddCollaboratorUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(collaboratorAdd)
  }
);}





export const getAddCollaboratorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{projectId: string;data: CollaboratorAdd}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{projectId: string;data: CollaboratorAdd}, TContext> => {

const mutationKey = ['addCollaborator'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCollaborator>>, {projectId: string;data: CollaboratorAdd}> = (props) => {
          const {projectId,data} = props ?? {};

          return  addCollaborator(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof addCollaborator>>>
    export type AddCollaboratorMutationBody = CollaboratorAdd
    export type AddCollaboratorMutationError = HTTPValidationError

    /**
 * @summary Add Collaborator
 */
export const useAddCollaborator = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{projectId: string;data: CollaboratorAdd}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCollaborator>>,
        TError,
        {projectId: string;data: CollaboratorAdd},
        TContext
      > => {
      return useMutation(getAddCollaboratorMutationOptions(options), queryClient);
    }

export const getRemoveCollaboratorUrl = (projectId: string,
    collabUserId: string,) => {




  return `/api/projects/${projectId}/collaborators/${collabUserId}`
}

/**
 * @summary Remove Collaborator
 */
export const removeCollaborator = async (projectId: string,
    collabUserId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRemoveCollaboratorUrl(projectId,collabUserId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveCollaboratorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{projectId: string;collabUserId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{projectId: string;collabUserId: string}, TContext> => {

const mutationKey = ['removeCollaborator'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCollaborator>>, {projectId: string;collabUserId: string}> = (props) => {
          const {projectId,collabUserId} = props ?? {};

          return  removeCollaborator(projectId,collabUserId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof removeCollaborator>>>

    export type RemoveCollaboratorMutationError = HTTPValidationError

    /**
 * @summary Remove Collaborator
 */
export const useRemoveCollaborator = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{projectId: string;collabUserId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCollaborator>>,
        TError,
        {projectId: string;collabUserId: string},
        TContext
      > => {
      return useMutation(getRemoveCollaboratorMutationOptions(options), queryClient);
    }

export const getTransferProjectOwnershipUrl = () => {




  return `/api/projects/transfer-ownership`
}

/**
 * Transfer ownership of one or more projects to another active org member.
 * @summary Transfer Project Ownership
 */
export const transferProjectOwnership = async (transferOwnershipRequest: TransferOwnershipRequest, options?: Parameters<typeof customInstance>[1]): Promise<TransferProjectOwnership200> => {

  return customInstance<TransferProjectOwnership200>(getTransferProjectOwnershipUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferOwnershipRequest)
  }
);}





export const getTransferProjectOwnershipMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferProjectOwnership>>, TError,{data: TransferOwnershipRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof transferProjectOwnership>>, TError,{data: TransferOwnershipRequest}, TContext> => {

const mutationKey = ['transferProjectOwnership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferProjectOwnership>>, {data: TransferOwnershipRequest}> = (props) => {
          const {data} = props ?? {};

          return  transferProjectOwnership(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransferProjectOwnershipMutationResult = NonNullable<Awaited<ReturnType<typeof transferProjectOwnership>>>
    export type TransferProjectOwnershipMutationBody = TransferOwnershipRequest
    export type TransferProjectOwnershipMutationError = HTTPValidationError

    /**
 * @summary Transfer Project Ownership
 */
export const useTransferProjectOwnership = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferProjectOwnership>>, TError,{data: TransferOwnershipRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferProjectOwnership>>,
        TError,
        {data: TransferOwnershipRequest},
        TContext
      > => {
      return useMutation(getTransferProjectOwnershipMutationOptions(options), queryClient);
    }

export const getSearchProfilesUrl = () => {




  return `/api/search/profiles`
}

/**
 * @summary Search Profiles
 */
export const searchProfiles = async (searchRequestSchema: SearchRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<SearchProfilesResponseSchema> => {

  return customInstance<SearchProfilesResponseSchema>(getSearchProfilesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchRequestSchema)
  }
);}





export const getSearchProfilesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProfiles>>, TError,{data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchProfiles>>, TError,{data: SearchRequestSchema}, TContext> => {

const mutationKey = ['searchProfiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchProfiles>>, {data: SearchRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  searchProfiles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof searchProfiles>>>
    export type SearchProfilesMutationBody = SearchRequestSchema
    export type SearchProfilesMutationError = HTTPValidationError

    /**
 * @summary Search Profiles
 */
export const useSearchProfiles = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProfiles>>, TError,{data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchProfiles>>,
        TError,
        {data: SearchRequestSchema},
        TContext
      > => {
      return useMutation(getSearchProfilesMutationOptions(options), queryClient);
    }

export const getSearchCoverageUrl = () => {




  return `/api/search/coverage`
}

/**
 * @summary Search Coverage
 */
export const searchCoverage = async (coverageRequestSchema: CoverageRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<CoverageResponseSchema> => {

  return customInstance<CoverageResponseSchema>(getSearchCoverageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(coverageRequestSchema)
  }
);}





export const getSearchCoverageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchCoverage>>, TError,{data: CoverageRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchCoverage>>, TError,{data: CoverageRequestSchema}, TContext> => {

const mutationKey = ['searchCoverage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchCoverage>>, {data: CoverageRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  searchCoverage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchCoverageMutationResult = NonNullable<Awaited<ReturnType<typeof searchCoverage>>>
    export type SearchCoverageMutationBody = CoverageRequestSchema
    export type SearchCoverageMutationError = HTTPValidationError

    /**
 * @summary Search Coverage
 */
export const useSearchCoverage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchCoverage>>, TError,{data: CoverageRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchCoverage>>,
        TError,
        {data: CoverageRequestSchema},
        TContext
      > => {
      return useMutation(getSearchCoverageMutationOptions(options), queryClient);
    }

export const getAutocompleteUrl = (field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["pool_ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search/autocomplete/${field}?${stringifiedParams}` : `/api/search/autocomplete/${field}`
}

/**
 * Suggestions from the given pools (omitted = the org's default pools).
 * @summary Autocomplete
 */
export const autocomplete = async (field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: Parameters<typeof customInstance>[1]): Promise<AutocompleteResponseSchema> => {

  return customInstance<AutocompleteResponseSchema>(getAutocompleteUrl(field,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutocompleteQueryKey = (field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams,) => {
    return [
    `/api/search/autocomplete/${field}`, ...(params ? [params] : [])
    ] as const;
    }


export const getAutocompleteQueryOptions = <TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteQueryKey(field,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocomplete>>> = ({ signal }) => autocomplete(field,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: field !== null && field !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutocompleteQueryResult = NonNullable<Awaited<ReturnType<typeof autocomplete>>>
export type AutocompleteQueryError = HTTPValidationError


export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params: undefined |  AutocompleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocomplete>>,
          TError,
          Awaited<ReturnType<typeof autocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocomplete>>,
          TError,
          Awaited<ReturnType<typeof autocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Autocomplete
 */

export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutocompleteQueryOptions(field,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAutocompleteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteQueryKey(field,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocomplete>>> = ({ signal }) => autocomplete(field,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutocompleteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof autocomplete>>>
export type AutocompleteSuspenseQueryError = HTTPValidationError


export function useAutocompleteSuspense<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params: undefined |  AutocompleteParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteSuspense<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteSuspense<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Autocomplete
 */

export function useAutocompleteSuspense<TData = Awaited<ReturnType<typeof autocomplete>>, TError = HTTPValidationError>(
 field: 'skills' | 'companies' | 'locations' | 'job_titles' | 'industries' | 'universities' | 'company_tags' | 'investors' | 'majors' | 'languages' | 'certification_names' | 'certification_vendors' | 'occupational_series',
    params?: AutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutocompleteSuspenseQueryOptions(field,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBatchAutocompleteUrl = () => {




  return `/api/search/autocomplete/batch`
}

/**
 * Validate multiple entities across fields in a single round-trip.
 * @summary Batch Autocomplete
 */
export const batchAutocomplete = async (batchAutocompleteRequestSchema: BatchAutocompleteRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<BatchAutocompleteResponseSchema> => {

  return customInstance<BatchAutocompleteResponseSchema>(getBatchAutocompleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchAutocompleteRequestSchema)
  }
);}





export const getBatchAutocompleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchAutocomplete>>, TError,{data: BatchAutocompleteRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof batchAutocomplete>>, TError,{data: BatchAutocompleteRequestSchema}, TContext> => {

const mutationKey = ['batchAutocomplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchAutocomplete>>, {data: BatchAutocompleteRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  batchAutocomplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchAutocompleteMutationResult = NonNullable<Awaited<ReturnType<typeof batchAutocomplete>>>
    export type BatchAutocompleteMutationBody = BatchAutocompleteRequestSchema
    export type BatchAutocompleteMutationError = HTTPValidationError

    /**
 * @summary Batch Autocomplete
 */
export const useBatchAutocomplete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchAutocomplete>>, TError,{data: BatchAutocompleteRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchAutocomplete>>,
        TError,
        {data: BatchAutocompleteRequestSchema},
        TContext
      > => {
      return useMutation(getBatchAutocompleteMutationOptions(options), queryClient);
    }

export const getFilterOptionsUrl = () => {




  return `/api/search/filter-options`
}

/**
 * @summary Filter Options
 */
export const filterOptions = async ( options?: Parameters<typeof customInstance>[1]): Promise<FilterOptionsResponseSchema> => {

  return customInstance<FilterOptionsResponseSchema>(getFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilterOptionsQueryKey = () => {
    return [
    `/api/search/filter-options`
    ] as const;
    }


export const getFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterOptions>>> = ({ signal }) => filterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof filterOptions>>>
export type FilterOptionsQueryError = unknown


export function useFilterOptions<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterOptions>>,
          TError,
          Awaited<ReturnType<typeof filterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterOptions<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterOptions>>,
          TError,
          Awaited<ReturnType<typeof filterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterOptions<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Filter Options
 */

export function useFilterOptions<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterOptions>>> = ({ signal }) => filterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof filterOptions>>>
export type FilterOptionsSuspenseQueryError = unknown


export function useFilterOptionsSuspense<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterOptionsSuspense<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterOptionsSuspense<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Filter Options
 */

export function useFilterOptionsSuspense<TData = Awaited<ReturnType<typeof filterOptions>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClassifySearchUrl = () => {




  return `/api/search/classify`
}

/**
 * @summary Classify Search
 */
export const classifySearch = async (searchClassifyRequest: SearchClassifyRequest, options?: Parameters<typeof customInstance>[1]): Promise<SearchClassifyResponse> => {

  return customInstance<SearchClassifyResponse>(getClassifySearchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchClassifyRequest)
  }
);}





export const getClassifySearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifySearch>>, TError,{data: SearchClassifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classifySearch>>, TError,{data: SearchClassifyRequest}, TContext> => {

const mutationKey = ['classifySearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classifySearch>>, {data: SearchClassifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  classifySearch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassifySearchMutationResult = NonNullable<Awaited<ReturnType<typeof classifySearch>>>
    export type ClassifySearchMutationBody = SearchClassifyRequest
    export type ClassifySearchMutationError = HTTPValidationError

    /**
 * @summary Classify Search
 */
export const useClassifySearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifySearch>>, TError,{data: SearchClassifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classifySearch>>,
        TError,
        {data: SearchClassifyRequest},
        TContext
      > => {
      return useMutation(getClassifySearchMutationOptions(options), queryClient);
    }

export const getGetProfileUrl = (profileId: string,
    params?: GetProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/profiles/${profileId}?${stringifiedParams}` : `/api/profiles/${profileId}`
}

/**
 * @summary Get Profile
 */
export const getProfile = async (profileId: string,
    params?: GetProfileParams, options?: Parameters<typeof customInstance>[1]): Promise<ProfileDetailSchema> => {

  return customInstance<ProfileDetailSchema>(getGetProfileUrl(profileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileQueryKey = (profileId: string,
    params?: GetProfileParams,) => {
    return [
    `/api/profiles/${profileId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = HTTPValidationError


export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  GetProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile
 */

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(profileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileSuspenseQueryError = HTTPValidationError


export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  GetProfileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile
 */

export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSuspenseQueryOptions(profileId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProfileJobsUrl = (profileId: string,
    params?: GetProfileJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/profiles/${profileId}/jobs?${stringifiedParams}` : `/api/profiles/${profileId}/jobs`
}

/**
 * List jobs this profile is in across projects the viewer can access.
 *
 * Previously project-scoped to the selected project only. Expanded so
 * recruiters can see "active elsewhere" context (jobs, sequences, last
 * contact) without leaking private projects they cannot open.
 * @summary Get Profile Jobs
 */
export const getProfileJobs = async (profileId: string,
    params?: GetProfileJobsParams, options?: Parameters<typeof customInstance>[1]): Promise<ProfileJobsResponse> => {

  return customInstance<ProfileJobsResponse>(getGetProfileJobsUrl(profileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileJobsQueryKey = (profileId: string,
    params?: GetProfileJobsParams,) => {
    return [
    `/api/profiles/${profileId}/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfileJobsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileJobsQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileJobs>>> = ({ signal }) => getProfileJobs(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileJobs>>>
export type GetProfileJobsQueryError = HTTPValidationError


export function useGetProfileJobs<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  GetProfileJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileJobs>>,
          TError,
          Awaited<ReturnType<typeof getProfileJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileJobs<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileJobs>>,
          TError,
          Awaited<ReturnType<typeof getProfileJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileJobs<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Jobs
 */

export function useGetProfileJobs<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileJobsQueryOptions(profileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfileJobsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileJobsQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileJobs>>> = ({ signal }) => getProfileJobs(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileJobsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileJobs>>>
export type GetProfileJobsSuspenseQueryError = HTTPValidationError


export function useGetProfileJobsSuspense<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params: undefined |  GetProfileJobsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileJobsSuspense<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileJobsSuspense<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Profile Jobs
 */

export function useGetProfileJobsSuspense<TData = Awaited<ReturnType<typeof getProfileJobs>>, TError = HTTPValidationError>(
 profileId: string,
    params?: GetProfileJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileJobsSuspenseQueryOptions(profileId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSavedSearchesUrl = (projectId: string,
    params?: ListSavedSearchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/searches?${stringifiedParams}` : `/api/projects/${projectId}/searches`
}

/**
 * @summary List Saved Searches
 */
export const listSavedSearches = async (projectId: string,
    params?: ListSavedSearchesParams, options?: Parameters<typeof customInstance>[1]): Promise<SavedSearchListResponseSchema> => {

  return customInstance<SavedSearchListResponseSchema>(getListSavedSearchesUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedSearchesQueryKey = (projectId: string,
    params?: ListSavedSearchesParams,) => {
    return [
    `/api/projects/${projectId}/searches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSavedSearchesQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearches>>> = ({ signal }) => listSavedSearches(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchesQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearches>>>
export type ListSavedSearchesQueryError = HTTPValidationError


export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListSavedSearchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Saved Searches
 */

export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSavedSearchesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearches>>> = ({ signal }) => listSavedSearches(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearches>>>
export type ListSavedSearchesSuspenseQueryError = HTTPValidationError


export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListSavedSearchesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Saved Searches
 */

export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSavedSearchUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/searches`
}

/**
 * Deprecated: legacy assistant path; removed with spec 2.
 *
 * Creates a *definition-less* saved search only (the assistant attaches the
 * definition afterwards through the run route). A body carrying ``filters``
 * is rejected with 400 ``USE_RUN_ROUTE``: filters are only written by
 * ``POST /projects/{id}/searches/run`` / ``POST /searches/{id}/run`` so a
 * search never ends up with a definition and no run.
 * @summary Create Saved Search
 */
export const createSavedSearch = async (projectId: string,
    searchRequestSchema: SearchRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<SearchWithRunResponseSchema> => {

  return customInstance<SearchWithRunResponseSchema>(getCreateSavedSearchUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchRequestSchema)
  }
);}





export const getCreateSavedSearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{projectId: string;data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{projectId: string;data: SearchRequestSchema}, TContext> => {

const mutationKey = ['createSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSavedSearch>>, {projectId: string;data: SearchRequestSchema}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createSavedSearch(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof createSavedSearch>>>
    export type CreateSavedSearchMutationBody = SearchRequestSchema
    export type CreateSavedSearchMutationError = HTTPValidationError

    /**
 * @summary Create Saved Search
 */
export const useCreateSavedSearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{projectId: string;data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSavedSearch>>,
        TError,
        {projectId: string;data: SearchRequestSchema},
        TContext
      > => {
      return useMutation(getCreateSavedSearchMutationOptions(options), queryClient);
    }

export const getGetSavedSearchUrl = (searchId: string,) => {




  return `/api/searches/${searchId}`
}

/**
 * The search's definition plus its latest run (results live on
 * ``GET /searches/{id}/results``).
 *
 * Lazy migration: a pre-run-era search (a definition but no run yet) gets a
 * ``migration`` run claimed here, single-winner across concurrent readers,
 * committed, then dispatched (commit-before-enqueue so the worker reads the
 * committed row). Definition-less searches get no run.
 * @summary Get Saved Search
 */
export const getSavedSearch = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<SearchWithRunResponseSchema> => {

  return customInstance<SearchWithRunResponseSchema>(getGetSavedSearchUrl(searchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedSearchQueryKey = (searchId: string,) => {
    return [
    `/api/searches/${searchId}`
    ] as const;
    }


export const getGetSavedSearchQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearch>>> = ({ signal }) => getSavedSearch(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearch>>>
export type GetSavedSearchQueryError = HTTPValidationError


export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Saved Search
 */

export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchQueryOptions(searchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSavedSearchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearch>>> = ({ signal }) => getSavedSearch(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearch>>>
export type GetSavedSearchSuspenseQueryError = HTTPValidationError


export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Saved Search
 */

export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchSuspenseQueryOptions(searchId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSavedSearchUrl = (searchId: string,) => {




  return `/api/searches/${searchId}`
}

/**
 * @summary Update Saved Search
 */
export const updateSavedSearch = async (searchId: string,
    savedSearchUpdateSchema: SavedSearchUpdateSchema, options?: Parameters<typeof customInstance>[1]): Promise<SavedSearchSchema> => {

  return customInstance<SavedSearchSchema>(getUpdateSavedSearchUrl(searchId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedSearchUpdateSchema)
  }
);}





export const getUpdateSavedSearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{searchId: string;data: SavedSearchUpdateSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{searchId: string;data: SavedSearchUpdateSchema}, TContext> => {

const mutationKey = ['updateSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSavedSearch>>, {searchId: string;data: SavedSearchUpdateSchema}> = (props) => {
          const {searchId,data} = props ?? {};

          return  updateSavedSearch(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof updateSavedSearch>>>
    export type UpdateSavedSearchMutationBody = SavedSearchUpdateSchema
    export type UpdateSavedSearchMutationError = HTTPValidationError

    /**
 * @summary Update Saved Search
 */
export const useUpdateSavedSearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{searchId: string;data: SavedSearchUpdateSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSavedSearch>>,
        TError,
        {searchId: string;data: SavedSearchUpdateSchema},
        TContext
      > => {
      return useMutation(getUpdateSavedSearchMutationOptions(options), queryClient);
    }

export const getDeleteSavedSearchUrl = (searchId: string,) => {




  return `/api/searches/${searchId}`
}

/**
 * @summary Delete Saved Search
 */
export const deleteSavedSearch = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteSavedSearchUrl(searchId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSavedSearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{searchId: string}, TContext> => {

const mutationKey = ['deleteSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedSearch>>, {searchId: string}> = (props) => {
          const {searchId} = props ?? {};

          return  deleteSavedSearch(searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedSearch>>>

    export type DeleteSavedSearchMutationError = HTTPValidationError

    /**
 * @summary Delete Saved Search
 */
export const useDeleteSavedSearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedSearch>>,
        TError,
        {searchId: string},
        TContext
      > => {
      return useMutation(getDeleteSavedSearchMutationOptions(options), queryClient);
    }

export const getGetSearchInsightsUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/insights`
}

/**
 * Compute aggregated insights for a saved search's current filter state.
 *
 * Accepts the same SearchRequestSchema as execute but runs a size=0
 * aggregation-only query — no hits are returned, only statistics.
 * @summary Get Search Insights
 */
export const getSearchInsights = async (searchId: string,
    searchRequestSchema: SearchRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<InsightsResponseSchema> => {

  return customInstance<InsightsResponseSchema>(getGetSearchInsightsUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchRequestSchema)
  }
);}





export const getGetSearchInsightsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSearchInsights>>, TError,{searchId: string;data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getSearchInsights>>, TError,{searchId: string;data: SearchRequestSchema}, TContext> => {

const mutationKey = ['getSearchInsights'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSearchInsights>>, {searchId: string;data: SearchRequestSchema}> = (props) => {
          const {searchId,data} = props ?? {};

          return  getSearchInsights(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSearchInsightsMutationResult = NonNullable<Awaited<ReturnType<typeof getSearchInsights>>>
    export type GetSearchInsightsMutationBody = SearchRequestSchema
    export type GetSearchInsightsMutationError = HTTPValidationError

    /**
 * @summary Get Search Insights
 */
export const useGetSearchInsights = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSearchInsights>>, TError,{searchId: string;data: SearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSearchInsights>>,
        TError,
        {searchId: string;data: SearchRequestSchema},
        TContext
      > => {
      return useMutation(getGetSearchInsightsMutationOptions(options), queryClient);
    }

export const getGetSearchProfileSummaryUrl = (searchId: string,
    profileId: string,) => {




  return `/api/searches/${searchId}/profiles/${profileId}/summary`
}

/**
 * Recruiter-facing summary of one profile against the search's latest
 * *ready* run. Generated lazily on first open and cached on the run.
 * @summary Get Search Profile Summary
 */
export const getSearchProfileSummary = async (searchId: string,
    profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<CriteriaSummarySchema> => {

  return customInstance<CriteriaSummarySchema>(getGetSearchProfileSummaryUrl(searchId,profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSearchProfileSummaryQueryKey = (searchId: string,
    profileId: string,) => {
    return [
    `/api/searches/${searchId}/profiles/${profileId}/summary`
    ] as const;
    }


export const getGetSearchProfileSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(searchId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchProfileSummaryQueryKey(searchId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchProfileSummary>>> = ({ signal }) => getSearchProfileSummary(searchId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined && profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchProfileSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchProfileSummary>>>
export type GetSearchProfileSummaryQueryError = HTTPValidationError


export function useGetSearchProfileSummary<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchProfileSummary>>,
          TError,
          Awaited<ReturnType<typeof getSearchProfileSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchProfileSummary<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchProfileSummary>>,
          TError,
          Awaited<ReturnType<typeof getSearchProfileSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchProfileSummary<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Search Profile Summary
 */

export function useGetSearchProfileSummary<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchProfileSummaryQueryOptions(searchId,profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSearchProfileSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(searchId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchProfileSummaryQueryKey(searchId,profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchProfileSummary>>> = ({ signal }) => getSearchProfileSummary(searchId,profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchProfileSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchProfileSummary>>>
export type GetSearchProfileSummarySuspenseQueryError = HTTPValidationError


export function useGetSearchProfileSummarySuspense<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchProfileSummarySuspense<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchProfileSummarySuspense<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Search Profile Summary
 */

export function useGetSearchProfileSummarySuspense<TData = Awaited<ReturnType<typeof getSearchProfileSummary>>, TError = HTTPValidationError>(
 searchId: string,
    profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchProfileSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchProfileSummarySuspenseQueryOptions(searchId,profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitSearchFeedbackUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/feedback`
}

/**
 * @summary Submit Search Feedback
 */
export const submitSearchFeedback = async (searchId: string,
    searchFeedbackCreateSchema: SearchFeedbackCreateSchema, options?: Parameters<typeof customInstance>[1]): Promise<SearchFeedbackResponseSchema> => {

  return customInstance<SearchFeedbackResponseSchema>(getSubmitSearchFeedbackUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchFeedbackCreateSchema)
  }
);}





export const getSubmitSearchFeedbackMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSearchFeedback>>, TError,{searchId: string;data: SearchFeedbackCreateSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitSearchFeedback>>, TError,{searchId: string;data: SearchFeedbackCreateSchema}, TContext> => {

const mutationKey = ['submitSearchFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitSearchFeedback>>, {searchId: string;data: SearchFeedbackCreateSchema}> = (props) => {
          const {searchId,data} = props ?? {};

          return  submitSearchFeedback(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitSearchFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof submitSearchFeedback>>>
    export type SubmitSearchFeedbackMutationBody = SearchFeedbackCreateSchema
    export type SubmitSearchFeedbackMutationError = HTTPValidationError

    /**
 * @summary Submit Search Feedback
 */
export const useSubmitSearchFeedback = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSearchFeedback>>, TError,{searchId: string;data: SearchFeedbackCreateSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitSearchFeedback>>,
        TError,
        {searchId: string;data: SearchFeedbackCreateSchema},
        TContext
      > => {
      return useMutation(getSubmitSearchFeedbackMutationOptions(options), queryClient);
    }

export const getGenerateSpotlightsUrl = () => {




  return `/api/spotlights`
}

/**
 * @summary Generate Spotlights
 */
export const generateSpotlights = async (spotlightRequestSchema: SpotlightRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<SpotlightResponseSchema> => {

  return customInstance<SpotlightResponseSchema>(getGenerateSpotlightsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(spotlightRequestSchema)
  }
);}





export const getGenerateSpotlightsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSpotlights>>, TError,{data: SpotlightRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateSpotlights>>, TError,{data: SpotlightRequestSchema}, TContext> => {

const mutationKey = ['generateSpotlights'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateSpotlights>>, {data: SpotlightRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  generateSpotlights(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateSpotlightsMutationResult = NonNullable<Awaited<ReturnType<typeof generateSpotlights>>>
    export type GenerateSpotlightsMutationBody = SpotlightRequestSchema
    export type GenerateSpotlightsMutationError = HTTPValidationError

    /**
 * @summary Generate Spotlights
 */
export const useGenerateSpotlights = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSpotlights>>, TError,{data: SpotlightRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateSpotlights>>,
        TError,
        {data: SpotlightRequestSchema},
        TContext
      > => {
      return useMutation(getGenerateSpotlightsMutationOptions(options), queryClient);
    }

export const getPostAssistantMessageUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/assistant/messages`
}

/**
 * Run one agent turn against an existing search, streaming SSE events.
 *
 * The agent loop runs in a background task that survives client
 * disconnects. SSE events are forwarded via Redis pub/sub.
 * @summary Post Assistant Message
 */
export const postAssistantMessage = async (searchId: string,
    assistantMessageRequest: AssistantMessageRequest, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getPostAssistantMessageUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assistantMessageRequest)
  }
);}





export const getPostAssistantMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantMessage>>, TError,{searchId: string;data: AssistantMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAssistantMessage>>, TError,{searchId: string;data: AssistantMessageRequest}, TContext> => {

const mutationKey = ['postAssistantMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssistantMessage>>, {searchId: string;data: AssistantMessageRequest}> = (props) => {
          const {searchId,data} = props ?? {};

          return  postAssistantMessage(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAssistantMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postAssistantMessage>>>
    export type PostAssistantMessageMutationBody = AssistantMessageRequest
    export type PostAssistantMessageMutationError = HTTPValidationError

    /**
 * @summary Post Assistant Message
 */
export const usePostAssistantMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantMessage>>, TError,{searchId: string;data: AssistantMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAssistantMessage>>,
        TError,
        {searchId: string;data: AssistantMessageRequest},
        TContext
      > => {
      return useMutation(getPostAssistantMessageMutationOptions(options), queryClient);
    }

export const getReconnectAssistantStreamUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/assistant/stream`
}

/**
 * Reconnect to a running agent stream.
 *
 * If the agent is still running for this search, subscribes to the
 * Redis channel and forwards SSE events. If not running, returns an
 * immediate ``agent_done`` event so the frontend knows to just fetch
 * persisted messages.
 * @summary Reconnect Assistant Stream
 */
export const reconnectAssistantStream = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getReconnectAssistantStreamUrl(searchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReconnectAssistantStreamQueryKey = (searchId: string,) => {
    return [
    `/api/searches/${searchId}/assistant/stream`
    ] as const;
    }


export const getReconnectAssistantStreamQueryOptions = <TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconnectAssistantStreamQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconnectAssistantStream>>> = ({ signal }) => reconnectAssistantStream(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconnectAssistantStreamQueryResult = NonNullable<Awaited<ReturnType<typeof reconnectAssistantStream>>>
export type ReconnectAssistantStreamQueryError = HTTPValidationError


export function useReconnectAssistantStream<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconnectAssistantStream>>,
          TError,
          Awaited<ReturnType<typeof reconnectAssistantStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectAssistantStream<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconnectAssistantStream>>,
          TError,
          Awaited<ReturnType<typeof reconnectAssistantStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectAssistantStream<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconnect Assistant Stream
 */

export function useReconnectAssistantStream<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconnectAssistantStreamQueryOptions(searchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReconnectAssistantStreamSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconnectAssistantStreamQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconnectAssistantStream>>> = ({ signal }) => reconnectAssistantStream(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconnectAssistantStreamSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof reconnectAssistantStream>>>
export type ReconnectAssistantStreamSuspenseQueryError = HTTPValidationError


export function useReconnectAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconnect Assistant Stream
 */

export function useReconnectAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectAssistantStream>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconnectAssistantStreamSuspenseQueryOptions(searchId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAssistantStatusUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/assistant/status`
}

/**
 * Check if the agent is currently running for a search.
 * @summary Get Assistant Status
 */
export const getAssistantStatus = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<GetAssistantStatus200> => {

  return customInstance<GetAssistantStatus200>(getGetAssistantStatusUrl(searchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssistantStatusQueryKey = (searchId: string,) => {
    return [
    `/api/searches/${searchId}/assistant/status`
    ] as const;
    }


export const getGetAssistantStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantStatusQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantStatus>>> = ({ signal }) => getAssistantStatus(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantStatus>>>
export type GetAssistantStatusQueryError = HTTPValidationError


export function useGetAssistantStatus<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantStatus>>,
          TError,
          Awaited<ReturnType<typeof getAssistantStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantStatus<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantStatus>>,
          TError,
          Awaited<ReturnType<typeof getAssistantStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantStatus<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assistant Status
 */

export function useGetAssistantStatus<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantStatusQueryOptions(searchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAssistantStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantStatusQueryKey(searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantStatus>>> = ({ signal }) => getAssistantStatus(searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantStatus>>>
export type GetAssistantStatusSuspenseQueryError = HTTPValidationError


export function useGetAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assistant Status
 */

export function useGetAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getAssistantStatus>>, TError = HTTPValidationError>(
 searchId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantStatusSuspenseQueryOptions(searchId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelAssistantUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/assistant/cancel`
}

/**
 * Signal a running agent to stop.
 *
 * Only the user who started the run — or a project role strictly above
 * viewer — may cancel it. Clears the running key so the background task's
 * next TTL refresh sees it missing and winds down. Also publishes an
 * ``agent_done`` event so any connected SSE clients close cleanly.
 * @summary Cancel Assistant
 */
export const cancelAssistant = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<CancelAssistant200> => {

  return customInstance<CancelAssistant200>(getCancelAssistantUrl(searchId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelAssistantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAssistant>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAssistant>>, TError,{searchId: string}, TContext> => {

const mutationKey = ['cancelAssistant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAssistant>>, {searchId: string}> = (props) => {
          const {searchId} = props ?? {};

          return  cancelAssistant(searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAssistant>>>

    export type CancelAssistantMutationError = HTTPValidationError

    /**
 * @summary Cancel Assistant
 */
export const useCancelAssistant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAssistant>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAssistant>>,
        TError,
        {searchId: string},
        TContext
      > => {
      return useMutation(getCancelAssistantMutationOptions(options), queryClient);
    }

export const getCreateAndRunUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/searches/run`
}

/**
 * @summary Create And Run
 */
export const createAndRun = async (projectId: string,
    runSearchRequestSchema: RunSearchRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<SearchWithRunResponseSchema> => {

  return customInstance<SearchWithRunResponseSchema>(getCreateAndRunUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runSearchRequestSchema)
  }
);}





export const getCreateAndRunMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAndRun>>, TError,{projectId: string;data: RunSearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAndRun>>, TError,{projectId: string;data: RunSearchRequestSchema}, TContext> => {

const mutationKey = ['createAndRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAndRun>>, {projectId: string;data: RunSearchRequestSchema}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createAndRun(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAndRunMutationResult = NonNullable<Awaited<ReturnType<typeof createAndRun>>>
    export type CreateAndRunMutationBody = RunSearchRequestSchema
    export type CreateAndRunMutationError = HTTPValidationError

    /**
 * @summary Create And Run
 */
export const useCreateAndRun = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAndRun>>, TError,{projectId: string;data: RunSearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAndRun>>,
        TError,
        {projectId: string;data: RunSearchRequestSchema},
        TContext
      > => {
      return useMutation(getCreateAndRunMutationOptions(options), queryClient);
    }

export const getRunSearchUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/run`
}

/**
 * @summary Run Search
 */
export const runSearch = async (searchId: string,
    runSearchRequestSchema: RunSearchRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<SearchWithRunResponseSchema> => {

  return customInstance<SearchWithRunResponseSchema>(getRunSearchUrl(searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runSearchRequestSchema)
  }
);}





export const getRunSearchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSearch>>, TError,{searchId: string;data: RunSearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runSearch>>, TError,{searchId: string;data: RunSearchRequestSchema}, TContext> => {

const mutationKey = ['runSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runSearch>>, {searchId: string;data: RunSearchRequestSchema}> = (props) => {
          const {searchId,data} = props ?? {};

          return  runSearch(searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunSearchMutationResult = NonNullable<Awaited<ReturnType<typeof runSearch>>>
    export type RunSearchMutationBody = RunSearchRequestSchema
    export type RunSearchMutationError = HTTPValidationError

    /**
 * @summary Run Search
 */
export const useRunSearch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSearch>>, TError,{searchId: string;data: RunSearchRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runSearch>>,
        TError,
        {searchId: string;data: RunSearchRequestSchema},
        TContext
      > => {
      return useMutation(getRunSearchMutationOptions(options), queryClient);
    }

export const getCancelRunUrl = (searchId: string,) => {




  return `/api/searches/${searchId}/run/cancel`
}

/**
 * @summary Cancel Run
 */
export const cancelRun = async (searchId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getCancelRunUrl(searchId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelRunMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,{searchId: string}, TContext> => {

const mutationKey = ['cancelRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRun>>, {searchId: string}> = (props) => {
          const {searchId} = props ?? {};

          return  cancelRun(searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRun>>>

    export type CancelRunMutationError = HTTPValidationError

    /**
 * @summary Cancel Run
 */
export const useCancelRun = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,{searchId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRun>>,
        TError,
        {searchId: string},
        TContext
      > => {
      return useMutation(getCancelRunMutationOptions(options), queryClient);
    }

export const getGetSearchResultsUrl = (searchId: string,
    params?: GetSearchResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/searches/${searchId}/results?${stringifiedParams}` : `/api/searches/${searchId}/results`
}

/**
 * @summary Get Search Results
 */
export const getSearchResults = async (searchId: string,
    params?: GetSearchResultsParams, options?: Parameters<typeof customInstance>[1]): Promise<SearchResultsPageSchema> => {

  return customInstance<SearchResultsPageSchema>(getGetSearchResultsUrl(searchId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSearchResultsQueryKey = (searchId: string,
    params?: GetSearchResultsParams,) => {
    return [
    `/api/searches/${searchId}/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSearchResultsQueryOptions = <TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchResultsQueryKey(searchId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchResults>>> = ({ signal }) => getSearchResults(searchId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: searchId !== null && searchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchResults>>>
export type GetSearchResultsQueryError = HTTPValidationError


export function useGetSearchResults<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params: undefined |  GetSearchResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResults>>,
          TError,
          Awaited<ReturnType<typeof getSearchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResults<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResults>>,
          TError,
          Awaited<ReturnType<typeof getSearchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResults<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Search Results
 */

export function useGetSearchResults<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchResultsQueryOptions(searchId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSearchResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchResultsQueryKey(searchId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchResults>>> = ({ signal }) => getSearchResults(searchId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchResults>>>
export type GetSearchResultsSuspenseQueryError = HTTPValidationError


export function useGetSearchResultsSuspense<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params: undefined |  GetSearchResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsSuspense<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsSuspense<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Search Results
 */

export function useGetSearchResultsSuspense<TData = Awaited<ReturnType<typeof getSearchResults>>, TError = HTTPValidationError>(
 searchId: string,
    params?: GetSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchResultsSuspenseQueryOptions(searchId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamProjectSearchRunsUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/search-runs/stream`
}

/**
 * @summary Stream Project Search Runs
 */
export const streamProjectSearchRuns = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getStreamProjectSearchRunsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamProjectSearchRunsQueryKey = (projectId: string,) => {
    return [
    `/api/projects/${projectId}/search-runs/stream`
    ] as const;
    }


export const getStreamProjectSearchRunsQueryOptions = <TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamProjectSearchRunsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamProjectSearchRuns>>> = ({ signal }) => streamProjectSearchRuns(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamProjectSearchRunsQueryResult = NonNullable<Awaited<ReturnType<typeof streamProjectSearchRuns>>>
export type StreamProjectSearchRunsQueryError = HTTPValidationError


export function useStreamProjectSearchRuns<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamProjectSearchRuns>>,
          TError,
          Awaited<ReturnType<typeof streamProjectSearchRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectSearchRuns<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamProjectSearchRuns>>,
          TError,
          Awaited<ReturnType<typeof streamProjectSearchRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectSearchRuns<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Project Search Runs
 */

export function useStreamProjectSearchRuns<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamProjectSearchRunsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStreamProjectSearchRunsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamProjectSearchRunsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamProjectSearchRuns>>> = ({ signal }) => streamProjectSearchRuns(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamProjectSearchRunsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof streamProjectSearchRuns>>>
export type StreamProjectSearchRunsSuspenseQueryError = HTTPValidationError


export function useStreamProjectSearchRunsSuspense<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectSearchRunsSuspense<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectSearchRunsSuspense<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Project Search Runs
 */

export function useStreamProjectSearchRunsSuspense<TData = Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectSearchRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamProjectSearchRunsSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamProjectConversationsUrl = (projectId: string,) => {




  return `/api/projects/${projectId}/conversations/stream`
}

/**
 * @summary Stream Project Conversations
 */
export const streamProjectConversations = async (projectId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getStreamProjectConversationsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamProjectConversationsQueryKey = (projectId: string,) => {
    return [
    `/api/projects/${projectId}/conversations/stream`
    ] as const;
    }


export const getStreamProjectConversationsQueryOptions = <TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamProjectConversationsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamProjectConversations>>> = ({ signal }) => streamProjectConversations(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamProjectConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof streamProjectConversations>>>
export type StreamProjectConversationsQueryError = HTTPValidationError


export function useStreamProjectConversations<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamProjectConversations>>,
          TError,
          Awaited<ReturnType<typeof streamProjectConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectConversations<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamProjectConversations>>,
          TError,
          Awaited<ReturnType<typeof streamProjectConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectConversations<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Project Conversations
 */

export function useStreamProjectConversations<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamProjectConversationsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStreamProjectConversationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamProjectConversationsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamProjectConversations>>> = ({ signal }) => streamProjectConversations(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StreamProjectConversationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof streamProjectConversations>>>
export type StreamProjectConversationsSuspenseQueryError = HTTPValidationError


export function useStreamProjectConversationsSuspense<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectConversationsSuspense<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStreamProjectConversationsSuspense<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream Project Conversations
 */

export function useStreamProjectConversationsSuspense<TData = Awaited<ReturnType<typeof streamProjectConversations>>, TError = HTTPValidationError>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof streamProjectConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamProjectConversationsSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUniversalSearchUrl = (params: UniversalSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search/universal?${stringifiedParams}` : `/api/search/universal`
}

/**
 * @summary Universal Search
 */
export const universalSearch = async (params: UniversalSearchParams, options?: Parameters<typeof customInstance>[1]): Promise<UniversalSearchResponseSchema> => {

  return customInstance<UniversalSearchResponseSchema>(getUniversalSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUniversalSearchQueryKey = (params?: UniversalSearchParams,) => {
    return [
    `/api/search/universal`, ...(params ? [params] : [])
    ] as const;
    }


export const getUniversalSearchQueryOptions = <TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(params: UniversalSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniversalSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof universalSearch>>> = ({ signal }) => universalSearch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UniversalSearchQueryResult = NonNullable<Awaited<ReturnType<typeof universalSearch>>>
export type UniversalSearchQueryError = HTTPValidationError


export function useUniversalSearch<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof universalSearch>>,
          TError,
          Awaited<ReturnType<typeof universalSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniversalSearch<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof universalSearch>>,
          TError,
          Awaited<ReturnType<typeof universalSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniversalSearch<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Universal Search
 */

export function useUniversalSearch<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUniversalSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUniversalSearchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(params: UniversalSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniversalSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof universalSearch>>> = ({ signal }) => universalSearch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UniversalSearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof universalSearch>>>
export type UniversalSearchSuspenseQueryError = HTTPValidationError


export function useUniversalSearchSuspense<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniversalSearchSuspense<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniversalSearchSuspense<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Universal Search
 */

export function useUniversalSearchSuspense<TData = Awaited<ReturnType<typeof universalSearch>>, TError = HTTPValidationError>(
 params: UniversalSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof universalSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUniversalSearchSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSequencesUrl = (jobId: string,
    params?: ListSequencesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/sequences?${stringifiedParams}` : `/api/jobs/${jobId}/sequences`
}

/**
 * Paginated list of sequences within a job.
 *
 * Archived sequences are hidden unless ``include_archived=true``.
 * Returns a slim envelope with ``sequences``, ``next_cursor``, and
 * ``total`` so the inbox / list page can page server-side.
 * @summary List Sequences
 */
export const listSequences = async (jobId: string,
    params?: ListSequencesParams, options?: Parameters<typeof customInstance>[1]): Promise<ListSequences200> => {

  return customInstance<ListSequences200>(getListSequencesUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSequencesQueryKey = (jobId: string,
    params?: ListSequencesParams,) => {
    return [
    `/api/jobs/${jobId}/sequences`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSequencesQueryOptions = <TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSequencesQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSequences>>> = ({ signal }) => listSequences(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSequencesQueryResult = NonNullable<Awaited<ReturnType<typeof listSequences>>>
export type ListSequencesQueryError = HTTPValidationError


export function useListSequences<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListSequencesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSequences>>,
          TError,
          Awaited<ReturnType<typeof listSequences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSequences<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSequences>>,
          TError,
          Awaited<ReturnType<typeof listSequences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSequences<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sequences
 */

export function useListSequences<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSequencesQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSequencesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSequencesQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSequences>>> = ({ signal }) => listSequences(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSequencesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSequences>>>
export type ListSequencesSuspenseQueryError = HTTPValidationError


export function useListSequencesSuspense<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  ListSequencesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSequencesSuspense<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSequencesSuspense<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sequences
 */

export function useListSequencesSuspense<TData = Awaited<ReturnType<typeof listSequences>>, TError = HTTPValidationError>(
 jobId: string,
    params?: ListSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSequencesSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSequenceUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/sequences`
}

/**
 * Create a sequence under the given job (empty step_set v1).
 * @summary Create Sequence
 */
export const createSequence = async (jobId: string,
    sequenceCreate: SequenceCreate, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getCreateSequenceUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sequenceCreate)
  }
);}





export const getCreateSequenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSequence>>, TError,{jobId: string;data: SequenceCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSequence>>, TError,{jobId: string;data: SequenceCreate}, TContext> => {

const mutationKey = ['createSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSequence>>, {jobId: string;data: SequenceCreate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  createSequence(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof createSequence>>>
    export type CreateSequenceMutationBody = SequenceCreate
    export type CreateSequenceMutationError = HTTPValidationError

    /**
 * @summary Create Sequence
 */
export const useCreateSequence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSequence>>, TError,{jobId: string;data: SequenceCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSequence>>,
        TError,
        {jobId: string;data: SequenceCreate},
        TContext
      > => {
      return useMutation(getCreateSequenceMutationOptions(options), queryClient);
    }

export const getGetJobSequenceAnalyticsUrl = (jobId: string,
    params?: GetJobSequenceAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/sequences/analytics?${stringifiedParams}` : `/api/jobs/${jobId}/sequences/analytics`
}

/**
 * Usage analytics across ALL sequences in the job.
 *
 * Powers the sequences list page chart (emails sent / replies /
 * interested by day) + Overview sidebar. Trailing ``days`` calendar
 * days in the caller's IANA timezone ``tz``.
 *
 * Scoping: job must be in the actor's org (404 otherwise, no leak)
 * AND the actor must pass the project ACL for viewing the job —
 * same two-layer gate the inbox routes use.
 * @summary Get Job Sequence Analytics
 */
export const getJobSequenceAnalytics = async (jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: Parameters<typeof customInstance>[1]): Promise<JobSequenceAnalyticsResponse> => {

  return customInstance<JobSequenceAnalyticsResponse>(getGetJobSequenceAnalyticsUrl(jobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobSequenceAnalyticsQueryKey = (jobId: string,
    params?: GetJobSequenceAnalyticsParams,) => {
    return [
    `/api/jobs/${jobId}/sequences/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetJobSequenceAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobSequenceAnalyticsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobSequenceAnalytics>>> = ({ signal }) => getJobSequenceAnalytics(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobSequenceAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobSequenceAnalytics>>>
export type GetJobSequenceAnalyticsQueryError = HTTPValidationError


export function useGetJobSequenceAnalytics<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  GetJobSequenceAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobSequenceAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getJobSequenceAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSequenceAnalytics<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobSequenceAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getJobSequenceAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSequenceAnalytics<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Sequence Analytics
 */

export function useGetJobSequenceAnalytics<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobSequenceAnalyticsQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobSequenceAnalyticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobSequenceAnalyticsQueryKey(jobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobSequenceAnalytics>>> = ({ signal }) => getJobSequenceAnalytics(jobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobSequenceAnalyticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getJobSequenceAnalytics>>>
export type GetJobSequenceAnalyticsSuspenseQueryError = HTTPValidationError


export function useGetJobSequenceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params: undefined |  GetJobSequenceAnalyticsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSequenceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobSequenceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Sequence Analytics
 */

export function useGetJobSequenceAnalyticsSuspense<TData = Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError = HTTPValidationError>(
 jobId: string,
    params?: GetJobSequenceAnalyticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobSequenceAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobSequenceAnalyticsSuspenseQueryOptions(jobId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCloneSequenceUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/clone`
}

/**
 * Clone ``{sequence_id}`` into a new draft sequence in the same job.
 *
 * The new sequence takes its name / sender / mailbox / schedule / rules
 * from the request body (the clone wizard prefills these from the source
 * but the user may edit them) and copies the source's current steps. The
 * source is identified by the path ``sequence_id`` and must belong to the
 * same job + org.
 * @summary Clone Sequence
 */
export const cloneSequence = async (jobId: string,
    sequenceId: string,
    sequenceCreate: SequenceCreate, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getCloneSequenceUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sequenceCreate)
  }
);}





export const getCloneSequenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceCreate}, TContext> => {

const mutationKey = ['cloneSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneSequence>>, {jobId: string;sequenceId: string;data: SequenceCreate}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  cloneSequence(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof cloneSequence>>>
    export type CloneSequenceMutationBody = SequenceCreate
    export type CloneSequenceMutationError = HTTPValidationError

    /**
 * @summary Clone Sequence
 */
export const useCloneSequence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneSequence>>,
        TError,
        {jobId: string;sequenceId: string;data: SequenceCreate},
        TContext
      > => {
      return useMutation(getCloneSequenceMutationOptions(options), queryClient);
    }

export const getCloneSequenceStepsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/clone-steps`
}

/**
 * Overwrite ``{sequence_id}``'s steps with ``source_sequence_id``'s steps.
 *
 * Both sequences must belong to the actor's org; a sequence cannot clone
 * from itself, and the source must have at least one step. The target's
 * status is preserved (a draft stays a draft).
 * @summary Clone Sequence Steps
 */
export const cloneSequenceSteps = async (jobId: string,
    sequenceId: string,
    sequenceCloneStepsRequest: SequenceCloneStepsRequest, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getCloneSequenceStepsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sequenceCloneStepsRequest)
  }
);}





export const getCloneSequenceStepsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneSequenceSteps>>, TError,{jobId: string;sequenceId: string;data: SequenceCloneStepsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneSequenceSteps>>, TError,{jobId: string;sequenceId: string;data: SequenceCloneStepsRequest}, TContext> => {

const mutationKey = ['cloneSequenceSteps'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneSequenceSteps>>, {jobId: string;sequenceId: string;data: SequenceCloneStepsRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  cloneSequenceSteps(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneSequenceStepsMutationResult = NonNullable<Awaited<ReturnType<typeof cloneSequenceSteps>>>
    export type CloneSequenceStepsMutationBody = SequenceCloneStepsRequest
    export type CloneSequenceStepsMutationError = HTTPValidationError

    /**
 * @summary Clone Sequence Steps
 */
export const useCloneSequenceSteps = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneSequenceSteps>>, TError,{jobId: string;sequenceId: string;data: SequenceCloneStepsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneSequenceSteps>>,
        TError,
        {jobId: string;sequenceId: string;data: SequenceCloneStepsRequest},
        TContext
      > => {
      return useMutation(getCloneSequenceStepsMutationOptions(options), queryClient);
    }

export const getGetSequenceUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}`
}

/**
 * @summary Get Sequence
 */
export const getSequence = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getGetSequenceUrl(jobId,sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSequenceQueryKey = (jobId: string,
    sequenceId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}`
    ] as const;
    }


export const getGetSequenceQueryOptions = <TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSequenceQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSequence>>> = ({ signal }) => getSequence(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSequenceQueryResult = NonNullable<Awaited<ReturnType<typeof getSequence>>>
export type GetSequenceQueryError = HTTPValidationError


export function useGetSequence<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSequence>>,
          TError,
          Awaited<ReturnType<typeof getSequence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSequence<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSequence>>,
          TError,
          Awaited<ReturnType<typeof getSequence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSequence<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sequence
 */

export function useGetSequence<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSequenceQueryOptions(jobId,sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSequenceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSequenceQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSequence>>> = ({ signal }) => getSequence(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSequenceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSequence>>>
export type GetSequenceSuspenseQueryError = HTTPValidationError


export function useGetSequenceSuspense<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSequenceSuspense<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSequenceSuspense<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sequence
 */

export function useGetSequenceSuspense<TData = Awaited<ReturnType<typeof getSequence>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSequence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSequenceSuspenseQueryOptions(jobId,sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSequenceUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}`
}

/**
 * @summary Update Sequence
 */
export const updateSequence = async (jobId: string,
    sequenceId: string,
    sequenceUpdate: SequenceUpdate, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getUpdateSequenceUrl(jobId,sequenceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sequenceUpdate)
  }
);}





export const getUpdateSequenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceUpdate}, TContext> => {

const mutationKey = ['updateSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSequence>>, {jobId: string;sequenceId: string;data: SequenceUpdate}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  updateSequence(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateSequence>>>
    export type UpdateSequenceMutationBody = SequenceUpdate
    export type UpdateSequenceMutationError = HTTPValidationError

    /**
 * @summary Update Sequence
 */
export const useUpdateSequence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSequence>>, TError,{jobId: string;sequenceId: string;data: SequenceUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSequence>>,
        TError,
        {jobId: string;sequenceId: string;data: SequenceUpdate},
        TContext
      > => {
      return useMutation(getUpdateSequenceMutationOptions(options), queryClient);
    }

export const getArchiveSequenceUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/archive`
}

/**
 * Soft-archive a sequence: hide it + block new enrollments.
 *
 * In-flight enrollments are unaffected. Reversible via ``/unarchive``.
 * @summary Archive Sequence
 */
export const archiveSequence = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getArchiveSequenceUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveSequenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext> => {

const mutationKey = ['archiveSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveSequence>>, {jobId: string;sequenceId: string}> = (props) => {
          const {jobId,sequenceId} = props ?? {};

          return  archiveSequence(jobId,sequenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof archiveSequence>>>

    export type ArchiveSequenceMutationError = HTTPValidationError

    /**
 * @summary Archive Sequence
 */
export const useArchiveSequence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveSequence>>,
        TError,
        {jobId: string;sequenceId: string},
        TContext
      > => {
      return useMutation(getArchiveSequenceMutationOptions(options), queryClient);
    }

export const getUnarchiveSequenceUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/unarchive`
}

/**
 * Restore a soft-archived sequence (clears ``archived_at``).
 * @summary Unarchive Sequence
 */
export const unarchiveSequence = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getUnarchiveSequenceUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveSequenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext> => {

const mutationKey = ['unarchiveSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveSequence>>, {jobId: string;sequenceId: string}> = (props) => {
          const {jobId,sequenceId} = props ?? {};

          return  unarchiveSequence(jobId,sequenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveSequence>>>

    export type UnarchiveSequenceMutationError = HTTPValidationError

    /**
 * @summary Unarchive Sequence
 */
export const useUnarchiveSequence = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveSequence>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveSequence>>,
        TError,
        {jobId: string;sequenceId: string},
        TContext
      > => {
      return useMutation(getUnarchiveSequenceMutationOptions(options), queryClient);
    }

export const getListStepSetsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/step-sets`
}

/**
 * List all versioned step sets for a sequence (newest first).
 * @summary List Step Sets
 */
export const listStepSets = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<ListStepSets200> => {

  return customInstance<ListStepSets200>(getListStepSetsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStepSetsQueryKey = (jobId: string,
    sequenceId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/step-sets`
    ] as const;
    }


export const getListStepSetsQueryOptions = <TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStepSetsQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStepSets>>> = ({ signal }) => listStepSets(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStepSetsQueryResult = NonNullable<Awaited<ReturnType<typeof listStepSets>>>
export type ListStepSetsQueryError = HTTPValidationError


export function useListStepSets<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStepSets>>,
          TError,
          Awaited<ReturnType<typeof listStepSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStepSets<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStepSets>>,
          TError,
          Awaited<ReturnType<typeof listStepSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStepSets<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Step Sets
 */

export function useListStepSets<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStepSetsQueryOptions(jobId,sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListStepSetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStepSetsQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStepSets>>> = ({ signal }) => listStepSets(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStepSetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listStepSets>>>
export type ListStepSetsSuspenseQueryError = HTTPValidationError


export function useListStepSetsSuspense<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStepSetsSuspense<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStepSetsSuspense<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Step Sets
 */

export function useListStepSetsSuspense<TData = Awaited<ReturnType<typeof listStepSets>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStepSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStepSetsSuspenseQueryOptions(jobId,sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStepSetVersionUrl = (jobId: string,
    sequenceId: string,
    version: number,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/step-sets/${version}`
}

/**
 * Fetch a specific step_set version with its full ordered step list.
 * @summary Get Step Set Version
 */
export const getStepSetVersion = async (jobId: string,
    sequenceId: string,
    version: number, options?: Parameters<typeof customInstance>[1]): Promise<SequenceStepSetResponse> => {

  return customInstance<SequenceStepSetResponse>(getGetStepSetVersionUrl(jobId,sequenceId,version),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStepSetVersionQueryKey = (jobId: string,
    sequenceId: string,
    version: number,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/step-sets/${version}`
    ] as const;
    }


export const getGetStepSetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepSetVersionQueryKey(jobId,sequenceId,version);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStepSetVersion>>> = ({ signal }) => getStepSetVersion(jobId,sequenceId,version, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined && version !== null && version !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStepSetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getStepSetVersion>>>
export type GetStepSetVersionQueryError = HTTPValidationError


export function useGetStepSetVersion<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStepSetVersion>>,
          TError,
          Awaited<ReturnType<typeof getStepSetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepSetVersion<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStepSetVersion>>,
          TError,
          Awaited<ReturnType<typeof getStepSetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepSetVersion<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Step Set Version
 */

export function useGetStepSetVersion<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStepSetVersionQueryOptions(jobId,sequenceId,version,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetStepSetVersionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepSetVersionQueryKey(jobId,sequenceId,version);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStepSetVersion>>> = ({ signal }) => getStepSetVersion(jobId,sequenceId,version, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStepSetVersionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStepSetVersion>>>
export type GetStepSetVersionSuspenseQueryError = HTTPValidationError


export function useGetStepSetVersionSuspense<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepSetVersionSuspense<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepSetVersionSuspense<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Step Set Version
 */

export function useGetStepSetVersionSuspense<TData = Awaited<ReturnType<typeof getStepSetVersion>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    version: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStepSetVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStepSetVersionSuspenseQueryOptions(jobId,sequenceId,version,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateStepUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps`
}

/**
 * Append a step (clones step_set + emits both audits).
 * @summary Create Step
 */
export const createStep = async (jobId: string,
    sequenceId: string,
    automaticEmailStepManualEmailStepPhoneCallStepTextMessageStepCustomTaskStepLinkedInProfileViewStepLinkedInConnectionRequestStepLinkedInMessageStep: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getCreateStepUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(automaticEmailStepManualEmailStepPhoneCallStepTextMessageStepCustomTaskStepLinkedInProfileViewStepLinkedInConnectionRequestStepLinkedInMessageStep)
  }
);}





export const getCreateStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStep>>, TError,{jobId: string;sequenceId: string;data: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createStep>>, TError,{jobId: string;sequenceId: string;data: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep}, TContext> => {

const mutationKey = ['createStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStep>>, {jobId: string;sequenceId: string;data: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  createStep(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStepMutationResult = NonNullable<Awaited<ReturnType<typeof createStep>>>
    export type CreateStepMutationBody = AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep
    export type CreateStepMutationError = HTTPValidationError

    /**
 * @summary Create Step
 */
export const useCreateStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStep>>, TError,{jobId: string;sequenceId: string;data: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStep>>,
        TError,
        {jobId: string;sequenceId: string;data: AutomaticEmailStep | ManualEmailStep | PhoneCallStep | TextMessageStep | CustomTaskStep | LinkedInProfileViewStep | LinkedInConnectionRequestStep | LinkedInMessageStep},
        TContext
      > => {
      return useMutation(getCreateStepMutationOptions(options), queryClient);
    }

export const getClearStepsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps`
}

/**
 * Remove ALL steps from a sequence (clones to an empty step set).
 * @summary Clear Steps
 */
export const clearSteps = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getClearStepsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearStepsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearSteps>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearSteps>>, TError,{jobId: string;sequenceId: string}, TContext> => {

const mutationKey = ['clearSteps'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearSteps>>, {jobId: string;sequenceId: string}> = (props) => {
          const {jobId,sequenceId} = props ?? {};

          return  clearSteps(jobId,sequenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearStepsMutationResult = NonNullable<Awaited<ReturnType<typeof clearSteps>>>

    export type ClearStepsMutationError = HTTPValidationError

    /**
 * @summary Clear Steps
 */
export const useClearSteps = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearSteps>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearSteps>>,
        TError,
        {jobId: string;sequenceId: string},
        TContext
      > => {
      return useMutation(getClearStepsMutationOptions(options), queryClient);
    }

export const getReorderStepsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps/reorder`
}

/**
 * @summary Reorder Steps
 */
export const reorderSteps = async (jobId: string,
    sequenceId: string,
    stepReorderRequest: StepReorderRequest, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getReorderStepsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stepReorderRequest)
  }
);}





export const getReorderStepsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSteps>>, TError,{jobId: string;sequenceId: string;data: StepReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderSteps>>, TError,{jobId: string;sequenceId: string;data: StepReorderRequest}, TContext> => {

const mutationKey = ['reorderSteps'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderSteps>>, {jobId: string;sequenceId: string;data: StepReorderRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  reorderSteps(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderStepsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderSteps>>>
    export type ReorderStepsMutationBody = StepReorderRequest
    export type ReorderStepsMutationError = HTTPValidationError

    /**
 * @summary Reorder Steps
 */
export const useReorderSteps = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSteps>>, TError,{jobId: string;sequenceId: string;data: StepReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderSteps>>,
        TError,
        {jobId: string;sequenceId: string;data: StepReorderRequest},
        TContext
      > => {
      return useMutation(getReorderStepsMutationOptions(options), queryClient);
    }

export const getUpdateStepUrl = (jobId: string,
    sequenceId: string,
    stepId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps/${stepId}`
}

/**
 * Patch a step in place (clones step_set).
 * @summary Update Step
 */
export const updateStep = async (jobId: string,
    sequenceId: string,
    stepId: string,
    stepUpdate: StepUpdate, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getUpdateStepUrl(jobId,sequenceId,stepId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stepUpdate)
  }
);}





export const getUpdateStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: StepUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: StepUpdate}, TContext> => {

const mutationKey = ['updateStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStep>>, {jobId: string;sequenceId: string;stepId: string;data: StepUpdate}> = (props) => {
          const {jobId,sequenceId,stepId,data} = props ?? {};

          return  updateStep(jobId,sequenceId,stepId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStepMutationResult = NonNullable<Awaited<ReturnType<typeof updateStep>>>
    export type UpdateStepMutationBody = StepUpdate
    export type UpdateStepMutationError = HTTPValidationError

    /**
 * @summary Update Step
 */
export const useUpdateStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: StepUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStep>>,
        TError,
        {jobId: string;sequenceId: string;stepId: string;data: StepUpdate},
        TContext
      > => {
      return useMutation(getUpdateStepMutationOptions(options), queryClient);
    }

export const getDeleteStepUrl = (jobId: string,
    sequenceId: string,
    stepId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps/${stepId}`
}

/**
 * @summary Delete Step
 */
export const deleteStep = async (jobId: string,
    sequenceId: string,
    stepId: string, options?: Parameters<typeof customInstance>[1]): Promise<SequenceResponse> => {

  return customInstance<SequenceResponse>(getDeleteStepUrl(jobId,sequenceId,stepId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStep>>, TError,{jobId: string;sequenceId: string;stepId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStep>>, TError,{jobId: string;sequenceId: string;stepId: string}, TContext> => {

const mutationKey = ['deleteStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStep>>, {jobId: string;sequenceId: string;stepId: string}> = (props) => {
          const {jobId,sequenceId,stepId} = props ?? {};

          return  deleteStep(jobId,sequenceId,stepId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStepMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStep>>>

    export type DeleteStepMutationError = HTTPValidationError

    /**
 * @summary Delete Step
 */
export const useDeleteStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStep>>, TError,{jobId: string;sequenceId: string;stepId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStep>>,
        TError,
        {jobId: string;sequenceId: string;stepId: string},
        TContext
      > => {
      return useMutation(getDeleteStepMutationOptions(options), queryClient);
    }

export const getPreviewStepUrl = (jobId: string,
    sequenceId: string,
    stepId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps/${stepId}/preview`
}

/**
 * Render a step against a sample candidate.
 *
 * Variables / snippet / AI-prompt expansion errors surface as
 * ``warnings`` rather than 500s — the user is iterating on a draft
 * and needs the preview to load even when one variable is missing.
 * @summary Preview Step
 */
export const previewStep = async (jobId: string,
    sequenceId: string,
    stepId: string,
    previewStepBody?: PreviewStepBody, options?: Parameters<typeof customInstance>[1]): Promise<RenderedStepPreview> => {

  return customInstance<RenderedStepPreview>(getPreviewStepUrl(jobId,sequenceId,stepId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(previewStepBody)
  }
);}





export const getPreviewStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data?: PreviewStepBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data?: PreviewStepBody}, TContext> => {

const mutationKey = ['previewStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewStep>>, {jobId: string;sequenceId: string;stepId: string;data?: PreviewStepBody}> = (props) => {
          const {jobId,sequenceId,stepId,data} = props ?? {};

          return  previewStep(jobId,sequenceId,stepId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewStepMutationResult = NonNullable<Awaited<ReturnType<typeof previewStep>>>
    export type PreviewStepMutationBody = PreviewStepBody | undefined
    export type PreviewStepMutationError = HTTPValidationError

    /**
 * @summary Preview Step
 */
export const usePreviewStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data?: PreviewStepBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewStep>>,
        TError,
        {jobId: string;sequenceId: string;stepId: string;data?: PreviewStepBody},
        TContext
      > => {
      return useMutation(getPreviewStepMutationOptions(options), queryClient);
    }

export const getTestSendStepUrl = (jobId: string,
    sequenceId: string,
    stepId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/steps/${stepId}/test-send`
}

/**
 * Send a one-off test of the step to ``destination_email``.
 *
 * Rate-limited at 100 sends per user per hour. Subject is forced to
 * ``[TEST]`` prefix so a stray test never lands at a real candidate's
 * inbox unbranded.
 * @summary Test Send Step
 */
export const testSendStep = async (jobId: string,
    sequenceId: string,
    stepId: string,
    testSendStepBody: TestSendStepBody, options?: Parameters<typeof customInstance>[1]): Promise<TestSendStep202> => {

  return customInstance<TestSendStep202>(getTestSendStepUrl(jobId,sequenceId,stepId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(testSendStepBody)
  }
);}





export const getTestSendStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSendStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: TestSendStepBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testSendStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: TestSendStepBody}, TContext> => {

const mutationKey = ['testSendStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testSendStep>>, {jobId: string;sequenceId: string;stepId: string;data: TestSendStepBody}> = (props) => {
          const {jobId,sequenceId,stepId,data} = props ?? {};

          return  testSendStep(jobId,sequenceId,stepId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestSendStepMutationResult = NonNullable<Awaited<ReturnType<typeof testSendStep>>>
    export type TestSendStepMutationBody = TestSendStepBody
    export type TestSendStepMutationError = HTTPValidationError

    /**
 * @summary Test Send Step
 */
export const useTestSendStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSendStep>>, TError,{jobId: string;sequenceId: string;stepId: string;data: TestSendStepBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testSendStep>>,
        TError,
        {jobId: string;sequenceId: string;stepId: string;data: TestSendStepBody},
        TContext
      > => {
      return useMutation(getTestSendStepMutationOptions(options), queryClient);
    }

export const getWriteWithAiUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/write-with-ai`
}

/**
 * Generate / rewrite a ProseMirror doc via Gatewae for the given step type.
 * @summary Write With Ai
 */
export const writeWithAi = async (jobId: string,
    sequenceId: string,
    writeWithAIRequest: WriteWithAIRequest, options?: Parameters<typeof customInstance>[1]): Promise<WriteWithAIResponse> => {

  return customInstance<WriteWithAIResponse>(getWriteWithAiUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(writeWithAIRequest)
  }
);}





export const getWriteWithAiMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeWithAi>>, TError,{jobId: string;sequenceId: string;data: WriteWithAIRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof writeWithAi>>, TError,{jobId: string;sequenceId: string;data: WriteWithAIRequest}, TContext> => {

const mutationKey = ['writeWithAi'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeWithAi>>, {jobId: string;sequenceId: string;data: WriteWithAIRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  writeWithAi(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteWithAiMutationResult = NonNullable<Awaited<ReturnType<typeof writeWithAi>>>
    export type WriteWithAiMutationBody = WriteWithAIRequest
    export type WriteWithAiMutationError = HTTPValidationError

    /**
 * @summary Write With Ai
 */
export const useWriteWithAi = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeWithAi>>, TError,{jobId: string;sequenceId: string;data: WriteWithAIRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeWithAi>>,
        TError,
        {jobId: string;sequenceId: string;data: WriteWithAIRequest},
        TContext
      > => {
      return useMutation(getWriteWithAiMutationOptions(options), queryClient);
    }

export const getListProjectSequencesUrl = (projectId: string,
    params?: ListProjectSequencesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/sequences?${stringifiedParams}` : `/api/projects/${projectId}/sequences`
}

/**
 * Project-scoped variant of :func:`list_sequences`.
 *
 * Same envelope (``{ sequences, next_cursor, total }``) and filters as
 * the job-scoped route, but lists every sequence in the given project.
 * Used by surfaces (e.g. tasks filter sidebar, Organize → Sequences)
 * that need a project-wide picker rather than a single-job one. Org
 * isolation is enforced by the service via
 * ``Sequence.org_id == actor.org_id``; project ACL matches other
 * project-scoped surfaces.
 * @summary List Project Sequences
 */
export const listProjectSequences = async (projectId: string,
    params?: ListProjectSequencesParams, options?: Parameters<typeof customInstance>[1]): Promise<ListProjectSequences200> => {

  return customInstance<ListProjectSequences200>(getListProjectSequencesUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectSequencesQueryKey = (projectId: string,
    params?: ListProjectSequencesParams,) => {
    return [
    `/api/projects/${projectId}/sequences`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectSequencesQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequencesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequences>>> = ({ signal }) => listProjectSequences(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequencesQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequences>>>
export type ListProjectSequencesQueryError = HTTPValidationError


export function useListProjectSequences<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequencesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequences>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequences<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequences>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequences<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequences
 */

export function useListProjectSequences<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequencesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectSequencesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequencesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequences>>> = ({ signal }) => listProjectSequences(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequencesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequences>>>
export type ListProjectSequencesSuspenseQueryError = HTTPValidationError


export function useListProjectSequencesSuspense<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequencesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesSuspense<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesSuspense<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequences
 */

export function useListProjectSequencesSuspense<TData = Awaited<ReturnType<typeof listProjectSequences>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequencesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProjectSequencesByJobUrl = (projectId: string,
    params?: ListProjectSequencesByJobParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/sequences/by-job?${stringifiedParams}` : `/api/projects/${projectId}/sequences/by-job`
}

/**
 * Job-grouped project sequences for the Organize → Sequences sheet.
 *
 * Paginates by **sequences** (``page`` / ``per_page``, newest first).
 * The page slice is regrouped by job for the sheet UI — a job with many
 * sequences may span pages.
 *
 * Filters (all optional) are applied server-side before pagination:
 * ``search`` (job title / sequence name / sender), ``job_id`` + ``job_op``,
 * ``steps`` + ``steps_op``, ``enrollments`` + ``enrollments_op``
 * (enrollment total).
 * @summary List Project Sequences By Job
 */
export const listProjectSequencesByJob = async (projectId: string,
    params?: ListProjectSequencesByJobParams, options?: Parameters<typeof customInstance>[1]): Promise<ListProjectSequencesByJob200> => {

  return customInstance<ListProjectSequencesByJob200>(getListProjectSequencesByJobUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectSequencesByJobQueryKey = (projectId: string,
    params?: ListProjectSequencesByJobParams,) => {
    return [
    `/api/projects/${projectId}/sequences/by-job`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectSequencesByJobQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequencesByJobQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequencesByJob>>> = ({ signal }) => listProjectSequencesByJob(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequencesByJobQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequencesByJob>>>
export type ListProjectSequencesByJobQueryError = HTTPValidationError


export function useListProjectSequencesByJob<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequencesByJobParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequencesByJob>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequencesByJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesByJob<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequencesByJob>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequencesByJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesByJob<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequences By Job
 */

export function useListProjectSequencesByJob<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequencesByJobQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectSequencesByJobSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequencesByJobQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequencesByJob>>> = ({ signal }) => listProjectSequencesByJob(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequencesByJobSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequencesByJob>>>
export type ListProjectSequencesByJobSuspenseQueryError = HTTPValidationError


export function useListProjectSequencesByJobSuspense<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequencesByJobParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesByJobSuspense<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequencesByJobSuspense<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequences By Job
 */

export function useListProjectSequencesByJobSuspense<TData = Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequencesByJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequencesByJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequencesByJobSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProjectSequenceFilterJobsUrl = (projectId: string,
    params?: ListProjectSequenceFilterJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects/${projectId}/sequences/filter-jobs?${stringifiedParams}` : `/api/projects/${projectId}/sequences/filter-jobs`
}

/**
 * Jobs that have ≥1 sequence — for the Sequences sheet Job filter.
 *
 * Excludes jobs with zero sequences so the dropdown never offers empty
 * options. Ordered by most recently updated sequence in that job.
 * @summary List Project Sequence Filter Jobs
 */
export const listProjectSequenceFilterJobs = async (projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: Parameters<typeof customInstance>[1]): Promise<ListProjectSequenceFilterJobs200> => {

  return customInstance<ListProjectSequenceFilterJobs200>(getListProjectSequenceFilterJobsUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectSequenceFilterJobsQueryKey = (projectId: string,
    params?: ListProjectSequenceFilterJobsParams,) => {
    return [
    `/api/projects/${projectId}/sequences/filter-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectSequenceFilterJobsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequenceFilterJobsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>> = ({ signal }) => listProjectSequenceFilterJobs(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequenceFilterJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>>
export type ListProjectSequenceFilterJobsQueryError = HTTPValidationError


export function useListProjectSequenceFilterJobs<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequenceFilterJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequenceFilterJobs<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>,
          TError,
          Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequenceFilterJobs<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequence Filter Jobs
 */

export function useListProjectSequenceFilterJobs<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequenceFilterJobsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectSequenceFilterJobsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectSequenceFilterJobsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>> = ({ signal }) => listProjectSequenceFilterJobs(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectSequenceFilterJobsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>>
export type ListProjectSequenceFilterJobsSuspenseQueryError = HTTPValidationError


export function useListProjectSequenceFilterJobsSuspense<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params: undefined |  ListProjectSequenceFilterJobsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequenceFilterJobsSuspense<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectSequenceFilterJobsSuspense<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Project Sequence Filter Jobs
 */

export function useListProjectSequenceFilterJobsSuspense<TData = Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError = HTTPValidationError>(
 projectId: string,
    params?: ListProjectSequenceFilterJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectSequenceFilterJobs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectSequenceFilterJobsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePreviewUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview`
}

/**
 * Build a fresh preview session for a cohort + sequence.
 * @summary Create Preview
 */
export const createPreview = async (jobId: string,
    sequenceId: string,
    enrollmentPreviewRequest: EnrollmentPreviewRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentPreviewResponse> => {

  return customInstance<EnrollmentPreviewResponse>(getCreatePreviewUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enrollmentPreviewRequest)
  }
);}





export const getCreatePreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreview>>, TError,{jobId: string;sequenceId: string;data: EnrollmentPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPreview>>, TError,{jobId: string;sequenceId: string;data: EnrollmentPreviewRequest}, TContext> => {

const mutationKey = ['createPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPreview>>, {jobId: string;sequenceId: string;data: EnrollmentPreviewRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  createPreview(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePreviewMutationResult = NonNullable<Awaited<ReturnType<typeof createPreview>>>
    export type CreatePreviewMutationBody = EnrollmentPreviewRequest
    export type CreatePreviewMutationError = HTTPValidationError

    /**
 * @summary Create Preview
 */
export const useCreatePreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreview>>, TError,{jobId: string;sequenceId: string;data: EnrollmentPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPreview>>,
        TError,
        {jobId: string;sequenceId: string;data: EnrollmentPreviewRequest},
        TContext
      > => {
      return useMutation(getCreatePreviewMutationOptions(options), queryClient);
    }

export const getEstimateEnrollmentRevealUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/estimate`
}

/**
 * Credit estimate (upper bound) for enrolling a cohort.
 * @summary Estimate Enrollment Reveal
 */
export const estimateEnrollmentReveal = async (jobId: string,
    sequenceId: string,
    enrollmentRevealEstimateRequest: EnrollmentRevealEstimateRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentRevealEstimateResponse> => {

  return customInstance<EnrollmentRevealEstimateResponse>(getEstimateEnrollmentRevealUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enrollmentRevealEstimateRequest)
  }
);}





export const getEstimateEnrollmentRevealMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateEnrollmentReveal>>, TError,{jobId: string;sequenceId: string;data: EnrollmentRevealEstimateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof estimateEnrollmentReveal>>, TError,{jobId: string;sequenceId: string;data: EnrollmentRevealEstimateRequest}, TContext> => {

const mutationKey = ['estimateEnrollmentReveal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof estimateEnrollmentReveal>>, {jobId: string;sequenceId: string;data: EnrollmentRevealEstimateRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  estimateEnrollmentReveal(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EstimateEnrollmentRevealMutationResult = NonNullable<Awaited<ReturnType<typeof estimateEnrollmentReveal>>>
    export type EstimateEnrollmentRevealMutationBody = EnrollmentRevealEstimateRequest
    export type EstimateEnrollmentRevealMutationError = HTTPValidationError

    /**
 * @summary Estimate Enrollment Reveal
 */
export const useEstimateEnrollmentReveal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateEnrollmentReveal>>, TError,{jobId: string;sequenceId: string;data: EnrollmentRevealEstimateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof estimateEnrollmentReveal>>,
        TError,
        {jobId: string;sequenceId: string;data: EnrollmentRevealEstimateRequest},
        TContext
      > => {
      return useMutation(getEstimateEnrollmentRevealMutationOptions(options), queryClient);
    }

export const getGetPreviewUrl = (jobId: string,
    sequenceId: string,
    previewSessionId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}`
}

/**
 * @summary Get Preview
 */
export const getPreview = async (jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentPreviewResponse> => {

  return customInstance<EnrollmentPreviewResponse>(getGetPreviewUrl(jobId,sequenceId,previewSessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreviewQueryKey = (jobId: string,
    sequenceId: string,
    previewSessionId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}`
    ] as const;
    }


export const getGetPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreviewQueryKey(jobId,sequenceId,previewSessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreview>>> = ({ signal }) => getPreview(jobId,sequenceId,previewSessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined && previewSessionId !== null && previewSessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPreview>>>
export type GetPreviewQueryError = HTTPValidationError


export function useGetPreview<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreview>>,
          TError,
          Awaited<ReturnType<typeof getPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreview<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreview>>,
          TError,
          Awaited<ReturnType<typeof getPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreview<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preview
 */

export function useGetPreview<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreviewQueryOptions(jobId,sequenceId,previewSessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPreviewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreviewQueryKey(jobId,sequenceId,previewSessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreview>>> = ({ signal }) => getPreview(jobId,sequenceId,previewSessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPreview>>>
export type GetPreviewSuspenseQueryError = HTTPValidationError


export function useGetPreviewSuspense<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreviewSuspense<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreviewSuspense<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preview
 */

export function useGetPreviewSuspense<TData = Awaited<ReturnType<typeof getPreview>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreviewSuspenseQueryOptions(jobId,sequenceId,previewSessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchPreviewUrl = (jobId: string,
    sequenceId: string,
    previewSessionId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}`
}

/**
 * @summary Patch Preview
 */
export const patchPreview = async (jobId: string,
    sequenceId: string,
    previewSessionId: string,
    enrollmentPreviewPatchRequest: EnrollmentPreviewPatchRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentPreviewResponse> => {

  return customInstance<EnrollmentPreviewResponse>(getPatchPreviewUrl(jobId,sequenceId,previewSessionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enrollmentPreviewPatchRequest)
  }
);}





export const getPatchPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data: EnrollmentPreviewPatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data: EnrollmentPreviewPatchRequest}, TContext> => {

const mutationKey = ['patchPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPreview>>, {jobId: string;sequenceId: string;previewSessionId: string;data: EnrollmentPreviewPatchRequest}> = (props) => {
          const {jobId,sequenceId,previewSessionId,data} = props ?? {};

          return  patchPreview(jobId,sequenceId,previewSessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof patchPreview>>>
    export type PatchPreviewMutationBody = EnrollmentPreviewPatchRequest
    export type PatchPreviewMutationError = HTTPValidationError

    /**
 * @summary Patch Preview
 */
export const usePatchPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data: EnrollmentPreviewPatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPreview>>,
        TError,
        {jobId: string;sequenceId: string;previewSessionId: string;data: EnrollmentPreviewPatchRequest},
        TContext
      > => {
      return useMutation(getPatchPreviewMutationOptions(options), queryClient);
    }

export const getDiscardPreviewUrl = (jobId: string,
    sequenceId: string,
    previewSessionId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}`
}

/**
 * @summary Discard Preview
 */
export const discardPreview = async (jobId: string,
    sequenceId: string,
    previewSessionId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDiscardPreviewUrl(jobId,sequenceId,previewSessionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDiscardPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof discardPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string}, TContext> => {

const mutationKey = ['discardPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardPreview>>, {jobId: string;sequenceId: string;previewSessionId: string}> = (props) => {
          const {jobId,sequenceId,previewSessionId} = props ?? {};

          return  discardPreview(jobId,sequenceId,previewSessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof discardPreview>>>

    export type DiscardPreviewMutationError = HTTPValidationError

    /**
 * @summary Discard Preview
 */
export const useDiscardPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discardPreview>>,
        TError,
        {jobId: string;sequenceId: string;previewSessionId: string},
        TContext
      > => {
      return useMutation(getDiscardPreviewMutationOptions(options), queryClient);
    }

export const getCommitPreviewUrl = (jobId: string,
    sequenceId: string,
    previewSessionId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}/commit`
}

/**
 * Commit the preview into ``sequence_enrollments`` rows + start workflow.
 * @summary Commit Preview
 */
export const commitPreview = async (jobId: string,
    sequenceId: string,
    previewSessionId: string,
    enrollmentCommitRequest?: EnrollmentCommitRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentCommitResponse> => {

  return customInstance<EnrollmentCommitResponse>(getCommitPreviewUrl(jobId,sequenceId,previewSessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enrollmentCommitRequest)
  }
);}





export const getCommitPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commitPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data?: EnrollmentCommitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof commitPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data?: EnrollmentCommitRequest}, TContext> => {

const mutationKey = ['commitPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commitPreview>>, {jobId: string;sequenceId: string;previewSessionId: string;data?: EnrollmentCommitRequest}> = (props) => {
          const {jobId,sequenceId,previewSessionId,data} = props ?? {};

          return  commitPreview(jobId,sequenceId,previewSessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommitPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof commitPreview>>>
    export type CommitPreviewMutationBody = EnrollmentCommitRequest | undefined
    export type CommitPreviewMutationError = HTTPValidationError

    /**
 * @summary Commit Preview
 */
export const useCommitPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commitPreview>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;data?: EnrollmentCommitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commitPreview>>,
        TError,
        {jobId: string;sequenceId: string;previewSessionId: string;data?: EnrollmentCommitRequest},
        TContext
      > => {
      return useMutation(getCommitPreviewMutationOptions(options), queryClient);
    }

export const getSampleAiForStepUrl = (jobId: string,
    sequenceId: string,
    previewSessionId: string,
    jobCandidateId: string,
    stepId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enroll/preview/${previewSessionId}/candidates/${jobCandidateId}/steps/${stepId}/sample-ai`
}

/**
 * @summary Sample Ai For Step
 */
export const sampleAiForStep = async (jobId: string,
    sequenceId: string,
    previewSessionId: string,
    jobCandidateId: string,
    stepId: string, options?: Parameters<typeof customInstance>[1]): Promise<SampleAiForStep200> => {

  return customInstance<SampleAiForStep200>(getSampleAiForStepUrl(jobId,sequenceId,previewSessionId,jobCandidateId,stepId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSampleAiForStepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sampleAiForStep>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;jobCandidateId: string;stepId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sampleAiForStep>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;jobCandidateId: string;stepId: string}, TContext> => {

const mutationKey = ['sampleAiForStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sampleAiForStep>>, {jobId: string;sequenceId: string;previewSessionId: string;jobCandidateId: string;stepId: string}> = (props) => {
          const {jobId,sequenceId,previewSessionId,jobCandidateId,stepId} = props ?? {};

          return  sampleAiForStep(jobId,sequenceId,previewSessionId,jobCandidateId,stepId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SampleAiForStepMutationResult = NonNullable<Awaited<ReturnType<typeof sampleAiForStep>>>

    export type SampleAiForStepMutationError = HTTPValidationError

    /**
 * @summary Sample Ai For Step
 */
export const useSampleAiForStep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sampleAiForStep>>, TError,{jobId: string;sequenceId: string;previewSessionId: string;jobCandidateId: string;stepId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sampleAiForStep>>,
        TError,
        {jobId: string;sequenceId: string;previewSessionId: string;jobCandidateId: string;stepId: string},
        TContext
      > => {
      return useMutation(getSampleAiForStepMutationOptions(options), queryClient);
    }

export const getListEnrollmentsUrl = (jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses","steps","outcomes","engagement","names","exclude_names","emails","exclude_emails","stages","exclude_stages"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments?${stringifiedParams}` : `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments`
}

/**
 * List enrollments with server-side filter / sort / pagination.
 *
 * ``statuses`` / ``steps`` / ``outcomes`` / ``engagement`` / ``names`` /
 * ``emails`` / ``stages`` (and the ``exclude_*`` counterparts of the last
 * three) are repeated query params (multi-select facets);
 * ``sort_by`` / ``sort_order`` are comma-joined and index-aligned (same shape
 * as the pipeline list). ``status`` (singular) is kept for the legacy
 * single-status caller.
 *
 * Every repeated facet is capped, and each free-text term trimmed to length: a
 * query param can be repeated without limit, and a term becomes an ILIKE
 * branch, so an uncapped list is unbounded query work.
 * @summary List Enrollments
 */
export const listEnrollments = async (jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentListResponse> => {

  return customInstance<EnrollmentListResponse>(getListEnrollmentsUrl(jobId,sequenceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEnrollmentsQueryKey = (jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEnrollmentsQueryKey(jobId,sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrollments>>> = ({ signal }) => listEnrollments(jobId,sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrollments>>>
export type ListEnrollmentsQueryError = HTTPValidationError


export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params: undefined |  ListEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Enrollments
 */

export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEnrollmentsQueryOptions(jobId,sequenceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEnrollmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEnrollmentsQueryKey(jobId,sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrollments>>> = ({ signal }) => listEnrollments(jobId,sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEnrollmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrollments>>>
export type ListEnrollmentsSuspenseQueryError = HTTPValidationError


export function useListEnrollmentsSuspense<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params: undefined |  ListEnrollmentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollmentsSuspense<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollmentsSuspense<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Enrollments
 */

export function useListEnrollmentsSuspense<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: ListEnrollmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEnrollmentsSuspenseQueryOptions(jobId,sequenceId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkPauseEnrollmentsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/bulk-pause`
}

/**
 * Pause every eligible (``scheduled`` / ``active``) selected enrollment.
 * @summary Bulk Pause Enrollments
 */
export const bulkPauseEnrollments = async (jobId: string,
    sequenceId: string,
    bulkPauseRequest: BulkPauseRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkEnrollmentActionResponse> => {

  return customInstance<BulkEnrollmentActionResponse>(getBulkPauseEnrollmentsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkPauseRequest)
  }
);}





export const getBulkPauseEnrollmentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPauseEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkPauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkPauseEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkPauseRequest}, TContext> => {

const mutationKey = ['bulkPauseEnrollments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkPauseEnrollments>>, {jobId: string;sequenceId: string;data: BulkPauseRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  bulkPauseEnrollments(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkPauseEnrollmentsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkPauseEnrollments>>>
    export type BulkPauseEnrollmentsMutationBody = BulkPauseRequest
    export type BulkPauseEnrollmentsMutationError = HTTPValidationError

    /**
 * @summary Bulk Pause Enrollments
 */
export const useBulkPauseEnrollments = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPauseEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkPauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkPauseEnrollments>>,
        TError,
        {jobId: string;sequenceId: string;data: BulkPauseRequest},
        TContext
      > => {
      return useMutation(getBulkPauseEnrollmentsMutationOptions(options), queryClient);
    }

export const getBulkResumeEnrollmentsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/bulk-resume`
}

/**
 * Resume every eligible (``paused``) selected enrollment.
 * @summary Bulk Resume Enrollments
 */
export const bulkResumeEnrollments = async (jobId: string,
    sequenceId: string,
    bulkEnrollmentActionRequest: BulkEnrollmentActionRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkEnrollmentActionResponse> => {

  return customInstance<BulkEnrollmentActionResponse>(getBulkResumeEnrollmentsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkEnrollmentActionRequest)
  }
);}





export const getBulkResumeEnrollmentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkResumeEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkEnrollmentActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkResumeEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkEnrollmentActionRequest}, TContext> => {

const mutationKey = ['bulkResumeEnrollments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkResumeEnrollments>>, {jobId: string;sequenceId: string;data: BulkEnrollmentActionRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  bulkResumeEnrollments(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkResumeEnrollmentsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkResumeEnrollments>>>
    export type BulkResumeEnrollmentsMutationBody = BulkEnrollmentActionRequest
    export type BulkResumeEnrollmentsMutationError = HTTPValidationError

    /**
 * @summary Bulk Resume Enrollments
 */
export const useBulkResumeEnrollments = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkResumeEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkEnrollmentActionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkResumeEnrollments>>,
        TError,
        {jobId: string;sequenceId: string;data: BulkEnrollmentActionRequest},
        TContext
      > => {
      return useMutation(getBulkResumeEnrollmentsMutationOptions(options), queryClient);
    }

export const getBulkCancelEnrollmentsUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/bulk-cancel`
}

/**
 * Stop (cancel) every eligible (non-terminal) selected enrollment.
 * @summary Bulk Cancel Enrollments
 */
export const bulkCancelEnrollments = async (jobId: string,
    sequenceId: string,
    bulkCancelRequest: BulkCancelRequest, options?: Parameters<typeof customInstance>[1]): Promise<BulkEnrollmentActionResponse> => {

  return customInstance<BulkEnrollmentActionResponse>(getBulkCancelEnrollmentsUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkCancelRequest)
  }
);}





export const getBulkCancelEnrollmentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCancelEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCancelEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkCancelRequest}, TContext> => {

const mutationKey = ['bulkCancelEnrollments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCancelEnrollments>>, {jobId: string;sequenceId: string;data: BulkCancelRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  bulkCancelEnrollments(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCancelEnrollmentsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCancelEnrollments>>>
    export type BulkCancelEnrollmentsMutationBody = BulkCancelRequest
    export type BulkCancelEnrollmentsMutationError = HTTPValidationError

    /**
 * @summary Bulk Cancel Enrollments
 */
export const useBulkCancelEnrollments = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCancelEnrollments>>, TError,{jobId: string;sequenceId: string;data: BulkCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkCancelEnrollments>>,
        TError,
        {jobId: string;sequenceId: string;data: BulkCancelRequest},
        TContext
      > => {
      return useMutation(getBulkCancelEnrollmentsMutationOptions(options), queryClient);
    }

export const getGetEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}`
}

/**
 * @summary Get Enrollment
 */
export const getEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getGetEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEnrollmentQueryKey = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}`
    ] as const;
    }


export const getGetEnrollmentQueryOptions = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnrollmentQueryKey(jobId,sequenceId,enrollmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnrollment>>> = ({ signal }) => getEnrollment(jobId,sequenceId,enrollmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined && enrollmentId !== null && enrollmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnrollmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEnrollment>>>
export type GetEnrollmentQueryError = HTTPValidationError


export function useGetEnrollment<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnrollment<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnrollment<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Enrollment
 */

export function useGetEnrollment<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnrollmentQueryOptions(jobId,sequenceId,enrollmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEnrollmentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnrollmentQueryKey(jobId,sequenceId,enrollmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnrollment>>> = ({ signal }) => getEnrollment(jobId,sequenceId,enrollmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnrollmentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEnrollment>>>
export type GetEnrollmentSuspenseQueryError = HTTPValidationError


export function useGetEnrollmentSuspense<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnrollmentSuspense<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnrollmentSuspense<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Enrollment
 */

export function useGetEnrollmentSuspense<TData = Awaited<ReturnType<typeof getEnrollment>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnrollmentSuspenseQueryOptions(jobId,sequenceId,enrollmentId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPauseEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}/pause`
}

/**
 * @summary Pause Enrollment
 */
export const pauseEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string,
    _pauseRequest?: _PauseRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getPauseEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(_pauseRequest)
  }
);}





export const getPauseEnrollmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _PauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _PauseRequest}, TContext> => {

const mutationKey = ['pauseEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseEnrollment>>, {jobId: string;sequenceId: string;enrollmentId: string;data?: _PauseRequest}> = (props) => {
          const {jobId,sequenceId,enrollmentId,data} = props ?? {};

          return  pauseEnrollment(jobId,sequenceId,enrollmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof pauseEnrollment>>>
    export type PauseEnrollmentMutationBody = _PauseRequest | undefined
    export type PauseEnrollmentMutationError = HTTPValidationError

    /**
 * @summary Pause Enrollment
 */
export const usePauseEnrollment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _PauseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pauseEnrollment>>,
        TError,
        {jobId: string;sequenceId: string;enrollmentId: string;data?: _PauseRequest},
        TContext
      > => {
      return useMutation(getPauseEnrollmentMutationOptions(options), queryClient);
    }

export const getResumeEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}/resume`
}

/**
 * @summary Resume Enrollment
 */
export const resumeEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getResumeEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResumeEnrollmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext> => {

const mutationKey = ['resumeEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeEnrollment>>, {jobId: string;sequenceId: string;enrollmentId: string}> = (props) => {
          const {jobId,sequenceId,enrollmentId} = props ?? {};

          return  resumeEnrollment(jobId,sequenceId,enrollmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof resumeEnrollment>>>

    export type ResumeEnrollmentMutationError = HTTPValidationError

    /**
 * @summary Resume Enrollment
 */
export const useResumeEnrollment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeEnrollment>>,
        TError,
        {jobId: string;sequenceId: string;enrollmentId: string},
        TContext
      > => {
      return useMutation(getResumeEnrollmentMutationOptions(options), queryClient);
    }

export const getRetryEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}/retry`
}

/**
 * Manually resume/retry a ``paused`` or ``error`` enrollment (E4).
 *
 * Starts a fresh per-enrollment driver run (the paused-by-error / error
 * terminal left no running workflow). Distinct from ``/resume`` which
 * signals a still-running, manually-paused driver.
 * @summary Retry Enrollment
 */
export const retryEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getRetryEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryEnrollmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retryEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext> => {

const mutationKey = ['retryEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryEnrollment>>, {jobId: string;sequenceId: string;enrollmentId: string}> = (props) => {
          const {jobId,sequenceId,enrollmentId} = props ?? {};

          return  retryEnrollment(jobId,sequenceId,enrollmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof retryEnrollment>>>

    export type RetryEnrollmentMutationError = HTTPValidationError

    /**
 * @summary Retry Enrollment
 */
export const useRetryEnrollment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryEnrollment>>,
        TError,
        {jobId: string;sequenceId: string;enrollmentId: string},
        TContext
      > => {
      return useMutation(getRetryEnrollmentMutationOptions(options), queryClient);
    }

export const getCancelEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}/cancel`
}

/**
 * @summary Cancel Enrollment
 */
export const cancelEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string,
    _cancelRequest?: _CancelRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getCancelEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(_cancelRequest)
  }
);}





export const getCancelEnrollmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _CancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _CancelRequest}, TContext> => {

const mutationKey = ['cancelEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEnrollment>>, {jobId: string;sequenceId: string;enrollmentId: string;data?: _CancelRequest}> = (props) => {
          const {jobId,sequenceId,enrollmentId,data} = props ?? {};

          return  cancelEnrollment(jobId,sequenceId,enrollmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEnrollment>>>
    export type CancelEnrollmentMutationBody = _CancelRequest | undefined
    export type CancelEnrollmentMutationError = HTTPValidationError

    /**
 * @summary Cancel Enrollment
 */
export const useCancelEnrollment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _CancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelEnrollment>>,
        TError,
        {jobId: string;sequenceId: string;enrollmentId: string;data?: _CancelRequest},
        TContext
      > => {
      return useMutation(getCancelEnrollmentMutationOptions(options), queryClient);
    }

export const getClassifyEnrollmentUrl = (jobId: string,
    sequenceId: string,
    enrollmentId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/enrollments/${enrollmentId}/classify`
}

/**
 * Manually set/override an enrollment's reply outcome.
 *
 * Writes ``manual_classification`` on the enrollment's linked inbox
 * thread(s) and LinkedIn chat(s) — the same field the inbox override
 * uses — so the enrollment outcome pill, the interest analytics, and the
 * inbox badge all stay in agreement. This intentionally does NOT re-fire
 * sequence reply rules (stage moves / archive); it only records the
 * outcome.
 * @summary Classify Enrollment
 */
export const classifyEnrollment = async (jobId: string,
    sequenceId: string,
    enrollmentId: string,
    _outcomeRequest?: _OutcomeRequest, options?: Parameters<typeof customInstance>[1]): Promise<EnrollmentResponse> => {

  return customInstance<EnrollmentResponse>(getClassifyEnrollmentUrl(jobId,sequenceId,enrollmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(_outcomeRequest)
  }
);}





export const getClassifyEnrollmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _OutcomeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classifyEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _OutcomeRequest}, TContext> => {

const mutationKey = ['classifyEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classifyEnrollment>>, {jobId: string;sequenceId: string;enrollmentId: string;data?: _OutcomeRequest}> = (props) => {
          const {jobId,sequenceId,enrollmentId,data} = props ?? {};

          return  classifyEnrollment(jobId,sequenceId,enrollmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassifyEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof classifyEnrollment>>>
    export type ClassifyEnrollmentMutationBody = _OutcomeRequest | undefined
    export type ClassifyEnrollmentMutationError = HTTPValidationError

    /**
 * @summary Classify Enrollment
 */
export const useClassifyEnrollment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyEnrollment>>, TError,{jobId: string;sequenceId: string;enrollmentId: string;data?: _OutcomeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classifyEnrollment>>,
        TError,
        {jobId: string;sequenceId: string;enrollmentId: string;data?: _OutcomeRequest},
        TContext
      > => {
      return useMutation(getClassifyEnrollmentMutationOptions(options), queryClient);
    }

export const getPollSequenceEventsUrl = (jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/sequences/${sequenceId}/events/poll?${stringifiedParams}` : `/api/jobs/${jobId}/sequences/${sequenceId}/events/poll`
}

/**
 * Long-poll the per-sequence realtime channel.
 *
 * Held open up to ``timeout`` seconds; returns as soon as an ephemeral
 * ``sequence_event`` lands for this sequence (a step sent, an outcome
 * changed, a task transitioned, …). ANY org member with access to the
 * sequence can subscribe — unlike the bell poll's per-user channel,
 * which only ever reached the sequence's sender. Events are ephemeral
 * (no replay); callers keep their periodic refetch backstop for gaps
 * between polls.
 * @summary Poll Sequence Events
 */
export const pollSequenceEvents = async (jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: Parameters<typeof customInstance>[1]): Promise<SequenceEventsPollResponse> => {

  return customInstance<SequenceEventsPollResponse>(getPollSequenceEventsUrl(jobId,sequenceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPollSequenceEventsQueryKey = (jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/events/poll`, ...(params ? [params] : [])
    ] as const;
    }


export const getPollSequenceEventsQueryOptions = <TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollSequenceEventsQueryKey(jobId,sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollSequenceEvents>>> = ({ signal }) => pollSequenceEvents(jobId,sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollSequenceEventsQueryResult = NonNullable<Awaited<ReturnType<typeof pollSequenceEvents>>>
export type PollSequenceEventsQueryError = HTTPValidationError


export function usePollSequenceEvents<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params: undefined |  PollSequenceEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollSequenceEvents>>,
          TError,
          Awaited<ReturnType<typeof pollSequenceEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollSequenceEvents<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollSequenceEvents>>,
          TError,
          Awaited<ReturnType<typeof pollSequenceEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollSequenceEvents<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Poll Sequence Events
 */

export function usePollSequenceEvents<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollSequenceEventsQueryOptions(jobId,sequenceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPollSequenceEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollSequenceEventsQueryKey(jobId,sequenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollSequenceEvents>>> = ({ signal }) => pollSequenceEvents(jobId,sequenceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollSequenceEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof pollSequenceEvents>>>
export type PollSequenceEventsSuspenseQueryError = HTTPValidationError


export function usePollSequenceEventsSuspense<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params: undefined |  PollSequenceEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollSequenceEventsSuspense<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollSequenceEventsSuspense<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Poll Sequence Events
 */

export function usePollSequenceEventsSuspense<TData = Awaited<ReturnType<typeof pollSequenceEvents>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string,
    params?: PollSequenceEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof pollSequenceEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollSequenceEventsSuspenseQueryOptions(jobId,sequenceId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOutreachAssistantStatusUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/status`
}

/**
 * Check whether the agent is currently running for this sequence.
 * @summary Get Outreach Assistant Status
 */
export const getOutreachAssistantStatus = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<GetOutreachAssistantStatus200> => {

  return customInstance<GetOutreachAssistantStatus200>(getGetOutreachAssistantStatusUrl(jobId,sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOutreachAssistantStatusQueryKey = (jobId: string,
    sequenceId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/status`
    ] as const;
    }


export const getGetOutreachAssistantStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutreachAssistantStatusQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreachAssistantStatus>>> = ({ signal }) => getOutreachAssistantStatus(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutreachAssistantStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOutreachAssistantStatus>>>
export type GetOutreachAssistantStatusQueryError = HTTPValidationError


export function useGetOutreachAssistantStatus<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreachAssistantStatus>>,
          TError,
          Awaited<ReturnType<typeof getOutreachAssistantStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantStatus<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreachAssistantStatus>>,
          TError,
          Awaited<ReturnType<typeof getOutreachAssistantStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantStatus<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Outreach Assistant Status
 */

export function useGetOutreachAssistantStatus<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutreachAssistantStatusQueryOptions(jobId,sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOutreachAssistantStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutreachAssistantStatusQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreachAssistantStatus>>> = ({ signal }) => getOutreachAssistantStatus(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutreachAssistantStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOutreachAssistantStatus>>>
export type GetOutreachAssistantStatusSuspenseQueryError = HTTPValidationError


export function useGetOutreachAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Outreach Assistant Status
 */

export function useGetOutreachAssistantStatusSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutreachAssistantStatusSuspenseQueryOptions(jobId,sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelOutreachAssistantUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/cancel`
}

/**
 * Signal a running agent to stop.
 *
 * Clears the running key so the background task's next TTL refresh sees it
 * missing and winds down, and publishes ``agent_done`` so any connected SSE
 * clients close cleanly.
 * @summary Cancel Outreach Assistant
 */
export const cancelOutreachAssistant = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<CancelOutreachAssistant200> => {

  return customInstance<CancelOutreachAssistant200>(getCancelOutreachAssistantUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelOutreachAssistantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext> => {

const mutationKey = ['cancelOutreachAssistant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOutreachAssistant>>, {jobId: string;sequenceId: string}> = (props) => {
          const {jobId,sequenceId} = props ?? {};

          return  cancelOutreachAssistant(jobId,sequenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOutreachAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOutreachAssistant>>>

    export type CancelOutreachAssistantMutationError = HTTPValidationError

    /**
 * @summary Cancel Outreach Assistant
 */
export const useCancelOutreachAssistant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOutreachAssistant>>,
        TError,
        {jobId: string;sequenceId: string},
        TContext
      > => {
      return useMutation(getCancelOutreachAssistantMutationOptions(options), queryClient);
    }

export const getResetOutreachAssistantUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/reset`
}

/**
 * Clear the Outreach Assistant conversation for a sequence (fresh start).
 *
 * Deletes every persisted ``OutreachAssistantMessage`` for the sequence
 * (org-scoped via the verified sequence ownership) so the assistant opens
 * empty next time. Defensively clears the running key and publishes
 * ``agent_done`` in case a stale agent is mid-flight.
 * @summary Reset Outreach Assistant
 */
export const resetOutreachAssistant = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<ResetOutreachAssistant200> => {

  return customInstance<ResetOutreachAssistant200>(getResetOutreachAssistantUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetOutreachAssistantMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext> => {

const mutationKey = ['resetOutreachAssistant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetOutreachAssistant>>, {jobId: string;sequenceId: string}> = (props) => {
          const {jobId,sequenceId} = props ?? {};

          return  resetOutreachAssistant(jobId,sequenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetOutreachAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof resetOutreachAssistant>>>

    export type ResetOutreachAssistantMutationError = HTTPValidationError

    /**
 * @summary Reset Outreach Assistant
 */
export const useResetOutreachAssistant = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOutreachAssistant>>, TError,{jobId: string;sequenceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetOutreachAssistant>>,
        TError,
        {jobId: string;sequenceId: string},
        TContext
      > => {
      return useMutation(getResetOutreachAssistantMutationOptions(options), queryClient);
    }

export const getGetOutreachAssistantMessagesUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/messages`
}

/**
 * Return the persisted conversation as renderable ``ui_parts``.
 *
 * Ordered by ordinal; rows with empty ``ui_parts`` (e.g. tool_result
 * turns) are omitted, mirroring how ``assistant.py`` returns stored
 * messages.
 * @summary Get Outreach Assistant Messages
 */
export const getOutreachAssistantMessages = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<GetOutreachAssistantMessages200Item[]> => {

  return customInstance<GetOutreachAssistantMessages200Item[]>(getGetOutreachAssistantMessagesUrl(jobId,sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOutreachAssistantMessagesQueryKey = (jobId: string,
    sequenceId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/messages`
    ] as const;
    }


export const getGetOutreachAssistantMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutreachAssistantMessagesQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreachAssistantMessages>>> = ({ signal }) => getOutreachAssistantMessages(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutreachAssistantMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getOutreachAssistantMessages>>>
export type GetOutreachAssistantMessagesQueryError = HTTPValidationError


export function useGetOutreachAssistantMessages<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreachAssistantMessages>>,
          TError,
          Awaited<ReturnType<typeof getOutreachAssistantMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantMessages<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreachAssistantMessages>>,
          TError,
          Awaited<ReturnType<typeof getOutreachAssistantMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantMessages<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Outreach Assistant Messages
 */

export function useGetOutreachAssistantMessages<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutreachAssistantMessagesQueryOptions(jobId,sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOutreachAssistantMessagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutreachAssistantMessagesQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreachAssistantMessages>>> = ({ signal }) => getOutreachAssistantMessages(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutreachAssistantMessagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOutreachAssistantMessages>>>
export type GetOutreachAssistantMessagesSuspenseQueryError = HTTPValidationError


export function useGetOutreachAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreachAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Outreach Assistant Messages
 */

export function useGetOutreachAssistantMessagesSuspense<TData = Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOutreachAssistantMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutreachAssistantMessagesSuspenseQueryOptions(jobId,sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostOutreachAssistantMessageUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/messages`
}

/**
 * Run one Outreach Assistant turn against an existing sequence (SSE).
 *
 * The agent loop runs in a background task that survives client disconnects;
 * SSE events are forwarded via Redis pub/sub.
 * @summary Post Outreach Assistant Message
 */
export const postOutreachAssistantMessage = async (jobId: string,
    sequenceId: string,
    outreachAssistantMessageRequest: OutreachAssistantMessageRequest, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getPostOutreachAssistantMessageUrl(jobId,sequenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(outreachAssistantMessageRequest)
  }
);}





export const getPostOutreachAssistantMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOutreachAssistantMessage>>, TError,{jobId: string;sequenceId: string;data: OutreachAssistantMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postOutreachAssistantMessage>>, TError,{jobId: string;sequenceId: string;data: OutreachAssistantMessageRequest}, TContext> => {

const mutationKey = ['postOutreachAssistantMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOutreachAssistantMessage>>, {jobId: string;sequenceId: string;data: OutreachAssistantMessageRequest}> = (props) => {
          const {jobId,sequenceId,data} = props ?? {};

          return  postOutreachAssistantMessage(jobId,sequenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostOutreachAssistantMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postOutreachAssistantMessage>>>
    export type PostOutreachAssistantMessageMutationBody = OutreachAssistantMessageRequest
    export type PostOutreachAssistantMessageMutationError = HTTPValidationError

    /**
 * @summary Post Outreach Assistant Message
 */
export const usePostOutreachAssistantMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOutreachAssistantMessage>>, TError,{jobId: string;sequenceId: string;data: OutreachAssistantMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postOutreachAssistantMessage>>,
        TError,
        {jobId: string;sequenceId: string;data: OutreachAssistantMessageRequest},
        TContext
      > => {
      return useMutation(getPostOutreachAssistantMessageMutationOptions(options), queryClient);
    }

export const getReconnectOutreachAssistantStreamUrl = (jobId: string,
    sequenceId: string,) => {




  return `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/stream`
}

/**
 * Reconnect to a running agent stream for this sequence.
 *
 * Re-checks job + sequence ownership before subscribing. If the agent is no
 * longer running, the subscription emits an immediate ``agent_done`` so the
 * frontend knows to just fetch persisted messages.
 * @summary Reconnect Outreach Assistant Stream
 */
export const reconnectOutreachAssistantStream = async (jobId: string,
    sequenceId: string, options?: Parameters<typeof customInstance>[1]): Promise<unknown> => {

  return customInstance<unknown>(getReconnectOutreachAssistantStreamUrl(jobId,sequenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReconnectOutreachAssistantStreamQueryKey = (jobId: string,
    sequenceId: string,) => {
    return [
    `/api/jobs/${jobId}/sequences/${sequenceId}/assistant/stream`
    ] as const;
    }


export const getReconnectOutreachAssistantStreamQueryOptions = <TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconnectOutreachAssistantStreamQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>> = ({ signal }) => reconnectOutreachAssistantStream(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined && sequenceId !== null && sequenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconnectOutreachAssistantStreamQueryResult = NonNullable<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>>
export type ReconnectOutreachAssistantStreamQueryError = HTTPValidationError


export function useReconnectOutreachAssistantStream<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>,
          TError,
          Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectOutreachAssistantStream<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>,
          TError,
          Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectOutreachAssistantStream<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconnect Outreach Assistant Stream
 */

export function useReconnectOutreachAssistantStream<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconnectOutreachAssistantStreamQueryOptions(jobId,sequenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReconnectOutreachAssistantStreamSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconnectOutreachAssistantStreamQueryKey(jobId,sequenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>> = ({ signal }) => reconnectOutreachAssistantStream(jobId,sequenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconnectOutreachAssistantStreamSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>>
export type ReconnectOutreachAssistantStreamSuspenseQueryError = HTTPValidationError


export function useReconnectOutreachAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectOutreachAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconnectOutreachAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconnect Outreach Assistant Stream
 */

export function useReconnectOutreachAssistantStreamSuspense<TData = Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError = HTTPValidationError>(
 jobId: string,
    sequenceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof reconnectOutreachAssistantStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconnectOutreachAssistantStreamSuspenseQueryOptions(jobId,sequenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateShareUrl = () => {




  return `/api/shares`
}

/**
 * @summary Create Share
 */
export const createShare = async (shareCreateRequestSchema: ShareCreateRequestSchema, options?: Parameters<typeof customInstance>[1]): Promise<ShareCreateResponseSchema> => {

  return customInstance<ShareCreateResponseSchema>(getCreateShareUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shareCreateRequestSchema)
  }
);}





export const getCreateShareMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShare>>, TError,{data: ShareCreateRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createShare>>, TError,{data: ShareCreateRequestSchema}, TContext> => {

const mutationKey = ['createShare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShare>>, {data: ShareCreateRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  createShare(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShareMutationResult = NonNullable<Awaited<ReturnType<typeof createShare>>>
    export type CreateShareMutationBody = ShareCreateRequestSchema
    export type CreateShareMutationError = HTTPValidationError

    /**
 * @summary Create Share
 */
export const useCreateShare = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShare>>, TError,{data: ShareCreateRequestSchema}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createShare>>,
        TError,
        {data: ShareCreateRequestSchema},
        TContext
      > => {
      return useMutation(getCreateShareMutationOptions(options), queryClient);
    }

export const getListSnippetsUrl = (params?: ListSnippetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/snippets?${stringifiedParams}` : `/api/snippets`
}

/**
 * @summary List Snippets
 */
export const listSnippets = async (params?: ListSnippetsParams, options?: Parameters<typeof customInstance>[1]): Promise<SnippetListResponse> => {

  return customInstance<SnippetListResponse>(getListSnippetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSnippetsQueryKey = (params?: ListSnippetsParams,) => {
    return [
    `/api/snippets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSnippetsQueryOptions = <TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(params?: ListSnippetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSnippetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSnippets>>> = ({ signal }) => listSnippets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSnippetsQueryResult = NonNullable<Awaited<ReturnType<typeof listSnippets>>>
export type ListSnippetsQueryError = HTTPValidationError


export function useListSnippets<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params: undefined |  ListSnippetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSnippets>>,
          TError,
          Awaited<ReturnType<typeof listSnippets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnippets<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSnippets>>,
          TError,
          Awaited<ReturnType<typeof listSnippets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnippets<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Snippets
 */

export function useListSnippets<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSnippetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSnippetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(params?: ListSnippetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSnippetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSnippets>>> = ({ signal }) => listSnippets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSnippetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSnippets>>>
export type ListSnippetsSuspenseQueryError = HTTPValidationError


export function useListSnippetsSuspense<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params: undefined |  ListSnippetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnippetsSuspense<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnippetsSuspense<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Snippets
 */

export function useListSnippetsSuspense<TData = Awaited<ReturnType<typeof listSnippets>>, TError = HTTPValidationError>(
 params?: ListSnippetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSnippets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSnippetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSnippetUrl = () => {




  return `/api/snippets`
}

/**
 * @summary Create Snippet
 */
export const createSnippet = async (snippetCreate: SnippetCreate, options?: Parameters<typeof customInstance>[1]): Promise<SnippetResponse> => {

  return customInstance<SnippetResponse>(getCreateSnippetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(snippetCreate)
  }
);}





export const getCreateSnippetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSnippet>>, TError,{data: SnippetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSnippet>>, TError,{data: SnippetCreate}, TContext> => {

const mutationKey = ['createSnippet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSnippet>>, {data: SnippetCreate}> = (props) => {
          const {data} = props ?? {};

          return  createSnippet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSnippetMutationResult = NonNullable<Awaited<ReturnType<typeof createSnippet>>>
    export type CreateSnippetMutationBody = SnippetCreate
    export type CreateSnippetMutationError = HTTPValidationError

    /**
 * @summary Create Snippet
 */
export const useCreateSnippet = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSnippet>>, TError,{data: SnippetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSnippet>>,
        TError,
        {data: SnippetCreate},
        TContext
      > => {
      return useMutation(getCreateSnippetMutationOptions(options), queryClient);
    }

export const getGetSnippetUrl = (snippetId: string,) => {




  return `/api/snippets/${snippetId}`
}

/**
 * @summary Get Snippet
 */
export const getSnippet = async (snippetId: string, options?: Parameters<typeof customInstance>[1]): Promise<SnippetResponse> => {

  return customInstance<SnippetResponse>(getGetSnippetUrl(snippetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSnippetQueryKey = (snippetId: string,) => {
    return [
    `/api/snippets/${snippetId}`
    ] as const;
    }


export const getGetSnippetQueryOptions = <TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(snippetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSnippetQueryKey(snippetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnippet>>> = ({ signal }) => getSnippet(snippetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: snippetId !== null && snippetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSnippetQueryResult = NonNullable<Awaited<ReturnType<typeof getSnippet>>>
export type GetSnippetQueryError = HTTPValidationError


export function useGetSnippet<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnippet>>,
          TError,
          Awaited<ReturnType<typeof getSnippet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnippet<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnippet>>,
          TError,
          Awaited<ReturnType<typeof getSnippet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnippet<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Snippet
 */

export function useGetSnippet<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSnippetQueryOptions(snippetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSnippetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(snippetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSnippetQueryKey(snippetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnippet>>> = ({ signal }) => getSnippet(snippetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSnippetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSnippet>>>
export type GetSnippetSuspenseQueryError = HTTPValidationError


export function useGetSnippetSuspense<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnippetSuspense<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnippetSuspense<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Snippet
 */

export function useGetSnippetSuspense<TData = Awaited<ReturnType<typeof getSnippet>>, TError = HTTPValidationError>(
 snippetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSnippet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSnippetSuspenseQueryOptions(snippetId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSnippetUrl = (snippetId: string,) => {




  return `/api/snippets/${snippetId}`
}

/**
 * @summary Update Snippet
 */
export const updateSnippet = async (snippetId: string,
    snippetUpdate: SnippetUpdate, options?: Parameters<typeof customInstance>[1]): Promise<SnippetResponse> => {

  return customInstance<SnippetResponse>(getUpdateSnippetUrl(snippetId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(snippetUpdate)
  }
);}





export const getUpdateSnippetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSnippet>>, TError,{snippetId: string;data: SnippetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSnippet>>, TError,{snippetId: string;data: SnippetUpdate}, TContext> => {

const mutationKey = ['updateSnippet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSnippet>>, {snippetId: string;data: SnippetUpdate}> = (props) => {
          const {snippetId,data} = props ?? {};

          return  updateSnippet(snippetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSnippetMutationResult = NonNullable<Awaited<ReturnType<typeof updateSnippet>>>
    export type UpdateSnippetMutationBody = SnippetUpdate
    export type UpdateSnippetMutationError = HTTPValidationError

    /**
 * @summary Update Snippet
 */
export const useUpdateSnippet = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSnippet>>, TError,{snippetId: string;data: SnippetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSnippet>>,
        TError,
        {snippetId: string;data: SnippetUpdate},
        TContext
      > => {
      return useMutation(getUpdateSnippetMutationOptions(options), queryClient);
    }

export const getArchiveSnippetUrl = (snippetId: string,) => {




  return `/api/snippets/${snippetId}`
}

/**
 * @summary Archive Snippet
 */
export const archiveSnippet = async (snippetId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getArchiveSnippetUrl(snippetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchiveSnippetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSnippet>>, TError,{snippetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveSnippet>>, TError,{snippetId: string}, TContext> => {

const mutationKey = ['archiveSnippet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveSnippet>>, {snippetId: string}> = (props) => {
          const {snippetId} = props ?? {};

          return  archiveSnippet(snippetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveSnippetMutationResult = NonNullable<Awaited<ReturnType<typeof archiveSnippet>>>

    export type ArchiveSnippetMutationError = HTTPValidationError

    /**
 * @summary Archive Snippet
 */
export const useArchiveSnippet = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSnippet>>, TError,{snippetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveSnippet>>,
        TError,
        {snippetId: string},
        TContext
      > => {
      return useMutation(getArchiveSnippetMutationOptions(options), queryClient);
    }

export const getPreviewSnippetUrl = () => {




  return `/api/snippets/preview`
}

/**
 * Render a snippet body_doc against sample candidates from talent search.
 * @summary Preview Snippet
 */
export const previewSnippet = async (snippetPreviewRequest: SnippetPreviewRequest, options?: Parameters<typeof customInstance>[1]): Promise<SnippetPreviewResponse> => {

  return customInstance<SnippetPreviewResponse>(getPreviewSnippetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(snippetPreviewRequest)
  }
);}





export const getPreviewSnippetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSnippet>>, TError,{data: SnippetPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewSnippet>>, TError,{data: SnippetPreviewRequest}, TContext> => {

const mutationKey = ['previewSnippet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewSnippet>>, {data: SnippetPreviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  previewSnippet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewSnippetMutationResult = NonNullable<Awaited<ReturnType<typeof previewSnippet>>>
    export type PreviewSnippetMutationBody = SnippetPreviewRequest
    export type PreviewSnippetMutationError = HTTPValidationError

    /**
 * @summary Preview Snippet
 */
export const usePreviewSnippet = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSnippet>>, TError,{data: SnippetPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewSnippet>>,
        TError,
        {data: SnippetPreviewRequest},
        TContext
      > => {
      return useMutation(getPreviewSnippetMutationOptions(options), queryClient);
    }

export const getAddStageUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/stages`
}

/**
 * @summary Add Stage
 */
export const addStage = async (jobId: string,
    stageCreate: StageCreate, options?: Parameters<typeof customInstance>[1]): Promise<StageResponse> => {

  return customInstance<StageResponse>(getAddStageUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stageCreate)
  }
);}





export const getAddStageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addStage>>, TError,{jobId: string;data: StageCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addStage>>, TError,{jobId: string;data: StageCreate}, TContext> => {

const mutationKey = ['addStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addStage>>, {jobId: string;data: StageCreate}> = (props) => {
          const {jobId,data} = props ?? {};

          return  addStage(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddStageMutationResult = NonNullable<Awaited<ReturnType<typeof addStage>>>
    export type AddStageMutationBody = StageCreate
    export type AddStageMutationError = HTTPValidationError

    /**
 * @summary Add Stage
 */
export const useAddStage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addStage>>, TError,{jobId: string;data: StageCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addStage>>,
        TError,
        {jobId: string;data: StageCreate},
        TContext
      > => {
      return useMutation(getAddStageMutationOptions(options), queryClient);
    }

export const getUpdateStageUrl = (jobId: string,
    stageId: string,) => {




  return `/api/jobs/${jobId}/stages/${stageId}`
}

/**
 * @summary Update Stage
 */
export const updateStage = async (jobId: string,
    stageId: string,
    stageUpdate: StageUpdate, options?: Parameters<typeof customInstance>[1]): Promise<StageResponse> => {

  return customInstance<StageResponse>(getUpdateStageUrl(jobId,stageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stageUpdate)
  }
);}





export const getUpdateStageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStage>>, TError,{jobId: string;stageId: string;data: StageUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStage>>, TError,{jobId: string;stageId: string;data: StageUpdate}, TContext> => {

const mutationKey = ['updateStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStage>>, {jobId: string;stageId: string;data: StageUpdate}> = (props) => {
          const {jobId,stageId,data} = props ?? {};

          return  updateStage(jobId,stageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStageMutationResult = NonNullable<Awaited<ReturnType<typeof updateStage>>>
    export type UpdateStageMutationBody = StageUpdate
    export type UpdateStageMutationError = HTTPValidationError

    /**
 * @summary Update Stage
 */
export const useUpdateStage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStage>>, TError,{jobId: string;stageId: string;data: StageUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStage>>,
        TError,
        {jobId: string;stageId: string;data: StageUpdate},
        TContext
      > => {
      return useMutation(getUpdateStageMutationOptions(options), queryClient);
    }

export const getDeleteStageUrl = (jobId: string,
    stageId: string,
    params?: DeleteStageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs/${jobId}/stages/${stageId}?${stringifiedParams}` : `/api/jobs/${jobId}/stages/${stageId}`
}

/**
 * @summary Delete Stage
 */
export const deleteStage = async (jobId: string,
    stageId: string,
    params?: DeleteStageParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteStageUrl(jobId,stageId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteStageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStage>>, TError,{jobId: string;stageId: string;params?: DeleteStageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStage>>, TError,{jobId: string;stageId: string;params?: DeleteStageParams}, TContext> => {

const mutationKey = ['deleteStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStage>>, {jobId: string;stageId: string;params?: DeleteStageParams}> = (props) => {
          const {jobId,stageId,params} = props ?? {};

          return  deleteStage(jobId,stageId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStage>>>

    export type DeleteStageMutationError = HTTPValidationError

    /**
 * @summary Delete Stage
 */
export const useDeleteStage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStage>>, TError,{jobId: string;stageId: string;params?: DeleteStageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStage>>,
        TError,
        {jobId: string;stageId: string;params?: DeleteStageParams},
        TContext
      > => {
      return useMutation(getDeleteStageMutationOptions(options), queryClient);
    }

export const getReorderStagesUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/stages/reorder`
}

/**
 * @summary Reorder Stages
 */
export const reorderStages = async (jobId: string,
    stageReorderRequest: StageReorderRequest, options?: Parameters<typeof customInstance>[1]): Promise<StageResponse[]> => {

  return customInstance<StageResponse[]>(getReorderStagesUrl(jobId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stageReorderRequest)
  }
);}





export const getReorderStagesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStages>>, TError,{jobId: string;data: StageReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderStages>>, TError,{jobId: string;data: StageReorderRequest}, TContext> => {

const mutationKey = ['reorderStages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderStages>>, {jobId: string;data: StageReorderRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  reorderStages(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderStagesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderStages>>>
    export type ReorderStagesMutationBody = StageReorderRequest
    export type ReorderStagesMutationError = HTTPValidationError

    /**
 * @summary Reorder Stages
 */
export const useReorderStages = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStages>>, TError,{jobId: string;data: StageReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderStages>>,
        TError,
        {jobId: string;data: StageReorderRequest},
        TContext
      > => {
      return useMutation(getReorderStagesMutationOptions(options), queryClient);
    }

export const getSyncJobStagesUrl = (jobId: string,) => {




  return `/api/jobs/${jobId}/stages/sync`
}

/**
 * @summary Sync Job Stages
 */
export const syncJobStages = async (jobId: string,
    stageSyncRequest: StageSyncRequest, options?: Parameters<typeof customInstance>[1]): Promise<StageSyncResponse> => {

  return customInstance<StageSyncResponse>(getSyncJobStagesUrl(jobId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stageSyncRequest)
  }
);}





export const getSyncJobStagesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncJobStages>>, TError,{jobId: string;data: StageSyncRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof syncJobStages>>, TError,{jobId: string;data: StageSyncRequest}, TContext> => {

const mutationKey = ['syncJobStages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncJobStages>>, {jobId: string;data: StageSyncRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  syncJobStages(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncJobStagesMutationResult = NonNullable<Awaited<ReturnType<typeof syncJobStages>>>
    export type SyncJobStagesMutationBody = StageSyncRequest
    export type SyncJobStagesMutationError = HTTPValidationError

    /**
 * @summary Sync Job Stages
 */
export const useSyncJobStages = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncJobStages>>, TError,{jobId: string;data: StageSyncRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncJobStages>>,
        TError,
        {jobId: string;data: StageSyncRequest},
        TContext
      > => {
      return useMutation(getSyncJobStagesMutationOptions(options), queryClient);
    }

export const getListTalentPoolsUrl = () => {




  return `/api/talent-pools`
}

/**
 * Pools visible to the org: standard pool, granted global pools, then the org's own pools.
 * @summary List Talent Pools
 */
export const listTalentPools = async ( options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolListResponse> => {

  return customInstance<TalentPoolListResponse>(getListTalentPoolsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTalentPoolsQueryKey = () => {
    return [
    `/api/talent-pools`
    ] as const;
    }


export const getListTalentPoolsQueryOptions = <TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTalentPoolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTalentPools>>> = ({ signal }) => listTalentPools({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTalentPoolsQueryResult = NonNullable<Awaited<ReturnType<typeof listTalentPools>>>
export type ListTalentPoolsQueryError = unknown


export function useListTalentPools<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTalentPools>>,
          TError,
          Awaited<ReturnType<typeof listTalentPools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPools<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTalentPools>>,
          TError,
          Awaited<ReturnType<typeof listTalentPools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPools<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Talent Pools
 */

export function useListTalentPools<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTalentPoolsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTalentPoolsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTalentPoolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTalentPools>>> = ({ signal }) => listTalentPools({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTalentPoolsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTalentPools>>>
export type ListTalentPoolsSuspenseQueryError = unknown


export function useListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Talent Pools
 */

export function useListTalentPoolsSuspense<TData = Awaited<ReturnType<typeof listTalentPools>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTalentPoolsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTalentPoolUrl = () => {




  return `/api/talent-pools`
}

/**
 * @summary Create Talent Pool
 */
export const createTalentPool = async (talentPoolNameRequest: TalentPoolNameRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolResponse> => {

  return customInstance<TalentPoolResponse>(getCreateTalentPoolUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolNameRequest)
  }
);}





export const getCreateTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTalentPool>>, TError,{data: TalentPoolNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTalentPool>>, TError,{data: TalentPoolNameRequest}, TContext> => {

const mutationKey = ['createTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTalentPool>>, {data: TalentPoolNameRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTalentPool(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof createTalentPool>>>
    export type CreateTalentPoolMutationBody = TalentPoolNameRequest
    export type CreateTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Create Talent Pool
 */
export const useCreateTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTalentPool>>, TError,{data: TalentPoolNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTalentPool>>,
        TError,
        {data: TalentPoolNameRequest},
        TContext
      > => {
      return useMutation(getCreateTalentPoolMutationOptions(options), queryClient);
    }

export const getSetTalentPoolUploadDestinationUrl = () => {




  return `/api/talent-pools/upload-destination`
}

/**
 * Pool that future uploads land in; people already uploaded stay where they are.
 * @summary Set Talent Pool Upload Destination
 */
export const setTalentPoolUploadDestination = async (talentPoolUploadDestinationRequest: TalentPoolUploadDestinationRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolResponse> => {

  return customInstance<TalentPoolResponse>(getSetTalentPoolUploadDestinationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolUploadDestinationRequest)
  }
);}





export const getSetTalentPoolUploadDestinationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTalentPoolUploadDestination>>, TError,{data: TalentPoolUploadDestinationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setTalentPoolUploadDestination>>, TError,{data: TalentPoolUploadDestinationRequest}, TContext> => {

const mutationKey = ['setTalentPoolUploadDestination'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTalentPoolUploadDestination>>, {data: TalentPoolUploadDestinationRequest}> = (props) => {
          const {data} = props ?? {};

          return  setTalentPoolUploadDestination(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTalentPoolUploadDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof setTalentPoolUploadDestination>>>
    export type SetTalentPoolUploadDestinationMutationBody = TalentPoolUploadDestinationRequest
    export type SetTalentPoolUploadDestinationMutationError = HTTPValidationError

    /**
 * @summary Set Talent Pool Upload Destination
 */
export const useSetTalentPoolUploadDestination = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTalentPoolUploadDestination>>, TError,{data: TalentPoolUploadDestinationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTalentPoolUploadDestination>>,
        TError,
        {data: TalentPoolUploadDestinationRequest},
        TContext
      > => {
      return useMutation(getSetTalentPoolUploadDestinationMutationOptions(options), queryClient);
    }

export const getRenameTalentPoolUrl = (poolId: string,) => {




  return `/api/talent-pools/${poolId}`
}

/**
 * Rename the pool, set the search filter categories it can't serve, or its icon and color.
 * @summary Rename Talent Pool
 */
export const renameTalentPool = async (poolId: string,
    talentPoolUpdateRequest: TalentPoolUpdateRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolResponse> => {

  return customInstance<TalentPoolResponse>(getRenameTalentPoolUrl(poolId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolUpdateRequest)
  }
);}





export const getRenameTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameTalentPool>>, TError,{poolId: string;data: TalentPoolUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameTalentPool>>, TError,{poolId: string;data: TalentPoolUpdateRequest}, TContext> => {

const mutationKey = ['renameTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameTalentPool>>, {poolId: string;data: TalentPoolUpdateRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  renameTalentPool(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof renameTalentPool>>>
    export type RenameTalentPoolMutationBody = TalentPoolUpdateRequest
    export type RenameTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Rename Talent Pool
 */
export const useRenameTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameTalentPool>>, TError,{poolId: string;data: TalentPoolUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameTalentPool>>,
        TError,
        {poolId: string;data: TalentPoolUpdateRequest},
        TContext
      > => {
      return useMutation(getRenameTalentPoolMutationOptions(options), queryClient);
    }

export const getDeleteTalentPoolUrl = (poolId: string,) => {




  return `/api/talent-pools/${poolId}`
}

/**
 * Delete the pool and its people; 409 ``TALENT_POOL_IN_USE`` while it receives uploads or an ATS connection or pipeline uses it.
 * @summary Delete Talent Pool
 */
export const deleteTalentPool = async (poolId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteTalentPoolUrl(poolId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTalentPoolMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPool>>, TError,{poolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPool>>, TError,{poolId: string}, TContext> => {

const mutationKey = ['deleteTalentPool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTalentPool>>, {poolId: string}> = (props) => {
          const {poolId} = props ?? {};

          return  deleteTalentPool(poolId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTalentPoolMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTalentPool>>>

    export type DeleteTalentPoolMutationError = HTTPValidationError

    /**
 * @summary Delete Talent Pool
 */
export const useDeleteTalentPool = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPool>>, TError,{poolId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTalentPool>>,
        TError,
        {poolId: string},
        TContext
      > => {
      return useMutation(getDeleteTalentPoolMutationOptions(options), queryClient);
    }

export const getListTalentPoolProfilesUrl = (poolId: string,
    params?: ListTalentPoolProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/talent-pools/${poolId}/profiles?${stringifiedParams}` : `/api/talent-pools/${poolId}/profiles`
}

/**
 * @summary List Talent Pool Profiles
 */
export const listTalentPoolProfiles = async (poolId: string,
    params?: ListTalentPoolProfilesParams, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolProfileListResponse> => {

  return customInstance<TalentPoolProfileListResponse>(getListTalentPoolProfilesUrl(poolId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTalentPoolProfilesQueryKey = (poolId: string,
    params?: ListTalentPoolProfilesParams,) => {
    return [
    `/api/talent-pools/${poolId}/profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTalentPoolProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTalentPoolProfilesQueryKey(poolId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTalentPoolProfiles>>> = ({ signal }) => listTalentPoolProfiles(poolId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: poolId !== null && poolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTalentPoolProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listTalentPoolProfiles>>>
export type ListTalentPoolProfilesQueryError = HTTPValidationError


export function useListTalentPoolProfiles<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params: undefined |  ListTalentPoolProfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTalentPoolProfiles>>,
          TError,
          Awaited<ReturnType<typeof listTalentPoolProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolProfiles<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTalentPoolProfiles>>,
          TError,
          Awaited<ReturnType<typeof listTalentPoolProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolProfiles<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Talent Pool Profiles
 */

export function useListTalentPoolProfiles<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTalentPoolProfilesQueryOptions(poolId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTalentPoolProfilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTalentPoolProfilesQueryKey(poolId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTalentPoolProfiles>>> = ({ signal }) => listTalentPoolProfiles(poolId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTalentPoolProfilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTalentPoolProfiles>>>
export type ListTalentPoolProfilesSuspenseQueryError = HTTPValidationError


export function useListTalentPoolProfilesSuspense<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params: undefined |  ListTalentPoolProfilesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolProfilesSuspense<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTalentPoolProfilesSuspense<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Talent Pool Profiles
 */

export function useListTalentPoolProfilesSuspense<TData = Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError = HTTPValidationError>(
 poolId: string,
    params?: ListTalentPoolProfilesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTalentPoolProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTalentPoolProfilesSuspenseQueryOptions(poolId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportTalentPoolProfilesUrl = (poolId: string,) => {




  return `/api/talent-pools/${poolId}/import`
}

/**
 * Create or update people keyed by ``external_id``, else by LinkedIn URL.
 * @summary Import Talent Pool Profiles
 */
export const importTalentPoolProfiles = async (poolId: string,
    talentPoolImportRequest: TalentPoolImportRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolImportResponse> => {

  return customInstance<TalentPoolImportResponse>(getImportTalentPoolProfilesUrl(poolId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolImportRequest)
  }
);}





export const getImportTalentPoolProfilesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolImportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolImportRequest}, TContext> => {

const mutationKey = ['importTalentPoolProfiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTalentPoolProfiles>>, {poolId: string;data: TalentPoolImportRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  importTalentPoolProfiles(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTalentPoolProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof importTalentPoolProfiles>>>
    export type ImportTalentPoolProfilesMutationBody = TalentPoolImportRequest
    export type ImportTalentPoolProfilesMutationError = HTTPValidationError

    /**
 * @summary Import Talent Pool Profiles
 */
export const useImportTalentPoolProfiles = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolImportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTalentPoolProfiles>>,
        TError,
        {poolId: string;data: TalentPoolImportRequest},
        TContext
      > => {
      return useMutation(getImportTalentPoolProfilesMutationOptions(options), queryClient);
    }

export const getTransferTalentPoolProfilesUrl = (poolId: string,) => {




  return `/api/talent-pools/${poolId}/profiles/transfer`
}

/**
 * Move or copy people to another of the org's pools; people already in the target are skipped.
 * @summary Transfer Talent Pool Profiles
 */
export const transferTalentPoolProfiles = async (poolId: string,
    talentPoolTransferRequest: TalentPoolTransferRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolTransferResponse> => {

  return customInstance<TalentPoolTransferResponse>(getTransferTalentPoolProfilesUrl(poolId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolTransferRequest)
  }
);}





export const getTransferTalentPoolProfilesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolTransferRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof transferTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolTransferRequest}, TContext> => {

const mutationKey = ['transferTalentPoolProfiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferTalentPoolProfiles>>, {poolId: string;data: TalentPoolTransferRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  transferTalentPoolProfiles(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransferTalentPoolProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof transferTalentPoolProfiles>>>
    export type TransferTalentPoolProfilesMutationBody = TalentPoolTransferRequest
    export type TransferTalentPoolProfilesMutationError = HTTPValidationError

    /**
 * @summary Transfer Talent Pool Profiles
 */
export const useTransferTalentPoolProfiles = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolTransferRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferTalentPoolProfiles>>,
        TError,
        {poolId: string;data: TalentPoolTransferRequest},
        TContext
      > => {
      return useMutation(getTransferTalentPoolProfilesMutationOptions(options), queryClient);
    }

export const getDeleteTalentPoolProfilesUrl = (poolId: string,) => {




  return `/api/talent-pools/${poolId}/profiles/delete`
}

/**
 * Delete people from the pool; 409 ``TALENT_POOL_IN_USE`` while any is in a pipeline or sequence.
 * @summary Delete Talent Pool Profiles
 */
export const deleteTalentPoolProfiles = async (poolId: string,
    talentPoolProfilesDeleteRequest: TalentPoolProfilesDeleteRequest, options?: Parameters<typeof customInstance>[1]): Promise<TalentPoolProfilesDeleteResponse> => {

  return customInstance<TalentPoolProfilesDeleteResponse>(getDeleteTalentPoolProfilesUrl(poolId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(talentPoolProfilesDeleteRequest)
  }
);}





export const getDeleteTalentPoolProfilesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolProfilesDeleteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolProfilesDeleteRequest}, TContext> => {

const mutationKey = ['deleteTalentPoolProfiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTalentPoolProfiles>>, {poolId: string;data: TalentPoolProfilesDeleteRequest}> = (props) => {
          const {poolId,data} = props ?? {};

          return  deleteTalentPoolProfiles(poolId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTalentPoolProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTalentPoolProfiles>>>
    export type DeleteTalentPoolProfilesMutationBody = TalentPoolProfilesDeleteRequest
    export type DeleteTalentPoolProfilesMutationError = HTTPValidationError

    /**
 * @summary Delete Talent Pool Profiles
 */
export const useDeleteTalentPoolProfiles = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentPoolProfiles>>, TError,{poolId: string;data: TalentPoolProfilesDeleteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTalentPoolProfiles>>,
        TError,
        {poolId: string;data: TalentPoolProfilesDeleteRequest},
        TContext
      > => {
      return useMutation(getDeleteTalentPoolProfilesMutationOptions(options), queryClient);
    }

export const getListTasksUrl = (params: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types","priorities","jobs","jobs_excluded","sequences","sequences_excluded","candidates","candidates_excluded","assignees","assignees_excluded"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks?${stringifiedParams}` : `/api/tasks`
}

/**
 * @summary List Tasks
 */
export const listTasks = async (params: ListTasksParams, options?: Parameters<typeof customInstance>[1]): Promise<TaskListPage> => {

  return customInstance<TaskListPage>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/api/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(params: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = HTTPValidationError


export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Tasks
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTasksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(params: ListTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksSuspenseQueryError = HTTPValidationError


export function useListTasksSuspense<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasksSuspense<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasksSuspense<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Tasks
 */

export function useListTasksSuspense<TData = Awaited<ReturnType<typeof listTasks>>, TError = HTTPValidationError>(
 params: ListTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskUrl = (params: CreateTaskParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks?${stringifiedParams}` : `/api/tasks`
}

/**
 * @summary Create Task
 */
export const createTask = async (manualEmailTaskCreateAutoEmailTaskCreatePhoneCallTaskCreateTextMessageTaskCreateCustomTaskCreateLinkedInProfileViewTaskCreateLinkedInConnectionRequestTaskCreateLinkedInMessageTaskCreate: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate,
    params: CreateTaskParams, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getCreateTaskUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(manualEmailTaskCreateAutoEmailTaskCreatePhoneCallTaskCreateTextMessageTaskCreateCustomTaskCreateLinkedInProfileViewTaskCreateLinkedInConnectionRequestTaskCreateLinkedInMessageTaskCreate)
  }
);}





export const getCreateTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate;params: CreateTaskParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate;params: CreateTaskParams}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate;params: CreateTaskParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createTask(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate
    export type CreateTaskMutationError = HTTPValidationError

    /**
 * @summary Create Task
 */
export const useCreateTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate;params: CreateTaskParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: ManualEmailTaskCreate | AutoEmailTaskCreate | PhoneCallTaskCreate | TextMessageTaskCreate | CustomTaskCreate | LinkedInProfileViewTaskCreate | LinkedInConnectionRequestTaskCreate | LinkedInMessageTaskCreate;params: CreateTaskParams},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options), queryClient);
    }

export const getGetTaskCountsUrl = (params: GetTaskCountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types","priorities","jobs","jobs_excluded","sequences","sequences_excluded","candidates","candidates_excluded","assignees","assignees_excluded"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/counts?${stringifiedParams}` : `/api/tasks/counts`
}

/**
 * @summary Get Task Counts
 */
export const getTaskCounts = async (params: GetTaskCountsParams, options?: Parameters<typeof customInstance>[1]): Promise<TaskCounts> => {

  return customInstance<TaskCounts>(getGetTaskCountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskCountsQueryKey = (params?: GetTaskCountsParams,) => {
    return [
    `/api/tasks/counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskCountsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(params: GetTaskCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskCounts>>> = ({ signal }) => getTaskCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskCounts>>>
export type GetTaskCountsQueryError = HTTPValidationError


export function useGetTaskCounts<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskCounts>>,
          TError,
          Awaited<ReturnType<typeof getTaskCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskCounts<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskCounts>>,
          TError,
          Awaited<ReturnType<typeof getTaskCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskCounts<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Counts
 */

export function useGetTaskCounts<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTaskCountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(params: GetTaskCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskCounts>>> = ({ signal }) => getTaskCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskCountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskCounts>>>
export type GetTaskCountsSuspenseQueryError = HTTPValidationError


export function useGetTaskCountsSuspense<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskCountsSuspense<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskCountsSuspense<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Counts
 */

export function useGetTaskCountsSuspense<TData = Awaited<ReturnType<typeof getTaskCounts>>, TError = HTTPValidationError>(
 params: GetTaskCountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskCountsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}`
}

/**
 * @summary Get Task
 */
export const getTask = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getGetTaskUrl(taskId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskQueryKey = (taskId: string,) => {
    return [
    `/api/tasks/${taskId}`
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = HTTPValidationError


export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task
 */

export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTaskSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskSuspenseQueryError = HTTPValidationError


export function useGetTaskSuspense<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskSuspense<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskSuspense<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task
 */

export function useGetTaskSuspense<TData = Awaited<ReturnType<typeof getTask>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskSuspenseQueryOptions(taskId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}`
}

/**
 * @summary Update Task
 */
export const updateTask = async (taskId: string,
    taskUpdate: TaskUpdate, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getUpdateTaskUrl(taskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskUpdate)
  }
);}





export const getUpdateTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data: TaskUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data: TaskUpdate}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {taskId: string;data: TaskUpdate}> = (props) => {
          const {taskId,data} = props ?? {};

          return  updateTask(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = TaskUpdate
    export type UpdateTaskMutationError = HTTPValidationError

    /**
 * @summary Update Task
 */
export const useUpdateTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data: TaskUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {taskId: string;data: TaskUpdate},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options), queryClient);
    }

export const getGetTaskVariablesUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/variables`
}

/**
 * Resolve every V1 template variable against the task's live
 * candidate / sender / job context.
 *
 * The side-panel body editors fetch this once when the panel opens
 * and insert the resolved value as literal text when the recruiter
 * picks a variable — a hand-executed task body is final copy and
 * must never embed an unresolved ``{{variable}}`` chip.
 * @summary Get Task Variables
 */
export const getTaskVariables = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<TaskVariablesResponse> => {

  return customInstance<TaskVariablesResponse>(getGetTaskVariablesUrl(taskId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskVariablesQueryKey = (taskId: string,) => {
    return [
    `/api/tasks/${taskId}/variables`
    ] as const;
    }


export const getGetTaskVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskVariablesQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskVariables>>> = ({ signal }) => getTaskVariables(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskVariables>>>
export type GetTaskVariablesQueryError = HTTPValidationError


export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Variables
 */

export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskVariablesQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTaskVariablesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskVariablesQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskVariables>>> = ({ signal }) => getTaskVariables(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskVariablesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskVariables>>>
export type GetTaskVariablesSuspenseQueryError = HTTPValidationError


export function useGetTaskVariablesSuspense<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariablesSuspense<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariablesSuspense<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Variables
 */

export function useGetTaskVariablesSuspense<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = HTTPValidationError>(
 taskId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskVariablesSuspenseQueryOptions(taskId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExecuteTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/execute`
}

/**
 * Execute a manual_email / linkedin_* task via the provider.
 *
 * For non-executable types (``phone_call``, ``text_message``,
 * ``custom_task``) the API returns 422 with ``TASK_NOT_EXECUTABLE``;
 * those types complete via :func:`mark_completed` instead.
 * @summary Execute Task
 */
export const executeTask = async (taskId: string,
    executeTaskRequestNull?: ExecuteTaskRequest | null, options?: Parameters<typeof customInstance>[1]): Promise<ExecuteResult> => {

  return customInstance<ExecuteResult>(getExecuteTaskUrl(taskId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(executeTaskRequestNull)
  }
);}





export const getExecuteTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeTask>>, TError,{taskId: string;data?: ExecuteTaskRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeTask>>, TError,{taskId: string;data?: ExecuteTaskRequest | null}, TContext> => {

const mutationKey = ['executeTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeTask>>, {taskId: string;data?: ExecuteTaskRequest | null}> = (props) => {
          const {taskId,data} = props ?? {};

          return  executeTask(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof executeTask>>>
    export type ExecuteTaskMutationBody = ExecuteTaskRequest | null | undefined
    export type ExecuteTaskMutationError = HTTPValidationError

    /**
 * @summary Execute Task
 */
export const useExecuteTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeTask>>, TError,{taskId: string;data?: ExecuteTaskRequest | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeTask>>,
        TError,
        {taskId: string;data?: ExecuteTaskRequest | null},
        TContext
      > => {
      return useMutation(getExecuteTaskMutationOptions(options), queryClient);
    }

export const getCancelScheduledTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/cancel-scheduled`
}

/**
 * Cancel a scheduled execute and revert the task to ``pending`` (G-06).
 *
 * Validates ``status='scheduled'`` AND ``scheduled_run_at > now()``. A
 * task already mid-send returns 409 ``task_in_progress_cannot_cancel``.
 * "Mid-send" is detected via the persisted ``executing`` status OR the
 * execute Redis lock — the lock is the cross-transaction signal, since a
 * concurrent send's ``executing`` flush isn't committed until it finishes.
 * On success, signals the deterministic Temporal workflow
 * ``outreach-manual-task-{task_id}`` with ``cancel`` so the still-pending
 * timer short-circuits, then reverts the row ``scheduled -> pending`` so
 * it rejoins the actionable queue.
 *
 * The signal is an optimization, not the guarantee: it can be lost (a
 * Temporal outage) or arrive after the timer already fired. The revert
 * is what actually cancels the send — ``execute_manual_task_activity``
 * refuses to dispatch a row that is no longer ``scheduled``.
 * @summary Cancel Scheduled Task
 */
export const cancelScheduledTask = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getCancelScheduledTaskUrl(taskId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelScheduledTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['cancelScheduledTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelScheduledTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  cancelScheduledTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelScheduledTaskMutationResult = NonNullable<Awaited<ReturnType<typeof cancelScheduledTask>>>

    export type CancelScheduledTaskMutationError = HTTPValidationError

    /**
 * @summary Cancel Scheduled Task
 */
export const useCancelScheduledTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelScheduledTask>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getCancelScheduledTaskMutationOptions(options), queryClient);
    }

export const getCompleteTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/complete`
}

/**
 * @summary Complete Task
 */
export const completeTask = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getCompleteTaskUrl(taskId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['completeTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  completeTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof completeTask>>>

    export type CompleteTaskMutationError = HTTPValidationError

    /**
 * @summary Complete Task
 */
export const useCompleteTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeTask>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getCompleteTaskMutationOptions(options), queryClient);
    }

export const getSkipTaskUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/skip`
}

/**
 * @summary Skip Task
 */
export const skipTask = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<TaskDetail> => {

  return customInstance<TaskDetail>(getSkipTaskUrl(taskId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSkipTaskMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof skipTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['skipTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  skipTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipTaskMutationResult = NonNullable<Awaited<ReturnType<typeof skipTask>>>

    export type SkipTaskMutationError = HTTPValidationError

    /**
 * @summary Skip Task
 */
export const useSkipTask = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skipTask>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getSkipTaskMutationOptions(options), queryClient);
    }

export const getMarkTaskReadUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/read`
}

/**
 * @summary Mark Task Read
 */
export const markTaskRead = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkTaskReadUrl(taskId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkTaskReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTaskRead>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markTaskRead>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['markTaskRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markTaskRead>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  markTaskRead(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkTaskReadMutationResult = NonNullable<Awaited<ReturnType<typeof markTaskRead>>>

    export type MarkTaskReadMutationError = HTTPValidationError

    /**
 * @summary Mark Task Read
 */
export const useMarkTaskRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTaskRead>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markTaskRead>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getMarkTaskReadMutationOptions(options), queryClient);
    }

export const getMarkTaskUnreadUrl = (taskId: string,) => {




  return `/api/tasks/${taskId}/unread`
}

/**
 * Inverse of ``POST /{task_id}/read``.
 *
 * Done / archived tasks are permanently read — the service raises
 * ``TaskReadLockedError`` which surfaces as 422 ``TASK_READ_LOCKED``.
 * @summary Mark Task Unread
 */
export const markTaskUnread = async (taskId: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getMarkTaskUnreadUrl(taskId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkTaskUnreadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTaskUnread>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markTaskUnread>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['markTaskUnread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markTaskUnread>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  markTaskUnread(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkTaskUnreadMutationResult = NonNullable<Awaited<ReturnType<typeof markTaskUnread>>>

    export type MarkTaskUnreadMutationError = HTTPValidationError

    /**
 * @summary Mark Task Unread
 */
export const useMarkTaskUnread = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTaskUnread>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markTaskUnread>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getMarkTaskUnreadMutationOptions(options), queryClient);
    }

export const getGetTechnicalProfileUrl = (profileId: string,) => {




  return `/api/profiles/${profileId}/technical-profile`
}

/**
 * Live snapshot of a candidate's GitHub and Stack Overflow profiles.
 *
 * Independent of the main profile load — the frontend renders skeletons
 * while this resolves and silently hides any block whose upstream call
 * returned ``null``.
 * @summary Get Technical Profile
 */
export const getTechnicalProfile = async (profileId: string, options?: Parameters<typeof customInstance>[1]): Promise<TechnicalProfileResponse> => {

  return customInstance<TechnicalProfileResponse>(getGetTechnicalProfileUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTechnicalProfileQueryKey = (profileId: string,) => {
    return [
    `/api/profiles/${profileId}/technical-profile`
    ] as const;
    }


export const getGetTechnicalProfileQueryOptions = <TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTechnicalProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTechnicalProfile>>> = ({ signal }) => getTechnicalProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTechnicalProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getTechnicalProfile>>>
export type GetTechnicalProfileQueryError = HTTPValidationError


export function useGetTechnicalProfile<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTechnicalProfile>>,
          TError,
          Awaited<ReturnType<typeof getTechnicalProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTechnicalProfile<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTechnicalProfile>>,
          TError,
          Awaited<ReturnType<typeof getTechnicalProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTechnicalProfile<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Technical Profile
 */

export function useGetTechnicalProfile<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTechnicalProfileQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTechnicalProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTechnicalProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTechnicalProfile>>> = ({ signal }) => getTechnicalProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTechnicalProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTechnicalProfile>>>
export type GetTechnicalProfileSuspenseQueryError = HTTPValidationError


export function useGetTechnicalProfileSuspense<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTechnicalProfileSuspense<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTechnicalProfileSuspense<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Technical Profile
 */

export function useGetTechnicalProfileSuspense<TData = Awaited<ReturnType<typeof getTechnicalProfile>>, TError = HTTPValidationError>(
 profileId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTechnicalProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTechnicalProfileSuspenseQueryOptions(profileId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getWebImportUrl = () => {




  return `/api/tools/web-import`
}

/**
 * @summary Web Import
 */
export const webImport = async (webImportRequest: WebImportRequest, options?: Parameters<typeof customInstance>[1]): Promise<WebImportResponse> => {

  return customInstance<WebImportResponse>(getWebImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(webImportRequest)
  }
);}





export const getWebImportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof webImport>>, TError,{data: WebImportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof webImport>>, TError,{data: WebImportRequest}, TContext> => {

const mutationKey = ['webImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof webImport>>, {data: WebImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  webImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WebImportMutationResult = NonNullable<Awaited<ReturnType<typeof webImport>>>
    export type WebImportMutationBody = WebImportRequest
    export type WebImportMutationError = HTTPValidationError

    /**
 * @summary Web Import
 */
export const useWebImport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof webImport>>, TError,{data: WebImportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof webImport>>,
        TError,
        {data: WebImportRequest},
        TContext
      > => {
      return useMutation(getWebImportMutationOptions(options), queryClient);
    }

export const getHealthHealthGetUrl = () => {




  return `/health`
}

/**
 * @summary Health
 */
export const healthHealthGet = async ( options?: Parameters<typeof customInstance>[1]): Promise<HealthHealthGet200> => {

  return customInstance<HealthHealthGet200>(getHealthHealthGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthHealthGetQueryKey = () => {
    return [
    `/health`
    ] as const;
    }


export const getHealthHealthGetQueryOptions = <TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthHealthGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthHealthGet>>> = ({ signal }) => healthHealthGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthHealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthHealthGet>>>
export type HealthHealthGetQueryError = unknown


export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health
 */

export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthHealthGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHealthHealthGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthHealthGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthHealthGet>>> = ({ signal }) => healthHealthGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthHealthGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof healthHealthGet>>>
export type HealthHealthGetSuspenseQueryError = unknown


export function useHealthHealthGetSuspense<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGetSuspense<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGetSuspense<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health
 */

export function useHealthHealthGetSuspense<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthHealthGetSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
